{
  "AccountInvitations": {
    "AccessAddedBody": "Your existing account has been linked to {customer}. You can sign in with your current password.",
    "AccessAddedTitle": "Access added",
    "Activate": "Request access",
    "Consent": "I want to request this customer access and consent to creating my access.",
    "Context": "Hello {name}, this invitation lets you request access for {email} to {customer}.",
    "ExistingAccount": "Your existing verified account will be linked to this customer. Your password will not change.",
    "Expires": "This invitation is valid until {date}.",
    "GoToLogin": "Go to sign in",
    "Loading": "Checking invitation…",
    "Title": "Account invitation",
    "UnavailableBody": "The link is invalid, expired, revoked, or already used. Request a new invitation if necessary.",
    "UnavailableTitle": "Invitation unavailable",
    "VerificationEmail": "After you consent, the customer access is created. You then receive the verification email at this email address to confirm your identity and set a password.",
    "VerifyEmailBody": "Your customer access has been created. We sent the verification email to {email}. Open that email to confirm your identity and set a password.",
    "VerifyEmailTitle": "Check your email"
  },
  "Admin": {
    "AssetsOverview": {
      "searchCategories": "Search categories",
      "noMatchingCategories": "No categories found.",
      "presence": {
        "present": "Assets available",
        "empty": "No current assets",
        "unknown": "Availability unknown"
      },
      "chooseCategory": "Select a category on the left to view assets.",
      "lastBackupStatus": "Last backup result",
      "lastBackupStatusHistory": "Last backup result per snapshot",
      "customers": "Customer | Customers",
      "workspaceTitle": "Stored assets by customer",
      "snapshotBadge": "Snapshots",
      "categories": "Category | Categories",
      "selection": "Selection",
      "navigatorHint": "Load the overview to browse asset categories here.",
      "overview": "Asset overview",
      "notLoaded": "No overview loaded yet",
      "readHint": "Stored data · No external API calls",
      "snapshotHint": "Source dates of the loaded overview",
      "snapshotEmptyHint": "After loading, snapshot dates per customer appear here.",
      "tableOnlyHint": "Table data was found for this asset type, but no chart data. Choose Tables only or Tables and diagrams, then load the overview again.",
      "noAssetData": "No data was found for this asset type.",
      "load": "Load overview",
      "allCustomers": "All customers",
      "selectedCustomers": "{count} customer selected | {count} customers selected",
      "allTypes": "All asset types",
      "selectedTypes": "{count} asset type selected | {count} asset types selected",
      "pendingFilters": "Filters changed. Click Load overview to apply them.",
      "emptyTitle": "Your overview, on demand",
      "emptyHint": "Set the filters and click Load overview. No assets have been requested yet.",
      "customerCount": "No customers with assets | {count} customer with assets | {count} customers with assets",
      "noSnapshot": "No snapshot",
      "noAssets": "No stored assets found for this selection.",
      "snapshotDates": "Snapshot dates by customer",
      "collapseSnapshots": "Collapse snapshot dates",
      "expandSnapshots": "Expand snapshot dates",
      "customerError": "The customer list could not be loaded.",
      "loadError": "These records could not be loaded. Try again; reload the overview if the snapshot has expired.",
      "retry": "Try again",
      "confirmTitle": "Fetch assets again?",
      "confirmBody": "All external integrations will be called again for {count} customer. Continue? | All external integrations will be called again for {count} customers. Continue?",
      "confirmHint": "This may take several minutes. The asset type filter does not limit this action. Use Load overview to view stored records.",
      "cancel": "Cancel",
      "confirmAction": "Fetch again",
      "refreshProgress": "Fetching assets: {current} of {total} customer processed. | Fetching assets: {current} of {total} customers processed.",
      "refreshResult": "Assets fetched for {success} of {total} customer. | Assets fetched for {success} of {total} customers.",
      "refreshFailed": "Fetch failed. Check the integration configuration and whether stored secrets can be read with the current key."
    },
    "Asterisk-status": {
      "Agent warning": "The current phone system status is unavailable or the latest apply failed. The last working configuration remains active.",
      "Available": "Available",
      "Error": "Configuration error",
      "Inactive": "Inactive",
      "Label": "Phone system status",
      "Not configured": "Not in use",
      "Pending": "Pending application",
      "Stale": "Status outdated",
      "Unavailable": "Not registered",
      "Unknown": "Status unknown"
    },
    "AccountInvitations": {
      "Account": "Account",
      "Actions": "Actions",
      "ApplyFilters": "Apply filters",
      "AutomaticCustomerUser": "After acceptance, Vision automatically creates the correct customer user and relation for this customer. For a new or unverified account, Vision then sends the verification email to confirm the identity and set a password. Existing accounts that only belong to the Admin portal are excluded.",
      "BackToSelection": "Back to selection",
      "Batch": "Batch reference",
      "BatchReference": "Batch reference",
      "Campaign": "Campaign reference",
      "CampaignReference": "Campaign reference",
      "Confirm": "I reviewed the selection and exclusions and want to prepare these personal links.",
      "ContactIds": "Customer contacts",
      "Contacts": "Customer contacts",
      "Copied": "Activation link copied.",
      "Copy": "Copy activation link",
      "Customer": "Customer",
      "Delivery_mailchimp": "Mailchimp",
      "Delivery_manual": "Manual / Excel",
      "DeliveryMethod": "Delivery method",
      "DeliveryMethodOptions": {
        "Mailchimp": "Mailchimp",
        "Manual": "Manual / Excel"
      },
      "DownloadExcel": "Download Excel",
      "Eligible": "Eligible",
      "Email": "Email address",
      "ErrorLoading": "The account invitation list could not be loaded due to an error.",
      "Excluded": "Excluded",
      "ExclusionReasons": {
        "AdminPortalAccount": "This existing account only belongs to the Admin portal and cannot be linked as a customer user.",
        "AlreadyHasAccess": "This account already has these customer roles for this customer.",
        "AmbiguousAccount": "Multiple user accounts were found for this email address.",
        "AmbiguousEmail": "This email address occurs more than once in the selected customer contacts.",
        "MailchimpMergeFieldInvalid": "The VISIONURL URL merge tag is not configured correctly in Mailchimp.",
        "MailchimpMergeFieldMissing": "The VISIONURL URL merge tag is missing in Mailchimp.",
        "MailchimpNotSubscribed": "This contact is not or is no longer subscribed to email in the Mailchimp audience.",
        "MailchimpUnavailable": "This contact's status in the Mailchimp audience could not be checked.",
        "MissingName": "This contact's first name or last name is missing.",
        "MissingOrInvalidEmail": "This contact does not have a valid email address.",
        "NonInteractiveAccountConflict": "This email address already belongs to a technical account and cannot be used for a customer user.",
        "NotMailable": "Receive email is set to no for this contact.",
        "OpenInvitation": "A valid account invitation is already open for this contact."
      },
      "Existing": "Existing",
      "Expires": "Valid until",
      "GenericError": "The account invitations could not be processed.",
      "History": "Invitation history",
      "Intro": "Create personal, temporary activation links and deliver them manually or through Mailchimp.",
      "LoadingContacts": "Loading customer contacts…",
      "MailchimpChecking": "Checking the Mailchimp configuration…",
      "MailchimpDelivery": "Mailchimp",
      "MailchimpNotReady": "Mailchimp is disabled, incomplete, or missing a private, non-required URL merge tag",
      "MailchimpReady": "Mailchimp is ready with the private, non-required URL merge tag",
      "MailchimpRetryOneTimeWarning": "One or more Mailchimp updates failed. These full activation links are shown only once. Download the Excel file and retry the Mailchimp update before closing this window.",
      "MailchimpStatusOptions": {
        "Cleared": "Cleared",
        "Disabled": "Disabled",
        "Failed": "Failed",
        "Pending": "Processing",
        "Synced": "Updated"
      },
      "ManualDelivery": "Manual / Excel",
      "ManualDeliveryNotice": "Vision only creates the links and shows them once for copying or an API-generated Excel export. Mailchimp is not consulted or changed, and Vision does not send an email while preparing the batch.",
      "ManualOneTimeWarning": "These personal activation links are shown only once. Copy them now or download the Excel file and treat it as confidential information.",
      "New": "New",
      "NewDialogTitle": "Prepare new account invitations",
      "NewInvitationBatch": "New account invitations",
      "OneTimeWarning": "Mailchimp was updated. These full activation links are shown only once. Download the Excel file before closing this window if you want to keep them.",
      "Prepare": "Prepare links",
      "Prepared": "The account invitations were prepared.",
      "Preview": "Review selection",
      "PreviewTitle": "Preview: nothing created yet",
      "Reason": "Reason",
      "Refresh": "Refresh",
      "Reissue": "Issue a new link",
      "ReissueConfirm": "Are you sure you want to issue a new link for {email}? Any current link that is still valid will then be revoked.",
      "ReissuedFromPortal": "Reissued from the admin portal",
      "ReissueOneTime": "The new link is shown once.",
      "ReplaceOpen": "Revoke existing open invitations for this selection",
      "ReplaceOpenInvitations": "Revoke existing open invitations for this selection",
      "Result": "Prepared links",
      "ResultDialogTitle": "One-time activation links",
      "Retry": "Retry Mailchimp",
      "RetrySuccess": "Mailchimp was updated without rotating the token.",
      "Revoke": "Revoke invitation",
      "RevokeConfirm": "Are you sure you want to revoke the open invitation for {email}?",
      "RevokedFromPortal": "Revoked from the admin portal",
      "Roles": "Customer roles",
      "ScheduledSendAt": "Valid from",
      "Selection": "Selection and validity",
      "Status": "Status",
      "StatusOptions": {
        "Accepted": "Accepted",
        "Failed": "Failed",
        "Pending": "Pending",
        "Processing": "Processing",
        "Revoked": "Revoked"
      },
      "Title": "Account invitations",
      "ValidDays": "Days valid",
      "ValidForDays": "Days valid",
      "ValidFrom": "Valid from",
      "Whitelabel": "Whitelabel"
    },
    "Audit-logs": {
      "ClientIp": "IP address",
      "Data": "Data",
      "Differences": "Differences",
      "Error loading data": "The list of audit logs could not be loaded due to an error.",
      "Id": "ID",
      "ImpersonatedBy": "Impersonated by",
      "ImpersonatedByOptions": {
        "NoImpersonation": "No impersonation"
      },
      "Level": "Result",
      "LevelOptions": {
        "Error": "Error",
        "Success": "Success"
      },
      "Meta": {
        "impersonatedBy": "Impersonated by",
        "method": "Method",
        "path": "Service",
        "user": "User"
      },
      "Method": "Method",
      "OriginalObject": "Original object",
      "Path": "Service",
      "Pipeline": "Pipeline",
      "Query": "Query",
      "RequestId": "Request ID",
      "ResultObject": "Result object",
      "Timestamp": "Date",
      "User": "User",
      "UserOptions": {
        "NoUser": "No authenticated user"
      },
      "View item": "Audit log details"
    },
    "Authmanagement-roles": {
      "Already assigned": "Already assigned",
      "Assign roles": "Assign roles",
      "Assign roles to customer": "Assign roles to customer",
      "AssignRoles item fail": "Error assigning roles. {msg}",
      "AssignRoles item success": "Roles successfully assigned.",
      "Auth source": "Authentication source",
      "Available roles": "Available roles",
      "Customer": "Customer",
      "Customers": "Customers",
      "Delete": "delete",
      "Delete item": "Delete role",
      "Delete item fail": "Error while deleting the role. {msg}",
      "Delete item success": "Role successfully deleted.",
      "Delete item text": "Are you sure you want to {1} the role {0}?",
      "Edit item": "Edit role",
      "Edit item fail": "Error editing role. {msg}",
      "Edit item success": "Role successfully changed.",
      "Error loading data": "The list of roles could not be loaded due to an error.",
      "Name": "Role",
      "New item": "New role",
      "New item fail": "Error while creating the new role. {msg}",
      "New item success": "Role successfully created.",
      "No assignable roles": "No roles available to assign to this customer.",
      "No roles selected": "No roles selected.",
      "Refresh list": "Refresh role list",
      "Role": "Role",
      "Roles to assign": "Roles to assign",
      "Select customer": "Select customer",
      "Select roles": "Select roles",
      "Selected customer": "Selected customer",
      "Summary": "Summary",
      "Roles": {
        "Assets": "Asset management",
        "Purchase-orders": "Purchase orders",
        "Stock": "Stock",
        "Stock-locations": "Stock locations",
        "Stock-movements": "Stock movements",
        "Audit-logs": "Audit logs",
        "Account-invitations": "Account invitations",
        "Authmanagement-roles": "Authmanagement roles",
        "Business-insights": "Vision insights",
        "Card-menus": "Card menus",
        "Contacts": "Contacts",
        "Contracts": "Contracts",
        "Customer-assets": "Customer assets",
        "Customer-contacts": "Customer contacts",
        "Customer-offers": "Customer offers",
        "Customer-phone-numbers": "Customer phone numbers",
        "Customer-sip-accounts": "Customer SIP accounts",
        "Customer-users": "Customer users",
        "Customers": "Customers",
        "Dmarc": "DMARC",
        "Dmarc-aggregate-reports": "DMARC aggregate reports",
        "Dmarc-failure-reports": "DMARC failure reports",
        "Domain-ns-groups": "Nameserver groups",
        "Domain-tld-settings": "Domain TLD settings",
        "Domains": "Domains",
        "Email-logs": "E-mail management",
        "Email-message-templates": "Message templates",
        "Email-queue": "Email queue",
        "Email-triggers": "Email triggers",
        "Feedback-answers": "Feedback answers",
        "Feedback-questions": "Feedback questions",
        "Files": "Files",
        "Invoices": "Invoices",
        "License-partner-programs": "Partner programs",
        "License-slas": "SLAs",
        "Licenses": "Licenses",
        "Product-groups": "Product groups",
        "Products": "Products",
        "Project-task-time-tracking": "Time tracking",
        "Project-task-types": "Task types",
        "Project-tasks": "Project tasks",
        "Projects": "Projects",
        "Sales-orders": "Sales orders",
        "Sepa": "Sepa",
        "Settings": "Settings",
        "Sms-logs": "SMS statistics",
        "Sharingcenter-meeting-files": "OMNI Sessions meeting files",
        "Sharingcenter-appointments": "OMNI Sessions appointments",
        "Sharingcenter-calendar-settings": "OMNI Sessions calendar settings",
        "Sharingcenter-calendars": "OMNI Sessions calendars",
        "Sharingcenter-contacts": "OMNI Sessions contacts",
        "Sharingcenter-profiles": "OMNI Sessions profiles",
        "Sharingcenter-groups": "OMNI Sessions groups",
        "Sharingcenter-meeting-logs": "OMNI Sessions statistics",
        "Sharingcenter-colleagues": "OMNI Sessions colleagues",
        "Sharingcenter-ai-queue": "OMNI Sessions AI queue",
        "Ssl-certificates": "Ssl certificates",
        "Subscriptions": "Subscriptions",
        "User-totp-devices": "User TOTP devices",
        "Users": "Users",
        "Vat": "Vat",
        "Vpn-activity": "VPN activities",
        "Vpn-certificates": "VPN certificates",
        "Vpn-firewall-verification-logs": "VPN firewall verification logs",
        "Vpn-firewalls": "VPN firewalls",
        "Vpn-mac-address-groups": "VPN mac address groups",
        "Webhooks/health-status": "Health status",
        "Webhosting": "Webhosting",
        "Webhosting-packages": "Webhosting packages",
        "Whitelabels": "Whitelabels",
        "Microsoft-privileged-sign-ins": "Microsoft sign-in monitor",
        "Overview-totals": "Global overview totals",
        "Webhooks": "Webhooks",
        "Webhook-queue": "Webhook deliveries",
        "Webhook-logs": "Webhook logs",
        "Suppliers": "Suppliers",
        "Supplier-contacts": "Supplier contacts",
        "Supplier-assessments": "Supplier assessments",
        "Supplier-documents": "Supplier documents"
      }
    },
    "Card-menus": {
      "App search no results": "Oh no! That app seems to be missing!",
      "Which app can we help you find today": "Which app can we help you find today?"
    },
    "Contacts": {
      "City": "City",
      "Clone item": "Clone contact",
      "Clone item fail": "Error cloning contact. {msg}",
      "Clone item success": "Contact cloned successfully.",
      "CompanyName": "Company name",
      "Contact": "Contact",
      "Country": "Country",
      "CountryBirth": "Country of birth",
      "Customer": "Customer",
      "DateBirth": "Date of birth",
      "Delete": "delete",
      "Delete item": "Delete contact",
      "Delete item fail": "Error deleting the contact. {msg}",
      "Delete item success": "Successfully deleted contact.",
      "Delete item text": "Are you sure you want to {1} the contact {0}?",
      "Delete ProductCommitments item": "Delete product commitment",
      "Domain": "Domain",
      "Edit item": "Edit contact",
      "Edit item fail": "Error editing the contact. {msg}",
      "Edit item success": "Successfully changed contact.",
      "Email": "Email address",
      "EnsId": "Eligibility and Name Selection ID",
      "EnsPassword": "Eligibility and Name Selection password",
      "Errors": {
        "default": "Something went wrong while saving the contact. {msg}",
        "ErrorCode": {
          "OXXA_API_BAD_STATUS_CODE": "Unable to connect to domain supplier.",
          "OXXA_API_NO_CHANGES": "The contact was not changed.",
          "OXXA_API_NO_HANDLE_FOUND": "No ID found at the supplier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "No data found to delete.",
          "OXXA_API_REQUEST_FAILED": "Unable to connect to domain supplier.",
          "OXXA_API_RESULT_DIFF": "The contact was partially saved, please verify the result.",
          "OXXA_API_RESULT_NOT_FOUND": "No results found for contact."
        }
      },
      "Fax": "Fax number",
      "FirstName": "Firstname",
      "Handle": "Handle",
      "HkIndustryType": "HK Industry Type",
      "HouseNumber": "House number",
      "HouseNumberSuffix": "Suffix",
      "IdCardDate": "ID card date",
      "IdCardIssuer": "ID card issuer",
      "IdNumber": "ID number",
      "Initials": "Initials",
      "JobTitle": "Job title",
      "LastName": "Lastname",
      "Name": "Name",
      "New item": "New contact",
      "New item fail": "Error creating contact. {msg}",
      "New item success": "Successfully added contact.",
      "No customer attached": "No customer attached",
      "PlaceBirth": "Place of birth",
      "PostalBirth": "Postal code of birth",
      "PostalCode": "Postal code",
      "Profession": "Profession",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "None": "None",
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "RegNumber": "Registration number",
      "State": "State/Province",
      "Street": "Street",
      "Tabs": {
        "Additional details": {
          "Additional details": "Additional details",
          "Aero domain": ".aero domain specific details",
          "CoC details": "Chamber of Commerce details",
          "Hk domain": ".hk domain specific details",
          "ID card": "ID card",
          "Pro domain": ".pro domain specific details",
          "Sponsored community": "Sponsored community details",
          "Sponsored community context": "The domains specified below are sponsored domains and need sponsor credentials, as well as domain specific details",
          "Trademark details": "Trademark details",
          "Travel domain": ".travel domain specific details"
        },
        "Contact details": "Contact details",
        "General": "General"
      },
      "Tel": "Phone number",
      "TmCountry": "Trademark country",
      "TmName": "Trademark name",
      "TmNumber": "Trademark number",
      "TravelUinId": "Travel industry ID",
      "VatNumber": "VAT number",
      "XxxMemberId": "Sponsored community member ID",
      "XxxPassword": "Sponsored community member ID password"
    },
    "Contracts": {
      "Add ProductCommitments item": "Add product commitment",
      "Amount": "Amount",
      "Archive": "archive",
      "CancelDate": "Cancel date",
      "Cancelled": "Cancelled",
      "Contract": "Contract",
      "Customer": "Customer",
      "Dates": "Dates",
      "Delete": "delete",
      "Delete item": "Delete contract",
      "Delete item fail": "Error deleting the contract. {msg}",
      "Delete item success": "Successfully deleted contract.",
      "Delete item text": "Are you sure you want to {1} the contract {0}?",
      "Delete ProductCommitments item": "Delete product commitment",
      "Discount": "Discount",
      "DiscountType": "Type",
      "DiscountTypeOptions": {
        "Percentage": "Percentage"
      },
      "Edit item": "Edit contract",
      "Edit item fail": "Error editing the contract. {msg}",
      "Edit item success": "Successfully changed contract.",
      "EndDate": "End date",
      "Errors": {
        "CONTRACT_IS_ACTIVE": "Cannot delete an active contract.",
        "ErrorCode": {
          "PRODUCTCOMMITMENT_BUNDLE_DISCOUNT_NOT_SUPPORTED": "Discounts on product commitments that are a bundled product are not supported.",
          "PRODUCTCOMMITMENT_DOUBLE_PRODUCTS_NOT_SUPPORTED": "Double products in product commitments are not supported"
        }
      },
      "InvestmentRepaymentMonths": "Investment term",
      "IsArchived": "Archived",
      "LicenseContractInfo": "This contract belongs to a license. The start date, end date and cancellation date are managed through license management.",
      "Name": "Name",
      "New item": "New contract",
      "New item fail": "Error creating contract. {msg}",
      "New item success": "Successfully created contract.",
      "Period": " Notice period",
      "Periodic": " Notice periodic",
      "PriceIndex": "Price index",
      "Product": "Product",
      "ProductCommitments": "Product commitments",
      "RenewalPeriod": "Renewal period",
      "RenewalPeriodic": "Renewal periodic",
      "RenewalPeriodicOptions": {
        "Day": "Day",
        "Month": "Month",
        "Year": "Year"
      },
      "RenewDate": "Renew date",
      "StartDate": "Start date",
      "Tabs": {
        "General": "General",
        "Product commitments": "Product commitments",
        "Subscriptions": "@:Shared.Globals.Subscriptions"
      },
      "This contract has ended or was cancelled, consider removing it": "This contract has ended or was cancelled, consider deleting it.",
      "Type": "Type"
    },
    "Customer-assets": {
      "AppDisplayName": "App display name",
      "ClientAppUsed": "Client app used",
      "CustomerName": "Customer name",
      "DeviceDetail": {
        "operatingSystem": "Operating system"
      },
      "Location": {
        "city": "City",
        "countryOrRegion": "Country or region",
        "state": "State"
      },
      "UserPrincipalName": "User principal name"
    },
    "Customer-contacts": {
      "Address": "Address",
      "Address information": "Address information",
      "Birthday": "Date of birth",
      "City": "City",
      "Comments": "Comments",
      "Contact": "Contact",
      "Country": "Country",
      "Customer": "Customer",
      "Customer address": "Customer address",
      "Delete": "delete",
      "Delete item": "Delete customer contact",
      "Delete item fail": "Failed to delete customer contact. {msg}",
      "Delete item success": "Successfully deleted customer contact.",
      "Delete item text": "Are you sure you want to {1} the customer contact {0}?",
      "Edit item": "Edit customer contact",
      "Edit item fail": "Error when changing the contact. {msg}",
      "Edit item success": "Successfully changed customer contact.",
      "EmailAddress": "Email address",
      "Export": "Export",
      "FirstName": "First name",
      "Initials": "Initials",
      "InvoiceReference": "Invoice reference",
      "JobTitle": "Job title",
      "Labels": "Labels",
      "LastName": "Last name",
      "Name": "Name",
      "New item": "New contact",
      "New item fail": "Failed to create new customer contact. {msg}",
      "New item success": "Successfully created customer contact.",
      "No labels": "No labels",
      "OverwriteAddress": "Overwrite address",
      "Phone": "Phone",
      "Salutation": "Salutation",
      "SalutationOptions": {
        "D": "Department",
        "F": "Female",
        "M": "Male",
        "U": "Unspecified"
      },
      "SendMail": "Send mail",
      "Tabs": {
        "General": "General"
      },
      "Zipcode": "Zipcode"
    },
    "Customer-phone-numbers": {
      "Active": "Active",
      "Customers": "Customers",
      "Delete": "delete",
      "Delete item": "Delete phone number",
      "Delete item fail": "The phone number could not be deleted. {msg}",
      "Delete item success": "Phone number deleted successfully.",
      "Delete item text": "Are you sure you want to {1} phone number {0}?",
      "Direction required": "Enable at least inbound or outbound traffic.",
      "Directions": "Directions",
      "Edit item": "Edit phone number",
      "Edit item fail": "An error occurred while editing the phone number. {msg}",
      "Edit item success": "Phone number updated successfully.",
      "Errors": {
        "ErrorCode": {
          "PHONE_NUMBER_ALREADY_EXISTS": "This phone number already exists.",
          "PHONE_NUMBER_DIRECTION_REQUIRED": "Enable at least inbound or outbound traffic.",
          "PHONE_NUMBER_IN_USE": "This phone number is selected in customer or profile settings for a linked customer.",
          "PHONE_NUMBER_SIP_ACCOUNT_INACTIVE": "An active phone number requires an active SIP account.",
          "PHONE_NUMBER_SIP_ACCOUNT_NOT_FOUND": "The selected SIP account does not exist."
        }
      },
      "Inbound": "Inbound",
      "Label": "Label",
      "New item": "New phone number",
      "New item fail": "An error occurred while adding the phone number. {msg}",
      "New item success": "Phone number added successfully.",
      "Number": "Phone number (E.164)",
      "Outbound": "Outbound",
      "SipAccount": "SIP account"
    },
    "Customer-sip-accounts": {
      "Active": "Active",
      "ClientUriDomain": "Client URI domain",
      "Codecs": "Codecs",
      "Customers": "Customers",
      "Delete": "delete",
      "Delete item": "Delete SIP account",
      "Delete item fail": "The SIP account could not be deleted. {msg}",
      "Delete item success": "SIP account deleted successfully.",
      "Delete item text": "Are you sure you want to {1} SIP account {0} for all linked customers?",
      "Edit item": "Edit SIP account",
      "Edit item fail": "An error occurred while editing the SIP account. {msg}",
      "Edit item success": "SIP account updated successfully.",
      "Endpoint": "Endpoint",
      "Errors": {
        "ErrorCode": {
          "SIP_ACCOUNT_ACTIVE_PHONE_NUMBERS": "This SIP account cannot be deactivated while active phone numbers are linked to it.",
          "SIP_ACCOUNT_CUSTOMER_IN_USE": "One or more selected customers cannot be unlinked from the SIP account while one of its phone numbers is selected in customer or profile settings.",
          "SIP_ACCOUNT_CUSTOMER_NOT_FOUND": "One or more selected customers do not exist.",
          "SIP_ACCOUNT_IN_USE": "Remove all linked phone numbers before deleting the SIP account.",
          "SIP_ACCOUNT_REGISTRATION_ALREADY_EXISTS": "A SIP account already exists for this registration. Add the customer to that existing SIP account."
        }
      },
      "FromDomain": "From domain",
      "Host": "Host",
      "Name": "Name",
      "New item": "New SIP account",
      "New item fail": "An error occurred while adding the SIP account. {msg}",
      "New item success": "SIP account added successfully.",
      "Password": "Password",
      "PasswordConfigured": "Password configured",
      "Port": "Port",
      "Tabs": {
        "General": "General",
        "Phone numbers": "Phone numbers"
      },
      "Transport": "Transport",
      "Username": "Username"
    },
    "Customer-offers": {
      "Accept offer": "Accept offer",
      "Accept offer item fail": "Error accepting the customer offer. {msg}",
      "Accept offer item success": "Successfully accepted customer offer and created a sales order.",
      "Add Products item": "Add product",
      "Amount": "Amount",
      "Cannot download offer": "Unable to start downloading the offer.",
      "Check dates": "Check start dates",
      "Clone item": "Clone offer",
      "Confirm customer offer accept": "Are you sure you want to accept the customer offer? A sales order will be created as soon as you accept the customer offer.",
      "Confirm customer offer reject": "Are you sure you want to reject the customer offer?",
      "Confirm customer offer reject title": "Reject customer offer",
      "Customer": "Customer",
      "Customer offers merged successfully": "The selected customer offers have been merged successfully.",
      "CustomPeriodAndPeriodic": "Period and periodic",
      "Date": "Date",
      "Delete": "delete",
      "Delete item": "Delete customer offer",
      "Delete item fail": "Error deleting the customer offer. {msg}",
      "Delete item success": "Successfully deleted customer offer.",
      "Delete item text": "Are you sure you want to {1} the customer offer {0}?",
      "Delete Products item": "Delete product",
      "Description": "Description",
      "Discount": "Discount",
      "Download offer pdf": "Download offer PDF",
      "Edit item": "Edit offer",
      "Edit item fail": "Error editing the customer offer. {msg}",
      "Edit item success": "Successfully changed offer.",
      "Errors": {
        "CAN_ONLY_DELETE_DRAFT_CUSTOMER_OFFERS": "Cannot delete a customer offer that does not have the status 'draft'.",
        "ErrorCode": {
          "CUSTOMER_CONTACT_NOT_SET": "Customer has no offer contact set.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "A product bundle cannot have a discount.",
          "PRODUCT_BUNDLE_DUPLICATE": "The offer can not contain the same product bundle twice.",
          "PRODUCT_BUNDLE_PRICE_NOT_FOUND": "The offer contains a product bundle with a bundle price that could not be found."
        }
      },
      "Filename": "Filename",
      "Generate customer offers": "Generate customer offers",
      "Generation date": "Generation date",
      "Memo": "Internal memo",
      "Merge customer offers": "Merge customer offers",
      "New item": "New offer",
      "New item fail": "Error creating customer offer. {msg}",
      "New item success": "Successfully created customer offer.",
      "Offer": "Offer",
      "Offer contact not set": "This customer has no offer contact set. Please set an offer contact and try again.",
      "Offer has missing dates": "One or more products in the offer are missing a 'Period from' date value. Please set a date for these products.",
      "OfferNumber": "Offer number",
      "OfferReference": "Order reference",
      "OfferTemplate": "Offer template",
      "OfferTemplateOptions": {
        "En-US": "English",
        "Nl-NL": "Dutch"
      },
      "Period": "Period",
      "PeriodFrom": "Period from",
      "Periodic": "Periodic",
      "PeriodicOptions": {
        "Month": "Month",
        "One-time": "One-time",
        "Year": "Year"
      },
      "PeriodTo": "Period to",
      "PriceCalculator": {
        "AmountOfDays": "Amount of days",
        "CurrentPrice": "Current price",
        "EndDate": "End date",
        "NewPrice": "New price",
        "Period string": "Period: {startDate} until {endDate}",
        "PricePerDay": "Price per day",
        "StartDate": "Start date",
        "Subscription": "Subscription",
        "Title": "Price calculation"
      },
      "PriceExclPerPiece": "Price per piece (excl VAT)",
      "Product": "Product",
      "Products": "Products",
      "Reject offer": "Reject offer",
      "Reject offer item fail": "Error rejecting the offer. {msg}",
      "Reject offer item success": "Successfully rejected offer.",
      "Select contract": "Select a contract",
      "Select dates": "Select dates",
      "Send offer": "Mark offer as sent",
      "Set all dates": "Set the all dates to: {date}",
      "Set missing dates": "Set the missing dates to: ",
      "Status": "Status",
      "StatusOptions": {
        "Accepted": "Accepted",
        "Draft": "Draft",
        "Rejected": "Rejected",
        "Sent": "Sent"
      },
      "Sync customer offers": "Sync customer offer | Sync customer offers",
      "Tabs": {
        "General": "General",
        "Products": "Products"
      },
      "To contract": "To contract",
      "TotalAmount": "Total amount (excl VAT)",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Fixed",
        "None": "None",
        "Percentage": "Percentage"
      }
    },
    "Customer-users": {
      "Api account": "API account",
      "Api accounts": "API accounts",
      "Api token": "API token",
      "Api token shown once": "This token is only shown once. Store it safely.",
      "Assigned roles": "Assigned roles",
      "Assign roles": "Assign roles",
      "Available roles": "Available roles",
      "Cannot impersonate user": "Login on behalf of this user failed.",
      "Cannot open customer portal": "Unable to open the customer portal for this customer user.",
      "Copy roles from user": "Copy roles from another user",
      "Copy roles from user title": "Copy roles",
      "Customer": "Customer",
      "Customer users": "Customer users",
      "Delete": "delete",
      "Delete api account": "Delete API account",
      "Delete api account text": "Are you sure you want to remove the API account {0}?",
      "Delete item": "Delete customer user",
      "Delete item fail": "Failed to delete customer user. {msg}",
      "Delete item success": "Successfully deleted customer user.",
      "Delete item text": "Are you sure you want to {1} the customer user {0}?",
      "Edit item": "Edit customer user",
      "Edit item fail": "Error when changing the user. {msg}",
      "Edit item success": "Successfully changed customer user.",
      "Edit api account": "Edit API account",
      "Email": "Email address",
      "Error loading data": "The list of customer users could not be loaded due to an error.",
      "FirstName": "First name",
      "Full name": "Full name",
      "Impersonate user": "Log in on behalf of the user",
      "IsSSO": "Using SSO?",
      "IsVerified": "Account verified?",
      "LastImpersonation": "Last impersonation",
      "LastName": "Last name",
      "Licenses": "Licenses",
      "Locale": "Locale",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Keep existing roles": "Keep all current roles of the users",
      "Name": "Name",
      "New api account": "New API account",
      "New item": "New user",
      "New item fail": "Failed to create new customer user. {msg}",
      "New item success": "Successfully created new customer user.",
      "New user": "Create new user",
      "MultiAssignRoles item fail": "Error assigning roles. {msg}",
      "MultiAssignRoles item success": "Successfully assigned roles.",
      "No assignable roles": "No roles available to assign.",
      "No users to copy roles from": "No other customer users with roles are available.",
      "No api accounts found": "No API accounts found",
      "No customer users available": "No customer users available.",
      "No customer users selected": "No customer users selected.",
      "No assigned roles": "No roles assigned.",
      "No roles to add": "No roles to add.",
      "No roles selected": "No roles selected.",
      "No users with role": "No users with this role.",
      "No users without role": "No users without this role.",
      "Overwrite existing roles": "Overwrite existing roles",
      "RegionalSettings": "Regional settings",
      "Regenerate API token": "Regenerate API token",
      "Regenerate API token confirm": "Regenerate API token",
      "Regenerate API token confirm text": "Are you sure you want to regenerate the API token for {fullName}? The current token will stop working.",
      "Regenerate API token fail": "Could not regenerate API token.",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Role assignment mode": "Role assignment mode",
      "Roles to copy": "Roles to copy",
      "Roles": "Roles",
      "Select customer before copying roles": "Select a customer before copying roles.",
      "Select customer users": "Select customer users first.",
      "Select roles": "Select roles",
      "Select user for roles": "User to copy roles from",
      "Selected customer users": "Selected customer users",
      "Selected users": "Selected users",
      "Roles to add": "Roles to add",
      "Roles to assign": "Roles to assign",
      "Roles to remove": "Roles to remove",
      "Summary": "Summary",
      "Take over roles": "Take over roles",
      "User": "User",
      "Users with role": "Users with this role",
      "Users without role": "Users without this role",
      "Virtual": "Virtual",
      "What is virtual user": "A virtual user is not linked to a real login account. One or more roles for this customer are always required."
    },
    "Customers": {
      "AccountName": "Account name / ascription",
      "Address": "Address",
      "AppDisplayName": "App Display Name",
      "AppId": "App ID",
      "Archive": "archive",
      "Archived": "Archived",
      "Assets": {
        "Assets date": "Assets date",
        "Comparisons": {
          "Compare Devices": {
            "Amount of too many devices": "Amount of too many devices",
            "Compare Devices": "Compare Devices",
            "Compare Missing Devices": "Compare Missing Devices",
            "Compare Protected Items": "Compare Protected Items",
            "Compare Total Devices": "Compare Total Devices",
            "Microsoft Azure devices not existing in the list of VPN certificates": "Microsoft Azure devices not existing in the list of VPN certificates",
            "More Microsoft Azure or VPN devices": "More Microsoft Azure or VPN devices",
            "VPN certificates not existing in the list of Microsoft Azure devices": "VPN certificates not existing in the list of Microsoft Azure devices"
          },
          "Compare Public IPs": {
            "Compare Public IPs": "Compare Public IPs",
            "Compare Total Public IPs": "Compare Total Public IPs",
            "NAT Gateway is not required but configured": "NAT Gateway is not required but configured",
            "NAT Gateway is required but not configured": "NAT Gateway is required but not configured"
          },
          "Compare Recovery Services": {
            "Compare Protected Items": "Compare Protected Items",
            "Compare Recovery Services": "Compare Recovery Services",
            "List of removed Virtual Machines still existing in Protected Items": "List of removed Virtual Machines still existing in Protected Items",
            "List of Virtual Machines not existing in Protected Items": "List of Virtual Machines not existing in Protected Items",
            "More Microsoft Azure or VPN devices": "More Microsoft Azure or VPN devices"
          },
          "Compare Reservations": {
            "Amount reservation points": "All existing reservation series have the following amount of points",
            "Compare Reservation Points": "Compare Reservation Points",
            "Compare Reservation Series": "Compare Reservation Series",
            "Compare Reservations": "Compare Reservations",
            "Reservation series not existing in Virtual Machine series": "Reservation series not existing in Virtual Machine series",
            "Virtual Machine series not existing in Reservation series": "Virtual Machine series not existing in Reservation series"
          },
          "Compare Veeam": {
            "Compare Mapped Job Repositories": "Compare Mapped Job Repositories",
            "Compare Mapped Repository Folders": "Compare Mapped Repository Folders",
            "Compare Repository Data": "Compare Repository Data",
            "Compare Repository Naming": "Compare Repository Naming",
            "Compare Veeam": "Compare Veeam",
            "Correct Name": "Correct Name",
            "Current Name": "Current Name",
            "Current Path": "Current Path",
            "Job Name": "Job Name",
            "List of jobs with incorrect folder mapped to the repository": "List of jobs with incorrect folder mapped to the repository",
            "List of jobs with incorrect repository mapped": "List of jobs with incorrect repository mapped",
            "List of repositories with incorrect naming": "List of repositories with incorrect naming",
            "Repositories with incorrect backup data included": "Repositories with incorrect backup data included"
          },
          "Compare Veeam with Microsoft Teams": {
            "Compare Team Backups": "Compare Team Backups",
            "Compare Veeam with Microsoft Teams": "Compare Veeam with Microsoft Teams",
            "Missing backups from Teams in Veeam": "Missing backups from Teams in Veeam",
            "Too many backups from Teams in Veeam": "Too many backups from Teams in Veeam"
          },
          "FriendlyStatus": {
            "ALL_JOBS_HAVE_CORRECT_REPOS_MAPPED": "All jobs have the correct repositories mapped.",
            "ALL_MS_TEAMS_HAVE_EXISTING_BACKUP": "All Microsoft teams have an existing backup in Veeam.",
            "ALL_REPOS_HAVE_CORRECT_FOLDER_MAPPED": "All repositories have the correct folder mapped.",
            "ALL_REPOS_HAVE_CORRECT_NAMING": "All repositories have the correct name, it includes mailboxes, teams, onedrive or sites.",
            "ALL_REPOS_INCLUDES_CORRECT_BACKUP_DATA": "All repositories are including the correct backup data.",
            "AMOUNT_OF_DEVICES_AND_VPN_CERTS_ARE_EQUAL": "The total number of Microsoft Azure devices equals the total number of VPN certificates.",
            "DEVICES_AND_VPN_CERTS_NAMED_CORRECTLY": "All Microsoft Azure devices and VPN certificates are named correctly.",
            "DEVICES_MISSING_IN_VPN_CERTS_LIST": "There are Microsoft Azure devices that don't exist in the list of VPN certificates.",
            "EXISTING_MS_TEAMS_MISSING_IN_VEEAM": "There are existing Microsoft teams missing in Veeam.",
            "EXISTING_VEEAM_TEAMS_NOT_EXISTING_IN_MS": "There are existing teams in Veeam which not exists in Microsoft Teams anymore.",
            "INCORRECT_RESERVATION_POINTS": "Not all series have the correct amount of reservation points.",
            "MORE_RESERVATION_SERIES_THAN_VM_SERIES": "There are more Reservation series than Virtual Machine series, there are too much series reserved.",
            "MORE_VM_SERIES_THAN_RESERVATION_SERIES": "There are more Virtual Machine series than Reservation series, there are too less series reserved.",
            "NO_TEAM_BACKUP_FOUND_FROM_REMOVED_MS_TEAM": "No removed Microsoft team found in Veeam backup.",
            "NO_TEAM_BACKUPS_ACTIVATED_AND_FOUND": "No backups from teams in Veeam found, there are no team jobs activated for this customer.",
            "NOT_ALL_JOBS_HAVE_CORRECT_REPOS_MAPPED": "Not all jobs have the correct repositories mapped.",
            "NOT_ALL_REPOS_HAVE_CORRECT_FOLDER_MAPPED": "Not all repositories have the correct folder mapped.",
            "NOT_ALL_REPOS_HAVE_CORRECT_NAMING": "Not all repositories have the correct name, it doesn't includes mailboxes, teams, onedrive or sites.",
            "NOT_ALL_REPOS_INCLUDES_CORRECT_BACKUP_DATA": "Not all repositories are including the correct backup data.",
            "PROTECTED_ITEMS_MISSING_IN_VIRTUAL_MACHINES": "There are removed Virtual Machines, but still existing in protected items.",
            "PUBLIC_IPS_EQUAL_OR_LOWER_THAN_TEN_BUT_NAT_GATEWAY_CONFIGURED": "The total number of assigned Public IPs is equal or lower than 10 (current total of {s}), but NAT Gateway is configured.",
            "PUBLIC_IPS_EQUAL_OR_LOWER_THAN_TEN_BUT_NAT_GATEWAY_NOT_CONFIGURED": "The total number of assigned Public IPs is equal or lower than 10 (current total of {s}), but NAT Gateway is not configured.",
            "PUBLIC_IPS_HIGHER_THAN_TEN_BUT_NAT_GATEWAY_CONFIGURED": "The total number of assigned Public IPs is higher than 10 (current total of {s}), but NAT Gateway is configured.",
            "PUBLIC_IPS_HIGHER_THAN_TEN_BUT_NAT_GATEWAY_NOT_CONFIGURED": "The total number of assigned Public IPs is higher than 10 (current total of {s}), but NAT Gateway is not configured.",
            "RESERVATION_POINTS_EQUAL": "All reservation points are equal.",
            "TOO_MANY_DEVICES_COMPARED_TO_VPN_CERTS": "There are a total of {s} too many Microsoft Azure devices compared to VPN certificates.",
            "TOO_MANY_VPN_CERTS_COMPARED_TO_DEVICES": "There are a total of {s} too many VPN certificates compared to Microsoft Azure devices.",
            "VEEAM_DISK_THRESHOLD_EXCEEDED": "The threshold of 95% is exceeded for some Veeam backup disks.",
            "VEEAM_DISK_THRESHOLD_NOT_EXCEEDED": "The threshold of 95% is not exceeded for Veeam backup disks.",
            "VIRTUAL_MACHINES_MISSING_IN_PROTECTED_ITEMS": "There are Virtual Machines not found in protected items.",
            "VM_AND_PROTECTED_ITEMS_EQUAL": "All Virtual Machines and protected items are equal.",
            "VM_AND_RESERVATION_SERIES_EQUAL": "All Virtual Machine series are equal to Reservation series.",
            "VPN_CERTS_MISSING_IN_DEVICES_LIST": "There are VPN certificates that don't exist in the list of Microsoft Azure devices."
          },
          "Messages": "Messages"
        },
        "Diagrams only": "Diagrams only",
        "Errors": {
          "NO_ASSETS": "No assets were found for this customer. Please verify that at least one API is activated and that the assets have been reloaded."
        },
        "Hetzner": {
          "Architecture": "Architecture",
          "Backup Window": "Backup window",
          "Backups": "Backups",
          "Blocked": "Blocked",
          "Calculations": {
            "Backups": {
              "Backups": "Backups",
              "Total Backups Per Date": "Total Virtual Machine Backups Per Date",
              "Total Protection Status": "Backup Status Per Virtual Machine",
              "Total Unique VMBackups Per Date": "Total Unique Virtual Machine Backups Per Date",
              "Virtual Machine Backups": "Virtual Machine Backups"
            },
            "Firewalls": "Firewalls",
            "Public IPs": "Public IPs",
            "Storages": {
              "Storages": "Storage",
              "Total Storage Statuses": "Total Available Storage"
            },
            "Virtual Machines": {
              "Total Operating Systems": "Total Operating Systems",
              "Total Statuses": "Total Virtual Machine Statuses",
              "Total Types": "Total Virtual Machine Types",
              "Virtual Machines": "Virtual Machines"
            }
          },
          "Created Date": "Created at",
          "Datacenter": "Datacenter",
          "Delete protection": "Delete protection",
          "Disk Size": "Disk size",
          "Errors": {
            "FLOATING_IPS_NOT_FOUND": "Unable to get Floating IPs.",
            "HETZNER_API_CREDENTIALS_MISSING": "Hetzner API data not found in database and shared TransIP is not used.",
            "HETZNER_API_NOT_ACTIVATED": "Hetzner API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "IMAGES_IPS_NOT_FOUND": "Unable to get Images.",
            "SERVERS_IPS_NOT_FOUND": "Unable to get Servers.",
            "VOLUMES_NOT_FOUND": "Unable to get Volumes."
          },
          "Firewall applied": "Firewall applied",
          "Format": "Format",
          "Image Size": "Image size",
          "IP Address": "IP Address",
          "IPv4 Address": "IPv4 address",
          "Location": "Location",
          "Locked": "Locked",
          "Name": "Name",
          "OS": "OS",
          "Private IPv4 Address": "Private IPv4 address",
          "Public IPs": "Public IPs",
          "Server": "Server",
          "Server Type": "Server type",
          "Size": "Size",
          "Status": "Status",
          "Storages": "Storages",
          "Type": "Type",
          "Virtual machines": "Virtual machines",
          "Virtual machines backups": "Virtual machine backups"
        },
        "Locked Vault Backups": {
          "Backups": {
            "Backups": "Backups",
            "Created": "Created at",
            "Customer name": "Customer name",
            "Daily Restore Points": "Daily Restore Points",
            "Hostname": "Hostname",
            "Monthly Restore Points": "Monthly Restore Points",
            "Repository Url": "Repository Url",
            "Snapshot Id": "Snapshot Id",
            "Snapshot Size Kb": "Snapshot size",
            "Status": "Status",
            "Total Repository Size Kb": " Total Repository size",
            "Weekly Restore Points": "Weekly Restore Points",
            "Yearly Restore Points": "Yearly Restore Points"
          },
          "Calculations": {
            "Backups": "Backups"
          },
          "Errors": {
            "LOCKED_VAULT_BACKUPS_NOT_FOUND": "No Locked Vault Backups found."
          }
        },
        "MicrosoftAzure": {
          "Applied scope": "Applied scope",
          "Archived": "Archived",
          "Billing plan": "Billing plan",
          "Calculations": {
            "Disks": {
              "Disks": "Disks",
              "Total Disk Types": "Total Disk Types",
              "Total Disks In Use": "Total Disks In Use"
            },
            "Host Pools": "Host Pool | Host Pools",
            "Nat Gateways": "NAT Gateways",
            "Public IPs": "Public IPs",
            "Recovery Services": {
              "Total Last Backup Status": "Last backup result",
              "Recovery Services": "Recovery Services",
              "Total Protection Status": "Total Protection Status"
            },
            "Reservations": {
              "Reservations": "Reservations",
              "Total Active Reservation Points Per Serie": "Total Active Reservation Points Per Serie",
              "Total Active Reservations Per Serie": "Total Active Reservations Per Serie",
              "Total Created Reservation Per Type": "Total Created Reservation Per Type",
              "Total Created Reservations Per Provisioning State": "Total Created Reservations Per Provisioning State",
              "Total Reservation Per Type": "Total Reservation Per Type",
              "Total Reservation Types Per Provisioning State": {
                "Cancelled": "Cancelled",
                "Succeeded": "Succeeded",
                "Total Reservation Types Per Provisioning State": "Total Reservation Types Per Provisioning State"
              },
              "Total Reservations Per Provisioning State": "Total Reservations Per Provisioning State"
            },
            "Resource Groups": "Resource Group",
            "Route Tables": "Route Tables",
            "Subscriptions": "Subscriptions",
            "Virtual Machines": {
              "Total Agent Statuses": "Total Agent Statuses",
              "Total Virtual Machine Points Per Serie": "Total Virtual Machine Points Per Serie",
              "Total Virtual Machine Statuses": "Total Virtual Machine Statuses",
              "Total Virtual Machine Types": "Total Virtual Machine Types",
              "Total Virtual Machines Per Serie": "Total Virtual Machines Per Serie",
              "Virtual Machines": "Virtual Machines"
            },
            "Virtual Networks": "Virtual Networks"
          },
          "Errors": {
            "AZURE_API_CREDENTIALS_MISSING": "Microsoft Azure API credentials are not found in the database for this customer. Go to the API credentials tab to fill in the API credentials.",
            "AZURE_API_NOT_ACTIVATED": "Microsoft Azure API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "DISKS_NOT_FOUND": "Unable to get Disks.",
            "HOST_POOLS_NOT_FOUND": "Unable to get Host Pools.",
            "NAT_GATEWAYS_NOT_FOUND": "Unable to get NAT gateways.",
            "PUBLIC_IPS_NOT_FOUND": "Unable to get Public IPs.",
            "RECOVERY_SERVICES_NOT_FOUND": "Unable to get Recovery Services.",
            "RESERVATIONS_NOT_FOUND": "Unable to get Reservations.",
            "RESOURCE_GROUPS_NOT_FOUND": "Unable to get Resource Groups.",
            "ROUTE_TABLES_NOT_FOUND": "Unable to get Route Tables.",
            "SESSION_HOSTS_NOT_FOUND": "Unable to get Session Hosts.",
            "SUBSCRIPTIONS_NOT_FOUND": "Unable to get Subscriptions.",
            "TOKEN_NOT_FOUND": "Unable to get the API token. Make sure that the API credentials are correct.",
            "USER_SESSIONS_NOT_FOUND": "Unable to get User Sessions from Session Host.",
            "VAULT_POLICIES_NOT_FOUND": "Unable to get Backup Policies for Vault.",
            "VAULT_PROTECTED_ITEMS_NOT_FOUND": "Unable to get Protected Items for Vault.",
            "VIRTUAL_MACHINES_NOT_FOUND": "Unable to get Virtual Machines.",
            "VIRTUAL_NETWORKS_NOT_FOUND": "Unable to get Virtual Networks."
          },
          "Expiry date": "Expiry date",
          "Location": "Location",
          "Active": "Active",
          "Archived - Cancelled": "Archived - Cancelled",
          "Archived - Expired": "Archived - Expired",
          "Cancelled": "Cancelled",
          "Expired": "Expired",
          "Expiring": "Expiring",
          "Failed": "Failed",
          "Merged": "Merged",
          "Name": "Name",
          "Pending": "Pending",
          "Purchase date": "Purchase date",
          "Quantity": "Quantity",
          "Renew": "Renew",
          "Reservations": "Reservations",
          "Reserved resource type": "Reserved resource type",
          "SKU name": "SKU name",
          "Split": "Split",
          "Status": "Status",
          "Utilization": "Utilization",
          "Utilization 24 hours": "Utilization 24 hours",
          "Utilization 7 days": "Utilization 7 days",
          "Utilization 30 days": "Utilization 30 days",
          "Subscriptions": {
            "DisplayName": "Display name",
            "Resource groups": {
              "Disks": {
                "Disk": "Disk | Disks | Disk {name}",
                "Disk IOPS": "Disk IOPS read/write",
                "Disk Mbps": "Disk Mbps read/write",
                "Disk size GB": "Disk size (GB)",
                "Disk state": "Disk state",
                "Location": "Location",
                "Name": "Name",
                "OS type": "OS type",
                "SKU name": "SKU name",
                "SKU tier": "SKU tier"
              },
              "Host pools": {
                "Host pool": "Host Pool | Host Pools | Host Pool {name}",
                "Session hosts": {
                  "Assigned user": "Assigned user",
                  "Assigned virtual machine": "Assigned virtual machine",
                  "Name": "Name",
                  "Session host": "Session Host | Session Hosts | Session Host {host}",
                  "Sessions": "Sessions",
                  "Update state": "Update state",
                  "User sessions": {
                    "Created time": "Created time",
                    "Session state": "Session state",
                    "User principal name": "User principal name",
                    "User session": "User Session | User Sessions | User Session {name}"
                  }
                }
              },
              "Location": "Location",
              "Name": "Name",
              "NAT gateways": {
                "Idle timeout": "Idle timeout in minutes",
                "Location": "Location",
                "Name": "Name",
                "NAT gateway": "NAT Gateway | NAT Gateways | NAT Gateway {name}",
                "SKU name": "SKU Name"
              },
              "Public IPs": {
                "Allocation method": "Allocation method",
                "Idle timeout": "Idle timeout (minutes)",
                "IP address": "IP address",
                "IP address version": "IP address version",
                "Location": "Location",
                "Name": "Name",
                "Public IP": "Public IP | Public IPs | Public IP {address}",
                "SKU name": "SKU name",
                "SKU tier": "SKU tier"
              },
              "Recovery services": {
                "Backup policies": {
                  "Backup policies": "Backup Policies",
                  "Daily retention": "Daily retention",
                  "Daily schedule retention times": "Daily schedule retention times",
                  "Monthly retention": "Monthly retention",
                  "Monthly retention day": "Monthly retention day",
                  "Name": "Name",
                  "Retention duration count": "Retention duration count",
                  "Retention duration type": "Retention duration type",
                  "Schedule run frequency": "Schedule run frequency",
                  "Schedule run times": "Schedule run times",
                  "Schedule weekly frequency": "Schedule weekly frequency",
                  "Weekly retention": "Weekly retention",
                  "Weekly retention days": "Weekly retention days",
                  "Yearly retention": "Yearly retention",
                  "Yearly retention day": "Yearly retention day"
                },
                "Location": "Location",
                "Name": "Name",
                "Protected items": {
                  "Health status": "Health status",
                  "Last backup status": "Last backup status",
                  "Last backup time": "Last backup time",
                  "Last recovery point": "Last recovery point",
                  "Name": "Name",
                  "Policy name": "Policy name",
                  "Protected items": "Protected Items",
                  "Protection state": "Protection state",
                  "Protection status": "Protection status"
                },
                "Recovery service": "Recovery Service | Recovery Services | Recovery Service {name}",
                "SKU name": "SKU name",
                "SKU tier": "SKU tier",
                "Vault name": "Vault name"
              },
              "Resource group": "Resource Group| Resource Groups | Resource Group {resourceGroup}",
              "Route tables": {
                "Address prefix": "Address prefix",
                "Has BGP override": "Has BGP override",
                "Location": "Location",
                "Name": "Name",
                "Next hop address": "Next hop address",
                "Next hop type": "Next hop type",
                "Route": "Route | Routes",
                "Route propagation": "Disable BGP Route Propagation",
                "Route table": "Route Table | Route Tables | Route Table {name}"
              },
              "Virtual Machines": {
                "Admin username": "Admin username",
                "Agent Messages": "Agent messages",
                "Agent Status": "Agent status",
                "Computer name": "Computer name",
                "Location": "Location",
                "Name": "Name",
                "OS disk name": "OS disk name",
                "OS disk size GB": "OS disk size (GB)",
                "OS disk type": "OS disk type",
                "Virtual Machine": "Virtual Machine | Virtual Machines | Virtual Machine {name}",
                "VM id": "VM ID",
                "VM Size": "VM Size",
                "VM Status": "VM-status"
              },
              "Virtual networks": {
                "Address prefixes": "Address prefixes",
                "DDOS protection": "DDOS protection",
                "DNS Servers": "DNS Servers",
                "Location": "Location",
                "Name": "Name",
                "Subnets": {
                  "Name": "Name",
                  "Prefix": "Subnet address prefix",
                  "Subnet": "Subnet | Subnets"
                },
                "Virtual network": "Virtual Network | Virtual Networks | Virtual Network {name}"
              }
            },
            "State": "State",
            "Subscription": "Subscription {subscription}",
            "SubscriptionId": "Subscription ID",
            "TenantId": "Tenant ID"
          },
          "Term": "Term"
        },
        "MicrosoftGraph": {
          "Applications": {
            "App id": "App id",
            "Application": "Application | Applications",
            "Created date time": "Created date time",
            "Display name": "Display name",
            "Key credentials": {
              "Certificates": "Certificates",
              "Display name": "Display name",
              "End datetime": "End datetime",
              "Start datetime": "Start datetime",
              "Type": "Type"
            },
            "Password credentials": {
              "Credentials": "Credentials",
              "Display name": "Display name",
              "End datetime": "End datetime",
              "Hint": "Hint",
              "Start datetime": "Start datetime"
            },
            "Publisher domain": "Publisher domain",
            "Sign in audience": "Sign in audience"
          },
          "Audit Logs Sign Ins": {
            "App display name": "App display name",
            "Audit Logs Sign In": "Audit Log Sign Ins | Audit Logs Sign Ins",
            "Browser": "Browser",
            "City": "City",
            "Client app": "Client app",
            "Conditional access status": "Conditional access status",
            "Country or region": "Country or region",
            "Created at": "Created at",
            "Device display name": "Device display name",
            "Geo altitude": "Geo altitude",
            "Geo latitude": "Geo latitude",
            "Geo longitude": "Geo longitude",
            "Id": "ID",
            "Is compliant": "Is compliant",
            "Is interactive": "Is interactive",
            "Is managed": "Is managed",
            "Operating system": "Operating system",
            "Resource display name": "Resource display name",
            "State": "State",
            "Status": "Status",
            "Status failure reason": "Status failure reason",
            "Status message": "Status message",
            "User display name": "User display name",
            "User principle name": "User principle name"
          },
          "Calculations": {
            "Applications": "Applications",
            "Audit Logs Sign Ins": {
              "Audit Logs Sign Ins": "Audit Logs Sign Ins",
              "Total Login Attempts Per App Display Name": "Total Login Attempts Per App Display Name",
              "Total Login Attempts Per City": "Total Login Attempts Per City",
              "Total Login Attempts Per Client App": "Total Login Attempts Per Client App",
              "Total Login Attempts Per Country Or Region": "Total Login Attempts Per Country Or Region",
              "Total Login Attempts Per Operating System": "Total Login Attempts Per Operating System",
              "Total Login Attempts Per State": "Total Login Attempts Per State",
              "Total Login Attempts Per User Principal Name": "Total Login Attempts Per User Principal Name"
            },
            "Devices": {
              "Devices": "Devices",
              "Total Operating Systems": "Total Operating Systems"
            },
            "Shared Mailboxes": "Shared Mailboxes",
            "Subscribed Skus": "Subscribed Skus",
            "Teams": "Teams",
            "Users": "Users"
          },
          "Devices": {
            "Compliance state": "Compliance state",
            "Device": "Device | Devices | Device {device}",
            "Device enrollment type": "Device enrollment type",
            "Device name": "Device name",
            "Enrolled datetime": "Enrolled datetime",
            "Ethernet mac address": "Ethernet mac address",
            "Free storage space in bytes": "Free storage space (bytes)",
            "Imei": "Imei",
            "Managed device owner": "Managed device owner",
            "Operating system": "Operating system",
            "Serial number": "Serial number",
            "Total storage space in bytes": "Total storage space (bytes)",
            "User display name": "User display name",
            "User principal name": "User principal name",
            "WiFi mac address": "WiFi mac address"
          },
          "Errors": {
            "APPLICATIONS_NOT_FOUND": "Unable to get Applications.",
            "AUDIT_LOGS_SIGN_INS_NOT_FOUND": "Unable to get Audit Logs Sign Ins.",
            "DEVICES_NOT_FOUND": "Unable to get Devices.",
            "GRAPH_API_CREDENTIALS_MISSING": "Microsoft Graph API credentials are not found in the database for this customer. Go to the API credentials tab to fill in the API credentials.",
            "GRAPH_API_NOT_ACTIVATED": "Microsoft Graph API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "SHARED_MAILBOXES_NOT_FOUND": "Unable to get Shared Mailboxes. Make sure there is one group existing in the Azure Active Directory with the name: SharedMailboxes.",
            "SUBSCRIBED_SKUS_NOT_FOUND": "Unable to get subscribed Skus.",
            "TEAMS_NOT_FOUND": "Unable to get Teams.",
            "TOKEN_NOT_FOUND": "Unable to get the API token. Make sure that the API credentials are correct.",
            "USERS_NOT_FOUND": "Unable to get Users."
          },
          "Microsoft licenses": {
            "Applies to": "Applies to",
            "Capability status": "Capability status",
            "Consumed units": "Consumed units",
            "Microsoft license": "Microsoft License | Microsoft Licenses | Microsoft License {license}",
            "Prepaid units enabled": "Prepaid units enabled",
            "Prepaid units suspended": "Prepaid units suspended",
            "Prepaid units warning": "Prepaid units warning",
            "SKU id": "SKU id",
            "SKU name": "SKU name",
            "SKU part number": "SKU part number"
          },
          "Shared mailboxes": {
            "Display name": "Display name",
            "Mail": "Mail",
            "Mail nickname": "Mail nickname",
            "Shared mailbox": "Shared Mailbox | Shared Mailboxes | Shared Mailbox {mailbox}",
            "User principal name": "User principal name"
          },
          "Teams": {
            "Archived": "Archived",
            "Description": "Description",
            "Display name": "Display name",
            "Team": "Team | Teams | Team {team}",
            "Visibility": "Visibility"
          },
          "Users": {
            "Display name": "Display name",
            "Given name": "Given name",
            "Surname": "Surname",
            "User": "User | Users | User {name}",
            "User principal name": "User principal name"
          }
        },
        "MicrosoftSecurity": {
          "Alerts": {
            "Alerts": "Alert | Alerts",
            "Assigned to": "Assigned to",
            "Classification": "Classification",
            "Computer DNS name": "Computer DNS name",
            "Description": "Description",
            "First event time": "First event time",
            "Last event time": "Last event time",
            "Last update time": "Last update time",
            "Related user": "Related user",
            "Resolved time": "Resolved time",
            "Severity": "Severity",
            "Title": "Title"
          },
          "Calculations": {
            "Alerts": {
              "Alerts": "Alerts",
              "Total Alerts Per Severity": "Total Alerts Per Severity"
            },
            "Indicators": "Indicators",
            "Machine Actions": "Machine Actions",
            "Machines": "Machines",
            "Recommendations": "Recommendations",
            "Remediations": "Remediations",
            "Software": "Software",
            "Vulnerabilities": {
              "Total Vulnerabilities Per Severity": "Total Vulnerabilities Per Severity",
              "Vulnerabilities": "Vulnerabilities"
            },
            "Vulnerabilities By Machine And Software": {
              "Total Vulnerabilities Per Severity": "Total Vulnerabilities Per Severity",
              "Vulnerabilities By Machine And Software": "Vulnerabilities By Machine And Software"
            }
          },
          "Errors": {
            "ALERTS_NOT_FOUND": "Unable to get Alerts.",
            "INDICATORS_NOT_FOUND": "Unable to get Indicators.",
            "MACHINE_ACTIONS_NOT_FOUND": "Unable to get Machine Actions.",
            "MICROSOFT_SECURITY_API_CREDENTIALS_MISSING": "Microsoft Security API data not found in database.",
            "MICROSOFT_SECURITY_API_NOT_ACTIVATED": "Microsoft Security API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "ONBOARDED_MACHINES_NOT_FOUND": "Unable to get Onboarded Machines.",
            "RECOMMENDATIONS_NOT_FOUND": "Unable to get Recommendations.",
            "REMEDIATION_NOT_FOUND": "Unable to get Remediation.",
            "SOFTWARE_NOT_FOUND": "Unable to get Software.",
            "TOKEN_NOT_FOUND": "Unable to get token.",
            "VULNERABILITIES_BY_MACHINE_AND_SOFTWARE_NOT_FOUND": "Unable to get VulnerabilitiesByMachineAndSoftware.",
            "VULNERABILITIES_NOT_FOUND": "Unable to get Vulnerabilities."
          },
          "Machines": {
            "Agent version": "Agent version",
            "Device value": "Device value",
            "Exposure level": "Exposure level",
            "First seen": "First seen",
            "Health status": "Health status",
            "Is Aad joined": "Is Aad joined",
            "Is excluded": "Is excluded",
            "Last external IP address": "Last external IP address",
            "Last IP address": "Last IP address",
            "Last seen": "Last seen",
            "Machine": "Machine | Machines",
            "Managed by": "Managed by",
            "Name": "Name",
            "OS architecture": "OS architecture",
            "OS Build": "OS Build",
            "OS platform": "OS platform",
            "Version": "Version"
          },
          "Recommendations": {
            "Active alert": "Active alert",
            "Category": "Category",
            "Config score impact": "Config score impact",
            "Exposed machine count": "Exposed machine count",
            "Exposure impact": "Exposure impact",
            "Has unpatchable CVE": "Has unpatchable CVE",
            "Name": "Name",
            "Product name": "Product name",
            "Public exploit": "Public exploit",
            "Recommendations": "Recommendation | Recommendations",
            "Recommended program": "Recommended program",
            "Recommended vendor": "Recommended vendor",
            "Recommended version": "Recommended version",
            "Related components": "Related components",
            "Remediation type": "Remediation type",
            "Severity score": "Severity score",
            "Total machine count": "Total machine count",
            "Vendor": "Vendor",
            "Weaknesses": "Weaknesses"
          },
          "Remediations": {
            "Category": "Category",
            "Completer email": "Completer email",
            "Created on": "Created on",
            "Description": "Description",
            "Fixed devices": "Fixed devices",
            "Last modified on": "Last modified on",
            "Priority": "Priority",
            "Recommendation name": "Recommendation name",
            "Remediations": "Remediation | Remediations",
            "Requester email": "Requester email",
            "Requester notes": "Requester notes",
            "Software name": "Software name",
            "Software vendor": "Software vendor",
            "Target devices": "Target devices",
            "Title": "Title",
            "Type": "Type"
          },
          "Software": {
            "Active alert": "Active alert",
            "Exposed machines": "Exposed machines",
            "Impact score": "Impact score",
            "Installed machines": "Installed machines",
            "Name": "Name",
            "Public exploit": "Public exploit",
            "Recommendation": "Recommendation",
            "Software": "Software",
            "Vendor": "Vendor",
            "Weaknesses": "Weaknesses"
          },
          "Vulnerabilities": {
            "cvssV3": "cvssV3",
            "Description": "Description",
            "Exploit verified": "Exploit verified",
            "Exposed machines": "Exposed machines",
            "Name": "Name",
            "Public exploit": "Public exploit",
            "Published on": "Published on",
            "Severity": "Severity",
            "Updated on": "Updated on",
            "Vulnerabilities": "Vulnerability | Vulnerabilities"
          },
          "Vulnerabilities by machine and software": {
            "cvssV3": "cvssV3",
            "Description": "Description",
            "Exploit verified": "Exploit verified",
            "Exposed machines": "Exposed machines",
            "Machine name": "Machine name",
            "Name": "Name",
            "OS platform": "OS platform",
            "Public exploit": "Public exploit",
            "Published on": "Published on",
            "Recommendation name": "Recommendation name",
            "Severity": "Severity",
            "Software name": "Software name",
            "Software vendor": "Software vendor",
            "Updated on": "Updated on",
            "Vulnerabilities by machine and software": "Vulnerabilities by machine and software"
          }
        },
        "Nothing to show": "Nothing to show, please select at least one asset type and one customer from the selectboxes | Nothing to show, please select at least one asset type from the selectbox | Nothing to show, please select at least one customer from the selectbox",
        "Overview": "Customer assets overview",
        "Reload assets": "Reload assets",
        "Reload complete": "All customers and assets data has been reloaded",
        "Reload complete title": "Finished reloading assets",
        "Show history": "Show history",
        "Tables and diagrams": "Tables and diagrams",
        "Tables only": "Tables only",
        "TransIP": {
          "Availability zone": "Availability zone",
          "Block storage backups": "Block storage backups",
          "Block storage description": "Block storage description",
          "Block storage name": "Block storage name",
          "Block storages": "Block storages",
          "Calculations": {
            "Block Storage Backups": {
              "Block Storage Backups": "Block Storage Backups",
              "Total Backups Per Date": "Total Block Storage Backups Per Date",
              "Total Unique Block Storage Backups Per Date": "Total Unique Block Storage Backups Per Date"
            },
            "Block Storages": {
              "Block Storages": "Block Storages",
              "Total Block Storages Statuses": "Total Block Storages Statuses"
            },
            "Virtual Machine Backups": {
              "Total Backups Per Date": "Total Virtual Machine Backups Per Date",
              "Total Protection Status": "Backup status per virtual machine",
              "Total Unique VMBackups Per Date": "Total Unique Virtual Machine Backups Per Date",
              "Virtual Machine Backups": "Virtual Machine Backups"
            },
            "Virtual Machines": {
              "Total Operating Systems": "Total Operating Systems",
              "Total Virtual Machine Statuses": "Total Virtual Machine Statuses",
              "Total Virtual Machine Types": "Total Virtual Machine Types",
              "Virtual Machines": "Virtual Machines"
            }
          },
          "CPUs": "CPUs",
          "Created at": "Created at",
          "Current snaphots": "Current snaphots",
          "Description": "Description",
          "Disk size": "Disk size",
          "Errors": {
            "BLOCK_STORAGE_BACKUPS_NOT_FOUND": "Unable to get Backups from Block Storage.",
            "BLOCK_STORAGES_NOT_FOUND": "Unable to get Block Storages.",
            "KEY_SIGNATURE_INVALID": "Not able to decode signature.",
            "TOKEN_NOT_FOUND": "Unable to get token.",
            "TRANSIP_API_CREDENTIALS_MISSING": "TransIP API data not found in database and shared TransIP is not used.",
            "TRANSIP_API_NOT_ACTIVATED": "TransIP API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "VIRTUAL_MACHINE_BACKUPS_NOT_FOUND": "Unable to get Backups from Virtual Machine.",
            "VIRTUAL_MACHINES_NOT_FOUND": "Unable to get Virtual Machines."
          },
          "IP address": "IP address",
          "Is blocked": "Is blocked",
          "Is customer locked": "Is customer locked",
          "Is locked": "Is locked",
          "MAC address": "MAC address",
          "Max snapshots": "Max snapshots",
          "Memory size": "Memory size",
          "Name": "Name",
          "Offsite backups": "Offsite backups",
          "Operating system": "Operating system",
          "Product name": "Product name",
          "Serial": "Serial",
          "Status": "Status",
          "Virtual machine description": "Virtual machine description",
          "Virtual machine name": "Virtual machine name",
          "Virtual machines": "Virtual machines",
          "Virtual machines backups": "Virtual machine backups"
        },
        "Veeam": {
          "Calculations": {
            "Backup Items": "Backup Items",
            "Backup Items Per Date": {
              "Backup Items Per Date": "Backup Items Per Date",
              "Total Mailbox Items Per Date": "Total Mailbox Items Per Date",
              "Total One Drive Items Per Date": "Total One Drive Items Per Date",
              "Total Site Items Per Date": "Total Site Items Per Date",
              "Total Team Items Per Date": "Total Team Items Per Date"
            },
            "Job Sessions Backup Status Per Job": {
              "Job Sessions Backup Status Per Job": "Job Sessions Backup Status Per Job"
            },
            "Job Sessions Total Backup Status": "Job Sessions Total Backup Status",
            "Jobs": "Jobs",
            "Licensed Users": "Licensed Users",
            "Storage Usage": {
              "Storage Usage": "Storage Usage",
              "Total Usage Per Drive Letter": "Total Usage Per Drive Letter",
              "Total Usage Per Repository": "Total Usage Per Repository"
            }
          },
          "Errors": {
            "BACKUP_REPOSITORY_NOT_FOUND": "Unable to get Backup Repository.",
            "JOB_SESSIONS_NOT_FOUND": "Unable to get Job Sessions.",
            "JOBS_NOT_FOUND": "Unable to get Jobs.",
            "LICENSED_USERS_NOT_FOUND": "Unable to get Licensed Users.",
            "LICENSING_INFORMATION_NOT_FOUND": "Unable to get Licensing Information.",
            "MAILBOX_DATA_NOT_FOUND": "Unable to get Mailbox Data.",
            "ONEDRIVE_DATA_NOT_FOUND": "Unable to get OneDrive Data.",
            "ORGANIZATION_GROUPS_NOT_FOUND": "Unable to get Organization Groups.",
            "ORGANIZATION_SITES_NOT_FOUND": "Unable to get Organization Sites.",
            "ORGANIZATION_TEAMS_NOT_FOUND": "Unable to get Organization Teams.",
            "ORGANIZATION_USERS_NOT_FOUND": "Unable to get Organization Users.",
            "ORGANIZATION_WITH_TENANT_URL_NOT_FOUND": "No organization found with Microsoft Azure tenant URL. Go to the API credentials tab to fill in the correct tenant URL.",
            "ORGANIZATIONS_NOT_FOUND": "Unable to get Organizations.",
            "PROCESSED_OBJECTS_NOT_FOUND": "Unable to get Processed Objects.",
            "SITE_DATA_NOT_FOUND": "Unable to get Site Data.",
            "TEAM_DATA_NOT_FOUND": "Unable to get Team Data.",
            "TOKEN_NOT_FOUND": "Unable to get the API token. Make sure that the API credentials are correct.",
            "USED_REPOSITORIES_NOT_FOUND": "Unable to get Used Repositories.",
            "VEEAM_API_NOT_ACTIVATED": "Veeam API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials.",
            "VEEAM_TENANT_URL_MISSING": "Veeam Microsoft Azure tenant URL not found in database for this customer. Go to the API credentials tab to fill in the correct tenant URL."
          },
          "Jobs": {
            "Backup type": "Backup type",
            "Backup window enabled": "Backup window enabled",
            "Enabled": "Enabled",
            "Job": "Job | Jobs | Job {job}",
            "Job sessions": {
              "Creation time": "Creation time",
              "Details": "Details",
              "End time": "End time",
              "Job session": "Job session | Job sessions",
              "Job type": "Job type",
              "Processed objects": {
                "Display name": "Display name",
                "Name": "Name",
                "Processed objects": "Processed objects",
                "Status": "Status",
                "Type": "Type"
              },
              "Processing rate bytes": "Processing rate bytes",
              "Processing rate items": "Processing rate items",
              "Progress": "Progress",
              "Read rate bytes": "Read rate bytes",
              "Retry count": "Retry count",
              "Retry job": "Retry job",
              "Status": "Status",
              "Transferred data bytes": "Transferred data bytes",
              "Write rate bytes": "Write rate bytes"
            },
            "Mailbox data": {
              "Archive": "Archive",
              "Backup time": "Backup time",
              "Deleted": "Deleted",
              "Display name": "Display name",
              "Email": "Email",
              "Mailbox data": "Mailbox Data",
              "Type": "Type"
            },
            "Name": "Name | Job name",
            "Next run": "Next run",
            "One drive data": {
              "Backup time": "Backup time",
              "Deleted": "Deleted",
              "One drive data": "OneDrive Data",
              "Title": "Title",
              "Type": "Type"
            },
            "Periodically windows enabled": "Periodically windows enabled",
            "Policy daily time": "Policy daily time",
            "Policy daily type": "Policy daily type",
            "Policy type": "Policy type",
            "Repository daily retention type": "Repository daily retention type",
            "Repository daily time": "Repository daily time",
            "Repository daily type": "Repository daily type",
            "Repository free space (bytes)": "Repository free space (bytes)",
            "Repository frequency type": "Repository frequency type",
            "Repository monthly retention type": "Repository monthly retention type",
            "Repository name": "Repository name",
            "Repository out of sync": "Repository out of sync",
            "Repository path": "Repository path",
            "Repository retention period": "Repository retention period",
            "Repository retention type": "Repository retention type",
            "Repository yearly retention type": "Repository yearly retention type",
            "Retry enabled": "Retry enabled",
            "Retry interval": "Retry interval",
            "Retry number": "Retry number",
            "Schedule enabled": "Schedule enabled",
            "Site data": {
              "Backup time": "Backup time",
              "Deleted": "Deleted",
              "Site data": "Site Data",
              "Title": "Title",
              "Type": "Type",
              "Url": "Url"
            },
            "Storage details": "Storage details",
            "Storage used space (bytes)": "Storage used space (bytes)",
            "Teams data": {
              "Backup time": "Backup time",
              "Deleted": "Deleted",
              "Display name": "Display name",
              "Teams data": "Teams Data",
              "Type": "Type"
            }
          },
          "Licensed users": {
            "Backed up": "Backed up",
            "Last backup": "Last backup",
            "License state": "License state",
            "Licensed users": "Licensed Users",
            "Name": "Name"
          },
          "Licensing Information": {
            "Licensed users": "Licensed Users",
            "Licensing Information": "Licensing Information",
            "New users": "New users"
          },
          "Organization": {
            "Exchange": "Exchange",
            "Exchange account": "Exchange account",
            "Exchange application ID": "Exchange application ID",
            "Name": "Name",
            "Office name": "Office name",
            "Organization": "Organization",
            "Region": "Region",
            "SharePoint": "SharePoint",
            "SharePoint account": "SharePoint account",
            "SharePoint application ID": "SharePoint application ID",
            "Teams": "Teams",
            "Teams chat": "Teams chat",
            "Type": "Type"
          }
        },
        "View type": "View type",
        "VPN": {
          "Assigned to": "Assigned to",
          "Calculations": {
            "Certificates": "Certificates",
            "Total Certificates": "Total Certificates",
            "Total Devices": "Total Devices",
            "Total Managed Devices": "Total Managed Devices",
            "Total Other Devices": "Total Other Devices",
            "Total Phones": "Total Phones",
            "Total Routers": "Total Routers",
            "Total Tablets": "Total Tablets"
          },
          "Certificates": "Certificates",
          "Comments": "Comments",
          "Created at": "Created at",
          "Errors": {
            "CERTIFICATES_NOT_FOUND": "No VPN certificates found.",
            "TOKEN_NOT_FOUND": "Unable to get the API token. Make sure that the API credentials are correct.",
            "VPN_API_CREDENTIALS_MISSING": "Shared VPN is not active, but VPN API credentials are not found in the database for this customer. Go to the API credentials tab to fill in the API credentials.",
            "VPN_API_NOT_ACTIVATED": "VPN API is not active for this customer. Go to the API credentials tab to activate the API and fill in the API credentials."
          },
          "External IP": "External IP",
          "Iroute": "Internal route(s)",
          "Last seen": "Last seen",
          "Name": "Name",
          "Status": "Status",
          "VPN IP": "VPN IP"
        }
      },
      "Assets reloading": "Assets reloading",
      "BankCity": "Bank city",
      "Banking": "Bank details",
      "BankName": "Bank name",
      "BIC": "Bank Identifier Code (BIC)",
      "Birthday": "Birthday",
      "BlockStorageDescription": "Block Storage Description",
      "BlockStorageName": "Block Storage Name",
      "City": "City",
      "ClientAppUsed": "Client App Used",
      "ClientSecret": "Client Secret",
      "CocNumber": "Chamber of Commerce number",
      "Comments": "Comments",
      "Contact information": "@:Admin.Contacts.Contact @.lower:Shared.Globals.Information",
      "Contact person": "Contact person",
      "ContactInfo": "Contact information",
      "Country": "Country",
      "CountryOrRegion": "Country or Region",
      "Custom address": "Custom address",
      "Customer": "Customer",
      "Customer information": "@:Admin.Customers.Customer @.lower:Shared.Globals.Information",
      "CustomerId": "Customer ID",
      "CustomerName": "Customer name",
      "DefaultContract": "Default contract",
      "Delete": "delete",
      "Delete item": "Delete customer",
      "Delete item fail": "Error deleting the customer. {msg}",
      "Delete item success": "Successfully deleted customer.",
      "Delete item text": "Are you sure you want to {1} the customer {0}?",
      "DirectDebitMandate": "Mandate ID",
      "DirectDebitMandateSignatureDate": "Mandate signature date",
      "Edit": "Edit @.lower:{item}",
      "Edit contact": "Edit @.lower:{contact} information",
      "Edit item": "Edit customer ({name}) | Edit customer",
      "Errors": {
        "CUSTOMER_ARCHIVE_INVOICING_SYNC_FAILED": "The linked relationship could not be made inactive in SnelStart. The customer has not been archived. Please try again later."
      },
      "Edit item fail": "Error editing the customer. {msg}",
      "Edit item success": "Successfully changed customer.",
      "EmailAddress": "Email address",
      "Error loading data": "The list of customers could not be loaded due to an error.",
      "Export": "Export",
      "FirstName": "First name",
      "HasInvoices": "Has invoices",
      "HetznerAPI": {
        "HetznerInUse": "Hetzner API"
      },
      "HetznerInUse": "Hetzner API",
      "Host": "Host",
      "HostFactCustomerId": "HostFact Customer ID",
      "IBAN": "Account number",
      "Initials": "Initials",
      "Invoice contact information": "@:Admin.Customers.InvoiceContact",
      "Invoice information": "@:Admin.Invoices.Invoice @.lower:Shared.Globals.Information",
      "InvoiceContact": "Invoice contact",
      "InvoiceEmailAddress": "Invoice email address",
      "IsActive": "Active customer",
      "IsArchived": "Archived",
      "Labels": "Labels",
      "LastName": "Last name",
      "LegalForm": "Legal Form",
      "LegalFormOptions": {
        "Bv": "BV",
        "Coop": "Cooperation",
        "Cv": "CV",
        "Eenmanszaak": "Loner",
        "Nv": "NV",
        "Other": "Other",
        "Stichting": "Foundation",
        "Vereniging": "Association",
        "Vof": "VoF"
      },
      "Machine": {
        "computerDnsName": "Computer name"
      },
      "MicrosoftAzureAPI": {
        "MicrosoftAzureInUse": "Microsoft Azure API"
      },
      "MicrosoftAzureInUse": "Microsoft Azure API",
      "MicrosoftGraphAPI": {
        "MicrosoftGraphInUse": "Microsoft Graph API"
      },
      "MicrosoftGraphInUse": "Microsoft Graph API",
      "MicrosoftSecurityAPI": {
        "MicrosoftSecurityInUse": "Microsoft Security API"
      },
      "MicrosoftSecurityInUse": "Microsoft Security API",
      "Name": "Name | Customer name",
      "New item": "New customer",
      "New item fail": "Error creating customer. {msg}",
      "New item success": "Successfully created customer.",
      "No labels": "No labels",
      "Offer contact information": "@:Admin.Customers.OfferContact",
      "Offer information": "@:Admin.Customer-offers.Offer @.lower:Shared.Globals.Information",
      "OfferContact": "Offer contact",
      "OfferEmailAddress": "Offer email address",
      "OperatingSystem": "Operating System",
      "PayByDirectDebit": "Payment by direct debit",
      "Phone": "Phone number",
      "Primary contact information": "@:Admin.Customers.PrimaryContact",
      "PrimaryContact": "Primary contact",
      "PrimaryContactOld": "Primary contact",
      "Refresh list": "Refresh list",
      "Reload assets item success": "Assets reloaded successfully.",
      "Salutation": "Salutation",
      "SecondaryContacts": "Secondary contacts",
      "Secret": "Secret",
      "Severity": "Severity",
      "SharedHetzner": "Shared Hetzner",
      "SharedTransIP": "Shared TransIP",
      "SharedVPN": "Shared VPN",
      "State": "State",
      "Tabs": {
        "API Credentials": "API Credentials",
        "Assets": "Assets",
        "Contacts": "Contacts",
        "Contracts": "Contracts",
        "Financial": "Financial",
        "General": "General",
        "Invoices": "Invoices",
        "Settings": "Settings",
        "Services": {
          "Domains": "Domains",
          "Hosting accounts": "Hosting accounts",
          "Services": "Services",
          "SSL certificates": "SSL certificates"
        },
        "Subscriptions": "Subscriptions",
        "Users": "Users"
      },
      "TaxNumber": "Tax number",
      "Tenant": "Tenant",
      "TransIPAPI": {
        "TransIPInUse": "TransIP API"
      },
      "TransIPInUse": "TransIP API",
      "User": "User",
      "UserPrincipalName": "User Principal Name",
      "Users": {
        "No users": "There are no users to show for this customer"
      },
      "VeeamInUse": "Veeam API",
      "VeeamMicrosoftAzureTenantURL": "Tenant URL",
      "View invoices": "View invoices",
      "VirtualMachineDescription": "Virtual Machine Description",
      "VirtualMachineName": "Virtual Machine Name",
      "VPNAPI": {
        "VPNInUse": "OMNI VPN API"
      },
      "VPNInUse": "OMNI VPN API",
      "Website": "Website",
      "Zipcode": "Zipcode"
    },
    "Domain-ns-groups": {
      "Add NameServers item": "Add nameserver",
      "Alias": "Alias",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete nameserver group",
      "Delete item fail": "Failed to delete nameserver group. {msg}",
      "Delete item success": "Successfully deleted nameserver group.",
      "Delete item text": "Are you sure you want to {1} the nameserver group {0}?",
      "Delete NameServers item": "Delete nameserver",
      "Domain-ns-group": "Nameserver group",
      "Edit item": "Edit nameserver group",
      "Edit item fail": "Error editing the nameserver group. {msg}",
      "Edit item success": "Successfully edited nameserver group.",
      "Errors": {
        "default": "Something went wrong processing the nameserver group request. {msg}",
        "ErrorCode": {
          "default": "Something went wrong processing the nameserver group request. {msg}",
          "NAMESERVERS_NOT_UNIQUE": "Nameservers are not unique.",
          "OXXA_API_BAD_STATUS_CODE": "Unable to connect to domain supplier.",
          "OXXA_API_NO_CHANGES": "The contact was not changed.",
          "OXXA_API_NO_HANDLE_FOUND": "No ID found at the supplier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "No data found to delete.",
          "OXXA_API_REQUEST_FAILED": "Unable to connect to domain supplier.",
          "OXXA_API_RESULT_DIFF": "The contact was partially saved, please verify the result.",
          "OXXA_API_RESULT_NOT_FOUND": "No results found for NS group.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "The field '@.lower:{key}' is not unique."
        }
      },
      "isAttached": "Attached to domain?",
      "isPublic": "Public nameserver?",
      "Nameservers": "Nameservers",
      "NameServers": "Nameserver",
      "NameServers 1": "Nameserver 1",
      "NameServers 2": "Nameserver 2",
      "NameServers 3": "Nameserver 3",
      "NameServers 4": "Nameserver 4",
      "NameServers 5": "Nameserver 5",
      "NameServers 6": "Nameserver 6",
      "New item": "New nameserver group",
      "New item fail": "Failed to create new nameserver group. {msg}",
      "New item success": "Successfully created new nameserver group.",
      "No customer": "No customer"
    },
    "Dmarc": {
      "AggregateAuthorizationRecord": "Aggregate authorization record",
      "AggregateReportEmail": "Aggregate report address",
      "AggregateReportDomainDns": "Aggregate report domain DNS",
      "AggregateReports": "Aggregate reports",
      "AggregateReportsEnabled": "Aggregate reports",
      "AggregateAndFailureAuthorizationRecord": "Aggregate and failure authorization record",
      "AlignmentOptions": {
        "r": "Relaxed",
        "s": "Strict"
      },
      "Alignment": "Alignment",
      "AlignmentRate": "Alignment rate",
      "AuthFailure": "Authentication failure",
      "AuthorizationRecordValue": "Authorization record value",
      "Count": "Count",
      "CurrentRecord": "Current DNS record",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete DMARC domain",
      "Delete item fail": "Error deleting DMARC domain. {msg}",
      "Delete item success": "Successfully deleted DMARC domain.",
      "Delete item text": "Are you sure you want to {1} the DMARC domain {0}?",
      "Dkim": "DKIM",
      "DkimAlignment": "DKIM alignment",
      "Dmarc": "DMARC",
      "Dns": "DNS",
      "DnsDiffers": "Differs",
      "DnsMatches": "Matches",
      "DnsMissing": "Not found",
      "Domain": "Domain",
      "DomainRecord": "Domain DMARC record",
      "DomainRecordTarget": "Add this TXT record on the customer domain: {domain}",
      "Domains": "Domains",
      "Disposition": "Disposition",
      "EnvelopeFrom": "Envelope from",
      "Edit item": "Edit DMARC domain",
      "Edit item fail": "Error editing DMARC domain. {msg}",
      "Edit item success": "DMARC domain successfully updated.",
      "Error in fields": "Check the DMARC fields.",
      "FailureAuthorizationRecord": "Failure authorization record",
      "FailureReportEmail": "Failure report address",
      "FailureReportDomainDns": "Failure report domain DNS",
      "FailureReportOptions": {
        "0": "All mechanisms fail",
        "1": "Any failure",
        "d": "DKIM failure",
        "s": "SPF failure"
      },
      "FailureReportOptionsLabel": "Failure mode",
      "FailureReports": "Failure reports",
      "FailureReportsEnabled": "Failure reports",
      "FromDate": "From",
      "HeaderFrom": "Header from",
      "IdentityAlignment": "Identity alignment",
      "Inherit": "Inherit",
      "InheritWithValue": "Inherit ({value})",
      "InvalidEmail": "Enter a valid email address.",
      "InvalidReportDestination": "Select one of the configured DMARC report destinations.",
      "ManagedDomains": "Managed domains",
      "New item": "New DMARC domain",
      "New item fail": "Error creating DMARC domain. {msg}",
      "New item success": "DMARC domain successfully created.",
      "NonexistentSubdomainPolicy": "Non-existent subdomain policy",
      "Notes": "Notes",
      "OriginalMailFrom": "Original mail from",
      "Policy": "Policy",
      "PolicyOptions": {
        "none": "None",
        "quarantine": "Quarantine",
        "reject": "Reject"
      },
      "ProcessMailbox": "Process mailbox",
      "ProcessMailboxResult": "Processed: {processed}, created: {created}, duplicates: {duplicates}, skipped: {skipped}",
      "ProcessedAt": "Processed at",
      "RawReport": "Raw DMARC report",
      "RawReportUnavailable": "The raw report is not stored for this report.",
      "RecordName": "Record name",
      "RecordValue": "Record value",
      "Records": "Records",
      "ReportAuthorizationRecords": "External report authorization",
      "ReportAuthorizationRecordsText": "External DMARC reporting needs an authorization record on the reporting domain.",
      "ReportAuthorizationTarget": "Add this TXT record on the OMNI reporting domain: {domain}",
      "ReportDate": "Report date",
      "ReportDestinationDisabled": "Do not use",
      "Reporter": "Reporter",
      "Reporters": "Reporters",
      "Reporting": "Reporting",
      "SmtpMailFrom": "SMTP mail from",
      "SourceHost": "Source host",
      "SourceIp": "Source IP",
      "SourceIps": "Source IPs",
      "Spf": "SPF",
      "SpfAlignment": "SPF alignment",
      "SubdomainPolicy": "Subdomain policy",
      "TargetDomainDns": "Target domain DNS",
      "Testing": "Testing mode",
      "TotalMessages": "Messages",
      "TotalReports": "Reports",
      "UntilDate": "Until",
      "ViewRawReport": "View raw report"
    },
    "Dmarc-aggregate-reports": {
      "Disposition": "Disposition",
      "Dkim": "DKIM",
      "Domain": "Domain",
      "EnvelopeFrom": "Envelope from",
      "HeaderFrom": "Header from",
      "OrgName": "Reporter",
      "SourceIp": "Source IP",
      "Spf": "SPF"
    },
    "Dmarc-failure-reports": {
      "Domain": "Domain",
      "HeaderFrom": "Header from",
      "SmtpMailFrom": "SMTP mail from",
      "SourceHost": "Source host",
      "SourceIp": "Source IP"
    },
    "Domains": {
      "Add DNSSEC item": "Add DNSSEC line",
      "Add Nameservers item": "Add nameserver",
      "AdministrativeContact": "Administrative contact",
      "Alg": "Algorithm",
      "All customers": "All customers",
      "Auto renew disabled": "Automatic renewal of the domain is disabled for this domain",
      "AutoRenew": "Automatic renewal",
      "AutoRenewdisabled": "Auto renew is disabled for this domain",
      "BillingContact": "Billing contact",
      "Check domain": "Check domain",
      "Check domain availability": "Check domain availability",
      "Confirm domain force delete text": "Are you sure you want to delete the domain {0}? The domain will be quarantined and there will be a fee to reverse this.",
      "Confirm domain force delete title": "Delete domain",
      "Confirm domain restore text": "Are you sure you want to restore the domain {0}? There is a fee to remove the domain from quarantine.",
      "Confirm domain restore title": "Restore domain",
      "Copy transfercode": "Click to copy the transfercode",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete DNSSEC item": "Delete DNSSEC item",
      "Delete domain status not error item success": "Auto renew is turned off, domain {name} will be removed after the expire date",
      "Delete item": "Delete domain",
      "Delete item fail": "Error deleting the domain. {msg}",
      "Delete item success": "Successfully deleted the domain.",
      "Delete item text": "Are you sure you want to {1} the domain {0}?",
      "Delete Nameservers item": "Delete nameserver",
      "DNSSEC": "DNSSEC",
      "Dnssec item": "DNSSEC",
      "DNSSECInfo": "Use the form below to configure DNSSEC records. Note that when a record is modified it will be deleted and recreated, make sure to carefully check the results!",
      "Domain": "Domain",
      "Domain has no DNS Sec": "This domain doesn’t have any DNSSEC records configured",
      "Domain in quarantaine": "Domain is in quarantaine",
      "Domain not linked": "Domain is not linked to this hosting account in cPanel",
      "DomainNSGroup": "Domain Nameservers Group",
      "DomainStatus": "Domain status",
      "DomainStatusOptions": {
        "Error": "Error",
        "Quarantine": "Quarantine",
        "Registered": "Registered",
        "Transfer pending": "Pending",
        "Transferred": "Transferred",
        "Unknown": "Unknown"
      },
      "Edit domain DNSSEC item fail": "Error editing the domain DNSSEC settings. {msg}",
      "Edit domain DNSSEC item success": "Successfully changed domain DNSSEC settings.",
      "Edit item": "Edit domain",
      "Edit item fail": "Error editing the domain. {msg}",
      "Edit item success": "Successfully changed domain.",
      "Errors": {
        "default": "Error while processing the domain request. {msg}",
        "ErrorCode": {
          "DOMAINS_CHECK_REQUIRED_FIELDS_MISSING": "Required fields are missing.",
          "OXXA_API_BAD_STATUS_CODE": "Unable to connect to domain supplier.",
          "OXXA_API_DISABLED": "Oxxa API is not enabled.",
          "OXXA_API_NO_CHANGES": "The contact was not changed.",
          "OXXA_API_NO_HANDLE_FOUND": "No ID found at the supplier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "No data found to delete.",
          "OXXA_API_REQUEST_FAILED": "Unable to connect to domain supplier.",
          "OXXA_API_RESULT_DIFF": "The contact was partially saved, please verify the result.",
          "OXXA_API_RESULT_NOT_FOUND": "No results found for NS group.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "The field '@.lower:{key}' is not unique."
        }
      },
      "ExpireDate": "Expire date",
      "Flags": "Flag",
      "Force remove domain": "Forcefully remove domain",
      "Force remove domain item fail": "Domain could not be forcefully removed. {msg}",
      "Force remove domain item success": "Successfully forcefully removed domain.",
      "FullDomain": "Full domain result",
      "Hostname": "Hostname",
      "IPv4": "IPv4",
      "IPv6": "IPv6",
      "LastRenewDate": "Last renew date",
      "Lock": "Lock",
      "Lock domain item success": "Successfully locked domain.",
      "Lock item": "Lock domain",
      "Manage DNSSEC": "Manage DNSSEC",
      "Nameservers": "Nameservers",
      "New item": "New domain",
      "New item fail": "Error creating domain. {msg}",
      "New item success": "Successfully created domain.",
      "No customer attached": "No customer attached",
      "NoticeDate": "Notice date",
      "Only one DNSSEC record configured": "Only one DNSSEC record configured",
      "OwnerContact": "Owner contact",
      "Protocol": "Protocol",
      "PubKey": "Public key",
      "QuarantaineEnd": "Quarantaine end",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "Restore domain": "Restore domain",
      "Restore domain item fail": "Domain could not be restored. {msg}",
      "Restore domain item success": "Successfully restored domain.",
      "Retrieve transfercode": "If you want to transfer the domain, retrieve the transfer code here",
      "Send EPP item fail": "Could not send transfercode.",
      "Send EPP item success": "Successfully sent transfercode.",
      "Send transfercode": "Send",
      "Show transfercode": "Show",
      "Show transfercode item": "Transfercode",
      "StartDate": "Start date",
      "Subscription": "Subscription",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Customer"
        }
      },
      "Tabs": {
        "Contacts": "Contacts",
        "General": "General",
        "Name servers": "@:Admin.Domains.Nameservers"
      },
      "TechnicalContact": "Technical contact",
      "Tld": "Top level domain",
      "TransferCode": "Transfer code",
      "Unlock domain item success": "Successfully unlocked domain.",
      "Unlock item": "Unlock domain",
      "Webhosting": "Webhosting"
    },
    "Email-logs": {
      "Attachments": "Attachments",
      "Bcc": "BCC",
      "BelongsTo": "Belongs to",
      "Cc": "CC",
      "Content": "Message content",
      "CreatedAt": "Created at",
      "Customer": "Customer",
      "Error loading data": "The list of email logs could not be loaded due to an error.",
      "From": "From",
      "MailSent": "Sent",
      "MailSentAt": "Sent at",
      "New item": "New email",
      "ReplyTo": "Reply to",
      "Subject": "Subject",
      "To": "To",
      "ToOptions": {
        "NoBcc": "No 'bcc' address",
        "NoCc": "No 'cc' address",
        "NoFrom": "No 'from' address",
        "NoReplyTo": "No 'reply to' address",
        "NoTo": "No 'to' address"
      },
      "VendorResponse": "Vendor response",
      "View item": "Email log details"
    },
    "Email-message-templates": {
      "Delete": "delete",
      "Delete item": "Delete message template",
      "Delete item text": "Are you sure you want to {1} message template {0}? Existing mailings will be retained.",
      "Delete item success": "Message template deleted.",
      "Delete item fail": "@:Admin.EmailMessageTemplates.DeleteError",
      "Name": "@:Admin.EmailMessageTemplates.Name",
      "Category": "@:Admin.EmailMessageTemplates.Category",
      "Subject": "@:Admin.EmailMessageTemplates.Subject",
      "Content": "@:Admin.EmailMessageTemplates.Content"
    },
    "EmailMessageTemplates": {
      "Title": "Message templates",
      "Subtitle": "Choose and manage reusable messages.",
      "Library": "Available templates",
      "Search": "Search by name or subject",
      "Category": "Category",
      "Categories": {
        "incident": "Incident",
        "newsletter": "Newsletter",
        "update": "Update",
        "other": "Other"
      },
      "New": "New template",
      "SaveCurrent": "Save current message",
      "Name": "Name",
      "Subject": "Subject (optional)",
      "Content": "Message",
      "SubjectHelp": "An empty subject keeps the email subject.",
      "VariablesHelp": "Use the existing variables in the editor. Check the personalized result in the email preview.",
      "PreviewHelp": "Variables are not resolved when applying a template. Check the email preview with the selected recipients afterwards.",
      "SelectHelp": "Choose a template to view its content or create a new template.",
      "NoSubject": "Keep the email subject",
      "Empty": "No message templates found.",
      "Edit": "Edit",
      "Delete": "Delete",
      "Save": "Save",
      "Use": "Use template",
      "Saved": "Message template saved.",
      "LoadError": "The message templates could not be loaded. Please try again.",
      "SaveError": "The message template could not be saved. Check the input and try again.",
      "DeleteError": "The message template could not be deleted.",
      "ReplaceTitle": "Replace message",
      "ReplaceConfirm": "The current message and subject (if the template has a subject) will be replaced. Continue?",
      "UnsavedTitle": "Unsaved changes",
      "UnsavedConfirm": "Changes to this template have not been saved. Discard changes?",
      "Required": "Complete this field."
    },
    "Email-queue": {
      "An error occurred while loading the template": "An error occurred while loading the template.",
      "Approve": "Approve",
      "Approved": "Approved",
      "Attachments": "Attachments",
      "Attachments too big": "Attachments too large, exceeding the total allowed maximum of 10 MB.",
      "Attempts": "Attempts",
      "Bulk approve confirm": "Approve {selected} email | Approve {selected} emails",
      "Bulk approve confirm text": "Are you sure you want to approve {selected} email from the queue? | Are you sure you want to approve {selected} emails from the queue?",
      "Bulk approve fail": "Error approving {fail} email from the queue. | Error approving {fail} emails from the queue.",
      "Bulk approve mixed result": "{success} email successfully approved from the queue, {fail} failed. | {success} emails successfully approved from the queue, {fail} failed.",
      "Bulk approve success": "Successfully approved {succes} email from the queue. | Successfully approved {success} emails from the queue.",
      "Bulk remove confirm": "Remove {selected} email | Remove {selected} emails",
      "Bulk remove confirm text": "Are you sure you want to remove {selected} email from the queue? | Are you sure you want to remove {selected} emails from the queue?",
      "Bulk remove fail": "Error removing {fail} email from the queue. | Error removing {fail} emails from the queue.",
      "Bulk remove mixed result": "{success} email successfully removed from the queue, {fail} failed. | {success} emails successfully removed from the queue, {fail} failed.",
      "Bulk remove success": "Successfully removed {succes} email from the queue. | Successfully removed {success} emails from the queue.",
      "Bulk requeue confirm": "Requeue {selected} email | Requeue {selected} emails",
      "Bulk requeue confirm text": "Are you sure you want to requeue {selected} email? | Are you sure you want to requeue {selected} emails?",
      "Bulk requeue fail": "Error requeueing {fail} email. | Error requeueing {fail} emails.",
      "Bulk requeue mixed result": "{success} email successfully requeued, {fail} failed. | {success} emails successfully requeued, {fail} failed.",
      "Bulk requeue success": "Successfully requeued {succes} email. | Successfully requeued {success} emails.",
      "Choose send time": "Choose send time",
      "Confirm item": "Confirm email",
      "Confirm item fail": "Error while sending.",
      "Confirm item success": "Email successfully added to the queue.",
      "Contact vars only works when one item is selected": "The merge tags <strong>contact.</strong> work as soon as at least one contact is selected.",
      "Contacts": "Contact | Contacts",
      "Content": "Message",
      "Created at": "Created at",
      "Customer user": "Customer user",
      "Delete": "remove",
      "Delete item": "Remove email",
      "Delete item fail": "Error removing the email from the queue.",
      "Delete item success": "Successfully removed email from the queue.",
      "Delete item text": "Are you sure you want to {1} email with subject {0} from the queue?",
      "Delete selected": "Remove",
      "Delivery error": "Delivery error",
      "Description": "Description",
      "Email": "Email",
      "Error reason": "Error reason",
      "Errors": {
        "ErrorCode": {
          "INVALID_MESSAGE": "Message is invalid.",
          "INVALID_SUBJECT": "Subject is invalid."
        }
      },
      "Explain marketing purposes": "Emails with a marketing purpose are sent only to contacts who have explicitly opted in to receive marketing communications. These emails contain commercial or promotional content, such as offers, newsletters, or product updates. Emails without a marketing purpose must be strictly informational and may not include any commercial or promotional content. This communication is purely functional, such as service updates, important notifications, or administrative messages.",
      "Explain message variables": "You can use the merge tags below in your message and subject by placing them in double curly braces, like <strong>&#123;&#123;varName&#125;&#125;</strong>. This ensures that the merge tag is automatically replaced with the correct value.<br /><br />For example:<br />If you use <strong>&#123;&#123;currentUser.firstName&#125;&#125;</strong>, it will be replaced with the first name of your user account.<br /><br />{selectOneElement}<br /><br />Below you will find the available merge tags:",
      "From": "From",
      "General": "General",
      "Hide message vars": "Hide merge tags",
      "Marketing purposes": "Marketing purposes",
      "MessageVariableListContacts": {
        "contact.address": "Street name and house number of the selected contact.",
        "contact.birthday": "Birthday of the selected contact.",
        "contact.city": "City of the selected contact.",
        "contact.country": "Country of the selected contact.",
        "contact.customerInfo.address": "Street name and house number of the customer.",
        "contact.customerInfo.city": "City of the customer.",
        "contact.customerInfo.country": "Country of the customer.",
        "contact.customerInfo.customerId": "Unique customer ID of the selected contact.",
        "contact.customerInfo.name": "Name of the customer to whom the selected contact belongs.",
        "contact.customerInfo.zipcode": "Zip code of the customer.",
        "contact.emailAddress": "Email address of the selected contact.",
        "contact.firstName": "First name of the selected contact.",
        "contact.initials": "Initials of the selected contact.",
        "contact.lastName": "Last name of the selected contact.",
        "contact.overwriteAddress": "Indicates whether the address of the selected contact can be overwritten.",
        "contact.phone": "Phone number of the selected contact.",
        "contact.salutation": "Salutation of the selected contact.",
        "contact.sendMail": "Indicates whether the selected contact receives emails.",
        "contact.zipcode": "Zip code of the selected contact."
      },
      "MessageVariableListCurrentUser": {
        "currentUser.createdAt": "Date and time when the current user was created.",
        "currentUser.email": "Email address of the current user.",
        "currentUser.firstName": "First name of the current user.",
        "currentUser.fullName": "Full name of the current user.",
        "currentUser.lastLoginAt": "Date and time of the current user's last login.",
        "currentUser.lastName": "Last name of the current user.",
        "currentUser.locale": "Language settings of the current user.",
        "currentUser.regionalSettings": "Regional settings of the current user.",
        "currentUser.updatedAt": "Date and time when the current user's data was last updated."
      },
      "MessageVariableListUsers": {
        "user.createdAt": "Date and time when the user was created.",
        "user.email": "Email address of the selected user.",
        "user.firstName": "First name of the selected user.",
        "user.fullName": "Full name of the selected user.",
        "user.lastLoginAt": "Date and time of the user's last login.",
        "user.lastName": "Last name of the selected user.",
        "user.locale": "Language settings of the selected user.",
        "user.regionalSettings": "Regional settings of the selected user.",
        "user.updatedAt": "Date and time when the user's data was last updated."
      },
      "Name": "Name",
      "Name in footer": "Name in footer",
      "New item": "New email",
      "None": "None",
      "Now": "Now",
      "Overview": "Overview",
      "Preview": "Preview",
      "Queue": "Queue",
      "Requeue selected": "Requeue",
      "Schedule": "Schedule",
      "Select a template to load the preview": "Select a template to load the preview.",
      "Send": "Send",
      "Send error": "Send error",
      "Send on behalf of the current user": "Send on behalf of the current user",
      "Send on behalf of the organization": "Send on behalf of the organization",
      "Send time": "Send time",
      "SendAt": "Send email at",
      "Show message vars": "Show merge tags",
      "Subject": "Subject",
      "Template": "Template",
      "To": "To",
      "Total attachments": "Attachments",
      "Triggers": "Triggers",
      "User": "User",
      "User vars only works when one item is selected": "The merge tags <strong>user.</strong> work as soon as at least one user is selected.",
      "Users": "User | Users",
      "Variables": "Merge Tags",
      "View item": "View email",
      "MailingHistory": "Mailing history",
      "MailingLoadError": "The original mailing could not be loaded. It may have been deleted or you may not have permission.",
      "RecipientFilters": {
        "customers": "Customer",
        "services": "Service",
        "customerLabels": "Customer label",
        "contactLabels": "Contact label"
      },
      "RecipientPickerTitle": "Recipients",
      "UniqueEmailAddresses": "Unique email addresses",
      "RecipientSearch": "Search contacts",
      "RecipientSearchPlaceholder": "Name, email address, customer, service or label",
      "RecipientFilterButton": "Filters",
      "ClearRecipientFilters": "Clear filters",
      "FilteredRecipientSelection": "{selected} of {total} visible contacts selected",
      "PersonalisationContext": "Contact details for {email}",
      "DuplicateMissingRecipients": "{count} original recipients are no longer available or may not receive this mailing.",
      "DuplicateChangedAddresses": "The email address has changed for {count} recipients. Review the current addresses.",
      "DuplicateMissingAttachments": "{count} original attachments are unavailable. Add them again if needed.",
      "DuplicateMissingSender": "The original sender is no longer available. Your own sender is selected.",
      "DuplicateMissingTemplate": "The original template is no longer available. Select a template.",
      "DuplicateNotice": "This is a new copy. Check recipients, consent, sender, template and attachments again before sending. Recipients that are no longer available are not selected.",
      "DuplicateMailing": "Duplicate mailing",
      "DeleteMailing": "Delete form history",
      "DeleteMailingConfirm": "The original form content and attachments that are no longer needed will be deleted. The mailing can no longer be duplicated. Pending or scheduled deliveries must be handled first.",
      "MailingDeleteError": "Deletion failed. Wait for preparation to finish and complete or remove the related queue items, then try again.",
      "HistoryCreated": "Created",
      "HistoryState": "Status",
      "HistoryHelp": "Original mailings remain available until you delete them manually. Older messages without a saved form are only available in the delivery log.",
      "MailingStates": {
        "preparing": "Preparing",
        "ready": "Available",
        "failed": "Preparation failed",
        "deleting": "Finishing deletion"
      }
    },
    "Email-triggers": {
      "Auto approve": "Auto approve",
      "CreatedAt": "Created at",
      "Data query": "Data query",
      "Data service": "Data service",
      "Description": "Description",
      "Enabled": "Enabled",
      "From": "From",
      "Group mail": "Group mail",
      "Last occurrence only": "Last occurrence only",
      "Last triggered": "Last triggered",
      "NA": "N/A",
      "Name": "Name",
      "Query based trigger": "Query-Based trigger",
      "Query per trigger": "Query per trigger",
      "Query results": "Query results",
      "Schedule": "Schedule",
      "Subject": "Subject",
      "Template description": "Template description",
      "Template name": "Template name",
      "To": "To",
      "To query": "To query",
      "To service": "To service",
      "Total recipients": "{total} recipient | {total} recipients",
      "Trigger": "Trigger",
      "Trigger query": "Trigger query",
      "Trigger service": "Trigger service",
      "View item": "View trigger"
    },
    "Feedback-answers": {
      "Customer": "Customer",
      "Value": "Value",
      "Errors": {
        "ErrorCode": {
          "FIELD_REQUIRED": "Providing an answer is required."
        }
      }
    },
    "Feedback-questions": {
      "Add Questions item": "Add question",
      "Answer type": "Answer type",
      "CanChangeAnswers": "Can change answers",
      "Delete Questions item": "Remove question",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete feedback",
      "Delete item fail": "Feedback could not be deleted. {msg}",
      "Delete item success": "Feedback successfully deleted.",
      "Delete item text": "Are you sure you want to {1} the feedback {0}?",
      "Edit item": "Edit feedback",
      "Edit item fail": "An error occurred while updating the feedback. {msg}",
      "Edit item success": "Feedback successfully updated.",
      "En": "English",
      "Name": "Name",
      "New item": "New feedback",
      "New item fail": "Unable to create new feedback. {msg}",
      "New item success": "New feedback created.",
      "Nl": "Dutch",
      "Question": "Question",
      "Questions": "Questions",
      "Required": "Required",
      "Tabs": {
        "Question": "Question",
        "Answers": "Answers"
      },
      "Type": "Type",
      "TypeOptions": {
        "Sharingcenter": "OMNI Sessions",
        "Stars": "Stars",
        "String": "Text"
      },
      "View item": "View feedback"
    },
    "Invoices": {
      "Add Lines item": "Add product line",
      "Additional attachments": "Additional attachments",
      "Amount": "Amount",
      "Amount open": "Open amount: {amount}",
      "Amount paid": "Paid amount: {amount}",
      "Cannot download invoice": "Unable to start downloading the invoice.",
      "Cannot download invoice attachment": "Unable to start downloading the invoice attachment.",
      "Choose mail type": "Please select the email type you wish to send",
      "Choose mail type title": "Select email type",
      "Create credit": "Create credit invoice",
      "Create credit item fail": "Failed to create the credit. {msg}",
      "Create credit item success": "Credit invoice(s) successfully created.",
      "Credit invoice item fail": "Failed to create the credit. {msg}",
      "Credit invoice item success": "Credit invoice(s) successfully created.",
      "Credit invoices": "Credit | Create credits",
      "CustomCreditLine": "Credit all lines | Credit line",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete invoice",
      "Delete item fail": "Failed to delete invoice. {msg}",
      "Delete item success": "Successfully deleted invoice.",
      "Delete item text": "Are you sure you want to {1} the invoice {0}?",
      "Delete Lines item": "Delete product line",
      "Description": "Description",
      "Discount": "Discount",
      "Download": "Download invoice",
      "Draft": "Draft",
      "Draft direct debit": "Draft direct debit",
      "Edit item": "Edit invoice",
      "Edit item fail": "Error editing the invoice. {msg}",
      "Edit item success": "Successfully changed invoice.",
      "Email address": "Email address",
      "EmailOptions": {
        "Final_notice": "Final notice",
        "Invoice": "Invoice",
        "Reminder_1": "First reminder",
        "Reminder_2": "Second reminder"
      },
      "Errors": {
        "ErrorCode": {
          "CUSTOMER_CONTACT_NOT_SET": "Customer has no invoice contact set.",
          "INVOICE_CREATION_DATE_BEFORE_LATEST_INVOICE": "The invoice creation date cannot be before the latest finalized invoice date.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "A product bundle cannot have a discount."
        }
      },
      "Filename": "Filename",
      "Generate invoices": "Generate | Generate invoices",
      "Generation date": "Generation date",
      "Invoice": "Invoice",
      "Invoice amount ex VAT": "Invoice amount excl VAT",
      "Invoice amount inc VAT": "Invoice amount incl VAT",
      "Invoice amount open": "Amount open",
      "Invoice contact not set": "This customer has no invoice contact set. Please set an invoice contact and try again.",
      "Invoice creation date": "Creation date",
      "Invoice date": "Date",
      "Invoice due date": "Invoice due date",
      "Invoice email status": "Email status",
      "Invoice item": "Invoices",
      "Invoice modified date": "Invoice modified date",
      "Invoice number": "Number",
      "Invoice overdue": "Invoice is overdue | OVERDUE",
      "Invoice overdue date": "Due date",
      "Invoice reference": "Invoice references",
      "InvoiceCreationDate": "Invoice creation date",
      "InvoiceDueDate": "Invoice due date",
      "InvoiceReference": "Invoice reference",
      "Invoices loading": "Invoices are loading, one moment please...",
      "Invoices merged successfully": "The selected invoices have been merged successfully.",
      "InvoiceTemplate": "Invoice template",
      "InvoiceTemplateOptions": {
        "En-US": "English",
        "Nl-NL": "Dutch"
      },
      "InvoicingSoftwareId": "Invoicing software ID",
      "LedgerAccountNumber": "Ledger Account Number",
      "Lines": "Lines",
      "List": "Invoices overview",
      "MailType": "Type",
      "Merge invoices": "Merge | Merge invoices",
      "Name": "Name",
      "New item": "New | Create new invoice",
      "New item fail": "Failed to create new invoice. {msg}",
      "New item success": "Successfully created new invoice.",
      "No document": "Document not found | No document was found for this invoice number. If you need a copy if this invoice, please contact <strong><a class='text-primary' href='mailto:servicedesk{'@'}omninetworks.nl'>servicedesk{'@'}omninetworks.nl</a><strong>",
      "No invoices": "There are no invoices to show for this customer.",
      "Open": "Open",
      "Open credit": "Open credit",
      "Open direct debit": "Open direct debit",
      "Overdue": "Overdue",
      "Paid": "Paid",
      "PaymentStatus": "Status",
      "PaymentStatuses": {
        "draft": "Draft",
        "draft direct debit": "Draft",
        "open": "Open",
        "open credit": "Open",
        "open direct debit": "Open",
        "overdue": "Overdue",
        "paid": "Paid"
      },
      "PaymentStatusOptions": {
        "Draft": "Draft",
        "Draft direct debit": "Draft direct debit",
        "Invoiced": "Invoiced",
        "Open": "Open",
        "Open credit": "Open credit",
        "Open direct debit": "Open direct debit",
        "Overdue": "Overdue",
        "Paid": "Paid"
      },
      "PriceExclPerPiece": "Price per piece (excl VAT)",
      "Product": "Product",
      "Remove attachment item success": "Successfully deleted attachment.",
      "Send invoice to": "Invoice will be send to {fullName} ({email}).",
      "Send mail": "Send | Send invoice(s) using email",
      "Send mail item fail": "Unable to send email.",
      "Send mail item success": "Email was sent successfully.",
      "Sent date": "Sent at",
      "Sepa": "SEPA Batch",
      "Status": "Status",
      "StatusOptions": {
        "Draft": "Draft",
        "Invoiced": "Invoiced"
      },
      "Sync status booked": "Invoice has a status of booked which indicated the invoice is known in the invoicing software, but the PDF file hasn't been uploaded yet.",
      "Tabs": {
        "General": "General",
        "Lines": "Lines"
      },
      "Type": "Type",
      "TypeOptions": {
        "Credit": "Credit",
        "Invoice": "Invoice"
      },
      "Update invoice": "Update invoice | Update invoices",
      "View": "View invoice | View invoices",
      "View item": "View invoice"
    },
    "Product-groups": {
      "Delete": "delete",
      "Delete item": "Delete product group",
      "Delete item fail": "Failed to delete product group. {msg}",
      "Delete item success": "Successfully deleted product group.",
      "Delete item text": "Are you sure you want to {1} the product group {0}?",
      "Edit item": "Edit product group",
      "Edit item fail": "Error editing the product group. {msg}",
      "Edit item success": "Successfully changed product group.",
      "Errors": {
        "ErrorCode": {
          "PRODUCT_GROUP_VAT_CHANGE_NOT_ALLOWED": "Group is part of a product bundle, the VAT group cannot be changed."
        }
      },
      "InvoicingSoftwareEUId": "Invoicing software ID (EU)",
      "InvoicingSoftwareId": "Invoicing software ID (NL)",
      "IsArchived": "Archived",
      "LedgerAccountNumber": "Ledger Account Number",
      "Name": "Name",
      "New item": "New product group",
      "New item fail": "Failed to create new product group. {msg}",
      "New item success": "Successfully created new product group.",
      "Percentage": "Percentage",
      "Product group": "Product group",
      "StartDate": "Start date",
      "Tabs": {
        "General": "General"
      },
      "Vat": "VAT"
    },
    "Products": {
      "Add BundledProducts item": "Add a bundled product",
      "Add PurchasePricesInput item": "Add a purchase price",
      "Add SalesPricesInput item": "Add a sales price",
      "Amount": "Amount",
      "Archive": "archive",
      "ArchivedAt": "Archived at",
      "BundledProducts": "Bundled products",
      "Delete": "delete",
      "Delete BundledProducts item": "Delete bundled product",
      "Delete item": "Delete product",
      "Delete item fail": "Failed to delete product. {msg}",
      "Delete item success": "Successfully deleted product.",
      "Delete item text": "Are you sure you want to {1} the product {0}?",
      "Delete PurchasePricesInput item": "Delete purchase price",
      "Delete SalesPricesInput item": "Delete sales price",
      "Discount": "Discount",
      "DomainTldSetting": "Domain TLD settings",
      "DowngradePaths": "Downgrade paths",
      "Edit item": "Edit product",
      "Edit item fail": "Error changing the product. {msg}",
      "Edit item success": "Successfully changed product.",
      "Errors": {
        "BUNDLED_PRODUCTS_CANNOT_BE_BUNDLES_OR_OF_NON_OTHER_TYPE": "ERROR: A bundle may not contain bundled products or products of a different type than 'Other services'.",
        "DUPLICATE_BUNDLED_PRODUCTS": "ERROR: A bundle may not contain the same product multiple times.",
        "ErrorCode": {
          "BUNDLED_PRODUCTS_DIFFERENT_VAT_GROUP": "Product has a different vat group than the primary product in the bundle."
        },
        "PURCHASEPRICES_DATE_TOO_EARLY": "ERROR: Start date must be later than or equal to the oldest date in old prices for the same period and periodic.",
        "PURCHASEPRICES_NO_PRICE_IN_PAST": "ERROR: At least one object must have a price in the past.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_DATE": "ERROR: Two objects with same period, periodic and date.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_PAST": "ERROR: Two objects with the same period and periodic with dates in the past.",
        "PURCHASEPRICES_SAME_PERIOD_PERIODIC_PRICE": "ERROR: Two objects with the same period, periodic, and price.",
        "SALESPRICES_DATE_TOO_EARLY": "ERROR: Start date must be later than or equal to the oldest date in old prices for the same period and periodic.",
        "SALESPRICES_NO_PRICE_IN_PAST": "ERROR: At least one object must have a price in the past.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_DATE": "ERROR: Two objects with same period, periodic and date.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_PAST": "ERROR: Two objects with same period and periodic with dates in the past.",
        "SALESPRICES_SAME_PERIOD_PERIODIC_PRICE": "ERROR: Two objects with the same period, period and price.",
        "SUBSCRIBED_BUNDLE_CANNOT_BE_CHANGED": "ERROR: A bundle that has been assigned to subscriptions can no longer be changed."
      },
      "Group": "Product group",
      "InvoiceDescription": "Invoice description",
      "IsArchived": "Archived",
      "IsBundle": "Is a product bundle",
      "IsStockItem": "Stock item",
      "Name": "Name",
      "New item": "New product",
      "New item fail": "Failed to create new product. {msg}",
      "New item success": "Successfully created new product.",
      "Period": "Period",
      "Period and periodic": "Period and periodic",
      "Periodic": "Periodic",
      "PeriodicOptions": {
        "Month": "Month",
        "One-time": "One-time",
        "Year": "Year"
      },
      "Price": "Price",
      "Price list": "Price list (.xlsx)",
      "Price list upload error message": "Error message",
      "Price list upload items processed": "Items processed",
      "Price list upload items skipped due to an error": "Items skipped due to an error",
      "Price list upload items skipped due to empty cells": "Items skipped due to empty cells",
      "Price list upload items skipped due to no price changes": "Items skipped due to no price changes",
      "PriceEx": "Price Ex. VAT",
      "Prices": "Prices",
      "Product": "Product",
      "Product bundle purchase price does not contain all bundle products": "Product bundle purchase price does not contain all bundle products",
      "ProductCode": "Product code",
      "ProductDescription": "Product description",
      "ProductType": "Product type",
      "ProductTypeOptions": {
        "Domain": "Domain",
        "Hosting": "Hosting",
        "License": "License",
        "Other": "Other services",
        "Ssl-certificate": "SSL-certificates"
      },
      "ProductVAT": "Product VAT group",
      "Purchase price cell": "Purchase price cell",
      "Purchase price value": "Purchase price value",
      "PurchasePrices": "Purchase prices",
      "PurchasePricesHistory": "Purchase prices history",
      "PurchasePricesInput": "Purchase prices",
      "SalesPrices": "Sales prices",
      "SalesPricesHistory": "Sales prices history",
      "SalesPricesInput": "Sales prices",
      "Selling price cell": "Selling price cell",
      "Selling price value": "Selling price value",
      "Sheet": "Sheet",
      "StartDate": "Start date",
      "SupplierProductCode": "Supplier product code",
      "SupplierProductUrl": "Supplier product URL",
      "Tabs": {
        "General": "General",
        "Product bundle": "Product bundle",
        "Purchase price": "Purchase price",
        "Sales price": "Sales price"
      },
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Fixed",
        "None": "None",
        "Percentage": "Percentage"
      },
      "Upgrade": "Upgrade or downgrade product",
      "UpgradePaths": "Upgrade paths",
      "Upload price list": "Upload price list",
      "Upload price list item failed": "Price list upload failed. {msg}",
      "Upload price list item success": "Price list uploaded successfully. Review the results to verify the import completed without errors.",
      "Upload price list start date": "Start date"
    },
    "Project-task-time-tracking": {
      "Add registration": "Add registration",
      "Created and updated items success": "Successfully created {newRecords} and updated {patchedRecords} registrations.",
      "Created invoice success": "Successfully created invoice for registration(s).",
      "Created items success": "Successfully created {newRecords} registration. | Successfully created {newRecords} registrations.",
      "Customer": "Customer",
      "Customer filter": "Customer filter",
      "Date": "Date",
      "Delete": "delete",
      "Delete Products item": "Delete product",
      "Delete item": "Delete registration",
      "Delete item fail": "Error deleting the registration. {msg}",
      "Delete item text": "Are you sure you want to {1} the registration {0}?",
      "Deleted items success": "Successfully deleted time registration. | Successfully deleted {removedRecords} time registrations.",
      "Description": "Description",
      "Discard changes leave": "Leave this page? Unsaved changes will be lost.",
      "Discard changes refresh": "Refresh and discard all unsaved changes?",
      "Done but not invoiced": "but is not yet invoiced",
      "Edit item": "Edit registration",
      "Edit item fail": "Error changing the registration. {msg}",
      "Edit item success": "Successfully changed registration.",
      "Export project registrations": "Export project registrations",
      "From date": "From date",
      "Generate invoice": "Generate invoice for selected registrations",
      "Group registrations on invoice": "Group all time registrations on the invoice",
      "Hr": "h",
      "Invalid date range": "Choose a valid period. The start date must not be after the end date.",
      "Invalid registrations": "Check the marked fields. Enter a date, task, description and performer, and use a duration in steps of 5 minutes.",
      "Invoice intro text": "In the table below, select which time registrations should be marked as done. By default, each time registration will be put separately on the invoice. If you want to group all the time registrations together, please ensure to tick the checkmark to do so.",
      "Invoice item": "Invoice time registrations",
      "IsInvoiced": "Is invoiced",
      "Mark as done": "Mark task as done",
      "Name": "Name",
      "New item": "New registration",
      "New item fail": "Error creating registration. {msg}",
      "New item success": "Successfully created registration.",
      "No projects found": "No projects were found.",
      "No registrations": "No registrations",
      "PerformedBy": "Performed by",
      "ProjectTaskInfo": {
        "status": "Task status",
        "statusOptions": {
          "Done": "Done",
          "Open": "Open",
          "Started": "Started"
        }
      },
      "Registration not yet invoiced": "This time registration has not yet been invoiced",
      "Registrations": "registrations",
      "Save before invoicing": "Save the changes for this project before creating an invoice.",
      "Save registrations": "Save registrations",
      "Saving": "Saving time registration(s), one moment please...",
      "Search in projects": "Search in projects",
      "Task": "Task",
      "Task status": "Task has status @.upper:{status}",
      "There are no changes to be processed": "There are no changes to be processed",
      "Time registration": "Time registration",
      "TimeSpent": "Time spent",
      "Total project hours": "Total hours",
      "Undo delete item": "Don't delete time registration",
      "Unsaved changes": "Are you sure that you want to change the date? The pending changes that you made will not be saved.",
      "Unsaved changes invoicing": "Are you sure that you want to start invoicing? The pending changes that you made will not be saved.",
      "Until date": "Until date",
      "Updated items success": "Successfully changed {patchedRecords} registration. | Successfully changed {patchedRecords} registrations.",
      "Week number": "Week"
    },
    "Project-task-types": {
      "Add Products item": "Add product",
      "Archive": "archive",
      "Delete": "delete",
      "Delete item": "Delete task type",
      "Delete item fail": "Error deleting the task type. {msg}",
      "Delete item success": "Successfully deleted task type.",
      "Delete item text": "Are you sure you want to {1} the task type {0}?",
      "Delete Products item": "Delete product",
      "Description": "Description",
      "Edit item": "Edit task type",
      "Edit item fail": "Error changing the task type. {msg}",
      "Edit item success": "Successfully changed task type.",
      "IsArchived": "Is archived",
      "IsInvoiceable": "Is invoiceable",
      "Name": "Name",
      "New item": "New task type",
      "New item fail": "Error creating task type. {msg}",
      "New item success": "Successfully added task type.",
      "Product": "Product",
      "Tabs": {
        "General": "General"
      },
      "Task type": "Task type"
    },
    "Project-tasks": {
      "ActualHours": "Actual hours",
      "Delete": "delete",
      "Delete item": "Delete task",
      "Delete item fail": "Error deleting the task. {msg}",
      "Delete item success": "Successfully deleted task.",
      "Delete item text": "Are you sure you want to {1} the task {0}?",
      "Description": "Description",
      "Edit item": "Edit task ({status})",
      "Edit item fail": "Error changing the task. {msg}",
      "Edit item success": "Successfully changed task.",
      "EstimatedHours": "Estimated hours",
      "Hr": "hr | hrs",
      "Mark as done": "Mark as done",
      "Name": "Name",
      "New item": "New task",
      "New item fail": "Error creating task. {msg}",
      "New item success": "Successfully created task.",
      "Project": "Project",
      "ProjectInfo": {
        "customer": "Customer"
      },
      "ProjectTaskType": "Task type",
      "Status": "Status",
      "StatusOptions": {
        "Done": "Done",
        "Open": "Open",
        "Started": "Started"
      },
      "Tabs": {
        "General": "General"
      },
      "Task": "Task"
    },
    "Projects": {
      "Add project item": "Add task",
      "Archive": "Archive",
      "Contract": "Contract",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete project",
      "Delete item fail": "Error deleting the project. {msg}",
      "Delete item success": "Successfully deleted project.",
      "Delete item text": "Are you sure you want to {1} the project {0}?",
      "Delete Products item": "Delete task",
      "Description": "Description",
      "Edit item": "Edit project",
      "Edit item fail": "Error changing the project. {msg}",
      "Edit item success": "Successfully changed project.",
      "Hr": "hr | hrs",
      "IsArchived": "Is archived",
      "Name": "Name",
      "New item": "New project",
      "New item fail": "Error creating project. {msg}",
      "New item success": "Successfully created project.",
      "Project": "Project",
      "ProjectHours": "Project hours",
      "Status": "Status",
      "StatusOptions": {
        "Done": "Done",
        "Open": "Open",
        "Started": "Started"
      },
      "Tabs": {
        "General": "General",
        "Tasks": "Tasks"
      }
    },
    "Sales-orders": {
      "Add Products item": "Add product",
      "Amount": "Amount",
      "Contract": "Contract",
      "Customer": "Customer",
      "CustomPeriodAndPeriodic": "Period and periodic",
      "Date": "Date",
      "Delete": "delete",
      "Delete item": "Delete sales order",
      "Delete item fail": "Error deleting the sales order. {msg}",
      "Delete item success": "Successfully deleted sales order.",
      "Delete item text": "Are you sure you want to {1} the sales order {0}?",
      "Delete Products item": "Delete product",
      "Deliver": "Ready for delivery",
      "DeliveryDate": "Delivery date",
      "Description": "Description",
      "Discount": "Discount",
      "Edit item": "Edit sales order",
      "Edit item fail": "Error changing the sales order. {msg}",
      "Edit item success": "Successfully changed sales order {name}.",
      "Errors": {
        "ErrorCode": {
          "CAN_ONLY_DELETE_OPEN_SALES_ORDERS": "The sales order can only be deleted it the status is 'open'.",
          "CUSTOMER_CONTACT_NOT_SET": "Customer has no invoice contact set.",
          "PRODUCT_BUNDLE_CANNOT_HAVE_DISCOUNT": "A product bundle cannot have a discount.",
          "PRODUCT_BUNDLE_DUPLICATE": "The sales order can not contain the same product bundle twice.",
          "PRODUCT_BUNDLE_PRICE_NOT_FOUND": "The sales order contains a product bundle with a price that could not be found."
        }
      },
      "Invoice templates": {
        "Invoice - EU (EN)": "Invoice - EU (EN)",
        "Invoice - EU (NL)": "Invoice - EU (NL)",
        "Invoice - NL (EN)": "Invoice - NL (EN)",
        "Invoice - NL (NL)": "Invoice - NL (NL)"
      },
      "InvoiceTemplate": "Invoice template",
      "Memo": "Internal memo",
      "Merge sales orders": "Merge sales orders",
      "New item": "New sales order",
      "New item fail": "Error creating sales order. {msg}",
      "New item success": "Successfully created sales order.",
      "OrderReference": "Order reference",
      "Period": "Period",
      "PeriodFrom": "Period from",
      "Periodic": "Periodic",
      "PeriodicOptions": {
        "Month": "Month",
        "One-time": "One-time",
        "Year": "Year"
      },
      "PeriodTo": "Period to",
      "PriceCalculator": {
        "AmountOfDays": "Amount of days",
        "CurrentPrice": "Current price",
        "EndDate": "End date",
        "NewPrice": "New price",
        "Period string": "Period: {startDate} until {endDate}",
        "PricePerDay": "Price per day",
        "StartDate": "Start date",
        "Subscription": "Subscription",
        "Title": "Price calculation"
      },
      "PriceExclPerPiece": "Price per piece (excl VAT)",
      "Product": "Product",
      "Products": "Products",
      "Sales order": "Sales order",
      "Sales orders merged successfully": "The selected sales orders have been merged successfully.",
      "Status": "Status",
      "StatusOptions": {
        "Done": "Done",
        "In progress": "In progress",
        "Open": "Open"
      },
      "Sync sales orders": "Sync sales order | Sync sales orders",
      "Tabs": {
        "General": "General",
        "Products": "Products"
      },
      "TotalAmount": "Total amount (excl VAT)",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Fixed",
        "None": "None",
        "Percentage": "Percentage"
      }
    },
    "Sepa": {
      "Batch": "Batch",
      "BatchId": "Batch ID",
      "BatchTotalInvoiceAmount": "Total invoice amount",
      "DebitDate": "Debit date",
      "Delete": "delete",
      "Delete item": "Delete SEPA batch",
      "Delete item fail": "Error deleting the SEPA batch. {msg}",
      "Delete item success": "Successfully deleted SEPA batch.",
      "Delete item text": "Are you sure you want to {1} the SEPA batch?",
      "Download item": "Download batch",
      "Edit item": "Edit SEPA batch",
      "Edit item fail": "Editing {item} failed. {msg}",
      "Edit item success": "Editing {item} success.",
      "Errors": {
        "ErrorCode": {
          "SEPA_BATCH_CONTAINS_DRAFTS": "This batch contains at least one draft invoice, remove it from the batch or finalize the draft invoices."
        }
      },
      "Generated batches": "Processed batches",
      "Initialized batches": "Open batches",
      "InvoicesInBatch": "Invoices in batch",
      "Remove from batch item fail": "Failed to delete invoice from batch. {msg}",
      "Remove from batch item success": "Successfully deleted invoice from batch.",
      "Remove invoices from batch": "Delete invoices from batch",
      "Status": "Status",
      "StatusOptions": {
        "Generated": "Generated",
        "Initialized": "Draft"
      },
      "Tabs": {
        "General": "General",
        "Invoices": "Invoices"
      }
    },
    "Settings": {
      "AdminsOnly": "Only admins can edit",
      "AllowedMimeTypes": "Allowed filetypes",
      "MaxSizeMb": "Maximum file size (MB)",
      "Image aspect ratio": "Image aspect ratio",
      "Image dimensions": "Image dimensions",
      "Ratio": "Ratio",
      "Tolerance": "Tolerance",
      "Height": "Height",
      "KeepAspectRatio": "Keep aspect ratio",
      "MaxHeight": "Maximum height",
      "MaxWidth": "Maximum width",
      "MinHeight": "Minimum height",
      "MinWidth": "Minimum width",
      "FitMode": "Scaling",
      "FitModeOptions": {
        "None": "Do not resize/crop (validate only)",
        "Contain": "Resize to fit without cropping (contain)",
        "Cover": "Resize and crop to fit (cover)",
        "Pad": "Resize and add padding to fit (pad)",
        "Fill": "Resize to fit by stretching (fill)"
      },
      "PreventUpscale": "Prevent image upscaling",
      "ExcludeFromUI": "Exclude from UI",
      "Add Options item": "Add option",
      "Add Type item": "Add type",
      "Delete": "delete",
      "Delete item": "Delete setting",
      "Delete item fail": "Error deleting the setting. {msg}",
      "Delete item success": "Setting successfully deleted.",
      "Delete item text": "Are you sure you want to {1} the setting {0}?",
      "Delete Options item": "Delete option",
      "Delete Type item": "Delete type",
      "Edit item": "Edit setting",
      "Edit item fail": "Error updating the setting. {msg}",
      "Edit item success": "Setting successfully updated.",
      "New item": "New setting",
      "New item fail": "Error creating setting. {msg}",
      "New item success": "Setting successfully added.",
      "No options": "The are no available options yet.",
      "Reorder settings": "Save order",
      "Found translations": "Found translations",
      "General": "General",
      "Dependency": "Dependency on setting",
      "Base Settings": "Basic",
      "Setting": "Setting",
      "ClearOnMismatch": "Clear current field value on mismatch",
      "Settings": "Settings",
      "Validation": "Validation",
      "UI": "Display",
      "Config": "Configuration",
      "Key": "Field name",
      "Type": "Type",
      "TypeOptions": {
        "Show": "Show setting",
        "Enable": "Enable setting"
      },
      "Color": "Color",
      "Control": "Element",
      "ControlOptions": {
        "Boolean": "On/off toggle",
        "Text": "Text field (single line)",
        "Textarea": "Textarea (multiple lines)",
        "Textarea-rte": "Rich text editor (RTE)",
        "Number": "Numeric input",
        "Range": "Slider",
        "Select": "Select box (single value)",
        "Multiselect": "Multi-select",
        "Radio": "Radio buttons",
        "Checkbox": "Checkbox",
        "Color": "Color picker",
        "Files": "File uploader",
        "Date": "Date field",
        "Datetime": "Date–time field",
        "Time": "Time field",
        "Json": "JSON input",
        "Code": "Code editor",
        "Steps": "Steps configuration"
      },
      "CustomOptions": "Generated options",
      "CustomValidation": "Custom validation",
      "Name": "Name",
      "NameOptions": {
        "Customers": "Customers",
        "Customer-users": "Customer-users",
        "Users": "Users",
        "Sharingcenter-profiles": "OMNI Sessions"
      },
      "Readonly": "Read-only",
      "Value": "Value",
      "ValueType": "Value type",
      "ValueTypeOptions": {
        "String": "String value",
        "Number": "Numeric value",
        "Boolean": "Boolean value",
        "Array": "List of values",
        "Array-strings": "List of text values",
        "Array-numbers": "List of numeric values",
        "Object": "Data object"
      },
      "Code config": "Code editor configuration",
      "Lang": "Language",
      "LangOptions": {
        "Css": "CSS",
        "Html": "HTML",
        "Javascript": "JavaScript"
      },
      "Mask Strings": "Mask strings",
      "Enabled": "Enabled",
      "ShowFirstChars": "Show first characters",
      "ShowLastChars": "Show last characters",
      "Enum": "Enumeration",
      "Files": "Files settings",
      "Options": "Options",
      "Default": "Default value",
      "Required": "Required",
      "Min": "Minimum",
      "Max": "Maximum",
      "Step": "Step",
      "Pattern": "Pattern",
      "MinLength": "Minimum length",
      "MaxLength": "Maximum length",
      "Ui": "Display",
      "Label": "Label",
      "Description": "Description",
      "Placeholder": "Placeholder",
      "Help": "Help",
      "Documentation": "Documentation",
      "Tooltip": "Tooltip",
      "Icon": "Icon",
      "Width": "Width",
      "Order": "Order",
      "Group": "Group",
      "Kind": "Type",
      "KindOptions": {
        "Steps": "Steps configuration",
        "Range": "Range settings"
      },
      "Steps": "Steps",
      "Optional": "Optional",
      "DefaultEnabled": "Enabled by default",
      "Operator": "Operator",
      "OperatorOptions": {
        "Eq": "is",
        "Neq": "is not",
        "Lt": "less than",
        "Lte": "less than or equal",
        "Gt": "greater than",
        "Gte": "greater than or equal",
        "Contains": "contains",
        "StartsWith": "starts with",
        "EndsWith": "ends with"
      },
      "Errors": {
        "ErrorCode": {
          "STEP_DOES_NOT_MATCH": "Allowed step: {step}.",
          "PATTERN_DOES_NOT_MATCH": "Allowed pattern: {pattern}.",
          "INVALID_OPTION": "Invalid @.lower:{key}, allowed: {allowed}.",
          "INVALID_MAXIMUM": "@:{key} exceeds the maximum ({maximum}MB).",
          "INVALID_IMAGE_DATA": "Invalid image file.",
          "INVALID_IMAGE_METADATA": "Image metadata is not available.",
          "INVALID_IMAGE_ASPECTRATIO": "Invalid image aspect ratio ({actual}), expected {expected}.",
          "INVALID_IMAGE_TRANSFORM": "Transformation not allowed for type {currentMimeType}, allowed types: {allowedMimeTypes}.",
          "INVALID_IMAGE_WIDTH": "Invalid width ({actual}px), expected {expected}px.",
          "INVALID_IMAGE_HEIGHT": "Invalid height ({actual}px), expected {expected}px.",
          "INVALID_IMAGE_MINWIDTH": "Width ({actual}px) is below the minimum ({expected}px).",
          "INVALID_IMAGE_MINHEIGHT": "Height ({actual}px) is below the minimum ({expected}px).",
          "INVALID_IMAGE_MAXWIDTH": "Width ({actual}px) exceeds the maximum ({expected}px).",
          "INVALID_IMAGE_MAXHEIGHT": "Height ({actual}px) exceeds the maximum ({expected}px)."
        }
      },
      "RemoveSettings item fail": "Error restoring setting. | Error restoring settings.",
      "RemoveSettings item success": "Setting restored successfully. | Settings restored successfully.",
      "SaveSettings item fail": "Error saving setting. | Error saving settings.",
      "SaveSettings item success": "Setting saved successfully. | Settings saved successfully.",
      "Remove setting confirm": "Restore settings",
      "Remove setting confirm text": "Are you sure you want to restore the settings to their default values?",
      "Remove single setting confirm": "Restore setting",
      "Remove single setting confirm text": "Are you sure you want to restore the setting to its default value?"
    },
    "Sms-logs": {
      "Content": "Message content",
      "CreatedAt": "Created at",
      "Customer": "Customer",
      "Error loading data": "The list of SMS logs could not be loaded due to an error.",
      "SmsSent": "Sent",
      "SmsSentAt": "Sent at",
      "To": "Recipient",
      "VendorResponse": "Vendor response",
      "View item": "SMS log details",
      "View item fail": "Error opening the log entry. {msg}",
      "View item success": "Log entry opened successfully."
    },
    "Ssl-certificates": {
      "AdministrativeContact": "Administrative contact",
      "ApproverEmail": "Approver email",
      "Autorenew": "Automatic renewal",
      "BillingContact": "Billing contact",
      "Certificate": "Certificate",
      "Certificate expired": "Certificate is expired!",
      "CommonName": "Common name",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete certificate",
      "Delete item fail": "Error deleting the certificate. {msg}",
      "Delete item success": "Successfully deleted certificate.",
      "Delete item text": "Are you sure you want to {1} the certificate {0}?",
      "Edit item": "Edit certificate",
      "Edit item fail": "Error changing the certificate. {msg}",
      "Edit item success": "Successfully changed certificate.",
      "Externally managed": "The certificate is externally managed",
      "IsMultiDomain": "Multi domain",
      "IsWildcard": "Wildcard",
      "MultiDomains": "Multi domains",
      "New item": "New certificate",
      "New item fail": "Error creating certificate. {msg}",
      "New item success": "Successfully created certificate.",
      "No subscription": "No subscription selected",
      "OwnerContact": "Owner contact",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "External": "Externally managed",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "RenewDate": "Renew date",
      "RequestDate": "Request date",
      "Subscription": "Subscription",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Customer"
        }
      },
      "Tabs": {
        "Contacts": "Contacts",
        "General": "General"
      },
      "TechnicalContact": "Technical contact",
      "Type": "Type",
      "TypeOptions": {
        "Dv": "Domain validation",
        "Ev": "Extended validation",
        "Ov": "Organization validation"
      }
    },
    "Subscription-cancellation": {
      "Cancel date": "Termination date",
      "Cancel reason": "Reason for termination",
      "Cancel subscription": "Unsubscribe",
      "Cancellation date select text": "Please choose a date below on which the service should be terminated. A notice period of {noticePeriod} applies.",
      "Cancellation domain note": "{0} on the selected date, the domain will be deleted and temporarily placed in quarantine. There are costs associated with retrieving the domain from quarantine.",
      "Cancellation hosting note": "{0} on the selected date, the hosting account will be permanently deleted.",
      "Cancellation ssl note": "{0} on the selected date, the SSL certificate will be permanently deleted.",
      "Cancellation warning": "Although the service can be terminated within the cancellation period, the customer will still receive an invoice for the remaining period. The service will still be deleted on the selected termination date.",
      "Confirm termination": "Confirm termination",
      "Confirm undo termination text": "Do you want to undo the termination of the service?",
      "PeriodicOptions": {
        "Day": "Day | Days",
        "Month": "Month | Months",
        "Year": "Year | Years"
      },
      "Subscription cancel item success": "Subscription is cancelled.",
      "Subscription cancel reversed item success": "Cancellation has been reversed.",
      "Termination date after invoiced until": "{0} The selected termination date is after the current invoicing period. Your service will be automatically extended.",
      "Undo cancellation": "Undo termination"
    },
    "Subscriptions": {
      "Amount": "Amount",
      "Attached service": "Attached service",
      "Cancel date": "Termination date",
      "Cancel reason": "Reason for termination",
      "Cancel subscription": "Unsubscribe",
      "CancelDate": "Cancelled on",
      "Cancellation date select text": "Please choose a date below on which the service should be terminated. A notice period of {noticePeriod} applies.",
      "Cancellation domain note": "{0} on the selected date, the domain will be deleted and temporarily placed in quarantine. There are costs associated with retrieving the domain from quarantine.",
      "Cancellation hosting note": "{0} on the selected date, the hosting account will be permanently deleted.",
      "Cancellation ssl note": "{0} on the selected date, the SSL certificate will be permanently deleted.",
      "Cancellation warning": "Although the service can be terminated within the cancellation period, the customer will still receive an invoice for the remaining period. The service will still be deleted on the selected termination date.",
      "ChangedBy": "Changed by",
      "Confirm": "Confirm",
      "Confirm termination": "Confirm termination",
      "Confirm undo termination text": "Do you want to undo the termination of the service?",
      "Contract": "Contract",
      "Contract takeover": "Contract takeover",
      "Contract takeover confirm": "Move all dependencies on this subscription together with the contract takeover",
      "Contract takeover confirm item": "Confirm contract takeover",
      "Contract takeover confirm item success": "Contract takeover was performed successfully.",
      "Contract takeover item": "Contract takeover",
      "Contract takeover text": "The contract transfer can only be carried out by moving dependent subscriptions.",
      "ContractEndDate": "Contract end date",
      "ContractInfo": {
        "_id": "Contract",
        "customer": "Customer"
      },
      "ContractStartDate": "Contract start date",
      "Contractual discount": "Contractual discount",
      "Contractual discount description": "According to the contract, a discount of {0} is already set. Setting a value below will override this contractual discount.",
      "Current product discount": "Current discount | Current {from} discount",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete subscription",
      "Delete item fail": "Failed to delete subscription. {msg}",
      "Delete item success": "Successfully deleted subscription.",
      "Delete item text": "Are you sure you want to {1} this subscription?",
      "Discount": "Discount | {from} discount",
      "Discount excl": "Discount excl",
      "Edit item": "Edit subscription",
      "Edit item fail": "Error when changing the subscription. {msg}",
      "Edit item success": "Successfully changed subscription.",
      "EndDate": "End date",
      "Errors": {
        "ErrorCode": {
          "GENERATE_SALES_ORDER_DATE_BEFORE_INVOICE_START_DATE": "Sales order date cannot be before invoice start date.",
          "LICENSE_SUBSCRIPTION_MANAGED_BY_LICENSE": "This subscription is managed through licenses.",
          "REVERT_SUBSCRIPTION_UPDATE_ERROR": "Something went wrong when reverting the subscription.",
          "SUBSCRIPTION_LICENSE_CONTRACT_NOT_ALLOWED": "License contracts can only be used through license management.",
          "SUBSCRIPTION_LICENSE_PRODUCT_NOT_ALLOWED": "License products can only be used through license management.",
          "SUBSCRIPTION_BUNDLE_CANNOT_HAVE_DISCOUNT": "ERROR: A bundled product cannot have a discount.",
          "SUBSCRIPTION_BUNDLE_CANNOT_SET_CUSTOM_PRICE": "ERROR: A bundled product cannot have a custom price.",
          "SUBSCRIPTION_CONTRACT_MOVE_HAS_DEPENDENCIES": "ERROR: Unable to transfer the subscription to a new contract because there are attached services linked to contacts from different customers."
        }
      },
      "Failed to update subscription prices": "Failed to update {amount} subscription prices.",
      "First select a new contract": "Select new contract first",
      "First time invoice": "Date of first invoice",
      "GenerateSalesOrder": "Generate sales order",
      "GenerateSalesOrderDate": "From date",
      "HasCustomPrice": "Has custom price",
      "HasDiscount": "Has discount",
      "HasEndedOrCancelled": "Contract ended or cancelled",
      "Invoice Description preview": "Invoice description preview",
      "InvoiceDescription": "Invoice description",
      "InvoicedUntilDate": "Invoiced until",
      "InvoiceNextDate": "Next invoice",
      "InvoiceStartDate": "Invoice start date",
      "Is attached": "Service attached",
      "IsAttached": "Service attached",
      "Move contract": "Move contract",
      "New contract summary": "New contract summary",
      "New item": "New subscription",
      "New item fail": "Failed to create new subscription. {msg}",
      "New item success": "Successfully created new subscription.",
      "New price": "Nieuwe prijs",
      "New product discount": "New discount | New {from} discount",
      "No service attached": "No service is attached",
      "Old contract summary": "Old contract summary",
      "Old price": "Oude prijs",
      "Period": "Period",
      "Periodic": "Periodic",
      "PeriodicOptions": {
        "Day": "Day",
        "Month": "Month",
        "Year": "Year"
      },
      "PriceExcl": "Price excl",
      "Product": "Product",
      "ProductInfo": {
        "productType": "Product type"
      },
      "ProductTypeOptions": {
        "Domain": "Domain",
        "Hosting": "Hosting",
        "License": "License",
        "Other": "Other services | Other",
        "Ssl-certificate": "SSL certificates | SSL"
      },
      "Revert item success": "Successfully reverted subscription.",
      "Revert last invoice": "Revert last invoice",
      "Select new contract": "Select new contract first",
      "SetNoticePeriod": "Set notice period",
      "SetNoticePeriodFromContract": "Copy notice period from contract",
      "Skipped subscription prices because the period and periodic are no longer available": "Skipped {amount} subscription prices because the period and periodic are no longer available.",
      "Subscription": "Subscription",
      "Subscription amount is less then product commitments": "Subscription amount is less then product commitments.",
      "Subscription cancel item success": "Subscription is cancelled.",
      "Subscription cancel reversed item success": "Cancellation has been reversed.",
      "Subscription contract date expired": "End date of subscription contract has expired.",
      "Subscription period no longer available": "Current subscription period no longer available",
      "Subscription period with custom price": "Custom price",
      "Subscription prices did not change": "Price not modified for {amount} subscription prices.",
      "SubscriptionAmount": "Amount",
      "Subtotal": "Subtotal excl",
      "Successfully updated subscription prices": "Successfully changed {amount} subscription prices.",
      "Sync prices": "Sync prices",
      "Tabs": {
        "Discount": "Discount",
        "General": "General",
        "PriceHistory": "Price history"
      },
      "TerminationDate": "Removal date",
      "This subscription belongs to a cancelled contract, consider removing it": "This subscription belongs to a ended or cancelled contract, consider deleting it.",
      "TotalPriceExcl": "Total Price excl",
      "Type": "Type",
      "TypeOptions": {
        "Fixed": "Fixed",
        "None": "None",
        "Percentage": "Percentage"
      },
      "Undo cancellation": "Undo termination",
      "UpgradeCalculator": {
        "Current Product": "Current Product",
        "Current sales price": "Current sales price",
        "Current sales price with discount": "Current sales price with discount",
        "Days": "Days",
        "Days in subscription": "Days in subscription",
        "Days to next invoice": "Days to next invoice",
        "Discount on price change": "Discount on price change",
        "Downgrade": "Downgrade",
        "New Product": "New Product",
        "New sales price": "New sales price",
        "New sales price with discount": "New sales price with discount",
        "Percentage": "Percentage",
        "Perform up- or downgrade": "Perform {type} immediately",
        "Price change": "Price change",
        "Price change with discount": "Price change with discount",
        "Settlement on price change": "Settlement on price change",
        "Title": "{type} calculator",
        "Up- or downgrade date": "{type} date",
        "Upgrade": "Upgrade"
      }
    },
    "Users": {
      "Value": "Picture",
      "Errors": {
        "ErrorCode": {
          "ADMIN_API_ROLES_REQUIRED": "Select at least one internal role.",
          "ADMIN_API_ROLES_INVALID": "Select only active internal roles."
        },
        "Formats": {
          "phone": "Phone number must be a valid international formatted phone number."
        }
      }
    },
    "Vat": {
      "Add VAT item": "Add VAT",
      "Delete": "delete",
      "Delete item": "Delete VAT setting",
      "Delete item fail": "Failed to delete VAT setting. {msg}",
      "Delete item success": "Successfully deleted VAT setting.",
      "Delete item text": "Are you sure you want to {1} the VAT setting {0}?",
      "Delete VAT item": "Delete VAT",
      "Edit item": "Edit VAT setting",
      "Edit item fail": "Error changing the VAT setting. {msg}",
      "Edit item success": "Successfully changed VAT setting.",
      "InvoicingSoftwareName": "Invoicing software name",
      "Name": "Name",
      "New item": "New VAT setting",
      "New item fail": "Failed to create new VAT setting. {msg}",
      "New item success": "Successfully created new VAT setting.",
      "Percentage": "Percentage",
      "StartDate": "Start date",
      "Tabs": {
        "General": "General",
        "VAT": "VAT"
      },
      "VAT": "VAT"
    },
    "Licenses": {
      "AlignWithLicense": "Align renew date with license",
      "Amount": "Amount",
      "AmountBelowAssigned": "Amount cannot be lower than assigned users.",
      "AmountMustBeZero": "Set the amount to 0 before deleting this license.",
      "Assigned": "Assigned users",
      "EffectiveAssigned": "Effective users",
      "ChangeOnRenewDate": "Change amount and payment method on renew date",
      "Customer": "Customer",
      "CustomerInfo": {
        "customerId": "Customer"
      },
      "Delete": "delete",
      "Delete Assigned item": "Delete assigned user",
      "Delete item": "Delete license",
      "Delete item fail": "Failed to delete license. {msg}",
      "Delete item success": "Successfully deleted license.",
      "Delete item text": "Are you sure you want to {1} license {0}?",
      "Edit item": "Edit license",
      "Edit item fail": "Failed to update license. {msg}",
      "Edit item success": "Successfully updated license.",
      "Email": "Email",
      "Errors": {
        "ErrorCode": {
          "LICENSE_AMOUNT_BELOW_ASSIGNED": "Amount cannot be lower than assigned users.",
          "LICENSE_AMOUNT_CANNOT_DECREASE": "Amount can only be increased directly.",
          "LICENSE_ALIGN_AMOUNT_MUST_BE_GREATER_THAN_ZERO": "Amount must be greater than 0 when aligning the renew date with a license.",
          "LICENSE_ALIGN_PAYMENT_METHOD_MISMATCH": "You can only align with a license that uses the same payment method.",
          "LICENSE_ALIGN_RENEW_DATE_BEFORE_START_DATE": "The start date must be before the renew date of the selected license.",
          "LICENSE_AMOUNT_MUST_BE_ZERO": "Set the amount to 0 before deleting this license.",
          "LICENSE_ASSIGNED_CAPACITY_EXCEEDED": "Too many active users.",
          "LICENSE_ASSIGNED_CUSTOMER_MISMATCH": "Assigned users must belong to the same customer as the license.",
          "LICENSE_ASSIGNED_DATE_IN_PAST": "Start and end dates for assigned users cannot be in the past.",
          "LICENSE_ASSIGNED_USER_INVALID": "Invalid user.",
          "LICENSE_ASSIGNED_USER_REQUIRED": "Select a user.",
          "LICENSE_ASSIGNED_USERS_NOT_UNIQUE": "A user can only be assigned once.",
          "LICENSE_CONTRACT_CANCEL_DATE_AMOUNT_INCREASE": "This license has been cancelled and cannot be increased anymore.",
          "LICENSE_CONTRACT_INVALID": "This license has no valid contract and can only be deleted.",
          "LICENSE_USER_ALREADY_ASSIGNED_TO_PRODUCT": "Product already assigned.",
          "LICENSE_PAYMENT_METHOD_NOT_AVAILABLE": "This payment method is not available for this license product.",
          "LICENSE_PENDING_ASSIGNED_CAPACITY_EXCEEDED": "Too many active users after the renew date.",
          "LICENSE_PENDING_AMOUNT_BELOW_RENEWAL_ASSIGNED": "The new amount is lower than the assigned users on the renew date.",
          "LICENSE_PERIOD_NOT_AVAILABLE": "This period is not available for this license product.",
          "LICENSE_START_DATE_IN_PAST": "The start date cannot be in the past."
        }
      },
      "Add Assigned item": "Add assigned user",
      "EndDate": "End date",
      "LoadError": "Failed to load licenses.",
      "LicensesTab": "Licenses",
      "Name": "Name",
      "New item": "New license",
      "New item fail": "Failed to create license. {msg}",
      "New item success": "Successfully created license.",
      "NoAssignedUsers": "No assigned users.",
      "PaymentMethod": "Payment method",
      "PendingAmount": "New amount",
      "PendingPaymentMethod": "New payment method",
      "PendingProduct": "New license product",
      "Period": "Period",
      "PartnerProgramsTab": "Partner programs",
      "SlasTab": "SLAs",
      "PeriodOptions": {
        "Month": "Month",
        "Year": "Year"
      },
      "Product": "Product",
      "RenewDate": "Renew date",
      "Required": "Required",
      "SetAssignedEndDatesToRenewDate": "Set end date to renew date",
      "StartDate": "Start date",
      "Tabs": {
        "General": "General",
        "Users": "Users"
      },
      "User": "User"
    },
    "License-partner-programs": {
      "Active": "Active",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete partner program",
      "Delete item fail": "Failed to delete partner program. {msg}",
      "Delete item success": "Successfully deleted partner program.",
      "Delete item text": "Are you sure you want to {1} partner program {0}?",
      "Discount": "Discount",
      "DiscountType": "Discount type",
      "DiscountTypeOptions": {
        "Fixed": "Fixed amount",
        "Percentage": "Percentage",
        "fixed": "Fixed amount",
        "percentage": "Percentage"
      },
      "Disabled": "Disabled",
      "Edit item": "Edit partner program",
      "Edit item fail": "Failed to update partner program. {msg}",
      "Edit item success": "Successfully updated partner program.",
      "Enabled": "Active",
      "EndDate": "End date",
      "Errors": {
        "ErrorCode": {
          "LICENSE_PARTNER_PROGRAM_FIXED_AMOUNT_REQUIRED": "Enter a monthly or yearly amount.",
          "LICENSE_PARTNER_PROGRAM_END_DATE_INVALID": "Enter a valid end date.",
          "LICENSE_PARTNER_PROGRAM_PERCENTAGE_REQUIRED": "Enter a percentage.",
          "LICENSE_PARTNER_PROGRAM_PERIOD_INVALID": "The end date must be later than the start date.",
          "LICENSE_PARTNER_PROGRAM_PRODUCT_INVALID": "Select a license or other product.",
          "LICENSE_PARTNER_PROGRAM_RANGE_INVALID": "The from amount cannot be higher than the to amount.",
          "LICENSE_PARTNER_PROGRAM_RANGE_OVERLAP": "This range overlaps with an existing partner program for this customer.",
          "LICENSE_PARTNER_PROGRAM_RANGE_PERIOD_OVERLAP": "Range/period overlaps.",
          "LICENSE_PARTNER_PROGRAM_START_DATE_REQUIRED": "Enter a valid start date."
        },
        "FixedAmountRequired": "Enter a monthly or yearly amount.",
        "PercentageRequired": "Enter a percentage.",
        "RangeOrder": "The from amount cannot be higher than the up-to amount.",
        "RangeOverlap": "This range overlaps with {name} ({from} - {to})."
      },
      "FixedMonthAmount": "Monthly amount",
      "FixedYearAmount": "Yearly amount",
      "FromAmount": "From amount",
      "Inactive": "Inactive",
      "License-partner-program": "Partner program | Partner programs | Partner program {licensePartnerProgram}",
      "LoadError": "Failed to load partner programs.",
      "Month": "Month",
      "Name": "Name",
      "New item": "New partner program",
      "New item fail": "Failed to create partner program. {msg}",
      "New item success": "Successfully created partner program.",
      "Percentage": "Percentage",
      "Product": "Product",
      "ProductInfo": "This product is used for the discount line on the invoice. The ledger account comes from this product.",
      "StartDate": "Start date",
      "ToAmount": "Up to amount",
      "Year": "Year"
    },
    "License-slas": {
      "Active": "Active",
      "Availability": "Availability",
      "Charge": "Surcharge",
      "ChargeType": "Surcharge type",
      "ChargeTypeOptions": {
        "Fixed": "Fixed amount",
        "Percentage": "Percentage",
        "fixed": "Fixed amount",
        "percentage": "Percentage"
      },
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete SLA",
      "Delete item fail": "Failed to delete SLA. {msg}",
      "Delete item success": "Successfully deleted SLA.",
      "Delete item text": "Are you sure you want to {1} SLA {0}?",
      "Disabled": "Disabled",
      "Edit item": "Edit SLA",
      "Edit item fail": "Failed to update SLA. {msg}",
      "Edit item success": "Successfully updated SLA.",
      "Enabled": "Active",
      "EndDate": "End date",
      "Errors": {
        "ErrorCode": {
          "LICENSE_SLA_AVAILABILITY_REQUIRED": "Enter availability.",
          "LICENSE_SLA_END_DATE_INVALID": "Enter a valid end date.",
          "LICENSE_SLA_FIXED_AMOUNT_REQUIRED": "Enter a monthly or yearly amount.",
          "LICENSE_SLA_PERCENTAGE_REQUIRED": "Enter a percentage.",
          "LICENSE_SLA_PERIOD_INVALID": "The end date must be later than the start date.",
          "LICENSE_SLA_PERIOD_OVERLAP": "Period overlaps.",
          "LICENSE_SLA_PRODUCT_INVALID": "Select a license or other product.",
          "LICENSE_SLA_RESPONSE_TIME_REQUIRED": "Enter a response time.",
          "LICENSE_SLA_RESPONSE_TIME_UNIT_REQUIRED": "Select a response time unit.",
          "LICENSE_SLA_SERVICE_HOURS_REQUIRED": "Enter service hours.",
          "LICENSE_SLA_SERVICE_HOURS_TYPE_REQUIRED": "Select service hours.",
          "LICENSE_SLA_START_DATE_REQUIRED": "Enter a valid start date."
        }
      },
      "FixedMonthAmount": "Monthly amount",
      "FixedYearAmount": "Yearly amount",
      "Inactive": "Inactive",
      "License-sla": "SLA | SLAs | SLA {licenseSla}",
      "LoadError": "Failed to load SLAs.",
      "Month": "Month",
      "Name": "Name",
      "New item": "New SLA",
      "New item fail": "Failed to create SLA. {msg}",
      "New item success": "Successfully created SLA.",
      "Percentage": "Percentage",
      "Product": "Product",
      "ProductInfo": "This product is used for the SLA surcharge line on the invoice. The ledger account comes from this product.",
      "ResponseTime": "Response time",
      "ResponseTimeAmount": "Response time",
      "ResponseTimeUnit": "Response time unit",
      "ResponseTimeUnitOptions": {
        "BusinessDays": "Business days",
        "Hours": "Hours",
        "Minutes": "Minutes",
        "businessDays": "business days",
        "hours": "hours",
        "minutes": "minutes"
      },
      "ServiceHours": "Service hours",
      "ServiceHoursFrom": "Service hours from",
      "ServiceHoursTo": "Service hours up to",
      "ServiceHoursType": "Service hours",
      "ServiceHoursTypeOptions": {
        "Custom": "Full week",
        "OfficeHours": "Office hours",
        "custom": "Full week",
        "officeHours": "Office hours"
      },
      "StartDate": "Start date",
      "Year": "Year"
    },
    "Whitelabels": {
      "AllowedCustomers": "Allowed customers",
      "Active": "Active",
      "BrandingCustomer": "Default branding customer",
      "Delete": "delete",
      "Delete item": "Delete whitelabel",
      "Delete item fail": "Failed to delete whitelabel. {msg}",
      "Delete item success": "Successfully deleted whitelabel.",
      "Delete item text": "Are you sure you want to {1} whitelabel {0}?",
      "Domain": "Domain",
      "Edit item": "Edit whitelabel",
      "Edit item fail": "Failed to update whitelabel. {msg}",
      "Edit item success": "Successfully updated whitelabel.",
      "Enabled": "Active",
      "Inactive": "Inactive",
      "LoadError": "Failed to load whitelabels.",
      "LocalLoginEnabled": "Allow local login",
      "Name": "Name",
      "New item": "New whitelabel",
      "New item fail": "Failed to create whitelabel. {msg}",
      "New item success": "Successfully created whitelabel.",
      "Notes": "Notes",
      "Off": "Off",
      "On": "On",
      "SSO": "SSO",
      "SMTP": "SMTP",
      "Smtp": {
        "Enabled": "Enable custom SMTP",
        "FromEmail": "Sender email address",
        "FromName": "Sender name",
        "Host": "SMTP host",
        "Password": "SMTP password",
        "Port": "SMTP port",
        "ReplyTo": "Reply-to email address",
        "Security": "SMTP security",
        "SecurityOptions": {
          "None": "None",
          "Starttls": "STARTTLS",
          "Tls": "TLS / SMTPS"
        },
        "Secure": "Secure connection",
        "enabled": "SMTP",
        "Username": "SMTP username"
      },
      "Sso": {
        "AccessUrl": "Token URL",
        "AuthorizeUrl": "Authorize URL",
        "AutoProvisionCustomerUserRoles": "Default customer-user roles for SSO provisioning",
        "AutoProvisionCustomerUsers": "Automatically create customer users",
        "ClientId": "Client ID",
        "ClientSecret": "Client secret",
        "Enabled": "Enable Azure SSO for this domain",
        "ProfileUrl": "Profile URL",
        "Prompt": "Prompt",
        "RedirectUri": "Redirect URI",
        "Scope": "Scope",
        "enabled": "SSO"
      },
      "Tabs": {
        "General": "General",
        "SSO": "SSO",
        "SMTP": "SMTP"
      }
    },
    "Vpn-activity": {
      "External IP": "External IP",
      "Offline at": "Offline at",
      "Online at": "Online at",
      "VPN IP": "VPN IP"
    },
    "Vpn-access-graph": {
      "Access map": "Access map",
      "All": "All",
      "All destinations": "all destinations",
      "All sources": "all sources",
      "All protocols": "All protocols",
      "Allowed": "Allowed",
      "Addresses reachable within route": "{count} IP addresses reachable within {route}",
      "Any": "Any address",
      "Asset legend": "Device type legend",
      "Asset types": {
        "MD": "Managed device",
        "OTHER": "Other",
        "PHONE": "Phone",
        "RTR": "Router",
        "SERVER": "Server",
        "TABLET": "Tablet",
        "UD": "Unmanaged Device",
        "VPN_SERVER": "VPN server"
      },
      "Assigned to": "Assigned to",
      "Blocked": "Blocked",
      "Broader firewall range": "The firewall rule applies to a broader network",
      "Broader source range": "Broader source range",
      "Broader target range": "Broader target range",
      "Both certificate types": "Routers and clients",
      "Calculating": "Evaluating firewall rules…",
      "Certificate": "VPN certificate",
      "Certificate prefix": "Certificate prefix",
      "Certificate type": "Certificate type",
      "Certificate route": "Certificate route",
      "Certificates": "Certificates",
      "Clients only": "Clients only",
      "Choose destination": "Choose a destination certificate",
      "Choose certificate": "Choose a certificate",
      "Choose source": "Choose a source certificate",
      "Clear destination": "Clear destination",
      "Clear focus": "Clear focus",
      "Clear source": "Clear source",
      "Customer group": "Customer number",
      "Default deny": "Default deny",
      "Description": "Current VPN access based on firewall rules",
      "Details": "Details",
      "Effective access": "Effective access",
      "Explain result": "Evidence for the selected access result",
      "Explicitly blocked": "Explicitly blocked",
      "Firewall source note": "Calculated from the current firewall rules",
      "Firewalls": "Firewalls",
      "Fit": "Fit view",
      "Focused node": "Access relationships for this item are being shown.",
      "From": "From",
      "From IP": "From IP",
      "Inspector": "Inspector",
      "Inspector hint": "Select a certificate on the left to analyse its effective access.",
      "Invalid IP": "Enter a valid IPv4 address or subnet, for example 10.10.0.15 or 10.10.0.0/24.",
      "Invalid port": "Use ports from 1 through 65535, for example 443, 80,443 or 8000:8100.",
      "Load failed": "The VPN access graph could not be loaded.",
      "Matching rules": "Deciding firewall rules",
      "Network": "Network",
      "No access": "No access",
      "No access explanation": "These certificates have no allowed connection in the selected direction for the chosen protocol or port. Default deny applies when no rule matches.",
      "No blocked objects": "No blocked objects within this filter.",
      "No line means deny": "No line means default deny",
      "No matching rule": "No firewall rule allows this connection. Default deny therefore applies.",
      "No objects": "No certificates found",
      "No source selected": "No certificate selected yet",
      "Node types": {
        "certificate-pattern": "Certificate pattern",
        "client": "VPN client",
        "host-alias": "Host alias",
        "network": "External network",
        "router": "VPN router",
        "subnet": "Subnet",
        "vpn-server": "VPN server"
      },
      "Not reachable": "not reachable",
      "Nothing selected": "Nothing to inspect yet",
      "Objects": "VPN certificates",
      "Online only": "Online only",
      "One address reachable within route": "1 IP address reachable within {route}",
      "One source address within route": "Access from 1 IP address within {route}",
      "Other ports blocked": "Other ports blocked",
      "Partial": "Partial",
      "Part of": "Part of",
      "Port": "Port",
      "Port examples": "80,443 or 8000:8100",
      "Protocol": "Protocol",
      "Reachable": "reachable",
      "Read only": "Read only",
      "Relationship limit": "Showing {shown} of {total} relationships. Select a protocol or port for a more focused view.",
      "Relationships": "Relationships",
      "Route": "Route",
      "Route subnets": "Route subnets",
      "Routers only": "Routers only",
      "Search": "Search certificate name or VPN IP",
      "Select relation": "Select an object or connection in the map to inspect its details.",
      "Select destination": "Select a destination certificate",
      "Select source": "Select a source certificate",
      "Select node hint": "Choose From or To on the left and select a certificate to calculate access relationships.",
      "Source range": "Source range",
      "Source addresses within route": "Access from {count} IP addresses within {route}",
      "Source subnet within route": "Access from a limited subnet within {route}",
      "Source subnets within route": "Access from {count} limited subnets within {route}",
      "Swap endpoints": "Swap From and To",
      "Subnet reachable within route": "Limited subnet reachable within {route}",
      "Subnets reachable within route": "{count} limited subnets reachable within {route}",
      "Target range": "Target range",
      "Title": "VPN access graph",
      "To": "To",
      "To IP": "To IP",
      "VPN IP": "VPN IP",
      "VPN server": "VPN server"
    },
    "Vpn-certificates": {
      "Active": "Active",
      "Activity": "Activity",
      "AssignedTo": "Assigned to",
      "Certificate": "Certificate",
      "Certificate {NAME}": "Certificate {NAME}",
      "Certificates": "Certificates",
      "Combined": "Combined",
      "Comments": "Comments",
      "Delete": "Delete",
      "Delete item": "Delete certificate",
      "Delete item fail": "Error while deleting the certificate.",
      "Delete item success": "Certificate successfully deleted.",
      "Delete item text": "Are you sure you want to delete certificate {0}?",
      "Deleted": "Deleted",
      "DHCP": "DHCP",
      "Download": "Download",
      "Download certificate combined or separated": "Download certificate {NAME} combined or separated?",
      "Download certificate item fail": "Not able to download certificate.",
      "Download certificate item success": "Certificate successfully downloaded.",
      "Edit item": "Edit certificate",
      "Edit item fail": "Error editing certificate.",
      "Edit item success": "Certificate successfully changed.",
      "Errors": {
        "ErrorCode": {
          "FIELD_IROUTE_ALREADY_IN_USE": "Route is already in use.",
          "FIELD_IROUTE_IP_INVALID": "Routes are invalid.",
          "FIELD_NAME_INVALID_CHARS": "Valid chars: 0-9 A-z . _ -",
          "FIELD_PUSH_IROUTE_INVALID": "Not all certificates have routes configured.",
          "FIELD_PUSHCUSTOMROUTES_IP_INVALID": "Routes are invalid."
        }
      },
      "External IP": "External IP",
      "Filter": "Filter",
      "HasPushRoutes": "Has push-routes",
      "Iroute": "Route subnets (comma separated)",
      "Last seen": "Last seen",
      "Manual IP": "Static IP",
      "Name": "Name",
      "Never": "Never",
      "New item": "New certificate",
      "New item fail": "Error while creating certificate.",
      "New item success": "Certificate successfully created.",
      "No items found": "No items found",
      "Offline": "Offline",
      "Offline at": "Offline at",
      "Online": "Online",
      "Online at": "Online at",
      "PushCustomRoutes": "Push routes manually to this client (comma separated)",
      "PushIroute": "Push routes to other clients",
      "PushManualIroutes": "Push routes from selected clients to this client",
      "RedirectGateway": "Route all traffic through VPN",
      "Reset filter": "Reset",
      "Route subnets": "Route subnets",
      "RouteSubnet": "Route subnets",
      "Routing": "Routing",
      "Separated": "Separated",
      "Status": "Status",
      "StatusOptions": {
        "Offline": "Offline",
        "Online": "Online"
      },
      "Tabs": {
        "Activity": "Activity",
        "General": "General"
      },
      "VPN IP": "VPN IP",
      "Copy certificate": "Copy certificate",
      "Retry route suggestion": "Could not load available addresses. Retry",
      "Range full": "No available address within {range}",
      "Use available route": "Use available route {route}"
    },
    "Vpn-firewalls": {
      "Action": "Action",
      "Add firewall": "Add firewall",
      "Allow": "Allow",
      "Both": "TCP/UDP",
      "Cancel": "Cancel",
      "Cert": "Cert",
      "Certificate name": "Certificate name",
      "Copy": "Copy",
      "Copy of": "copy_of_",
      "Delete": "Delete",
      "Delete item": "Delete firewall",
      "Delete item fail": "Error while deleting the firewall.",
      "Delete item success": "Firewall successfully deleted.",
      "Delete item text": "Are you sure you want to delete firewall {0}?",
      "Deny": "Deny",
      "Description": "Description",
      "Error in fields": "Not all fields have been filled in correctly.",
      "Errors": {
        "ErrorCode": {
          "FIELD_FROM_CERT_INVALID": "Valid chars: 0-9 A-z _ -",
          "FIELD_FROM_INVALID": "IP is invalid.",
          "FIELD_NAME_INVALID_CHARS": "Valid chars: 0-9 A-z . _ -",
          "FIELD_PORT_INVALID": "Port is invalid.",
          "FIELD_TO_CERT_INVALID": "Valid chars: 0-9 A-z _ -",
          "FIELD_TO_INVALID": "IP is invalid."
        }
      },
      "External IP": "External IP",
      "Firewalls": "Firewalls",
      "From": "From",
      "FromType": "Type",
      "ICMP": "ICMP",
      "IP": "IP",
      "IP address": "IP address",
      "Item is saved": "{NAME} is saved.",
      "Name": "Name",
      "No items found": "No results found.",
      "No rules found": "No rules found",
      "Not saved": "Not saved",
      "On Off": "On/Off",
      "Online only": "Online only",
      "Options": "Options",
      "Port": "Port",
      "Protocol": "Protocol",
      "Reject": "Reject",
      "Reset": "Reset",
      "Save conflict": "This firewall changed in the meantime. Refresh the page, review the current rules and then save again.",
      "Rule impact": {
        "Action": "Action",
        "Close": "Close",
        "Determining rule": "Determining rule",
        "Edit": "Edit",
        "Effective": "Determining",
        "Effective pairs": "Fully determining",
        "Effective pairs help": "Number of source-to-target connections for which this rule determines all selected traffic.",
        "Error": "The impact of this rule could not be calculated.",
        "Exceptions": "Exceptions caused by earlier rules",
        "Exceptions truncated": "Not all exceptions are shown. Narrow the rule to reduce the analysis.",
        "From": "From",
        "Impact": "View impact",
        "Impact counts": "{effective} determining · {partial} partial · {shadowed} shadowed",
        "Impact summary": "Actual impact after processing the firewall order",
        "No exceptions": "This rule is determining for its entire discovered scope.",
        "No matches": "No matching connections",
        "No matches description": "The source and target selectors do not result in any analyzable connections.",
        "Pairs": "Connections",
        "Pairs help": "Total number of analyzed source-to-target connections within this rule's selectors.",
        "Partial": "Partially determining",
        "Partial pairs": "Partial",
        "Partial pairs help": "Number of source-to-target connections for which this rule determines only part of the selected traffic because earlier rules also apply.",
        "Port": "Port",
        "Protocol": "Protocol",
        "Rule": "Rule #{number}",
        "Save first": "Save the firewall first to inspect its current impact.",
        "Scope sources": "Sources in scope",
        "Scope sources help": "Number of attributable sources matched by this rule's source selector.",
        "Scope targets": "Targets in scope",
        "Scope targets help": "Number of attributable targets matched by this rule's target selector.",
        "Shadowed": "Shadowed",
        "Shadowed pairs": "Shadowed",
        "Shadowed pairs help": "Number of source-to-target connections for which this rule has no effect because earlier rules determine all selected traffic.",
        "Status effective": "Fully determining",
        "Status no-matches": "No connections",
        "Status partial": "Partially determining",
        "Status shadowed": "Fully shadowed",
        "Title": "Rule impact",
        "To": "To",
        "Unmapped": "Not fully attributable"
      },
      "Rule verification": {
        "Active": "Active",
        "Allow only help": "Verification is only available for rules that allow access.",
        "Button": "Verify rules",
        "Cancel": "Cancel",
        "Close": "Close",
        "Confirm": "Verify rule",
        "Confirm revocation": "Revoke verification",
        "Current revocation": "Revoked by {name} at {date}.",
        "Current verification": "Verified by {name} and active until {date}.",
        "Explanation": "Temporary activation of protected rules",
        "Explanation help": "Rules that require verification are only active with a valid verification. A verification may remain valid for no more than {days} days.",
        "Expired help": "The verification has expired; this rule is not active.",
        "Future required": "Select an end date and time in the future.",
        "Load failed": "The verification statuses could not be loaded.",
        "Loading": "Loading firewall verifications",
        "Maximum exceeded": "The end date must be no more than {days} days in the future.",
        "Maximum help": "The selected verification may remain valid for no more than {days} days.",
        "No description": "No description",
        "No rules": "There are no firewall rules that require verification.",
        "Not required help": "This rule is active without separate verification.",
        "Reason": "Reason for verification",
        "Reason required": "Enter a reason for the verification.",
        "Refresh": "Refresh verification statuses",
        "Replacement help": "A new verification replaces the current one for this exact rule version and may shorten or extend its expiry.",
        "Revoke": "Revoke",
        "Revoke failed": "The verification could not be revoked.",
        "Revoke title": "Revoke firewall verification",
        "Revocation changed": "The verification or firewall rule changed in the meantime. Refresh the overview and review the current status.",
        "Revocation reason": "Reason for revocation",
        "Revocation reason required": "Enter a reason for the revocation.",
        "Revocation warning": "The firewall rule becomes inactive immediately. This revocation is recorded immutably.",
        "Revoked": "The firewall verification was revoked.",
        "Revoked help": "The verification was revoked; this rule is not active.",
        "Rule changed": "The firewall rule changed in the meantime. Review the current rule and try again.",
        "Required": "Verification required",
        "Required help": "This rule only becomes active after a valid verification.",
        "Required rules": "Rules requiring verification",
        "Requires attention": "Requires attention",
        "Status": {
          "active": "Active",
          "expired": "Expired",
          "revoked": "Revoked",
          "unverified": "Not verified"
        },
        "Subtitle": "Manage rules that only become active after temporary approval",
        "Title": "Verify firewall rules",
        "Try again": "Try again",
        "Unverified help": "This rule has not been verified yet and is therefore not active.",
        "Valid until": "Active until",
        "Verified": "The firewall rule has been verified.",
        "Verify": "Verify",
        "Verify again": "Verify again",
        "Verify failed": "The firewall rule could not be verified.",
        "Verify title": "Verify firewall rule"
      },
      "Rules analysis": {
        "All ports score": "All ports",
        "Analyzing": "Analyzing firewall rules",
        "Analyzing help": "The first-match order and effective source-to-target connections are being calculated.",
        "Button": "Rule analysis",
        "Close": "Close",
        "Completed in": "Analysis completed in {duration}",
        "Determined by": "Previously determined by",
        "Determining rule": "Determining firewall rule",
        "Direct lateral access": "Direct lateral access",
        "Error": "The rule analysis could not be completed.",
        "Fully shadowed": "Fully shadowed",
        "High risk": "High risk",
        "Invalid rules": "{count} rules could not be fully analyzed. Check these rules for invalid values.",
        "Lateral access": "Lateral access",
        "Lateral access help": "Allow rules that directly permit access from a managed certificate, iroute or VPN-server network to another managed network. External and unknown networks are excluded.",
        "Lateral scope": "Connections: {connections} · source networks: {sources} · target networks: {targets}",
        "Medium risk": "Elevated risk",
        "No description": "No description",
        "No lateral access": "No direct access between different managed networks was found.",
        "No matching scope": "No attributable scope",
        "No risky rules": "No broadly configured risk rules found.",
        "No unused rules": "No structurally unused rules found.",
        "Not listed": "Not listed",
        "Part of": "part of",
        "Port score": "Number of ports",
        "Protocol score": "Protocols",
        "Refresh": "Run analysis again",
        "Results truncated": "The analysis contains more results than are shown in this dialog.",
        "Risk reasons": {
          "all-ports": "All ports",
          "both-protocols": "TCP and UDP",
          "from-any": "From anyone",
          "from-broad-network": "Broad source network",
          "large-scope": "Very many connections",
          "many-ports": "Very many ports",
          "multiple-connections": "Many connections",
          "multiple-ports": "Multiple ports",
          "to-any": "To anyone",
          "to-broad-network": "Broad target network"
        },
        "Risky": "Risky rules",
        "Risky help": "Allow rules with a broad source, broad target, many ports or a large discovered scope. The score is a heuristic indication of configuration risk.",
        "Scope score": "Discovered source-target connections",
        "Score explanation": "How configuration risk is calculated",
        "Score explanation help": "Only allow rules with effective impact are assessed. Points for source, target, protocols, ports and discovered scope form the OMNI configuration risk score, capped at 100.",
        "Selector any": "Any / everyone",
        "Selector narrow": "Certificate or IP /25–/32",
        "Selector score": "Source and target (per side)",
        "Single protocol": "One protocol",
        "Rules analyzed": "Rules analyzed",
        "Rules analyzed help": "Number of stored firewall rules calculated using the current first-match order.",
        "Source": "Source",
        "Source any": "Source: any",
        "Structural analysis": "Structural configuration analysis",
        "Structural analysis help": "Unused means no attributable scope or fully shadowed by earlier rules. Without iptables hit counters, the analysis cannot determine whether an effective rule processes real traffic.",
        "Subtitle": "Unused rules, broad access and direct network crossing",
        "Target": "Target",
        "Target any": "Target: any",
        "Title": "Rule analysis",
        "Try again": "Try again",
        "Unused": "Unused rules",
        "Unused help": "Rules without an attributable source-to-target connection, or rules whose selected traffic is fully determined earlier in the firewall order.",
        "View rule": "View rule"
      },
      "Verification logs": {
        "Button": "Verification logs",
        "Clear search": "Clear search",
        "Close": "Close",
        "Details": "Verification details",
        "Event time": "Event time",
        "Expired": "Expired",
        "Firewall": "Firewall",
        "Load failed": "The verification logs could not be loaded.",
        "No logs": "No verification logs found.",
        "No results": "No verification logs found for this search.",
        "Performed by": "Performed by",
        "Reason": "Reason",
        "Refresh": "Refresh logs",
        "Route": "Connection",
        "Rule": "Rule",
        "Rule snapshot": "Firewall rule at the time of verification",
        "Revocation reason": "Reason for revocation",
        "Revoked at": "Revoked at",
        "Revoked by": "Revoked by",
        "Search": "Search by firewall, reason or employee",
        "Status": "Status",
        "Status values": {
          "Active": "Active",
          "Expired": "Expired",
          "Policy changed": "Invalidated by policy change",
          "Revoked": "Revoked",
          "Rule removed": "Rule removed",
          "Superseded": "Replaced by newer verification",
          "Unknown": "Status unknown"
        },
        "Subtitle": "Immutable record of temporary firewall verifications",
        "Title": "Firewall verification logs",
        "Try again": "Try again",
        "Valid until": "Valid until",
        "Verified at": "Verified at",
        "Verified by": "Verified by",
        "View details": "View details"
      },
      "Rules": "Rules",
      "Rules count": "{count} rule | {count} rules",
      "Save": "Save",
      "TCP": "TCP",
      "To": "To",
      "ToType": "Type",
      "Type": "Type",
      "UDP": "UDP",
      "VPN IP": "VPN IP"
    },
    "Vpn-mac-address-groups": {
      "Action": "Action",
      "Add group": "Add group",
      "Address": "MAC address",
      "BandwidthDown": "Bandwidth down (KBs)",
      "BandwidthUp": "Bandwidth up (KBs)",
      "Block": "Block",
      "Cancel": "Cancel",
      "Copy": "Copy",
      "Copy of": "copy_of_",
      "Delete": "Delete",
      "Delete item": "Delete group",
      "Delete item fail": "Error while deleting the group.",
      "Delete item success": "Group successfully deleted.",
      "Delete item text": "Are you sure you want to delete group {0}?",
      "Description": "Description",
      "Error in fields": "Not all fields have been filled in correctly.",
      "Errors": {
        "ErrorCode": {
          "FIELD_BANDWIDTH_DOWN_INVALID": "Invalid bandwidth down.",
          "FIELD_BANDWIDTH_UP_INVALID": "Invalid bandwidth up.",
          "FIELD_MAC_ADDRESS_INVALID": "MAC address is invalid.",
          "FIELD_MAC_ADDRESS_NOT_UNIQUE": "MAC address is not unique.",
          "FIELD_NAME_INVALID_CHARS": "Valid chars: 0-9 A-z . _ -"
        }
      },
      "Item is saved": "{NAME} is saved.",
      "Mac Addresses": "MAC addresses",
      "MACs": "MAC addresses",
      "MACs count": "{count} rule | {count} rules",
      "Name": "Name",
      "No items found": "No MAC address groups found",
      "No MACs found": "No MAC addresses found",
      "Not saved": "Not saved",
      "Options": "Options",
      "Pass": "Pass",
      "Reset": "Reset",
      "Save": "Save"
    },
    "Webhooks/health-status": {
      "5 mins": "5 mins | 5 min avg",
      "15 mins": "15 mins",
      "Actions": "Actions",
      "Adapters": "Adapters",
      "AgentPlatform": "Platform",
      "AgentPlatformOptions": {
        "Pfsense": "pfSense router",
        "Raspberry-pi": "Raspberry Pi",
        "Teltonika": "Teltonika router",
        "Ubuntu": "Ubuntu Server",
        "Ubuntu-client": "Ubuntu Client",
        "Windows": "Windows Server",
        "Windows-client": "Windows Client"
      },
      "AgentVersion": "Agent version",
      "Assets": "Assets",
      "Available updates": "Available updates",
      "Bulk actions": {
        "Label": "Bulk actions",
        "SetCheckForUpdate": "Set 'Check for updates' for all | Unset 'Check for updates' for all",
        "SetCleanupPackages": "Set 'Cleanup packages' for all | Unset 'Cleanup packages' for all",
        "SetDownloadUpdate": "Set 'Download updates' for all | Unset 'Download updates' for all",
        "SetInstallModemUpdate": "Set 'Install modem updates' for all | Unset 'Install modem updates' for all",
        "SetInstallUpdate": "Set 'Install updates' for all | Unset 'Install updates' for all",
        "SetRebootAfterUpdate": "Set 'Reboot after updates' for all | Unset 'Reboot after updates' for all",
        "SetRebootNow": "Set 'Reboot now' for all | Unset 'Reboot now' for all",
        "SetRebootWhenNoUser": "Set 'Reboot when no user' for all | Unset 'Reboot when no user' for all"
      },
      "CPU": "CPU",
      "CPU cores": "CPU cores",
      "CPU load average": "Load average",
      "CPU load percentage": "Load percentage",
      "Current": "Current",
      "Current version": "Current version",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete asset",
      "Delete item fail": "Error deleting the asset.",
      "Delete item success": "Successfully deleted the asset.",
      "Delete item text": "Are you sure you want to {1} the asset {0}?",
      "Disks": "Disks",
      "Enable auto refresh": "Auto refresh",
      "ExecuteCommands": {
        "CheckForUpdates": "Check for updates",
        "CleanupPackages": "Cleanup packages",
        "DownloadUpdates": "Download updates",
        "InstallModemUpdates": "Install modem updates",
        "InstallUpdates": "Install updates",
        "RebootAfterUpdates": "Reboot after updates",
        "RebootNow": "Reboot now",
        "RebootWhenNoUsers": "Reboot when no users"
      },
      "HasUpdates": "Updates available",
      "Health-status": "Health status | Health statuses",
      "History": "History",
      "Hostname": "Hostname",
      "Memory": "Memory",
      "Metadata": "Metadata",
      "Name": "Name",
      "NeedsReboot": "Reboot required",
      "New version": "New version",
      "Nothing to update": "There are no changes to save.",
      "Operating system": "Operating system",
      "Path": "Path",
      "Select customer": "Select customer",
      "signedInUsers": "Signed in users",
      "Status": "Status",
      "StatusOptions": {
        "Degraded": "Degraded",
        "Healthy": "Healthy",
        "NeedsReboot": "Reboot",
        "Unhealthy": "Unhealthy"
      },
      "Updated items success": "Successfully changed settings.",
      "UpdatedAt": "Updated at",
      "Updates": "Updates",
      "Uptime": "Uptime"
    },
    "Webhosting": {
      "Account": "Account",
      "Account has error": "This account has an error state.",
      "Account pending": "This account is in a pending state.",
      "Account suspended": "This account is suspended.",
      "AccountEmailAddress": "Notification email address",
      "Autologin": "Autologin into {product}",
      "Autologin item fail": "Autologin failed. {msg}",
      "Autologin item success": "The web hosting control panel has been opened in a new tab.",
      "Bandwidth quota does not match package settings": "Bandwidth quota does not match package settings.",
      "Bandwidth quota exceeds limit": "Bandwidth quota exceeds limit.",
      "BandwidthQuota": "Bandwidth quota",
      "Confirm delete": "I'm aware that deleting this account, will also delete the cPanel account and all correpsonding data.",
      "Cpanel": "cPanel",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete hosting account",
      "Delete item fail": "Error deleting the hosting account. {msg}",
      "Delete item success": "Hosting account {item} successfully deleted.",
      "Delete item text": "Are you sure you want to {1} account {0}?",
      "Directadmin": "DirectAdmin",
      "Disk quota does not match package settings": "Disk quota does not match package settings.",
      "Disk quota exceeds limit": "Disk quota exceeds limit.",
      "Disk Space": "Disk space",
      "DiskQuota": "Disk quota",
      "DiskspaceMB": "Disk space (MB)",
      "Edit item": "Edit hosting account",
      "Edit item fail": "Error changing the hosting account. {msg}",
      "Edit item success": "Successfully changed hosting account.",
      "Errors": {
        "ErrorCode": {
          "CPANEL_CREATE_ACCOUNT_USERNAME_ALREADY_IN_USE": "Given username is not available.",
          "FIELD_SUBSCRIPTION_IS_REQUIRED": "Subscription is a required field.",
          "PASSWORD_CONTAINS_INVALID_CHARACTERS": "Password contains illegal characters."
        }
      },
      "HasSubscription": "Has a subscription",
      "Hide password": "Hide password",
      "Mail account details": "Mail account details",
      "Name": "Name",
      "New item": "New hosting account",
      "New item fail": "Error creating the new hosting account. {msg}",
      "New item success": "Successfully created hosting account.",
      "New item success with warning": "Successfully created hosting account, but with warning(s). {warning}",
      "No password set": "No password is set, or present in our database, for this account.",
      "No subscription set": "No subscription is set for this account!",
      "Package does not match subscription product": "Configured package does not match with subscription.",
      "Packages dont match": "Configured package in cPanel does not match Vision.",
      "Password": "Password",
      "PrimaryDomain": "Primary domain",
      "PrimaryIP": "Primary IP",
      "ServerUrl": "Server URL",
      "Show password": "Show password",
      "Status": "Status",
      "StatusOptions": {
        "Active": "Active",
        "Error": "Error",
        "Pending": "Pending",
        "Suspended": "Suspended"
      },
      "Subscription": "Subscription",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Customer"
        }
      },
      "Tabs": {
        "Domains": "Domains",
        "General": "General"
      },
      "Unlimited": "Unlimited",
      "Username": "Username",
      "WebhostingPackage": "Hosting package"
    },
    "Webhosting-packages": {
      "Bandwidth": "Bandwidth",
      "BandwidthMB": "Bandwidth (MB)",
      "Delete": "delete",
      "Delete item": "Delete hosting package",
      "Delete item fail": "Error deleting the hosting package. {msg}",
      "Delete item success": "Succesfully deleted hosting package.",
      "Delete item text": "Are you sure you want to {1} package {0}?",
      "Disk Space": "Disk space",
      "DiskspaceMB": "Disk space (MB)",
      "Edit item": "Edit hosting package",
      "Edit item fail": "Error changing the hosting package. {msg}",
      "Edit item success": "Successfully changed hosting package.",
      "Name": "Name",
      "New item": "New hosting package",
      "New item fail": "Error creating the new hosting package. {msg}",
      "New item success": "Successfully created hosting package.",
      "Product": "Product",
      "SupplierPackageName": "Supplier package name",
      "Webhosting package": "Webhosting package"
    },
    "Webhosting-send-account-details": {
      "Change password": "Change password?",
      "Change password now": "Change the password in the cPanel account",
      "Email address": "Email address",
      "Mail details": "Your hosting account details will be sent to the following email address:",
      "New password": "New cPanel password",
      "Randomize password": "Randomize password",
      "Send account details item": "Send account details",
      "Send account details item fail": "Unable to send account details. {msg}",
      "Send account details item success": "Account details were sent successfully.",
      "Send mail": "Send mail"
    },
    "Sharingcenter-calendars": {
      "Calendar": "Calendar",
      "Calendars": "Calendar | Calendars",
      "Color": "Color",
      "CreatedAt": "Created at",
      "Customer": "Customer",
      "Change owner": "Change owner",
      "Delete": "delete",
      "Delete item": "Delete calendar",
      "Delete item fail": "Error while deleting the calendar. {msg}",
      "Delete item success": "Calendar successfully deleted.",
      "Delete item text": "Are you sure you want to {1} calendar {0}?",
      "Edit item": "Edit calendar",
      "Edit item fail": "Error editing calendar. {msg}",
      "Edit item success": "Calendar successfully changed.",
      "Groups": "Groups",
      "Name": "Name",
      "New item": "New calendar",
      "New item fail": "Error while creating calendar. {msg}",
      "New item success": "Calendar successfully created.",
      "Owner": "Owner",
      "Permissions": {
        "AvailabilityOnly": "Availability only",
        "Editor": "Editor",
        "Owner": "Owner",
        "Viewer": "Viewer"
      },
      "Remove appointments": "Remove appointments",
      "Search": "Search",
      "SharedWith": "Shared with",
      "SharedWithGroups": "Shared with groups",
      "SharedWithUsers": "Shared with users",
      "Tabs": {
        "General": "General"
      },
      "Take over appointments": "Transfer appointments to the new owner",
      "UpdatedAt": "Updated at",
      "User": "Owner",
      "Users": "Users",
      "What to do with appointments": "What would you like to do with the existing appointments?"
    },
    "Sharingcenter-contacts": {
      "Cancel": "Cancel",
      "Confirm owner or sharing change": "Owner or sharing change",
      "Confirm owner or sharing text": "Changing the owner or sharing settings may affect existing appointments that use this contact.",
      "Contact": "Contact",
      "Contacts": "Contact | Contacts",
      "Continue": "Continue",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete contact",
      "Delete item fail": "Error while deleting the contact. {msg}",
      "Delete item success": "Contact successfully deleted.",
      "Delete item text": "Are you sure you want to {1} contact {0}?",
      "Editor": "Editor",
      "Edit item": "Edit contact",
      "Edit item fail": "Error editing contact. {msg}",
      "Edit item success": "Contact successfully changed.",
      "Email": "Email address",
      "FirstName": "First name",
      "Groups": "Groups",
      "Keep appointments unchanged": "Keep appointments unchanged",
      "LastName": "Last name",
      "New item": "New contact",
      "New item fail": "Error while creating contact. {msg}",
      "New item success": "Contact successfully created.",
      "Owner": "Owner",
      "Phone": "Phone",
      "Resolve future appointments": "Resolve future appointments",
      "Search": "Search",
      "SharedWith": "Shared with",
      "SharedWithGroups": "Shared with groups",
      "SharedWithUsers": "Shared with users",
      "Tabs": {
        "General": "General"
      },
      "This contact is linked to upcoming appointments, what would you like to do": "This contact is linked to {count} upcoming appointment(s). What would you like to do?",
      "Update participants with new contact info": "Update participants with new contact info",
      "User": "Owner",
      "Users": "Users",
      "Viewer": "Viewer"
    },
    "Sharingcenter-groups": {
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete group",
      "Delete item fail": "Error while deleting the group. {msg}",
      "Delete item success": "Group successfully deleted.",
      "Delete item text": "Are you sure you want to {1} group {0}?",
      "Edit item": "Edit group",
      "Edit item fail": "Error editing group. {msg}",
      "Edit item success": "Group successfully changed.",
      "Group": "Group",
      "Groups": "Group | Groups",
      "Name": "Name",
      "New item": "New group",
      "New item fail": "Error while creating group. {msg}",
      "New item success": "Group successfully created.",
      "Tabs": {
        "General": "General"
      },
      "Users": "Users"
    },
    "Sharingcenter-profiles": {
      "Cancel": "Cancel",
      "Confirm owner or sharing change": "Owner or sharing change",
      "Confirm owner or sharing text": "Changing the owner or sharing settings may unlink this profile from existing appointments.",
      "Continue": "Continue",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete item": "Delete profile",
      "Delete item fail": "Error while deleting the profile. {msg}",
      "Delete item success": "Profile successfully deleted.",
      "Delete item text": "Are you sure you want to {1} profile {0}?",
      "Description": "Description",
      "Editor": "Editor",
      "Edit item": "Edit profile",
      "Edit item fail": "Error editing profile. {msg}",
      "Edit item success": "Profile successfully changed.",
      "Groups": "Groups",
      "IsPublic": "Public",
      "Name": "Name",
      "New item": "New profile",
      "New item fail": "Error while creating profile. {msg}",
      "New item success": "Profile successfully created.",
      "Owner": "Owner",
      "OwnerId": "Owner",
      "Private": "Private",
      "Profile": "Profile",
      "Profiles": "Profile | Profiles",
      "Public": "Public",
      "Search": "Search",
      "SharedWith": "Shared with",
      "SharedWithGroups": "Shared with groups",
      "SharedWithUsers": "Shared with users",
      "Tabs": {
        "General": "General",
        "Settings": "Settings"
      },
      "Type": "Type",
      "TypeOptions": {
        "Fileshare": "Fileshare",
        "Screenshare": "Screenshare",
        "Chat": "Chat",
        "Meeting": "Meeting"
      },
      "User": "Owner",
      "Users": "Users",
      "Viewer": "Viewer"
    },
    "Sharingcenter-meeting-logs": {
      "Customer": "Customer",
      "Status": "Status"
    },
    "Sharingcenter-ai-queue": {
      "Status": "Status",
      "TaskType": "Task"
    },
    "MicrosoftSignInMonitor": {
      "cardHints": {
        "total": "Unique Microsoft tenants for active customers with the Graph integration enabled. Each tenant is counted once.",
        "available": "Monitoring is available and the most recent successful Graph check is no more than 30 minutes old.",
        "license": "Graph reports that the required license is missing. The monitor retries after 24 hours without sending an outage email. These tenants are not included in Needs attention.",
        "attention": "Monitoring is unavailable, the most recent successful check is more than 30 minutes old, or no monitoring status is known yet. A successful check removes the tenant from this count. Refresh the overview to see the latest status."
      },
      "all": "All",
      "title": "Microsoft sign-in monitor",
      "refresh": "Refresh",
      "updated": "Updated at {time}",
      "overview": "Tenant status",
      "history": "Sign-in history",
      "scope": "Monitoring azure-admin and omni-break-glass accounts. History also includes changes in monitor availability.",
      "total": "Configured tenants",
      "available": "Active monitoring",
      "license": "License restriction",
      "attention": "Needs attention",
      "search": "Search customer, tenant or account",
      "StatusFilter": "Monitoring status",
      "KindFilter": "Event",
      "DeliveryFilter": "Delivery",
      "Period": "Period",
      "days": "Last {count} days",
      "customer": "Customer / tenant",
      "status": "Monitoring status",
      "lastSuccess": "Last successful check",
      "lastFailure": "Last failed check",
      "nextPoll": "Scheduled retry",
      "regularPoll": "Regular polling schedule",
      "notChecked": "Not checked yet",
      "openHistory": "View history",
      "time": "Time",
      "account": "Account / event",
      "result": "Result",
      "delivery": "Delivery",
      "noRows": "No results",
      "noRowsHint": "No records match this selection.",
      "error": "Monitor data could not be loaded. Please try again.",
      "retry": "Try again",
      "forbidden": "You do not have access to the Microsoft sign-in monitor.",
      "policy": "A license restriction is retried after 24 hours without an outage email. A one-time notification follows when monitoring becomes available.",
      "staleHint": "A successful check older than 30 minutes is shown as outdated. Refresh retrieves the stored overview.",
      "historyHint": "Events are retained for 90 days. Delivery status shows whether email processing has sent the notification.",
      "tenantFilter": "History for {name}",
      "clearTenant": "All tenants",
      "details": "Event details",
      "close": "Close",
      "eventId": "Event ID",
      "tenantId": "Tenant ID",
      "detectedAt": "Detected",
      "sentAt": "Sent at",
      "queuedAt": "Queued since",
      "app": "Application",
      "resource": "Resource",
      "ip": "IP address",
      "location": "Location",
      "reason": "Reason / explanation",
      "errorCode": "Error code",
      "interactive": "Interactive sign-in",
      "yes": "Yes",
      "no": "No",
      "unknown": "Not available",
      "delay": "Delay",
      "seconds": "{count} seconds",
      "success": "Successful",
      "failed": "Unsuccessful",
      "intermediate": "Intermediate step",
      "statuses": {
        "available": "Active",
        "license-restricted": "License restriction",
        "unavailable": "Unavailable",
        "waiting": "Not checked yet",
        "stale": "Outdated check"
      },
      "kinds": {
        "sign-in": "Sign-in",
        "availability": "Monitoring active",
        "health": "Monitoring unavailable",
        "recovery": "Monitoring restored"
      },
      "deliveries": {
        "sent": "Sent",
        "queued": "Queued",
        "pending": "Pending delivery",
        "suppressed": "No notification"
      },
      "suppressedHint": "The choice to stay signed in (50140) is an intermediate step and does not trigger a notification.",
      "searchTenant": "Search customer or tenant",
      "diagnostics": {
        "stage": "Failed step",
        "code": "Technical error code",
        "action": "Next action",
        "current": "Latest failure",
        "stages": {
          "token": "Request token",
          "graph": "Retrieve sign-ins",
          "monitor": "Sign-in check"
        },
        "reasons": {
          "TIMEOUT": "Microsoft did not respond within 60 seconds.",
          "DNS": "The Microsoft hostname could not be resolved.",
          "CONNECTION": "The connection to Microsoft was refused or interrupted.",
          "TLS": "The secure connection to Microsoft could not be verified.",
          "SOURCE_ERROR": "The check failed without a more specific recorded cause.",
          "INVALID_JSON": "Microsoft did not return valid JSON.",
          "SECRET_EXPIRED": "The Microsoft app registration client secret has expired (AADSTS7000222).",
          "SECRET_INVALID": "Microsoft rejected the client secret (AADSTS7000215).",
          "APP_NOT_FOUND": "The app registration was not found in the configured tenant (AADSTS700016).",
          "CONFIGURATION_MISSING": "The tenant ID, app ID or client secret is missing.",
          "CONFIGURATION_INVALID": "The Microsoft Graph configuration is invalid.",
          "TOKEN_MISSING": "Microsoft did not return an access token.",
          "INVALID_RESPONSE": "Microsoft did not return a valid list of sign-ins.",
          "INVALID_NEXT_LINK": "Microsoft returned an invalid next page.",
          "INVALID_EVENT": "A sign-in event contains invalid data.",
          "LEASE_LOST": "The monitor lost exclusive processing of this check.",
          "STORAGE_ERROR": "Sign-in data could not be stored.",
          "LICENSE_RESTRICTED": "Microsoft denied sign-in retrieval because of a license or access prerequisite restriction.",
          "UNAUTHORIZED": "Microsoft rejected authentication (HTTP {status}).",
          "FORBIDDEN": "Microsoft denied access (HTTP {status}).",
          "THROTTLED": "Microsoft is limiting the number of requests (HTTP {status}).",
          "SERVER_ERROR": "Microsoft reported a server error (HTTP {status}).",
          "HTTP_ERROR": "Microsoft rejected the request (HTTP {status})."
        },
        "actions": {
          "TIMEOUT": "Check connectivity and Microsoft service availability. The monitor will retry.",
          "DNS": "Check DNS and the Vision server network connection.",
          "CONNECTION": "Check the network, proxy and firewall. The monitor will retry.",
          "TLS": "Check certificates, system time and any TLS inspection.",
          "SOURCE_ERROR": "The exact cause of this notification can no longer be determined. Check the current tenant status or a subsequent check for a more specific diagnosis.",
          "INVALID_JSON": "Check Microsoft service availability and possible proxy errors.",
          "SECRET_EXPIRED": "Renew the secret and update the Graph integration in Vision.",
          "SECRET_INVALID": "Check the secret value in the Graph integration and app registration.",
          "APP_NOT_FOUND": "Check the tenant ID, app ID and application consent.",
          "CONFIGURATION_MISSING": "Complete the Microsoft Graph integration for this customer.",
          "CONFIGURATION_INVALID": "Check the configured endpoints and scope.",
          "TOKEN_MISSING": "Check the app registration and Graph integration.",
          "INVALID_RESPONSE": "The check was not recorded as successful. Check the Microsoft service.",
          "INVALID_NEXT_LINK": "The monitor refused it. The check will be retried.",
          "INVALID_EVENT": "The checkpoint was not advanced. Investigate the source data.",
          "LEASE_LOST": "Check the jobs and database connection.",
          "STORAGE_ERROR": "Check the database and validation. The checkpoint was not advanced.",
          "LICENSE_RESTRICTED": "Check the Entra license. A new check follows after 24 hours.",
          "UNAUTHORIZED": "Check the app registration and Graph integration.",
          "FORBIDDEN": "Check Graph permissions, administrator consent and license prerequisites.",
          "THROTTLED": "The monitor will retry at the next check.",
          "SERVER_ERROR": "Check Microsoft service availability. The monitor will retry.",
          "HTTP_ERROR": "Check the Graph configuration and supported request."
        }
      }
    },
    "AdminApiAccounts": {
      "Accounts": "Admin API accounts",
      "Customer accounts": "Customer accounts",
      "Admin accounts": "Admin accounts",
      "Account": "Admin API account",
      "New account": "New admin account",
      "Scope explanation": "These API accounts work without a customer association. Assign only the internal roles needed by the integration.",
      "Rotate token": "Regenerate API token",
      "Delete account": "Delete admin account",
      "Rotate confirmation": "Regenerate the API token for {name}? The current token and its issued access tokens will immediately become invalid.",
      "Delete confirmation": "Delete admin account {name}? API access will be revoked immediately."
    },
    "Stock-movements": {
      "Type": "Movement type",
      "StockInfo": {
        "product": "Product"
      },
      "New item": "Stock action",
      "Edit item": "Stock action",
      "View item": "Stock movements",
      "Receive": "Receive",
      "Product": "Product",
      "PurchaseDate": "Purchase date",
      "Amount": "Quantity",
      "RegistrationMode": "Registration",
      "Location": "Location",
      "Position": "Position",
      "SupplierWarranty": "Supplier warranty",
      "CustomerWarranty": "Customer warranty",
      "StartDate": "Start date",
      "DurationMonths": "Duration in months",
      "ScanInput": "Scan serial number",
      "PasteInput": "Paste serial numbers, one per line",
      "Customer": "Recipient / customer",
      "SalesOrder": "Sales order",
      "SalesOrderLine": "Sales order line",
      "DeliveryMode": "Customer delivery",
      "RelatedMovement": "Original issue",
      "AllowReallocation": "Explicitly reallocate",
      "Reason": "Reason",
      "Memo": "Stock note",
      "Errors": {
        "ErrorCode": {
          "STOCK_PRICES_UNKNOWN": "The purchase or sales price for the purchase date is missing. Enter the missing price before booking the receipt."
        }
      }
    },
    "Stock-locations": {
      "New item": "New stock location",
      "Edit item": "Stock location",
      "View item": "Stock location",
      "Name": "Name",
      "Description": "Description",
      "Customer": "Customer",
      "Positions": "Bins",
      "Add Positions item": "Add bin",
      "Delete Positions item": "Remove bin"
    },
    "Logistics": {
      "Internal": "Internal",
      "Customer stock": "Customer stock",
      "Unknown": "Unknown",
      "Months": "months",
      "Asset": "Asset",
      "Warranties": "Warranties",
      "History": "History",
      "Stock details": "Stock details",
      "Show empty stock": "Also show issued stock",
      "Open details": "Open details",
      "Open tracking": "View shipment",
      "Quantity registration": "By quantity",
      "Saved": "The information was saved.",
      "Asset details": "Asset details",
      "Receipt details": "Receipt",
      "Last delivery": "Last delivery",
      "Current warehouse position": "Current warehouse position",
      "Last warehouse position": "Last warehouse position",
      "Write-off date": "Write-off date",
      "Open sales order": "Open sales order",
      "Open purchase order": "Open purchase order",
      "Source location": "From location",
      "Source position": "From bin",
      "Destination location": "To location",
      "Destination position": "To bin",
      "Returned by": "Returned by",
      "Source warehouse position": "From location / bin",
      "Destination warehouse position": "To location / bin",
      "No warehouse position": "No current warehouse position",
      "Location explanation": "Bins belong to this location. Without a customer, stock is internal; with a customer it is allocated to that customer. Occupied bins are retained.",
      "Order explanation": "Product codes and supplier URLs remain on the product. Before closing or cancelling, enter the cancelled remainder and reason per line. Received quantities are retained.",
      "Warranty explanation": "Supplier and customer warranties have separate start dates and durations. Empty means unknown; 0 means no warranty. Customer warranty starts with its related customer delivery.",
      "Fields": {
        "Name": "Name",
        "Number": "Number",
        "Product": "Product",
        "Date": "Date",
        "Booked on": "Booked on",
        "Status": "Status",
        "Type": "Type",
        "Customer": "Customer",
        "Positions": "Bins",
        "Location": "Location",
        "Position": "Bin",
        "Amount": "Quantity",
        "Total": "Total present",
        "Received": "Received",
        "Remaining": "Remaining",
        "Tracking": "Tracking",
        "Serial": "Serial number",
        "Previous serial": "Previous serial number",
        "New serial": "New serial number",
        "Situation": "Situation",
        "Where": "Storage / last recipient",
        "Purchase date": "Acquisition date",
        "Purchase price": "Purchase price",
        "Sales price": "Sales price",
        "Balance": "Before / after",
        "Reason": "Reason",
        "Delivery date": "Delivery date",
        "Received date": "Receipt date",
        "Delivered to": "Delivered to",
        "Sales order": "Sales order",
        "Warranty end": "End date",
        "Delivery reference": "Delivery",
        "Actor": "User"
      },
      "Errors": {
        "Load": "The information could not be loaded.",
        "Save": "Saving failed.",
        "Required": "Complete the required fields.",
        "Duplicate positions": "Bin names must be unique within this location.",
        "Received line": "A received product line cannot be removed.",
        "Order lines": "Check the date, products, quantities and cancellation reasons.",
        "Tracking URL": "Use a full http or https URL.",
        "Warranty": "Enter both start dates and a whole duration from 0 months, or leave the duration empty.",
        "Duplicate serial": "Serial number {serial} is already in this receipt.",
        "Serial count": "Serial numbers cannot exceed the quantity to receive.",
        "Registered serial": "Serial number {serial} is already registered. Use a return for an asset coming back.",
        "Serial check": "Serial numbers could not be checked. Your input has been preserved.",
        "Receipt selection": "Select at least one product to receive now.",
        "Receipt fields": "Check the highlighted fields in this product line.",
        "Receipt product": "Choose the product you are receiving.",
        "Receipt purchase date": "Enter a valid acquisition date, or leave an unknown date empty.",
        "Receipt amount": "Enter a whole quantity of at least 1. Not receiving this product now? Uncheck the product line.",
        "Receipt maximum": "You can receive at most {remaining} more.",
        "Receipt location": "Choose a stock location.",
        "Receipt position": "Choose a valid bin within the selected location.",
        "Receipt allocation total": "You have allocated {allocated}, but are receiving {amount}. Allocate exactly {amount} across the storage positions.",
        "Receipt serial count": "You have added {count} serial numbers, but are receiving {amount}. Add exactly {amount} serial numbers or adjust the quantity.",
        "Warranty start": "Enter a valid start date of this warranty.",
        "Warranty duration": "Use a whole duration from 0 to 1200 months, or leave it empty.",
        "Action quantity": "Enter a valid whole quantity matching the available stock.",
        "Reason": "Enter a reason for this stock action.",
        "Placement": "Choose a location with a valid storage position.",
        "Related issue": "Choose the corresponding original issue.",
        "Sales order customer": "Choose a customer first, then a sales order for that customer.",
        "Sales order line": "Choose a matching product line from the selected sales order.",
        "Stock changed": "This item has changed or moved. Refresh the stock and try again.",
        "Serial required": "Enter a serial number.",
        "Serial duplicate": "This serial number is already registered for this product.",
        "Supplier required": "Select a supplier."
      },
      "Order statuses": {
        "open": "Open",
        "ordered": "Ordered",
        "partially_received": "Partially received",
        "received": "Received",
        "closed": "Closed",
        "cancelled": "Cancelled"
      },
      "Situations": {
        "in_stock": "In stock",
        "reserved": "Reserved",
        "issued": "Issued",
        "written_off": "Written off",
        "unknown": "Unknown"
      },
      "Warranty statuses": {
        "valid": "Valid",
        "expired": "Expired",
        "not_started": "Not started",
        "none": "No warranty",
        "unknown": "Unknown",
        "expiring_soon": "Expires within 30 days"
      },
      "Warranty kinds": {
        "supplier": "Supplier warranty",
        "customer": "Customer warranty"
      },
      "Warranty reasons": {
        "changed": "Changed",
        "new_delivery": "New customer delivery"
      },
      "Movement types": {
        "receipt": "Receipt",
        "opening": "Opening stock",
        "issue": "Issue",
        "transfer": "Transfer",
        "return": "Return",
        "adjustment": "Adjustment",
        "write_off": "Write-off",
        "reserve": "Reserve",
        "release": "Release reservation"
      },
      "Serial registration": "With serial numbers",
      "Receive": "Receive goods",
      "Opening stock": "Register opening stock",
      "Opening explanation": "Register existing stock without a purchase order. Leave an unknown purchase date empty. Choose quantities or serial numbers per product.",
      "Receipt selection explanation": "Select only the products delivered now. Uncheck the other lines; they remain open for a later delivery.",
      "Select receipt line": "Receive: {product}",
      "Not receiving now": "Not receiving now",
      "Add product line": "Add product line",
      "Remove line": "Remove product line",
      "Line progress": "Receive {amount} of {remaining} remaining",
      "Scan and paste": "Scan and paste",
      "Scan label": "Scan or enter a serial number and press Enter",
      "Serial progress": "{count} of {amount}",
      "Add pasted serials": "Add pasted serial numbers",
      "Remove serial": "Remove serial number",
      "Add allocation": "Add storage position",
      "Remove allocation": "Remove storage position",
      "Default serial placement": "Storage position for new serial numbers (optional)",
      "Default serial placement explanation": "This storage position is filled in when adding a serial number. Edit it directly per device afterwards; existing devices are not changed.",
      "Individual warranties": "Individual warranties",
      "Shared warranties": "Shared warranties",
      "Override warranties": "Adjust individual warranties",
      "Use shared warranties": "Use shared warranties",
      "Review": "Review",
      "Review receipt": "Check the products, quantities, storage positions and warranties before booking this receipt.",
      "Confirm receipt": "Book receipt",
      "Review action": "Check the details before booking this stock action.",
      "Confirm action": "Book stock action",
      "Booked": "The stock action has been booked.",
      "Pending actions": "Unfinished stock actions",
      "Pending explanation": "The booking has not been confirmed yet. Resume the same request to finish processing; the original input is preserved.",
      "No pending actions": "There are no unfinished stock actions.",
      "Resume": "Resume",
      "New delivery": "New customer delivery",
      "Same delivery": "Same original customer delivery, retain warranty",
      "Stock actions": "Stock actions",
      "Allocation change": "Allocation changes from {from} to {to}; provide a reason for this change.",
      "Adjustment explanation": "Enter the change: a positive quantity adds stock and a negative quantity removes stock. A reason is required.",
      "Issue explanation": "An issue for a sales order uses the selected line reservation. Invoicing takes place when processing the sales order.",
      "Save asset before stock action": "Save changed asset details before performing a stock action.",
      "Edit stock note": "Edit stock note",
      "Open delivery": "View delivery",
      "All movements": "All movements",
      "Save order before receipt": "Save the changed purchase order before receiving products.",
      "Manage stock": "Manage stock",
      "Stock registration label": "{amount} items · {date}",
      "Stock note": "Stock note",
      "Asset note": "Asset note",
      "Stock items": "Stock items",
      "Search stock items": "Search an item or serial number",
      "Selected stock amount": "{records} records selected · {amount} items",
      "Select stock item": "Select stock item {item}",
      "Unsaved stock changes": "You have unsaved changes. Save or discard them before selecting another item or performing a stock action.",
      "Discard stock changes": "Discard changes",
      "No stock remaining": "No stock remains for this item. Its registration and history are retained.",
      "Data": "Details",
      "Serial corrections": "Serial number corrections",
      "Warranty history": "Warranty history",
      "Choose stock": "Choose stock",
      "Change stock selection": "Change stock selection",
      "Stock choice count": "{selected} of {ordered} item selected | {selected} of {ordered} items selected",
      "Stock availability": "Present: {present} · Reserved: {reserved} · Available: {available}",
      "Reserved amount": "Reserved: {amount}",
      "Reserved for order": "{amount} units reserved for sales order {order}",
      "Reserved stock explanation": "This stock is physically present and linked to a sales order. Issue uses that link; release or change the reservation from the sales order.",
      "Reserve available stock": "Only freely available stock is selected for a new reservation. Choose an order line without an existing link to these items; change existing links from the sales order.",
      "No available stock": "No stock found",
      "Shared customer warranty": "Common customer warranty",
      "Apply to selected assets": "Apply to selected devices",
      "Link stock": "Link stock",
      "Clear stock selection": "Clear stock selection",
      "Linked stock amount": "Linked from stock: {amount}",
      "Issued stock amount": "Already issued from stock: {amount}",
      "Reserved": "Reserved",
      "Available": "Available",
      "Unknown warranty duration": "duration unknown",
      "No warranty": "no warranty",
      "Warranty through": "through",
      "Warranty duration": "{count} month | {count} months",
      "Serial number": "Serial number",
      "Customer warranty": "Customer warranty",
      "Individual warranty explanation": "Existing warranty settings are retained per device. Change the warranty fields below to apply these settings to all selected devices. The review shows each device’s period.",
      "Order line choice": "{description} · {amount} units | {description} · {amount} unit | {description} · {amount} units",
      "Add order line": "Add product line",
      "No matching order line": "This sales order has no matching open product line.",
      "Stock choice availability": "Present: {present} · Reserved: {reserved} · Selectable for this line: {available}"
    },
    "Purchase-orders": {
      "New item": "New purchase order",
      "Edit item": "Purchase order",
      "View item": "Purchase order",
      "Date": "Purchase date",
      "OrderReference": "Order reference",
      "ExpectedDeliveryDate": "Expected delivery",
      "TrackingUrl": "Tracking URL",
      "Description": "Description",
      "Memo": "Internal notes",
      "Status": "Status",
      "Products": "Product lines",
      "Product": "Product",
      "Amount": "Quantity",
      "CancelledAmount": "Cancelled",
      "CancellationReason": "Cancellation reason",
      "Add Products item": "Add product line",
      "Delete Products item": "Remove product line",
      "ReceiptInfo": {
        "status": "Status"
      },
      "SupplierProductUrl": "Open supplier product",
      "Tabs": {
        "General": "General",
        "Products": "Products"
      },
      "Supplier": "Supplier"
    },
    "Assets": {
      "New item": "Asset",
      "Edit item": "Asset management",
      "View item": "Asset management",
      "Product": "Product",
      "Memo": "Notes",
      "SupplierWarranty": "Supplier warranty",
      "CustomerWarranty": "Customer warranty",
      "StartDate": "Start date",
      "DurationMonths": "Duration in months",
      "LogisticsInfo": {
        "location": "Location",
        "customer": "Customer",
        "situation": "Situation",
        "supplierWarrantyStatus": "Supplier warranty",
        "customerWarrantyStatus": "Customer warranty"
      },
      "SerialNumber": "Serial number"
    },
    "Stock": {
      "New item": "Opening stock",
      "Edit item": "Stock",
      "View item": "Stock",
      "Product": "Product",
      "Location": "Location",
      "Memo": "Notes",
      "LocationInfo": {
        "customer": "Customer"
      },
      "Scope": "Allocation",
      "PurchaseDateFrom": "Purchase date",
      "PurchaseDateUntil": "Purchase date through",
      "UnknownPurchaseDate": "Unknown purchase date",
      "Position": "Position"
    },
    "Webhooks": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "Url": "URL",
      "Active": "Active",
      "Webhooks": "Webhooks",
      "ScopeOptions": {
        "Customer": "One customer",
        "Global": "All customers"
      },
      "EventsOptions": {
        "Create": "Create",
        "Patch": "Patch"
      },
      "New item": "New webhook",
      "Edit item": "Edit webhook",
      "View item": "View webhook",
      "Delete item": "Delete webhook",
      "New item success": "Webhook added.",
      "Edit item success": "Webhook saved.",
      "Delete item success": "Webhook deleted.",
      "New item fail": "Could not add webhook.",
      "Edit item fail": "Could not save webhook.",
      "Delete item fail": "Could not delete webhook.",
      "Summary": {
        "totalConfigurations": "Total configurations",
        "active": "Active webhooks",
        "inactive": "Disabled webhooks",
        "global": "Global webhooks",
        "totalDeliveries": "Total deliveries",
        "delivered": "Delivered",
        "pending": "Pending",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "totalAttempts": "Total attempts",
        "retry": "Retry"
      },
      "SummaryLoadFailed": "The summary or filters could not be refreshed. Please retry."
    },
    "Webhook-queue": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "DestinationHost": "Destination",
      "Active": "Active",
      "WebhookName": "Webhook",
      "Method": "Event",
      "Status": "Status",
      "Attempts": "Attempts",
      "Attempt": "Attempt",
      "StatusCode": "HTTP status",
      "ErrorCode": "Error code",
      "CreatedAt": "Time",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "View webhook delivery"
    },
    "Webhook-logs": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "DestinationHost": "Destination",
      "Active": "Active",
      "WebhookName": "Webhook",
      "Method": "Event",
      "Status": "Status",
      "Attempts": "Attempts",
      "Attempt": "Attempt",
      "StatusCode": "HTTP status",
      "ErrorCode": "Error code",
      "CreatedAt": "Time",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "View webhook log"
    },
    "Supplier-contacts": {
      "Address": "Address",
      "Address information": "Address information",
      "Birthday": "Date of birth",
      "City": "City",
      "Comments": "Comments",
      "Contact": "Contact",
      "Country": "Country",
      "Supplier": "Supplier",
      "Supplier address": "Supplier address",
      "Delete": "delete",
      "Delete item": "Delete supplier contact",
      "Delete item fail": "Failed to delete supplier contact. {msg}",
      "Delete item success": "Successfully deleted supplier contact.",
      "Delete item text": "Are you sure you want to {1} the supplier contact {0}?",
      "Edit item": "Edit supplier contact",
      "Edit item fail": "Error when changing the contact. {msg}",
      "Edit item success": "Successfully changed supplier contact.",
      "EmailAddress": "Email address",
      "Export": "Export",
      "FirstName": "First name",
      "Initials": "Initials",
      "InvoiceReference": "Invoice reference",
      "JobTitle": "Job title",
      "Labels": "Labels",
      "LastName": "Last name",
      "Name": "Name",
      "New item": "New contact",
      "New item fail": "Failed to create new supplier contact. {msg}",
      "New item success": "Successfully created supplier contact.",
      "No labels": "No labels",
      "OverwriteAddress": "Overwrite address",
      "Phone": "Phone",
      "Salutation": "Salutation",
      "SalutationOptions": {
        "D": "Department",
        "F": "Female",
        "M": "Male",
        "U": "Unspecified"
      },
      "SendMail": "Send mail",
      "Tabs": {
        "General": "General"
      },
      "Zipcode": "Zipcode"
    },
    "Suppliers": {
      "Address": "Address",
      "ContactInfo": "@:Admin.Customers.ContactInfo",
      "Archived": "Archived",
      "IsArchived": "Archived",
      "City": "City",
      "CocNumber": "Chamber of Commerce number",
      "Comments": "Comments",
      "Country": "Country",
      "InvoiceContact": "Invoice contact",
      "Labels": "Labels",
      "LegalForm": "Legal Form",
      "LegalFormOptions": {
        "Bv": "BV",
        "Coop": "Cooperation",
        "Cv": "CV",
        "Eenmanszaak": "Loner",
        "Nv": "NV",
        "Other": "Other",
        "Stichting": "Foundation",
        "Vereniging": "Association",
        "Vof": "VoF"
      },
      "Name": "Name | Supplier name",
      "OfferContact": "Offer contact",
      "PrimaryContact": "Primary contact",
      "TaxNumber": "Tax number",
      "Website": "Website",
      "Zipcode": "Zipcode",
      "Delete": "delete",
      "Delete item": "Delete supplier",
      "Delete item fail": "Error deleting the supplier. {msg}",
      "Delete item success": "Successfully deleted supplier.",
      "Delete item text": "Are you sure you want to {1} the supplier {0}?",
      "Edit item": "Edit supplier ({name}) | Edit supplier",
      "Edit item fail": "Error editing the supplier. {msg}",
      "Edit item success": "Successfully changed supplier.",
      "New item": "New supplier",
      "New item fail": "Error creating supplier. {msg}",
      "New item success": "Successfully created supplier.",
      "Export": "Export",
      "No labels": "No labels",
      "Criticality": "Criticality",
      "IsmsRelevance": "ISMS relevance",
      "RelevanceReason": "ISMS scope rationale",
      "CriticalityReason": "Criticality rationale",
      "Activated": "Feature enabled",
      "ServiceName": "Service name",
      "ContractReference": "Contract reference",
      "ContractOwner": "Contracting party",
      "AccountOwner": "Account owner",
      "StartDate": "Start date",
      "EndDate": "End date",
      "DecisionDate": "Renewal decision date",
      "NoticePeriod": "Notice period",
      "AutomaticRenewal": "Automatic renewal",
      "Archive": "archive",
      "Errors": {
        "SUPPLIER_ARCHIVE_BLOCKED": "This supplier cannot be archived yet. First finish the purchase orders, services and agreements or assessments listed below."
      }
    },
    "SupplierManagement": {
      "General": "General",
      "Contacts": "Contacts",
      "Assessments": "Assessments",
      "Assessment": "Assessment",
      "Documents": "Documents",
      "Save before contacts": "Save the supplier before adding contacts.",
      "ISMS scope": "ISMS relevance",
      "Services and contracts": "Services and contractual agreements",
      "New service": "New service",
      "Add service": "Add service",
      "Service name": "Service name",
      "Contract reference": "Contract reference",
      "Contract owner": "Contracting party",
      "Account owner": "Account owner",
      "Start date": "Start date",
      "End date": "End date",
      "Decision date": "Renewal decision date",
      "Notice period": "Notice period",
      "Automatic renewal": "Automatic renewal",
      "Remove service": "Remove service",
      "Required": "Required",
      "Saved": "Saved",
      "Save failed": "Save failed",
      "Load failed": "Load failed",
      "Archived supplier": "Archived supplier",
      "Restore": "Restore",
      "Archive": "Archive",
      "Title": "Title",
      "Category": "Category",
      "Version": "Version",
      "Valid until": "Valid until",
      "Upload document": "Upload document",
      "File": "File",
      "File limit": "PDF, PNG, JPEG, DOCX or XLSX, up to 25 MB. Every file is scanned for malware.",
      "Upload failed": "Upload failed",
      "Download failed": "Download failed",
      "Download": "Download",
      "New version": "New version",
      "No documents": "No documents",
      "New assessment": "Add full assessment",
      "No assessments": "No assessments",
      "Review type": "Review type",
      "Review date": "Review date",
      "Status": "Status",
      "Decision": "Decision",
      "Next review": "Next review",
      "Light check not applicable": "The six-month check applies only to critical and activated conditionally critical suppliers.",
      "Full follow-up": "Full follow-up assessment",
      "Full follow-up hint": "Annual reassessment or material change; previous information is reused.",
      "Light follow-up hint": "Four short checks against this assessment; the existing decision remains in place.",
      "Full assessment notice": "Initial, full periodic and full interim assessments use the same full questionnaire. For a short changes check, choose Six-month check on the Assessments tab.",
      "Review cycle": "Full annual review and full reassessment after material changes. Critical and activated conditionally critical suppliers also require a short six-month check.",
      "Open assessment": "Open assessment",
      "Follow-up assessment": "Follow-up assessment",
      "Evidence and actions": "Evidence and actions",
      "Decision and approvals": "Decision and approvals",
      "Service agreement": "Service agreement",
      "Review scope": "Review scope",
      "Questionnaire version": "Questionnaire version",
      "Result": "Result",
      "Explanation": "Explanation",
      "Evidence versions": "Evidence versions",
      "Save before evidence": "Save the assessment before adding its own attachments.",
      "Actions": "Actions",
      "Add action": "Add action",
      "Remove action": "Remove action",
      "Action description": "Action description",
      "Owner": "Owner",
      "Due date": "Due date",
      "Action reference": "Action reference",
      "Risk level": "Risk level",
      "Impact": "Impact (1 low, 3 critical)",
      "Conclusion": "Conclusion",
      "Exception reason": "Exception reason",
      "Compensating measures": "Compensating measures",
      "Exception expiry": "Exception expiry",
      "Contract review": "Contract review",
      "Technical review": "Technical review",
      "Confirm review": "Confirm review",
      "Awaiting review": "Awaiting review",
      "Authorized reviewer": "Authorized reviewer",
      "Complete assessment": "Complete assessment",
      "Completion confirmation": "Completion freezes this assessment, approvals and evidence versions. Complete this assessment?",
      "Completed immutable": "This assessment is complete and can no longer be edited. Start a follow-up assessment to record changes.",
      "Completed on": "Completed on",
      "Review reset notice": "Any content change invalidates both approvals. Both reviewers must confirm the changed version again.",
      "Confirm approval invalidation": "Invalidate approvals?",
      "Approval invalidation confirmation": "This change invalidates the existing approvals. The changed version must be confirmed again. Do you want to save the changes?",
      "Save invalidating approvals": "Save changes",
      "Dual review notice": "High risk or impact 3 requires contractual and technical confirmation by two distinct authorized reviewers.",
      "Values": {
        "pending": "Pending",
        "required": "ISMS relevant",
        "excluded": "Outside ISMS scope",
        "important": "Important",
        "critical": "Critical",
        "conditional": "Conditional",
        "initial": "Full initial",
        "periodic": "Full periodic review",
        "light": "Light six-month review",
        "interim": "Full interim",
        "draft": "Draft",
        "review": "Awaiting review",
        "completed": "Completed",
        "approved": "Approved",
        "rejected": "Rejected",
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "unknown": "Unknown / insufficient evidence",
        "met": "Meets requirement",
        "not_met": "Does not meet requirement",
        "not_applicable": "Not applicable",
        "open": "Open",
        "unchanged": "No changes",
        "follow_up": "Follow-up required"
      },
      "Categories": {
        "contract": "Contracts and data processing terms",
        "assurance": "Certificates and assurance",
        "security": "Security documents"
      },
      "Criteria": {
        "contract": "Contractual terms",
        "locations": "Processing locations",
        "incident": "Incident reporting",
        "access": "Access and accounts",
        "exit": "Exit and portability",
        "data": "Data and privacy",
        "subprocessors": "Subprocessors",
        "assurance": "Assurance and certificates",
        "encryption": "Encryption",
        "logging": "Logging and monitoring",
        "backup": "Backup and recovery",
        "retention": "Retention and deletion",
        "sla": "Availability and SLA",
        "contacts": "Verify contacts",
        "certificates": "Verify certificates",
        "changes": "Changes and incidents",
        "high_actions": "High risks and actions"
      },
      "CriteriaHelp": {
        "contract": "Verify signed terms, responsibilities, SLA and data processing agreement where applicable.",
        "locations": "Record countries of storage, processing and access and verify the legal basis.",
        "incident": "Check reporting deadlines, contacts and incident cooperation.",
        "access": "Check least privilege, MFA and access termination.",
        "exit": "Assess export, transfer, deletion and supplier dependency.",
        "data": "Assess data categories, purposes and privacy safeguards.",
        "subprocessors": "Check the supply chain, changes and contractual safeguards.",
        "assurance": "Check scope, validity and exceptions in independent evidence.",
        "encryption": "Check encryption in transit and at rest and key management.",
        "logging": "Assess detection, log access and follow-up.",
        "backup": "Check recoverability, restore tests and continuity.",
        "retention": "Check retention periods and verifiable deletion.",
        "sla": "Assess performance, availability and agreed escalation.",
        "contacts": "Verify current owner, contacts and escalation details.",
        "certificates": "Check certificate validity and scope changes.",
        "changes": "Assess changes in services, supply chain and incidents.",
        "high_actions": "Check outstanding actions and the validity of risk acceptances."
      },
      "Review confirmed": "Review confirmed",
      "Save before completion": "Save changes and obtain both review confirmations again.",
      "Periodic assessment": "Periodic supplier assessment",
      "Light check": "Six-month check",
      "Baseline assessment": "Existing full assessment",
      "Additional note": "Additional note (optional)",
      "Full assessment required": "The six-month check requires a completed full assessment with an approved or conditionally approved decision.",
      "Light check notice": "Check the four subjects for changes. The existing supplier decision remains in place; only findings require follow-up.",
      "Light action required": "Record an action with an owner and deadline for a finding.",
      "Record check": "Record check",
      "Check recorded": "Six-month check recorded",
      "Recorded by": "Recorded by",
      "Outcome": "Outcome",
      "Single review notice": "One authorized, competent assessor can finalize this assessment. Seek additional expertise where needed. Only high risk or impact 3 requires two separate confirmations.",
      "Approval history": "Approval history",
      "Approval history notice": "See who confirmed each version and when an edit invalidated approvals. Use the view button to open the contents recorded at that time.",
      "Historical version notice": "You are viewing a recorded historical version. It cannot be edited or approved.",
      "Historical version": "Historical version",
      "Content version": "Content version",
      "Event": "Event",
      "Recorded at": "Recorded at",
      "View reviewed version": "View recorded version",
      "Review reconfirmation required": "Confirmation required: this approval is not bound to a content version.",
      "Different reviewer required": "You already confirmed the other review. A different authorized reviewer must confirm this one.",
      "Review history events": {
        "contractReview": "Contract review confirmed",
        "technicalReview": "Technical review confirmed",
        "invalidated": "Approvals invalidated",
        "completed": "Assessment completed"
      }
    },
    "Supplier-assessments": {
      "Title": "Title",
      "Notes": "Explanation and evidence",
      "Type": "Review type",
      "ReviewDate": "Review date",
      "ScopeId": "Service agreement",
      "ServiceScope": "Review scope",
      "Documents": "Evidence versions",
      "Decision": "Decision",
      "RiskLevel": "Risk level",
      "Impact": "Impact (1 low, 3 critical)",
      "Conclusion": "Conclusion",
      "NextReviewDate": "Next review",
      "ExceptionReason": "Exception reason",
      "CompensatingMeasures": "Compensating measures",
      "ExceptionUntil": "Exception expiry",
      "Description": "Action description",
      "Owner": "Owner",
      "DueDate": "Due date",
      "Status": "Status",
      "Reference": "Action reference",
      "New item": "New supplier assessment",
      "Edit item": "Edit supplier assessment",
      "View item": "Supplier assessment details",
      "Errors": {
        "ErrorCode": {
          "SUPPLIER_LIGHT_BASELINE_REQUIRED": "Choose a completed full assessment for the same supplier and service.",
          "SUPPLIER_LIGHT_EXCEPTION_EXPIRED": "The existing exception has expired. Perform a full reassessment.",
          "SUPPLIER_LIGHT_CHECKS_REQUIRED": "Check all four subjects before recording the check.",
          "SUPPLIER_LIGHT_ACTION_REQUIRED": "Explain the finding and record an open action with an owner and deadline.",
          "SUPPLIER_LIGHT_NO_ACCEPTANCE": "A six-month check does not approve a supplier or accept a new exception. Use a full assessment.",
          "SUPPLIER_DUAL_REVIEW_REQUIRED": "High risk or impact 3 requires confirmation by two distinct authorized reviewers.",
          "SUPPLIER_REVIEW_PERSONAL_LOGIN_REQUIRED": "Confirm the assessment from your own personal account. API accounts and impersonated sessions cannot approve assessments.",
          "SUPPLIER_DISTINCT_REVIEWER_REQUIRED": "You already confirmed the other review. A different authorized reviewer must confirm this one."
        }
      }
    },
    "Supplier-documents": {
      "Title": "Title",
      "Supplier": "Supplier",
      "Assessment": "Supplier assessment",
      "Category": "Category",
      "ValidUntil": "Valid until",
      "Errors": {
        "default": "The supplier document could not be processed.",
        "ErrorCode": {
          "SUPPLIER_DOCUMENT_REJECTED": "The malware scan rejected this file. The document was not stored.",
          "SUPPLIER_EVIDENCE_IMMUTABLE": "This evidence version has already been reviewed and is retained. Upload a new version for changes."
        }
      }
    }
  },
  "Customer": {
    "Contacts": {
      "City": "City",
      "CompanyName": "Company name",
      "Contact": "Contact | Contacts",
      "Country": "Country",
      "Delete": "delete",
      "Delete contact": "Delete contact",
      "Delete item": "Delete contact",
      "Delete item fail": "Error deleting the contact.",
      "Delete item success": "Successfully deleted contact.",
      "Delete item text": "Are you sure you want to delete the contact {0}?",
      "Edit contact": "Edit contact",
      "Edit item fail": "Error changing the contact. {msg}",
      "Edit item success": "Successfully changed contact.",
      "Email": "Email address",
      "Errors": {
        "Delete item has dependencies": "Contact is in use and cannot be deleted.",
        "ErrorCode": {
          "OXXA_API_NO_CHANGES": "The contact was not changed.",
          "OXXA_API_RESULT_DIFF": "The contact was partially saved, please verify the result."
        }
      },
      "FirstName": "Firstname",
      "HouseNumber": "House number",
      "HouseNumberSuffix": "Suffix",
      "Initials": "Initials",
      "JobTitle": "Job title",
      "LastName": "Lastname",
      "New item": "New contact",
      "New item fail": "Error creating contact. {msg}",
      "New item success": "Successfully created contact.",
      "No contacts found": "No contacts found.",
      "PostalCode": "Postal code",
      "State": "State/Province",
      "Street": "Street",
      "Tel": "Phone number"
    },
    "Customer-contacts": {
      "Address": "Address",
      "Address information": "Address information",
      "Birthday": "Date of birth",
      "City": "City",
      "Contact": "Contact",
      "Country": "Country",
      "Customer": "Customer",
      "Customer address": "Customer address",
      "Delete": "delete",
      "Delete item": "Delete customer contact",
      "Delete item fail": "Failed to delete customer contact.",
      "Delete item success": "Successfully deleted customer contact.",
      "Delete item text": "Are you sure you want to {1} the customer contact {0}?",
      "Edit item": "Edit customer contact",
      "Edit item fail": "Error when changing the contact data.",
      "Edit item success": "Successfully changed contact data.",
      "EmailAddress": "Email address",
      "FirstName": "First name",
      "Initials": "Initials",
      "InvoiceReference": "Invoice reference",
      "LastName": "Last name",
      "Name": "Name",
      "OverwriteAddress": "Overwrite address",
      "Phone": "Phone",
      "Salutation": "Salutation",
      "SalutationOptions": {
        "D": "Department",
        "F": "Female",
        "M": "Male",
        "U": "Unspecified"
      },
      "SendMail": "Send mail",
      "Tabs": {
        "General": "General"
      },
      "Zipcode": "Zipcode"
    },
    "Customer-users": {
      "Api account": "API account",
      "Api accounts": "API accounts",
      "Api token": "API token",
      "Api token shown once": "This token is only shown once. Store it safely.",
      "Copy roles from user": "Copy roles from another user",
      "Copy roles from user title": "Copy roles",
      "Customer user": "User",
      "Customer users": "Users",
      "Delete api account": "Delete API account",
      "Delete api account text": "Are you sure you want to remove the API account {0}?",
      "Delete item": "Delete user",
      "Delete item fail": "Error deleting the user.",
      "Delete item success": "User successfully deleted.",
      "Delete item text": "Are you sure you want to remove the user {0} ?",
      "Edit item": "Edit user",
      "Edit item fail": "Error changing the user. {msg}",
      "Edit item success": "User successfully modified.",
      "Edit api account": "Edit API account",
      "Email": "Email address",
      "FirstName": "First Name",
      "Initials": "Initials",
      "IsSSO": "SSO",
      "Is MFA configured": "MFA activated",
      "Last login": "Last logged in at",
      "LastName": "Surname",
      "License": "License",
      "LicenseCode": "Code",
      "LicenseProduct": "Product",
      "Licenses": "Licenses",
      "Locale": "Language",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "New api account": "New API account",
      "New item": "New user",
      "New item fail": "Error adding the user. {msg}",
      "New item success": "User successfully added.",
      "New user": "Create new user",
      "No users to copy roles from": "No other users with roles are available.",
      "No assigned licenses": "No licenses assigned.",
      "No api accounts found": "No API accounts found",
      "No customer users found": "No users found",
      "RegionalSettings": "Regional settings",
      "Regenerate API token": "Regenerate API token",
      "Regenerate API token confirm": "Regenerate API token",
      "Regenerate API token confirm text": "Are you sure you want to regenerate the API token for {fullName}? The current token will stop working.",
      "Regenerate API token fail": "Could not regenerate API token.",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Resend invite": "Resend invite",
      "Resend invite text": "Are you sure you want to resend the invitation to {fullName}?",
      "Reset mfa": "Reset MFA",
      "Reset MFA text": "Are you sure you want to reset Multi-Factor Authentication (MFA) for {fullName}?",
      "Roles to copy": "Roles to copy",
      "Roles": "Roles",
      "Select user for roles": "User to copy roles from",
      "Take over roles": "Take over roles",
      "User": "User",
      "Virtual": "Virtual",
      "What is virtual user": "A virtual user is not linked to a real login account. One or more roles for this customer are always required.",
      "VerifiedOptions": {
        "True": "Verified",
        "False": "Not verified"
      },
      "Delete": "delete"
    },
    "Backups": {
      "Title": "Backups",
      "Description": "View the latest available backup information for your customer environment. This information is read-only.",
      "LastSynchronization": "Last synchronization",
      "Refresh": "Refresh backup information",
      "LoadError": "Backup information could not be loaded",
      "LoadErrorDescription": "Try again later or contact your administrator if the problem persists.",
      "NoBackupsFound": "No backups found",
      "NoBackupsFoundDescription": "No backup information is currently available for this customer.",
      "NoSourceBackupsFound": "No {source} backups found",
      "NoRecentSessions": "No recent backup sessions found",
      "NoProtectedItems": "No protected Microsoft 365 items found",
      "UnknownOperatingSystem": "Unknown",
      "NotApplicable": "Not applicable",
      "SourceError": "Information from this backup source could not be loaded",
      "SourceErrorDescription": "Other backup sources remain available. Try loading the information again later.",
      "BackupRecords": "backup records",
      "Enabled": "Enabled",
      "Disabled": "Disabled",
      "Microsoft365Description": "View Microsoft 365 backup jobs, protected accounts and Teams, schedules, and recent runs.",
      "Microsoft365Jobs": "Backup jobs",
      "ProtectedItems": "Protected items",
      "RecentSessions": "Recent sessions",
      "LockedVaultDescription": "View the latest Locked Vault backups and restore point counts.",
      "LockedVaultBackups": "Locked Vault backups",
      "CloudDescription": "View the latest available backups of your cloud systems, including status, backup time, and available system details.",
      "Tabs": {
        "Overview": "Overview",
        "Microsoft365": "Microsoft 365",
        "LockedVault": "Locked Vault",
        "Cloud": "Cloud backups"
      },
      "Status": {
        "Available": "Available",
        "Empty": "No data",
        "Error": "Unavailable",
        "Partial": "Partially available",
        "Loading": "Loading"
      },
      "Sources": {
        "microsoft365": {
          "Title": "Microsoft 365",
          "Description": "Backup jobs, protected items, and recent sessions",
          "ActionLabel": "Go to Microsoft 365",
          "Icon": "sym_o_business_center"
        },
        "lockedVault": {
          "Title": "Locked Vault",
          "Description": "Restic backups and restore points",
          "ActionLabel": "Go to Locked Vault",
          "Icon": "sym_o_lock"
        },
        "cloud": {
          "Title": "Cloud backups",
          "Description": "Virtual machine and storage backups",
          "ActionLabel": "Go to cloud backups",
          "Icon": "sym_o_cloud_queue"
        }
      },
      "Fields": {
        "Architecture": "Architecture",
        "Asset": "Asset",
        "BackupType": "Backup type",
        "CreatedAt": "Created",
        "DiskSize": "Disk size",
        "Enabled": "Enabled",
        "EndedAt": "Completed",
        "Failed": "Failed",
        "Hostname": "Hostname",
        "Item": "Item",
        "Job": "Job",
        "LastBackup": "Latest backup",
        "NextRun": "Next run",
        "OperatingSystem": "Operating system",
        "RestorePoints": "Restore points",
        "Schedule": "Schedule",
        "Server": "Server",
        "Size": "Size",
        "StartedAt": "Started",
        "Status": "Status",
        "Succeeded": "Succeeded",
        "Total": "Total",
        "Type": "Type",
        "Vault": "Vault",
        "Zone": "Zone"
      },
      "Types": {
        "virtualMachine": "Virtual machine",
        "blockStorage": "Block storage",
        "account": "Account",
        "team": "Team",
        "oneDrive": "OneDrive",
        "site": "SharePoint site"
      }
    },
    "Licenses": {
      "Add Assigned item": "Add assigned user",
      "AlignWithLicense": "Align renew date with license",
      "Amount": "Amount",
      "AmountMustBeZero": "Set the amount to 0 before deleting this license.",
      "Assigned": "Assigned users",
      "AssignedLicenses": "Assigned licenses",
      "EffectiveAssigned": "Effective users",
      "ChangeOnRenewDate": "Change amount and payment method on renew date",
      "ComingSoon": "Coming soon.",
      "Delete": "delete",
      "Delete Assigned item": "Delete assigned user",
      "Delete item": "Delete license",
      "Delete item fail": "Failed to delete license. {msg}",
      "Delete item success": "Successfully deleted license.",
      "Delete item text": "Are you sure you want to {1} license {0}?",
      "Edit item": "Edit license",
      "Edit item fail": "Failed to update license. {msg}",
      "Edit item success": "Successfully updated license.",
      "Email": "Email",
      "EndDate": "End date",
      "Id": "ID",
      "InvoiceDateHistory": {
        "EndDate": "End date",
        "InvoiceDate": "Invoice date",
        "StartDate": "Start date"
      },
      "InvoiceHistory": "Invoice history",
      "Errors": {
        "ErrorCode": {
          "LICENSE_AMOUNT_BELOW_ASSIGNED": "Amount cannot be lower than assigned users.",
          "LICENSE_AMOUNT_CANNOT_DECREASE": "Amount can only be increased directly.",
          "LICENSE_ALIGN_AMOUNT_MUST_BE_GREATER_THAN_ZERO": "Amount must be greater than 0 when aligning the renew date with a license.",
          "LICENSE_ALIGN_PAYMENT_METHOD_MISMATCH": "You can only align with a license that uses the same payment method.",
          "LICENSE_ALIGN_RENEW_DATE_BEFORE_START_DATE": "The start date must be before the renew date of the selected license.",
          "LICENSE_AMOUNT_MUST_BE_ZERO": "Set the amount to 0 before deleting this license.",
          "LICENSE_ASSIGNED_CAPACITY_EXCEEDED": "Too many active users.",
          "LICENSE_ASSIGNED_CUSTOMER_MISMATCH": "Assigned users must belong to the same customer as the license.",
          "LICENSE_ASSIGNED_DATE_IN_PAST": "Start and end dates for assigned users cannot be in the past.",
          "LICENSE_ASSIGNED_USER_INVALID": "Invalid user.",
          "LICENSE_ASSIGNED_USER_REQUIRED": "Select a user.",
          "LICENSE_ASSIGNED_USERS_NOT_UNIQUE": "A user can only be assigned once.",
          "LICENSE_CONTRACT_CANCEL_DATE_AMOUNT_INCREASE": "This license has been cancelled and cannot be increased anymore.",
          "LICENSE_CONTRACT_INVALID": "This license has no valid contract and can only be deleted.",
          "LICENSE_PAYMENT_METHOD_NOT_AVAILABLE": "This payment method is not available for this license product.",
          "LICENSE_PENDING_ASSIGNED_CAPACITY_EXCEEDED": "Too many active users after the renew date.",
          "LICENSE_PENDING_AMOUNT_BELOW_RENEWAL_ASSIGNED": "The new amount is lower than the assigned users on the renew date.",
          "LICENSE_PERIOD_NOT_AVAILABLE": "This period is not available for this license product.",
          "LICENSE_START_DATE_IN_PAST": "The start date cannot be in the past.",
          "LICENSE_USER_ALREADY_ASSIGNED_TO_PRODUCT": "Product already assigned."
        }
      },
      "FromRenewDate": "From renew date",
      "GoToMicrosoftLicenses": "Go to Microsoft licenses",
      "GoToOmniLicenses": "Go to OMNI licenses",
      "License": "License | Licenses | License {license}",
      "LoadError": "Failed to load licenses.",
      "MicrosoftLicenses": "Microsoft licenses",
      "MicrosoftLicensesDescription": "View your current Microsoft licenses.",
      "MicrosoftLicensesLoadError": "Failed to load Microsoft licenses.",
      "MicrosoftAppliesTo": {
        "Company": "Company",
        "Device": "Device",
        "User": "User"
      },
      "MicrosoftCapabilityStatus": {
        "Deleted": "Deleted",
        "Disabled": "Disabled",
        "Enabled": "Enabled",
        "LockedOut": "Locked out",
        "Suspended": "Suspended",
        "Warning": "Warning"
      },
      "MicrosoftLicenseTable": {
        "AppliesTo": "Applies to",
        "CapabilityStatus": "Status",
        "ConsumedUnits": "Consumed",
        "LastUpdated": "Last updated",
        "PrepaidUnitsEnabled": "Available",
        "PrepaidUnitsSuspended": "Suspended",
        "PrepaidUnitsWarning": "Warning",
        "SkuName": "SKU name",
        "SkuPartNumber": "SKU part number",
        "TotalConsumed": "Total consumed",
        "TotalEnabled": "Total available"
      },
      "Name": "Name",
      "New item": "New license",
      "New item fail": "Failed to create license. {msg}",
      "New item success": "Successfully created license.",
      "NoInvoiceHistory": "There is no invoice history yet.",
      "NoMicrosoftLicensesFound": "No Microsoft licenses were found.",
      "NoAssignedUsers": "No assigned users.",
      "No licenses found": "No licenses found.",
      "OmniLicenses": "OMNI licenses",
      "OmniLicensesDescription": "Manage OMNI licenses, amounts and assigned users.",
      "Overview": "Overview",
      "PaymentMethod": "Payment method",
      "PendingAmount": "New amount",
      "PendingPaymentMethod": "New payment method",
      "PendingProduct": "New license product",
      "Period": "Period",
      "PricePerLicense": "Price per license",
      "PricePeriod": "per {period}",
      "PeriodOptions": {
        "Month": "Month",
        "Year": "Year"
      },
      "Product": "Product",
      "RenewDate": "Renew date",
      "SetAssignedEndDatesToRenewDate": "Set end date to renew date",
      "StartDate": "Start date",
      "Tabs": {
        "General": "General",
        "Users": "Users"
      },
      "TotalPrice": "Total price",
      "User": "User",
      "ViewAssignments": "View assignments"
    },
    "Customers": {
      "Address": "Address",
      "Address information": "Address information",
      "Birthday": "Date of birth",
      "City": "City",
      "CocNumber": "Chamber of Commerce number",
      "Contact": "Contact",
      "Contact information": "Contact information",
      "Contact person": "Contact person",
      "ContactInfo": "Contact information",
      "Country": "Country",
      "CountryOrRegion": "Country or Region",
      "Customer": "Customer",
      "Customer address": "Customer address",
      "Customer information": "Customer information",
      "CustomerName": "Customer name",
      "Edit": "Edit @.lower:{item}",
      "Edit item fail": "Error when changing the customer information.",
      "Edit item success": "Successfully changed customer information.",
      "Invoice information": "Invoice information",
      "InvoiceContact": "Invoice contact",
      "InvoiceEmailAddress": "Invoice email address",
      "InvoiceReference": "Invoice reference",
      "Name": "Company name",
      "Offer information": "Offer information",
      "OfferContact": "Offer contact",
      "OfferEmailAddress": "Offer email address",
      "See all domains": "See all domains",
      "See all invoices": "See all invoices",
      "See all webhosting accounts": "See all hosting accounts",
      "See customer profile": "See customer profile",
      "SendMail": "Receive mail",
      "State": "State",
      "TaxNumber": "Tax number",
      "Zipcode": "Zipcode"
    },
    "Domain-contacts": {
      "AdministrativeContact": "Administrative contact",
      "All contacts": "All contacts",
      "BillingContact": "Billing contact",
      "Choose a contact": "Choose a contact",
      "Link contacts": "Link contacts",
      "OwnerContact": "Owner contact",
      "Set this for all contacts": "Set owner contact for all contacts",
      "TechnicalContact": "Technical contact"
    },
    "Domains": {
      "Add DNSSEC item": "Add DNSSEC line",
      "Add Nameservers item": "Add nameserver",
      "Administrative contact is required": "Administrative contact is required field.",
      "AdministrativeContact": "Administrative contact",
      "Alg": "Algorithm",
      "All customers": "All customers",
      "Auto renew disabled": "Automatic renewal of the domain is disabled for this domain.",
      "AutoRenew": "Automatic renewal",
      "AutoRenewdisabled": "Auto renew is disabled for this domain.",
      "Back to domains": "Back to domains",
      "Billing contact is required": "Billing contact is a required field.",
      "BillingContact": "Billing contact",
      "Cancel subscription": "Unsubscribe",
      "CancelDate": "Cancelled on",
      "Cancellation warning": "Although the domain can be transferred within the cancellation period, you will still receive an invoice for the remaining period.",
      "Cancelled": "Cancelled",
      "Change webhosting account": "Choose a hosting account below to which {domain} should be linked.",
      "Change webhosting account title": "Link hosting account",
      "Check domain": "Check domain",
      "Check domain availability": "Check domain availability",
      "City": "City",
      "CompanyName": "Company name",
      "Confirm domain force delete text": "Are you sure you want to delete the domain {domain}? The domain will be quarantined and there will be a fee to reverse this.",
      "Confirm domain force delete title": "Delete domain",
      "Confirm domain restore text": "Are you sure you want to restore the domain {domain}? There is a fee to remove the domain from quarantine.",
      "Confirm domain restore title": "Restore domain",
      "Contacts": "All contacts",
      "Copy transfercode": "Click to copy the transfercode",
      "Country": "Country",
      "Customer": "Customer",
      "Delete": "delete",
      "Delete DNSSEC item": "Delete DNSSEC item",
      "Delete domain status not error item success": "Auto renew is turned off, domain {name} will be removed after the expire date.",
      "Delete domain webhosting item fail": "Error deleting the hosting account for domain. {msg}",
      "Delete domain webhosting item success": "Successfully deleted hosting account for domain.",
      "Delete item": "Delete domain",
      "Delete item fail": "Error deleting the domain. {msg}",
      "Delete item success": "Successfully deleted the domain.",
      "Delete item text": "Are you sure you want to {1} the domain {0}?",
      "Delete Nameservers item": "Delete nameserver",
      "discount": "discount",
      "DNSSEC": "DNSSEC",
      "Dnssec item": "DNSSEC",
      "DNSSECInfo": "Use the form below to configure DNSSEC records. Note that when a record is modified it will be deleted and recreated, make sure to carefully check the results!",
      "Domain": "Domain | Domains",
      "Domain has no DNS Sec": "This domain doesn’t have any DNSSEC records configured.",
      "Domain in quarantaine": "Domain is in quarantaine",
      "DomainNSGroup": "Domain nameservers group | Domain nameservers groups",
      "DomainStatus": "Domain status",
      "DomainStatusOptions": {
        "Error": "Error",
        "Quarantine": "Quarantine",
        "Registered": "Registered",
        "Transfer pending": "Pending",
        "Transferred": "Transferred",
        "Unknown": "Unknown"
      },
      "Edit contact": "Edit contact",
      "Edit domain DNSSEC item fail": "Error editing the domain DNSSEC settings. {msg}",
      "Edit domain DNSSEC item success": "Successfully edited domain DNSSEC settings.",
      "Edit domain webhosting item fail": "Error changing the hosting account for the domain. {msg}",
      "Edit domain webhosting item success": "Successfully changed hosting account for domain.",
      "Edit item": "Edit domain",
      "Edit item fail": "Error when changing the domain.",
      "Edit item success": "Successfully changed domain.",
      "Email": "Email address",
      "Errors": {
        "default": "Error while processing the domain request. {msg}",
        "ErrorCode": {
          "DOMAINS_CHECK_REQUIRED_FIELDS_MISSING": "Required fields are missing.",
          "OXXA_API_BAD_STATUS_CODE": "Unable to connect to domain supplier.",
          "OXXA_API_DISABLED": "Oxxa API is not enabled.",
          "OXXA_API_NO_CHANGES": "The contact was not changed.",
          "OXXA_API_NO_HANDLE_FOUND": "No ID found at the supplier.",
          "OXXA_API_REMOVE_DATA_NOT_FOUND": "No data found to delete.",
          "OXXA_API_REQUEST_FAILED": "Unable to connect to domain supplier.",
          "OXXA_API_RESULT_DIFF": "The contact was partially saved, please verify the result.",
          "OXXA_API_RESULT_NOT_FOUND": "No results found for NS group.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "The field '@.lower:{key}' is not unique."
        }
      },
      "ExpireDate": "Expire date",
      "FirstName": "Firstname",
      "Flags": "Flag",
      "Force remove domain": "Forcefully remove domain",
      "Force remove domain item fail": "Domain could not be forcefully removed. {msg}",
      "Force remove domain item success": "Domain forcefully removed successfully.",
      "FullDomain": "Full domain result",
      "Get EPP item fail": "Could not retrieve transfercode.",
      "Get EPP item success": "Successfully retrieved transfercode.",
      "Hostname": "Hostname",
      "HouseNumber": "House number",
      "HouseNumberSuffix": "Suffix",
      "incl": "incl.",
      "Initials": "Initials",
      "InvoiceDateHistory": {
        "EndDate": "End date",
        "InvoiceDate": "Invoice date",
        "StartDate": "Start date"
      },
      "InvoicedUntilDate": "Invoiced up to",
      "InvoiceHistory": "Invoice history",
      "InvoiceNextDate": "Next invoice",
      "InvoiceStartDate": "Invoice start date",
      "IPv4": "IPv4",
      "IPv6": "IPv6",
      "JobTitle": "Job title",
      "LastName": "Lastname",
      "LastRenewDate": "Last renew date",
      "Link webhosting account": "Link",
      "Linked webhosting account": "Linked hosting account",
      "Lock": "Lock",
      "Lock domain item false success": "Domain unlocked successfully.",
      "Lock domain item true success": "Domain locked successfully.",
      "Lock item": "Lock domain",
      "Lock item fail": "Domain could not be locked.",
      "Manage contacts": "Manage contacts",
      "Manage DNSSEC": "Manage DNSSEC",
      "Manage nameservers": "Manage nameservers",
      "More info": "More information",
      "Move domain": "Transfer domain",
      "Move domain info": "Below you can request the transfer code. If you move the domain, the subscription will automatically be canceled on the day of the move. A notice period of {noticePeriod} applies.",
      "Nameservers": "Nameserver | Nameservers",
      "New contact": "New contact",
      "New domain webhosting item fail": "Error created hosting account to domain. {msg}",
      "New domain webhosting item success": "Successfully created hosting account to domain.",
      "New item": "New domain",
      "New item fail": "Error creating domain. {msg}",
      "New item success": "Successfully created domain.",
      "No customer attached": "No customer attached",
      "No domains found": "No domains found.",
      "No items": "Currently, there is no linked hosting account available.",
      "NoticeDate": "Notice date",
      "Only one DNSSEC record configured": "Only one DNSSEC record configured.",
      "Owner contact is required": "Owner contact is a required field.",
      "OwnerContact": "Domain holder",
      "Period": "Period",
      "PeriodicOptions": {
        "Day": "Day | Days",
        "Month": "Month | Months",
        "Year": "Year | Years"
      },
      "PostalCode": "Postal code",
      "Price": "Price",
      "Protocol": "Protocol",
      "PubKey": "Public key",
      "QuarantaineEnd": "Quarantaine end",
      "Registrar": "Registrar",
      "RegistrarOptions": {
        "Other": "Other",
        "Oxxa": "Oxxa",
        "Xolphin": "Xolphin"
      },
      "Restore domain": "Restore domain",
      "Restore domain item fail": "Domain could not be restored.",
      "Restore domain item success": "Domain restored successfully.",
      "Retrieve transfercode": "If you want to transfer the domain, retrieve the transfer code here",
      "Send EPP info": "When you choose to send the transfer code, it will be sent to the registered email address of the domain holder.",
      "Send EPP item fail": "Could not send transfercode.",
      "Send EPP item success": "Successfully sent transfercode.",
      "Send transfercode": "Send",
      "Set auto renew failed": "Failed to change auto renew status.",
      "Set auto renew false success": "Auto renew disabled successfully.",
      "Set auto renew true success": "Auto renew enabled successfully.",
      "Show transfercode": "Show",
      "Show transfercode item": "Transfercode",
      "StartDate": "Start date",
      "State": "State/Province",
      "Street": "Street",
      "Subscription": "Subscription",
      "SubscriptionInfo": {
        "contractInfo": {
          "customer": "Customer"
        }
      },
      "Tabs": {
        "Contacts": "Contacts",
        "General": "General",
        "Name servers": "@:Customer.Domains.Nameservers"
      },
      "Technical contact is required": "Technical contact is a required field.",
      "TechnicalContact": "Technical contact",
      "Tel": "Phone number",
      "TerminationDate": "Removal date",
      "Tld": "Top level domain",
      "Transfer domain": "Transfer domain",
      "TransferCode": "Transfer code",
      "Undo cancellation": "Undo termination",
      "Unlock item": "Unlock domain",
      "Webhosting": "Hosting account",
      "What are nameservers": "Nameservers are like phone books for the internet; they help your computer find the right address for the website you want to visit.",
      "What is DNSSEC": "DNSSEC is a security measure that ensures your computer connects to the correct website and is not tricked into visiting a fake one."
    },
    "Email-logs": {
      "MailSent": "Email status"
    },
    "Feedback-answers": {
      "Customer": "Customer",
      "Value": "Value"
    },
    "Globals": {
      "Customer-users": "Users"
    },
    "Invoices": {
      "Cannot download invoice": "Unable to start downloading the invoice.",
      "Download invoice": "Download invoice",
      "Invoice": "Invoice | Invoices",
      "Invoice date": "Date",
      "Invoice due date": "Payment due date",
      "Invoice item": "Invoice",
      "Invoice overdue": "Invoice is overdue | OVERDUE",
      "Invoice overdue date": "Due date",
      "Invoices loading": "Invoices are loading, one moment please...",
      "List": "Invoices overview",
      "No invoices found": "No invoices found.",
      "PaymentStatuses": {
        "open": "Open",
        "open credit": "Open",
        "open direct debit": "Open",
        "overdue": "Overdue",
        "paid": "Paid"
      },
      "View invoice": "View invoice"
    },
    "Main-page": {
      "Customer data": "Customer information",
      "Domains": "Domains",
      "Statistics": "Statistics",
      "Hosting accounts": "Hostingaccounts",
      "Invoices": "Invoices",
      "See all domains": "See all domains",
      "See all invoices": "See all invoices",
      "See all webhosting accounts": "See all hosting accounts",
      "See customer profile": "See customer profile",
      "New appointment": "New appointment",
      "Go to new appointment": "Go to new appointment",
      "Appointments": "Appointments",
      "Go to appointments": "Go to appointments",
      "Go to statistics": "Go to statistics",
      "Go to licenses": "View all licenses",
      "Licenses": "Licenses"
    },
    "New-domain": {
      "Back to domains": "Back to domains",
      "Choose package": "Choose package",
      "Create new webhosting account": "New webhosting account",
      "discount": "discount",
      "Do not link to webhosting account": "Do not link to webhosting account",
      "I agree with the terms": "I hereby agree to the {termsLink}.",
      "incl": "incl.",
      "Link a webhosting account to your new domain": "Link a webhosting account to your new domain.",
      "Link contacts to domain": "Link contacts to domain",
      "Linked hosting": "Linked webhosting",
      "New": "new",
      "New domain": "New domain",
      "Order": "Order",
      "Order completed": "Order completed",
      "Order failed": "Order failed",
      "Order partially completed": "Order partially completed",
      "Overview": "Overview",
      "per year": "per year",
      "Register domain": "Registreer een domein",
      "Select webhosting account": "Select webhosting account",
      "Something went wrong with the domain order": "Something went wrong with the domain order. Please contact our Service Desk.",
      "Something went wrong with the order of the web hosting account": "Something went wrong with the order of the web hosting account. Please contact our Service Desk.",
      "terms and conditions": "terms and conditions",
      "terms url": "https://omninetworks.nl/algemene-voorwaarden/",
      "Thank you for your order": "Thank you for your order!",
      "The transfer code is invalid": "The transfer code is invalid.",
      "Webhosting account": "Webhosting account",
      "Your domain registration is in progress": "Your domain registration is in progress. You can track the status of the registration on the domains page.",
      "Your new web hosting account is now available": "Your new web hosting account is now available. Go to the web hosting page to log in."
    },
    "New-webhosting-account": {
      "Back to accounts": "Back to hosting accounts",
      "Choose package": "Choose package",
      "discount": "discount",
      "I agree with the terms": "I hereby agree to the {termsLink}.",
      "incl": "incl.",
      "Link a primary domain to your new hosting account": "Link a primary domain to your new hosting account.",
      "Link contacts to domain": "Link contacts to domain",
      "New": "new",
      "New hosting account": "New hosting account",
      "Order": "Order",
      "Order completed": "Order completed",
      "Order failed": "Order failed",
      "Order partially completed": "Order partially completed",
      "Overview": "Overview",
      "per year": "per year",
      "Primary domain": "Primary domain",
      "Register domain": "Register domain",
      "Register new domain": "Register new domain",
      "Select primary domain": "Select primary domain",
      "Something went wrong with the domain order": "Something went wrong with the domain order. Please contact our Service Desk.",
      "Something went wrong with the order of the web hosting account": "Something went wrong with the order of the web hosting account. Please contact our Service Desk.",
      "terms and conditions": "terms and conditions",
      "terms url": "https://omninetworks.nl/algemene-voorwaarden/",
      "Thank you for your order": "Thank you for your order!",
      "The transfer code is invalid": "The transfer code is invalid.",
      "Your domain registration is in progress": "Your domain registration is in progress. You can track the status of the registration on the domains page.",
      "Your new web hosting account is now available": "Your new web hosting account is now available. Go to the web hosting page to log in."
    },
    "Register-domain": {
      "Available": "Available",
      "Choose": "Choose",
      "discount": "discount",
      "domain": "domain",
      "Domain is available": "Domain is available for registration.",
      "Domain is taken": "Domain is taken.",
      "extension": "extension",
      "Failed to check domain": "Failed to check domain.",
      "incl": "incl.",
      "Is the domain yours, and do you have a transfer code": "Do you want to transfer the domain name? Please enter the transfer code below.",
      "Most chosen": "Most chosen",
      "per year": "per year",
      "Check availability": "Check availability",
      "Selected domain": "Selected domain",
      "Selected domain is changed": "Selected domain is changed.",
      "Suggestions": "Other suggestions",
      "Taken": "Taken",
      "The domain cannot be transferred": "The domain cannot be transferred.",
      "Transfer code": "Transfer code"
    },
    "Settings": {
      "Value": "Value",
      "Delete": "delete",
      "Delete item": "Delete setting",
      "Delete item fail": "Error deleting the setting. {msg}",
      "Delete item success": "Setting successfully deleted.",
      "Delete item text": "Are you sure you want to {1} the setting {0}?",
      "Edit item": "Edit setting",
      "Edit item fail": "Error updating the setting. {msg}",
      "Edit item success": "Setting successfully updated.",
      "New item": "New setting",
      "New item fail": "Error creating setting. {msg}",
      "New item success": "Setting successfully added.",
      "Errors": {
        "ErrorCode": {
          "STEP_DOES_NOT_MATCH": "Allowed step: {step}.",
          "PATTERN_DOES_NOT_MATCH": "Allowed pattern: {pattern}.",
          "INVALID_OPTION": "Invalid @.lower:{key}, allowed: {allowed}.",
          "INVALID_MAXIMUM": "@:{key} exceeds the maximum ({maximum}MB).",
          "INVALID_IMAGE_DATA": "Invalid image file.",
          "INVALID_IMAGE_METADATA": "Image metadata is not available.",
          "INVALID_IMAGE_ASPECTRATIO": "Invalid image aspect ratio ({actual}), expected {expected}.",
          "INVALID_IMAGE_TRANSFORM": "Transformation not allowed for type {currentMimeType}, allowed types: {allowedMimeTypes}.",
          "INVALID_IMAGE_WIDTH": "Invalid width ({actual}px), expected {expected}px.",
          "INVALID_IMAGE_HEIGHT": "Invalid height ({actual}px), expected {expected}px.",
          "INVALID_IMAGE_MINWIDTH": "Width ({actual}px) is below the minimum ({expected}px).",
          "INVALID_IMAGE_MINHEIGHT": "Height ({actual}px) is below the minimum ({expected}px).",
          "INVALID_IMAGE_MAXWIDTH": "Width ({actual}px) exceeds the maximum ({expected}px).",
          "INVALID_IMAGE_MAXHEIGHT": "Height ({actual}px) exceeds the maximum ({expected}px)."
        }
      },
      "RemoveSettings item fail": "Error restoring setting. | Error restoring settings.",
      "RemoveSettings item success": "Setting restored successfully. | Settings restored successfully.",
      "SaveSettings item fail": "Error saving setting. | Error saving settings.",
      "SaveSettings item success": "Setting saved successfully. | Settings saved successfully.",
      "My settings": "My settings",
      "Customer settings": " Settings of {customerName}",
      "My customer settings": " My settings for {customerName}",
      "Remove setting confirm": "Restore settings",
      "Remove setting confirm text": "Are you sure you want to restore the settings to their default values?",
      "Remove single setting confirm": "Restore setting",
      "Remove single setting confirm text": "Are you sure you want to restore the setting to its default value?"
    },
    "Sharingcenter": {
      "Calendar": "Calendar",
      "Contacts": "Contacts",
      "Groups": "Groups",
      "MeetingStatistics": "Statistics",
      "New": "New",
      "Overview": "Overview",
      "Profiles": "Profiles",
      "Recordings": "Recordings",
      "Fileshare": "Fileshare",
      "Screenshare": "Screenshare",
      "Chat": "Chat",
      "Meeting": "Meeting",
      "Appointment": "Afspraak",
      "CallColleague": "Colleagues",
      "CallColleagueIntro": "See which colleagues are online and start a meeting right away.",
      "Accept": "Accept",
      "Colleague": "Colleague",
      "Colleagues": "Colleagues",
      "Decline": "Decline",
      "LoadColleaguesError": "The colleagues could not be loaded.",
      "NoColleagues": "No colleagues found.",
      "NoMatchingColleagues": "No colleagues found.",
      "Offline": "Offline",
      "Online": "Online",
      "PresenceStatus": "Status",
      "PresenceStatusAppearOffline": "Appear offline",
      "PresenceStatusAway": "Away",
      "PresenceStatusDoNotDisturb": "Busy",
      "PresenceStatusHelp": "Controls how colleagues see and call you.",
      "PresenceStatusMeetingManaged": "Automatically set while you are in a meeting.",
      "PresenceStatusOffline": "Offline",
      "PresenceStatusOnline": "Online",
      "SearchColleagues": "Search colleagues",
      "BrowserNotificationsTitle": "Browser notifications for calls and invitations",
      "BrowserNotificationsDescription": "Get notified when a colleague calls or invites you to a meeting, even while the portal is in the background.",
      "BrowserNotificationsEnable": "Enable browser notifications",
      "BrowserNotificationsOpen": "Open OMNI Sessions",
      "BrowserNotificationsDefault": "Not enabled",
      "BrowserNotificationsGranted": "Enabled",
      "BrowserNotificationsDenied": "Blocked",
      "BrowserNotificationsUnsupported": "Not supported",
      "BrowserNotificationsDeniedHelp": "Notifications are blocked in this browser. Change the permission in the browser's site settings.",
      "BrowserNotificationsUnsupportedHelp": "This browser does not support system notifications for the portal.",
      "BrowserNotificationsCallerNameToggle": "Show colleague name in system notification",
      "BrowserNotificationsCallerNameHelp": "With this option turned off, the system notification does not show a name. Only this preference is stored in this browser.",
      "BrowserNotificationsPermissionError": "Browser notification permission could not be requested.",
      "BrowserNotificationsLoginPromptTitle": "Never miss a call or invitation?",
      "BrowserNotificationsLoginPromptMessage": "Allow browser notifications so you can see calls and meeting invitations while the portal is in the background.",
      "BrowserNotificationsLoginPromptPrivacy": "By default, the colleague's name is not shown in the notification. You can change this later under",
      "BrowserNotificationsLoginPromptPrivacyLink": "Colleagues",
      "BrowserNotificationsLoginPromptLater": "Not now",
      "DirectCallButton": "Call",
      "CallingColleague": "Calling {colleague}...",
      "DirectCallConfirmTitle": "Call colleague",
      "DirectCallConfirmMessage": "Do you want to call {colleague}?",
      "DirectCallConfirmOk": "Yes, call",
      "DirectCallConfirmCancel": "Cancel",
      "DirectCallReasonLabel": "Reason for the call (optional)",
      "DirectCallReasonHint": "Briefly explain why you are calling.",
      "DirectCallReasonDetailLabel": "Reason",
      "DirectCallWaitingTitle": "Calling colleague",
      "DirectCallWaitingMessage": "Waiting for {colleague} to answer.",
      "DirectCallCancelButton": "Cancel call",
      "DirectCallCancelFailed": "The call could not be cancelled.",
      "DirectCallAcceptFailed": "The call could not be accepted.",
      "DirectCallDeclineFailed": "The call could not be declined.",
      "DirectCallRequestFailed": "The call could not be started.",
      "DirectCallCallerInMeeting": "You cannot call a colleague while you are in a meeting.",
      "DirectCallTargetBusy": "This colleague is already being called. Please try again later.",
      "IncomingDirectCallTitle": "Incoming call",
      "IncomingDirectCallMessage": "Direct colleague call.",
      "IncomingDirectCallNotificationTitle": "Incoming colleague call",
      "IncomingDirectCallNotificationGenericBody": "Open OMNI Sessions to respond.",
      "IncomingDirectCallNotificationNamedBody": "{caller}",
      "DirectCallAcceptedToast": "Call accepted.",
      "DirectCallAlreadyInCallToast": "Colleague is already in a call.",
      "DirectCallAppearedOfflineToast": "Colleague appeared offline.",
      "DirectCallDeclinedToast": "Call declined.",
      "DirectCallDoNotDisturbToast": "Colleague is busy.",
      "DirectCallCancelledToast": "The call was cancelled.",
      "DirectCallCallerDisconnectedToast": "{caller} disconnected. The call was retracted.",
      "DirectCallCalleeDisconnectedToast": "{callee} disconnected. The call was declined.",
      "DirectCallMeetingUnavailableToast": "The call could not be started.",
      "DirectCallNoAnswerToast": "{callee} is not responding.",
      "DirectCallMeetingOpenFailed": "The call could not be opened.",
      "Errors": {
        "ErrorCode": {
          "DIRECT_CALL_CUSTOMER_REQUIRED": "No customer context was found.",
          "DIRECT_CALL_CUSTOMER_USER_REQUIRED": "No valid customer user was found.",
          "DIRECT_CALL_TARGET_REQUIRED": "Select a colleague to call.",
          "DIRECT_CALL_SELF_CALL_NOT_ALLOWED": "You cannot call yourself.",
          "DIRECT_CALL_CALLER_IN_MEETING": "You cannot call a colleague while you are in a meeting.",
          "DIRECT_CALL_TARGET_UNAVAILABLE": "This colleague is not available for calls.",
          "DIRECT_CALL_TARGET_OFFLINE": "This colleague is offline.",
          "DIRECT_CALL_TARGET_NOT_CALLABLE": "This colleague cannot be reached right now.",
          "DIRECT_CALL_TARGET_BUSY": "This colleague is already being called. Please try again later.",
          "DIRECT_CALL_REASON_TOO_LONG": "The reason may contain no more than 500 characters.",
          "DIRECT_CALL_UNAVAILABLE": "This call is no longer available.",
          "DIRECT_CALL_PARTICIPANTS_INVALID": "The participants for this call are invalid.",
          "DIRECT_CALL_PARTICIPANTS_UNAVAILABLE": "A participant is not available in this customer context.",
          "DIRECT_CALL_PARTICIPANT_CUSTOMER_CONTEXT_MISMATCH": "A participant does not belong to the active customer context.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_MEETING_PERMISSIONS": "A participant does not have permission to use meetings.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_MEET_LICENSE": "A participant does not have an active OMNI Sessions Meet license.",
          "DIRECT_CALL_PARTICIPANTS_MISSING_CALENDAR": "A participant does not have a calendar for meetings.",
          "DIRECT_CALL_MEETING_CREATE_FAILED": "The meeting for this call could not be created.",
          "PRESENCE_CUSTOMER_USER_REQUIRED": "No valid customer user was found to update your status."
        }
      },
      "IncomingMeetingInviteTitle": "Meeting invitation",
      "IncomingMeetingInviteMessage": "{caller} invites you to join now.",
      "IncomingMeetingInviteNotificationTitle": "Meeting invitation",
      "IncomingMeetingInviteNotificationGenericBody": "Open OMNI Sessions to view the invitation.",
      "IncomingMeetingInviteNotificationNamedBody": "{caller} invites you to ‘{subject}’.",
      "IncomingMeetingInviteNotificationNamedBodyWithoutSubject": "{caller} invites you to a meeting.",
      "MeetingInviteSubjectLabel": "Subject",
      "MeetingInviteStartLabel": "Started",
      "MeetingInviteNoSubject": "No subject",
      "MeetingInviteNoStartTime": "Unknown",
      "MeetingInviteAcceptFailed": "The invitation could not be accepted.",
      "MeetingInviteDeclineFailed": "The invitation could not be declined.",
      "MeetingInviteDeclinedToast": "Invitation declined."
    },
    "Sms-logs": {
      "SmsSent": "SMS status"
    },
    "Statistics": {
      "Overview": "Overview",
      "Meetings": "Meetings",
      "Feedback": "Feedback",
      "Sms": "SMS",
      "Email": "Email",
      "Licenses": "Licenses",
      "MeetingsDescription": "View meeting totals, participants, sessions and durations.",
      "FeedbackDescription": "View totals for submitted feedback and unique respondents.",
      "SmsDescription": "View sent, failed and delivery trends for SMS traffic.",
      "EmailDescription": "View send performance, recipients and email type trends.",
      "LicensesDescription": "View license costs, seats, occupancy, renewals and scheduled changes.",
      "GoToMeetings": "Go to meetings",
      "GoToFeedback": "Go to feedback",
      "GoToSms": "Go to SMS",
      "GoToEmail": "Go to email",
      "GoToLicenses": "Go to license statistics"
    },
    "LicenseStatistics": {
      "LoadError": "The license statistics could not be loaded.",
      "OverviewSection": "License overview",
      "CapacitySection": "Capacity",
      "FinancialSection": "Total costs",
      "LicenseRevenueSection": "Licenses",
      "SlaRevenueSection": "SLAs",
      "PartnerProgramRevenueSection": "Partner discount",
      "LicenseRevenueSubject": "licenses",
      "SlaRevenueSubject": "SLAs",
      "PartnerProgramRevenueSubject": "partner discount",
      "RenewalSection": "Renewals and changes",
      "ScopeSection": "Scope",
      "TrendSection": "Trends",
      "ProductBreakdownSection": "By product",
      "CustomerBreakdownSection": "By customer",
      "LicenseListSection": "Licenses",
      "activeLicenses": "Active licenses",
      "totalSeats": "Purchased seats",
      "assignedSeats": "Assigned seats",
      "availableSeats": "Available seats",
      "occupancyRate": "Occupancy rate",
      "renewalsNext30Days": "Renewals in 30 days",
      "fullLicenses": "Fully used",
      "unusedLicenses": "Unused",
      "underusedLicenses": "Underused",
      "periodRevenue": "Costs in period",
      "currentMrr": "Current monthly costs",
      "currentArr": "Current yearly costs",
      "projectedMrr": "Projected monthly costs at snapshot",
      "futureProjectedMrr": "Projected monthly costs incl. future changes",
      "projectedMrrDelta": "Projected monthly cost change at snapshot",
      "projectedArr": "Projected yearly costs at snapshot",
      "futureProjectedArr": "Projected yearly costs incl. future changes",
      "projectedArrDelta": "Projected yearly cost change at snapshot",
      "partnerProgramDiscountPeriodRevenue": "Discount in period",
      "partnerProgramDiscountCurrentMrr": "Current monthly discount",
      "partnerProgramDiscountCurrentArr": "Current yearly discount",
      "partnerProgramDiscountProjectedMrr": "Projected monthly discount at snapshot",
      "partnerProgramDiscountFutureProjectedMrr": "Projected monthly discount incl. future changes",
      "partnerProgramDiscountProjectedMrrDelta": "Projected monthly discount change at snapshot",
      "partnerProgramDiscountProjectedArr": "Projected yearly discount at snapshot",
      "partnerProgramDiscountFutureProjectedArr": "Projected yearly discount incl. future changes",
      "partnerProgramDiscountProjectedArrDelta": "Projected yearly discount change at snapshot",
      "pendingChanges": "Scheduled changes",
      "pendingSeatDelta": "Scheduled seat change",
      "pendingProductChanges": "Scheduled product changes",
      "endingOnRenewal": "Ends on renewal",
      "activeProducts": "Products in use",
      "activeCustomers": "Customers with licenses",
      "periodRevenueCaption": "Prorated license costs over the selected period. If a subscription starts or ends halfway through a month, only active days are counted.",
      "currentMrrCaption": "Monthly recurring license costs as a run rate. Yearly amounts are normalized to a month amount; partial months are not prorated.",
      "currentArrCaption": "Yearly recurring license costs as a run rate. This is current monthly costs multiplied by 12.",
      "projectedMrrCaption": "Projected monthly costs based on licenses that are in scope on the snapshot date. Future purchases with a later start date are not included.",
      "futureProjectedMrrCaption": "The same projected monthly costs, but including known future changes such as licenses with a start date after the snapshot date.",
      "projectedMrrDeltaCaption": "Difference between projected monthly costs at the snapshot date and current monthly costs.",
      "projectedArrCaption": "Projected yearly costs after scheduled license changes are applied on the next renewal. This is projected monthly costs multiplied by 12.",
      "futureProjectedArrCaption": "The same projected yearly costs, but including known future changes such as licenses with a start date after the snapshot date.",
      "projectedArrDeltaCaption": "Difference between projected yearly costs at the snapshot date and current yearly costs.",
      "RevenueBreakdownPeriodRevenueCaption": "Prorated costs for {subject} over the selected period. If a subscription starts or ends halfway through a month, only active days are counted.",
      "RevenueBreakdownCurrentMrrCaption": "Monthly recurring costs for {subject} as a run rate. Yearly amounts are normalized to a month amount; partial months are not prorated.",
      "RevenueBreakdownCurrentArrCaption": "Yearly recurring costs for {subject} as a run rate. This is current monthly costs multiplied by 12.",
      "RevenueBreakdownProjectedMrrCaption": "Projected monthly costs for {subject} based on licenses that are in scope on the snapshot date. Future purchases with a later start date are not included.",
      "RevenueBreakdownFutureProjectedMrrCaption": "The same projected monthly costs for {subject}, but including known future changes such as licenses with a start date after the snapshot date.",
      "RevenueBreakdownProjectedMrrDeltaCaption": "Difference between projected monthly costs at the snapshot date and current monthly costs for {subject}.",
      "RevenueBreakdownProjectedArrCaption": "Projected yearly costs for {subject} after scheduled license changes are applied on the next renewal. This is projected monthly costs multiplied by 12.",
      "RevenueBreakdownFutureProjectedArrCaption": "The same projected yearly costs for {subject}, but including known future changes such as licenses with a start date after the snapshot date.",
      "RevenueBreakdownProjectedArrDeltaCaption": "Difference between projected yearly costs at the snapshot date and current yearly costs for {subject}.",
      "PartnerProgramDiscountBreakdownPeriodRevenueCaption": "Prorated partner discount over the selected period. If a subscription starts or ends halfway through a month, only active days are counted.",
      "PartnerProgramDiscountBreakdownCurrentMrrCaption": "Monthly recurring partner discount as a run rate. Yearly amounts are normalized to a month amount; partial months are not prorated.",
      "PartnerProgramDiscountBreakdownCurrentArrCaption": "Yearly recurring partner discount as a run rate. This is current monthly discount multiplied by 12.",
      "PartnerProgramDiscountBreakdownProjectedMrrCaption": "Projected monthly discount based on licenses that are in scope on the snapshot date. Future purchases with a later start date are not included.",
      "PartnerProgramDiscountBreakdownFutureProjectedMrrCaption": "The same projected monthly discount, but including known future changes such as licenses with a start date after the snapshot date.",
      "PartnerProgramDiscountBreakdownProjectedMrrDeltaCaption": "Difference between projected monthly discount at the snapshot date and current monthly discount.",
      "PartnerProgramDiscountBreakdownProjectedArrCaption": "Projected yearly discount after scheduled license changes are applied on the next renewal. This is projected monthly discount multiplied by 12.",
      "PartnerProgramDiscountBreakdownFutureProjectedArrCaption": "The same projected yearly discount, but including known future changes such as licenses with a start date after the snapshot date.",
      "PartnerProgramDiscountBreakdownProjectedArrDeltaCaption": "Difference between projected yearly discount at the snapshot date and current yearly discount.",
      "pendingChangesCaption": "Licenses with scheduled changes for the next renewal.",
      "pendingSeatDeltaCaption": "Net seat change from scheduled license changes.",
      "pendingProductChangesCaption": "Scheduled changes where the license product changes.",
      "endingOnRenewalCaption": "Licenses that will go to 0 seats on the next renewal.",
      "FromDate": "Trend from",
      "UntilDate": "Snapshot date",
      "ForecastRange": "Forecast range",
      "ForecastMonthsOption": "{months} months",
      "DateRangeHelp": "The start date determines where the trend charts begin. The snapshot date determines the totals in the cards and is also the end of the trend period.",
      "PeriodRevenueTrendTitle": "Costs per month",
      "RevenueTrendTitle": "Monthly costs per month",
      "FutureRevenueForecastTitle": "Projected cost development",
      "SeatTrendTitle": "Seats per month",
      "RenewalTrendTitle": "Renewals per month",
      "PeriodRevenuePerMonth": "Costs",
      "CurrentMrrPerMonth": "Current monthly costs",
      "ProjectedMrrPerMonth": "Projected monthly costs",
      "ForecastMrr": "Projected monthly costs",
      "TotalSeatsPerMonth": "Purchased seats",
      "AssignedSeatsPerMonth": "Assigned seats",
      "AvailableSeatsPerMonth": "Available seats",
      "RenewalsPerMonth": "Renewals",
      "PendingChangesPerMonth": "Scheduled changes",
      "NoPeriodRevenueTrendData": "No cost data is available in the selected period.",
      "NoRevenueTrendData": "No cost trend data is available in the selected period.",
      "NoFutureRevenueForecastData": "No forecast data is available for the selected period.",
      "NoSeatTrendData": "No seat trend data is available in the selected period.",
      "NoRenewalTrendData": "No renewal trend data is available in the selected period.",
      "Name": "Name",
      "Customer": "Customer",
      "Product": "Product",
      "ActiveLicenses": "Active licenses",
      "TotalSeats": "Purchased seats",
      "AssignedSeats": "Assigned seats",
      "AvailableSeats": "Available",
      "OccupancyRate": "Occupancy rate",
      "CurrentMrr": "Monthly costs",
      "RenewDate": "Renew date",
      "PendingChanges": "Scheduled changes",
      "Pending": "Scheduled",
      "User": "User",
      "Email": "Email",
      "StartDate": "Start date",
      "EndDate": "End date",
      "NoAssignedUsers": "No assigned users."
    },
    "Sharingcenter-meeting-logs": {
      "Customer": "Customer",
      "Status": "Status"
    },
    "Sharingcenter-appointments": {
      "Unable to join": "Unable to join.",
      "Confirm profile change": "Change profile",
      "Overwrite settings question": "This profile has its own settings. Do you want to replace the current settings with the profile settings?",
      "Overwrite": "Replace",
      "Keep": "Keep current",
      "Profile": "Profile",
      "No profile": "No profile",
      "TimeZone": "Timezone",
      "Tzid": "Timezone",
      "Edit only this occurrence": "Edit only this occurrence",
      "Edit all future occurrences": "Edit all future occurrences",
      "Edit all occurrences in this series": "Edit all occurrences in this series",
      "Delete only this occurrence": "Delete only this occurrence",
      "Delete all future occurrences": "Delete all future occurrences",
      "Delete all occurrences in this series": "Delete all occurrences in this series",
      "Message optional": "Message (optional)",
      "Email organizer": "Email organizer",
      "Mail everyone": "Email everyone",
      "InvalidLink": "The link is invalid.",
      "RsvpAccepted": "Appointment marked as accepted.",
      "RsvpDeclined": "Appointment marked as declined.",
      "RsvpTentative": "Appointment marked as tentative.",
      "RsvpGeneric": "RSVP processed.",
      "Decline": "Decline",
      "Maybe": "Tentative",
      "Accept": "Accept",
      "Send": "Send",
      "RSVP sent": "RSVP sent.",
      "RSVP failed": "Setting RSVP failed.",
      "Status": "Status",
      "Link": "Link",
      "StatusOptions": {
        "Accepted": "Accepted",
        "Declined": "Declined",
        "Tentative": "Tentative",
        "Waiting": "Waiting for response"
      },
      "Show link": "Show link",
      "Show more": "Show more",
      "Show less": "Show less",
      "Copy link": "Copy link",
      "Copy code": "Copy code",
      "Copied": "Copied.",
      "Copy failed": "Copy failed.",
      "UserOrContact": "User or contact",
      "Select participant": "Select participant (optional)",
      "Edit existing contact": "Edit existing contact",
      "Create new contact": "Create new contact",
      "Revert from contact": "Revert from contact",
      "Guest": "Guest",
      "Add participant": "Add participant",
      "Add participants (max x)": "Add participants (max {max})",
      "More options": "More options",
      "Agent": "Agent",
      "All day": "All day",
      "AllDay": "All day",
      "Pattern": "Pattern",
      "RecurrenceRangeMode": "Recurrence range mode",
      "RecurrencePattern": "Pattern",
      "Recurrence": {
        "In month": "In month",
        "DoesNotRepeat": "Does not repeat",
        "RepeatAppointment": "Repeat appointment",
        "RepeatDaily": "Repear daily",
        "RepeatWeekly": "Repear weekly",
        "RepeatMonthly": "Repear monthly",
        "RepeatYearly": "Repear yearly",
        "Title": "Recurrence",
        "Pattern": "Recurrence pattern",
        "Daily": "Daily",
        "Weekly": "Weekly",
        "Monthly": "Monthly",
        "Yearly": "Yearly",
        "Every": "Every",
        "Days": "day(s)",
        "Weeks": "week(s)",
        "Months": "month(s)",
        "Range": "Range of recurrence",
        "RangeNever": "No end date",
        "RangeAfter": "End after",
        "RangeOn": "End on",
        "Occurrences": "occurrences",
        "EndBy": "End by",
        "Clear": "Remove recurrence",
        "MonthlyModeDay": "On day",
        "MonthlyModeOnThe": "On the",
        "WeekIndex": {
          "First": "First",
          "Second": "Second",
          "Third": "Third",
          "Fourth": "Fourth",
          "Last": "Last"
        },
        "MonthWeekday": {
          "Day": "Day",
          "Weekday": "Workday",
          "WeekendDay": "Weekendday"
        }
      },
      "RecurrenceSummary": {
        "DoesNotRepeat": "Does not repeat",
        "DailySingular": "Repeats every day",
        "DailyPlural": "Repeats every {interval} days",
        "WeeklyWithDaysSingular": "Repeats every week on {days}",
        "WeeklyWithDaysPlural": "Repeats every {interval} weeks on {days}",
        "WeeklyNoDaysSingular": "Repeats every week",
        "WeeklyNoDaysPlural": "Repeats every {interval} weeks",
        "MonthlyDayOfMonthSingular": "Repeats every month on day {day}",
        "MonthlyDayOfMonthPlural": "Repeats every {interval} months on day {day}",
        "MonthlyNthWeekdaySingular": "Repeats every month on the {index} {weekday}",
        "MonthlyNthWeekdayPlural": "Repeats every {interval} months on the {index} {weekday}",
        "YearlyDayOfMonthSingular": "Repeats every year on {day} {month}",
        "YearlyNthWeekdaySingular": "Repeats every year on the {index} {weekday} in {month}",
        "YearlyGenericSingular": "Repeats every year",
        "RangeAfter": "ends after {count} occurrences",
        "RangeOn": "ends on {date}",
        "And": "and",
        "WeekdayNames": {
          "MO": "Monday",
          "TU": "Tuesday",
          "WE": "Wednesday",
          "TH": "Thursday",
          "FR": "Friday",
          "SA": "Saturday",
          "SU": "Sunday"
        },
        "WeekIndexNames": {
          "First": "first",
          "Second": "second",
          "Third": "third",
          "Fourth": "fourth",
          "Last": "last"
        },
        "MonthNames": {
          "10": "October",
          "11": "November",
          "12": "December",
          "01": "January",
          "02": "February",
          "03": "March",
          "04": "April",
          "05": "May",
          "06": "June",
          "07": "July",
          "08": "August",
          "09": "September"
        },
        "MonthWeekdayNames": {
          "DAY": "day",
          "WEEKDAY": "weekday",
          "WEEKEND": "weekend day"
        }
      },
      "Weekday": {
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun"
      },
      "Appointment types": {
        "chat": "Chat",
        "fileshare": "File sharing",
        "meeting": "Meeting",
        "screenshare": "Screen sharing"
      },
      "Appointment types heading": {
        "chat": "Chat",
        "fileshare": "File sharing",
        "meeting": "Meeting",
        "screenshare": "Screen sharing"
      },
      "Appointments": "Appointment | Appointments",
      "By email": "By email",
      "By SMS": "By SMS",
      "Calendar": "Calendar",
      "CalendarView": "View",
      "Choose a user or set role to guest": "Choose a user or set role to guest",
      "Code": "Code",
      "Code description icon": "Share this code with the user via a secondary channel (e.g., WhatsApp, SMS, or phone call). The user must enter the code when opening the appointment as an additional layer of security.",
      "Created at": "Created at",
      "Created by": "Created by",
      "Current calendar": "Current calendar",
      "Default calendar": "Default calendar",
      "Delete": "delete",
      "Delete appointment": "Delete appointment",
      "Delete item": "Delete appointment",
      "Delete item fail": "Error while deleting the appointment.",
      "Delete item success": "Appointment successfully deleted.",
      "Delete item text": "Are you sure you want to {1} appointment {0}?",
      "Delete item text series this": "Are you sure you want to {1} only this occurrence of appointment {0}?",
      "Delete item text series future": "Are you sure you want to {1} all future occurrences of appointment {0}?",
      "Description": "Description",
      "Do not notify": "Do not notify",
      "Edit appointment": "Edit appointment",
      "Edit item fail": "Error editing appointment",
      "Edit item success": "Appointment successfully changed.",
      "Email": "Email",
      "End": "End",
      "End must be after start": "End must be after start.",
      "EndAt": "End",
      "Errors": {
        "Error loading data": "Error loading data"
      },
      "Explain message variables": "Use the placeholders below; they will be automatically replaced when the email is sent.",
      "FirstName": "First name",
      "Form heading": "{name}",
      "FromDate": "From",
      "General": "General",
      "Generate": "Generate",
      "Link by email / Code by SMS": "Link by email / Code by SMS",
      "Link by SMS / Code by email": "Link by SMS / Code by email",
      "Guest fields are required when sending by email": "Guest fields are required when sending by email",
      "Guestemail": "Guest email",
      "Guestfirstname": "Guest first name",
      "Guestlastname": "Guest last name",
      "Hide message vars": "Hide merge tags",
      "Join": "Join",
      "Join disabled active meeting": "Another appointment is active.",
      "Join disabled not started": "Join not available yet.",
      "Join disabled expired": "Join no longer available.",
      "Kind": "Type",
      "Kind options": {
        "Agent": "Agent",
        "Guest": "Guest"
      },
      "LastName": "Last name",
      "Message": "Message",
      "MessageVariableList": {
        "email": "Email address of the participant.",
        "firstName": "First name of the participant.",
        "fullName": "Full name of the participant.",
        "lastName": "Last name of the participant."
      },
      "Name": "Name",
      "Narrow view": "Narrow view",
      "New appointment": "New appointment",
      "New item fail": "Failed to create appointment.",
      "New item success": "Appointment created successfully.",
      "No subject": "No subject",
      "No user": "No user",
      "Notes": "Notes",
      "Only shared calendars available": "This appointments can only be made in a shared calendar.",
      "Overlapping appointments one": "There is 1 overlapping appointment.",
      "Overlapping appointments other": "There are {count} overlapping appointments.",
      "Own calendar": "Own calendar",
      "Starts in": "Starts in {time}",
      "In progress": "Now",
      "Ended": "Ended",
      "participants": "participant | participants",
      "Participants": "Participants",
      "Phone": "Phone",
      "Please choose agent or guest for each participant": "Please choose agent or guest for each participant",
      "Please choose an agent for participant": "Please choose an agent for participant",
      "Role": "Role",
      "Search": "Zoeken",
      "Settings": "Settings",
      "Share": "Share",
      "Shared calendar": "Shared calendar",
      "Sharemethod": "How would you share the link",
      "ShareMethod": "Inform",
      "Sharemethod options": {
        "Email": "By email",
        "Self": "I share it myself"
      },
      "Show message vars": "Show merge tags",
      "Start": "Start",
      "StartAt": "Start",
      "Subject": "Subject",
      "Switch to calendar view": "Switch to calendar view",
      "Switch to list view": "Switch to list view",
      "TillDate": "Till",
      "Type": "Type",
      "User": "User",
      "User calendar": "User calendar",
      "UserCalendar": "Calendar",
      "Variables": "Variables",
      "View participants": "View participants",
      "Widen view": "Widen view",
      "You can add up to 3 persons": "You can add up to 3 persons"
    },
    "Sharingcenter-calendars": {
      "Calendars": "Calendar | Calendars",
      "Cancel": "Cancel",
      "Change owner": "Change owner",
      "Choose color": "Choose color",
      "Choose target calendar": "Choose target calendar",
      "Default": "Default",
      "Delete": "delete",
      "Delete all": "Delete all",
      "Delete calendar": "Delete calendar",
      "Delete item": "Delete calendar",
      "Delete item fail": "Error while deleting the calendar.",
      "Delete item success": "Calendar successfully deleted.",
      "Delete item text": "Are you sure you want to {1} calendar {0}? All appointments in this calendar will also be deleted.",
      "Edit calendar": "Edit calendar",
      "Edit item fail": "Error editing calendar.",
      "Edit item success": "Calendar successfully changed.",
      "Errors": {
        "Error loading data": "Error loading data"
      },
      "Groups": "Groups",
      "Make default": "Make default",
      "Manage calendars": "Manage calendars",
      "Move and delete": "Move and delete",
      "Move to another calendar": "Move to another calendar",
      "My calendars": "My calendars",
      "Name": "Name",
      "New calendar": "New calendar",
      "New item fail": "Error while creating calendar.",
      "New item success": "Calendar successfully created.",
      "No available target calendars": "No available calendars for the same owner",
      "Owner": "Owner",
      "OwnerId": "Owner ID",
      "Permissions": {
        "AvailabilityOnly": "Availability only",
        "Editor": "Editor",
        "Owner": "Owner",
        "Viewer": "Viewer"
      },
      "Pick color": "Pick color",
      "Save": "Save",
      "Search": "Search",
      "Shared with": "Shared with",
      "Shared with me": "Shared with me",
      "This calendar is shared": "This calendar is shared",
      "Users": "Users",
      "Visible": "Visible",
      "What to do with appointments": "What would you like to do with the appointments?"
    },
    "Sharingcenter-contacts": {
      "Resolve future appointments": "Resolve future appointments",
      "This contact is linked to upcoming appointments, what would you like to do": "This contact is linked to upcoming appointments. What would you like to do?",
      "Update participants with new contact info": "Update participants with new contact info",
      "Keep appointments unchanged": "Keep appointments unchanged",
      "Contacts": "Contacts",
      "My contacts": "My contacts",
      "Shared with me": "Shared with me",
      "Manage contacts": "Manage contacts",
      "New contact": "New contact",
      "Edit contact": "Edit contact",
      "Save": "Save",
      "Cancel": "Cancel",
      "Search": "Search",
      "Shared with": "Shared with",
      "Users": "Users",
      "Groups": "Groups",
      "FirstName": "First name",
      "LastName": "Last name",
      "Email": "Email",
      "Phone": "Phone",
      "Unknown": "Unknown",
      "Make default": "Make default",
      "Visible": "Visible",
      "Default": "Default",
      "Pick color": "Pick color",
      "Choose color": "Choose color",
      "Errors": {
        "Error loading data": "Error loading data"
      },
      "Delete": "delete",
      "Delete all": "Delete all",
      "Delete contact": "Delete contact",
      "Delete item": "Delete contact",
      "Delete item fail": "Error while deleting the contact.",
      "Delete item success": "Contact successfully deleted.",
      "Delete item text": "Are you sure you want to {1} contact {0}?",
      "New item success": "Contact successfully created.",
      "New item fail": "Error while creating contact.",
      "Edit item success": "Contact successfully changed.",
      "Edit item fail": "Error editing contact.",
      "Viewer": "Viewer",
      "Editor": "Editor",
      "OwnerId": "Owner",
      "Confirm owner or sharing change": "Owner or sharing change",
      "Continue": "Continue",
      "Confirm owner or sharing text": "Changing the owner or sharing settings may unlink this contact from existing appointments and stop automatic updates to its details."
    },
    "Sharingcenter-profiles": {
      "Settings": "Settings",
      "Resolve future appointments": "Resolve future appointments",
      "This profile is linked to upcoming appointments, what would you like to do": "This profile is linked to upcoming appointments. What would you like to do?",
      "Update participants with new profile info": "Update participants with new profile info",
      "Keep appointments unchanged": "Keep appointments unchanged",
      "Profiles": "Profiles",
      "My profiles": "My profiles",
      "Shared with me": "Shared with me",
      "Manage profiles": "Manage profiles",
      "New profile": "New profile",
      "Edit profile": "Edit profile",
      "Save": "Save",
      "Cancel": "Cancel",
      "Search": "Search",
      "Shared with": "Shared with",
      "Users": "Users",
      "Groups": "Groups",
      "Name": "Name",
      "Description": "Description",
      "IsPublic": "Public",
      "Public": "Public",
      "Public profile info": "Public profiles are visible to everyone in the organization. Only administrators with permission to manage public profiles can edit them. Once a profile is public, it cannot be made private again.",
      "Unknown": "Unknown",
      "Errors": {
        "Error loading data": "Error loading data"
      },
      "Delete": "delete",
      "Delete all": "Delete all",
      "Delete profile": "Delete profile",
      "Delete item": "Delete profile",
      "Delete item fail": "Error while deleting the profile.",
      "Delete item success": "Profile successfully deleted.",
      "Delete item text": "Are you sure you want to {1} profile {0}?",
      "New item success": "Profile successfully created.",
      "New item fail": "Error while creating profile.",
      "Edit item success": "Profile successfully changed.",
      "Edit item fail": "Error editing profile.",
      "Type": "Type",
      "TypeOptions": {
        "Fileshare": "Fileshare",
        "Screenshare": "Screenshare",
        "Chat": "Chat",
        "Meeting": "Meeting"
      },
      "Viewer": "Viewer",
      "Editor": "Editor",
      "OwnerId": "Owner",
      "Confirm owner or sharing change": "Owner or sharing change",
      "Continue": "Continue",
      "Confirm owner or sharing text": "Changing the owner or sharing settings may unlink this profile from existing appointments."
    },
    "Sharingcenter-groups": {
      "Cancel": "Cancel",
      "Delete group": "Delete group",
      "Delete item": "Delete group",
      "Delete item fail": "Error while deleting the group.",
      "Delete item success": "Group successfully deleted.",
      "Delete item text": "Are you sure you want to delete group {0}?",
      "Edit": "Edit",
      "Edit group": "Edit group",
      "Edit item fail": "Error editing group.",
      "Edit item success": "Group successfully changed.",
      "Errors": {
        "Error loading data": "Error loading data",
        "Error saving": "Error saving",
        "Missing group id": "Missing group id"
      },
      "Group name": "Group name",
      "Groups": "Groups",
      "Manage groups": "Manage groups",
      "members": "member | members",
      "My groups": "My groups",
      "Name": "Name",
      "New group": "New group",
      "New item fail": "Error while creating group.",
      "New item success": "Group successfully created.",
      "Save": "Save",
      "Saved": "Saved",
      "Search": "Search",
      "Users": "Members",
      "Validation": {
        "Name is required": "Name is required"
      },
      "View members": "View members"
    },
    "Sharingcenter-new-appointment": {
      "Share a file": "Share files",
      "Share a file - CTA": "Share files",
      "Share a file - Description": "Send a secure, time-limited link so clients can download files safely.",
      "Share your screen": "Share your screen",
      "Share your screen - CTA": "Start screen share",
      "Share your screen - Description": "Start an instant screen share or let your client share their screen and guide them live.",
      "SharedCalendarOnly": "This option is available because a calendar is shared. New appointments can only be made in a shared calendar.",
      "Start a chat": "Start a chat",
      "Start a chat - CTA": "Start chat",
      "Start a chat - Description": "Open a secure chat to exchange messages and files for a limited period.",
      "Start a meeting": "Start a meeting",
      "Start a meeting - CTA": "Start meeting",
      "Start a meeting - Description": "Host a meeting with camera, microphone, chat, screen sharing and more."
    },
    "Sharingcenter-overview": {
      "Appointments": "Appointments",
      "Go to appointments": "Go to appointments",
      "Go to calendar": "Go to calendar",
      "Go to groups": "Go to groups",
      "Go to profiles": "Go to profiles",
      "Go to contacts": "Go to contacts",
      "Go to new appointment": "Go to new appointment",
      "New appointment": "New appointment"
    },
    "Sharingcenter-meeting": {
      "Verify token invalid": "This link is invalid or has expired.",
      "Verify token expired": "This link has expired.",
      "Verify token error": "Something went wrong while loading.",
      "Verify license missing": "No available license found.",
      "Verify code text": "Enter the code to continue.",
      "Verify code": "Verify code",
      "Verify code invalid": "The code is invalid.",
      "Meeting end text": "Thank you for joining.",
      "Feedback already answered": "Answer already submitted.",
      "Feedback already answered text": "Thank you for your response.",
      "Feedback submitted text": "Thank you for your response."
    },
    "Subscription-cancellation": {
      "Cancel date": "Termination date",
      "Cancel reason": "Reason for termination",
      "Cancel subscription": "Unsubscribe",
      "Cancellation date select text": "Please choose a date below on which the service should be terminated. A notice period of {noticePeriod} applies.",
      "Cancellation domain note": "{0} on the selected date, the domain will be deleted and temporarily placed in quarantine. There are costs associated with retrieving the domain from quarantine.",
      "Cancellation hosting note": "{0} on the selected date, the hosting account will be permanently deleted.",
      "Cancellation ssl note": "{0} on the selected date, the SSL certificate will be permanently deleted.",
      "Cancellation warning": "Although the service can be terminated within the cancellation period, you will still receive an invoice for the remaining period. The service will still be deleted on the selected termination date.",
      "Confirm termination": "Confirm termination",
      "Confirm undo termination text": "Do you want to undo the termination of the service?",
      "PeriodicOptions": {
        "Day": "Day | Days",
        "Month": "Month | Months",
        "Year": "Year | Years"
      },
      "Subscription cancel item success": "Subscription is cancelled.",
      "Subscription cancel reversed item success": "Cancellation has been reversed.",
      "Termination date after invoiced until": "{0} The selected termination date is after the current invoicing period. Your service will be automatically extended.",
      "Undo cancellation": "Undo termination"
    },
    "Users": {
      "Value": "Picture",
      "Errors": {
        "Formats": {
          "phone": "Phone number must be a valid international formatted phone number."
        }
      }
    },
    "Webhosting": {
      "Account": "Account | Accounts",
      "Autologin item fail": "Autologin failed. {msg}",
      "Autologin item success": "The web hosting control panel has been opened in a new tab.",
      "Back to accounts": "Back to hosting accounts",
      "Bandwidth": "Bandwidth",
      "BandwidthQuota": "Bandwidth quota",
      "Cancel subscription": "Unsubscribe",
      "CancelDate": "Cancelled on",
      "Cancelled": "Cancelled",
      "Cpanel login": "Log in to hosting",
      "discount": "discount",
      "Disk Space": "Disk space",
      "DiskQuota": "Disk quota",
      "Email": "Email address",
      "Errors": {
        "ErrorCode": {
          "CPANEL_CREATE_ACCOUNT_USERNAME_ALREADY_IN_USE": "Given username is not available.",
          "PASSWORD_CONTAINS_INVALID_CHARACTERS": "Password contains illegal characters."
        }
      },
      "incl": "incl.",
      "InvoiceDateHistory": {
        "EndDate": "End date",
        "InvoiceDate": "Invoice date",
        "StartDate": "Start date"
      },
      "InvoicedUntilDate": "Invoiced up to",
      "InvoiceHistory": "Invoice history",
      "InvoiceNextDate": "Next invoice",
      "InvoiceStartDate": "Invoice start date",
      "Linked domains": "Linked domains",
      "Lost password": "Retrieve account information",
      "More info": "More information",
      "New item": "New hosting account",
      "No hosting accounts found": "No hosting accounts found.",
      "No items": "Currently, there are no linked domains available.",
      "Password": "Password",
      "Period": "Period",
      "PeriodicOptions": {
        "Day": "Day | Days",
        "Month": "Month | Months",
        "Year": "Year | Years"
      },
      "Price": "Price",
      "PrimaryDomain": "Primary domain",
      "StartDate": "Startdatum",
      "Subscription": "Subscription",
      "TerminationDate": "Removal date",
      "Undo cancellation": "Undo termination",
      "Unlimited": "Unlimited",
      "Upgraden": "Upgraden",
      "Username": "Username",
      "WebhostingPackage": "Hosting package"
    },
    "Webhosting-packages": {
      "30 days backup": "30 days backups",
      "Amount due by": "Amount due by",
      "bandwidth": "bandwidth",
      "Choose package": "Choose package",
      "discount": "discount",
      "diskspace": "disk space",
      "Free SSL certificates": "Free SSL certificates",
      "incl": "incl.",
      "Included features": "Included features:",
      "Most chosen": "Most chosen",
      "One-Click WordPress installation": "One-Click WordPress installation",
      "per year": "per year",
      "Support included": "Support included",
      "Unlimited databases": "Unlimited databases",
      "Unlimited domain links": "Unlimited domain linking",
      "Unlimited mailboxes": "Unlimited mailboxes",
      "Unlimited subdomains": "Unlimited subdomains"
    },
    "Webhosting-send-account-details": {
      "Change password": "Change password?",
      "Change password now": "Change the password in the hosting account",
      "Email address": "Email address",
      "Mail details": "Your hosting account details will be sent to the following email address:",
      "New password": "New password",
      "Randomize password": "Randomize password",
      "Send account details item": "Retrieve account information",
      "Send account details item fail": "Unable to send account details. {msg}",
      "Send account details item success": "Account details were sent successfully.",
      "Send mail": "Send mail"
    },
    "Webhosting-upgrade": {
      "Change package": "Change package",
      "New hosting package": "New hosting package",
      "Order now": "Order",
      "Upgrade hosting": "Upgrade hosting",
      "Upgrade item fail": "Error upgrading hosting account. {msg}",
      "Upgrade item success": "Successfully upgraded hosting account."
    },
    "Webhooks": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "Url": "URL",
      "Active": "Active",
      "Webhooks": "Webhooks",
      "ScopeOptions": {
        "Customer": "One customer",
        "Global": "All customers"
      },
      "EventsOptions": {
        "Create": "Create",
        "Patch": "Patch"
      },
      "New item": "New webhook",
      "Edit item": "Edit webhook",
      "View item": "View webhook",
      "Delete item": "Delete webhook",
      "New item success": "Webhook added.",
      "Edit item success": "Webhook saved.",
      "Delete item success": "Webhook deleted.",
      "New item fail": "Could not add webhook.",
      "Edit item fail": "Could not save webhook.",
      "Delete item fail": "Could not delete webhook."
    },
    "Webhook-queue": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "DestinationHost": "Destination",
      "Active": "Active",
      "WebhookName": "Webhook",
      "Method": "Event",
      "Status": "Status",
      "Attempts": "Attempts",
      "Attempt": "Attempt",
      "StatusCode": "HTTP status",
      "ErrorCode": "Error code",
      "CreatedAt": "Time",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "View webhook delivery"
    },
    "Webhook-logs": {
      "Name": "Name",
      "Scope": "Scope",
      "Customer": "Customer",
      "Service": "Service",
      "Events": "Events",
      "DestinationHost": "Destination",
      "Active": "Active",
      "WebhookName": "Webhook",
      "Method": "Event",
      "Status": "Status",
      "Attempts": "Attempts",
      "Attempt": "Attempt",
      "StatusCode": "HTTP status",
      "ErrorCode": "Error code",
      "CreatedAt": "Time",
      "Webhook": "Webhook",
      "Webhooks": "Webhooks",
      "View item": "View webhook log"
    }
  },
  "Shared": {
    "AzureBackupDisks": {
      "title": "Disks in backup",
      "osDisk": "OS disk",
      "dataDisk": "Data disk - LUN {lun}",
      "included": "Selected",
      "excluded": "Not selected",
      "unknown": "Unknown",
      "status": {
        "complete": "All disks selected",
        "incomplete": "Disk missing from backup selection",
        "unknown": "Disk coverage cannot be assessed",
        "notApplicable": "Not an Azure VM backup"
      },
      "reason": {
        "vmUnavailable": "The associated VM is missing from this asset snapshot.",
        "inventoryUnavailable": "The disk inventory is incomplete or cannot be matched reliably.",
        "selectionUnavailable": "The backup selection could not be determined."
      }
    },
    "Licenses": {
      "Conditions": {
        "Button": "Conditions",
        "Examples": {
          "Alignment": {
            "Monthly": "With monthly payment, in this example a first period shorter than one month is calculated: from June 15 until July 1. After that, normal monthly billing continues until the license aligns with October 1.",
            "Result": "From the selected renew date, the new license follows the same billing period as the existing license.",
            "Situation": "You create a new license on June 15 and align the billing period with an existing license with renew date October 1.",
            "Title": "Align billing period",
            "Yearly": "With yearly payment, the period until the selected renew date is calculated and invoiced in one go."
          },
          "Assignments": {
            "Calculation": "The user with the end date no longer counts from September 1. The user with the start date does count from September 1.",
            "Result": "The number of active assigned users remains 5 and fits within the available number of licenses.",
            "Situation": "You have 5 licenses and 5 active assigned users. One user gets end date September 1 and a new user gets start date September 1.",
            "Title": "Change users with start and end date"
          },
          "Decrease": {
            "Calculation": "Set an end date of October 1 or earlier for at least 3 users, or make sure users with a future start date only become active when this fits within the new amount.",
            "Result": "On October 1 there are at most 7 active assigned users and the scheduled decrease can be processed.",
            "Situation": "You have 10 licenses with renew date October 1 and want to decrease to 7 licenses from that date.",
            "Title": "Decrease amount on renew date"
          },
          "Increase": {
            "Calculation": "The 3 extra licenses are calculated from June 15 until the next renew date. After that, the new total continues.",
            "Result": "You can assign extra users immediately, as long as there are at most 8 active assigned users.",
            "Situation": "You have 5 licenses with renew date October 1. On June 15, you increase the amount to 8 licenses.",
            "Title": "Increase amount immediately"
          },
          "Intro": "These examples show how amounts, users and billing periods are calculated in common situations.",
          "Stop": {
            "Calculation": "Set end date October 1 for all assigned users and set the scheduled amount to 0.",
            "Result": "From October 1 there are no active assigned users anymore and the license can be ended.",
            "Situation": "You want to stop a license with renew date October 1.",
            "Title": "End on renew date"
          }
        },
        "Intro": "These are the most important conditions for creating, changing and ending your licenses.",
        "Sections": {
          "Alignment": {
            "SalesOrderGap": "When aligning with a future renew date, the first period is calculated automatically and invoiced accordingly. This period may differ from the following periods.",
            "SameCustomer": "Aligning the billing period is only possible with another license in your current customer environment with the same period and payment method.",
            "StartBeforeRenew": "The start date of the new license must be before or on the renew date of the selected license.",
            "Title": "Align billing period with another license"
          },
          "Changes": {
            "CustomerDecrease": "Decreasing the number of licenses is only possible on the renew date through a scheduled change.",
            "DirectIncrease": "The number of licenses can be increased immediately. The period until the next renew date is calculated automatically and invoiced accordingly.",
            "PendingCapacity": "A scheduled change can only be saved when enough licenses are available on the renew date to apply the change.",
            "PendingChanges": "Changes to amount, license and payment method can be scheduled for the renew date.",
            "Title": "Amounts and changes"
          },
          "General": {
            "CreateAmount": "When creating a new license, the minimum purchase is one.",
            "Customer": "Licenses are only valid per user within the same customer.",
            "RenewDate": "The renew date is determined automatically and cannot be selected manually.",
            "StartDate": "Providing a start date is required and cannot be in the past when creating a license.",
            "Title": "General"
          },
          "Processing": {
            "Automatic": "Term and billing are linked to the license automatically.",
            "RenewDate": "Changes scheduled for the renew date are processed automatically once that date is reached.",
            "Title": "Processing"
          },
          "Removal": {
            "AmountZero": "A license can only be removed when the license amount is set to 0.",
            "CancelContract": "When removing a license, the license and the related agreement are ended.",
            "RenewAmountZero": "To end on the renew date, set the users' end date to the renew date and set the scheduled amount to 0.",
            "Title": "Ending and removing"
          },
          "Users": {
            "ActiveCapacity": "There can never be more active assigned users than the available number of licenses.",
            "EndDate": "An assignment with an end date no longer counts as an active assigned user from that date.",
            "JobCleanup": "Start and end dates and the related product access are processed automatically once the configured date is reached.",
            "StartDate": "An assignment with a future start date counts as an active assigned user from that date.",
            "Title": "Users",
            "UniqueUser": "Within the same customer, a user can only be assigned to the same license once."
          }
        },
        "Tabs": {
          "Conditions": "Conditions",
          "Examples": "Calculation examples"
        },
        "Title": "License management conditions"
      }
    },
    "Sharingcenter-calendars": {
      "Delete": "delete"
    },
    "Sharingcenter-profiles": {
      "Delete": "delete"
    },
    "SharingCenterMeetingStatistics": {
      "Title": "Meeting management",
      "Subtitle": "Browse meeting histories, inspect breakout activity, and follow who was in the room over time.",
      "StatusAll": "All",
      "StatusActive": "Active",
      "StatusEnded": "Ended",
      "Status": "Status",
      "Appointment": "Appointment",
      "Meeting": "Meeting",
      "StartedAt": "Started",
      "Duration": "Duration",
      "UpdatedAt": "Updated at",
      "Meetings": "Meetings",
      "MeetingDetails": "Meeting details",
      "BackToOverview": "Back to statistics",
      "LoadError": "The meeting log could not be loaded.",
      "NoMeetingFound": "No meeting log was found for this appointment.",
      "OpenDetail": "Open detail",
      "Active": "Active",
      "Ended": "Ended",
      "Participant": "Participant",
      "Participants": "Participants",
      "ParticipantNoLongerInMeeting": "No longer present in this meeting",
      "Sessions": "Sessions",
      "MeetingSessionsSection": "Meeting sessions",
      "MeetingParticipantsSection": "Meeting participants",
      "Breakout": "Breakout",
      "MainRoom": "Main room",
      "BreakoutRoom": "Breakout room",
      "BreakoutRooms": "Breakout rooms",
      "ParticipantTimelineTitle": "Meeting presence over time",
      "ConcurrentParticipantsTitle": "Participants in the meeting over time",
      "EventTreeTitle": "Meeting event timeline",
      "EventTreeSubtitle": "Room sessions, breakout branches, and participant movement over time.",
      "NoEventTreeData": "No room event timeline data is available yet.",
      "MeetingStarted": "Meeting started",
      "MeetingEnded": "Meeting ended",
      "BreakoutOpened": "Breakout opened",
      "BreakoutClosed": "Breakout closed",
      "ParticipantJoined": "Participant joined",
      "ParticipantLeft": "Participant left",
      "SessionHierarchyTitle": "Main sessions and breakout branches in the meeting",
      "NoTimelineData": "No participant timeline data is available yet.",
      "TimelineStart": "Start",
      "TimelineEnd": "End",
      "CurrentlyActive": "Currently active",
      "uniqueParticipants": "Unique participants",
      "participantSessions": "Participant sessions",
      "mainSessions": "Main sessions",
      "breakoutRooms": "Breakout rooms",
      "breakoutSessions": "Breakout sessions",
      "PeakConcurrent": "Peak concurrent",
      "peakConcurrent": "Highest concurrent participants",
      "PeakReachedAt": "Reached at {time}",
      "peakConcurrentMeetings": "Highest concurrent meetings",
      "duration": "Duration",
      "meetings": "Total number of meetings",
      "active": "Active meetings",
      "ended": "Ended meetings",
      "totalMeetingSessions": "Total meeting sessions",
      "totalParticipantSessions": "Total participant sessions",
      "totalParticipantSessionDuration": "Total participant session duration",
      "averageParticipants": "Average participants",
      "totalParticipants": "Total participants",
      "totalMeetingDuration": "Total meeting duration",
      "averageMeetingDuration": "Average meeting duration",
      "totalMeetingSessionDuration": "Total meeting session duration",
      "longestMeetingDuration": "Longest meeting duration",
      "DurationSection": "Meeting duration",
      "MeetingsPerDayTitle": "Meetings per day",
      "DurationsPerDayTitle": "Meeting duration per day",
      "ParticipantsPerDay": "Participants per day",
      "MeetingDurationPerDay": "Meeting duration per day",
      "ParticipantSessionDurationPerDay": "Participant session duration per day",
      "NoDailyChartData": "No data is available in the selected period.",
      "NoMeetingsPerDayData": "No meetings were active in the selected period.",
      "DailyStatisticsSection": "Daily meeting statistics",
      "MeetingListSection": "Meeting overview",
      "RecordingsOverviewTitle": "Recordings",
      "RecordingsOverviewDescription": "View recording files, transcripts, and minutes per meeting.",
      "NoMeetingRecordingsFound": "No meetings were found.",
      "OpenRecordingFiles": "Open recording files",
      "RecordingFilesTitle": "Recordings",
      "RecordingFilesDescription": "Transcripts are processed after the recording stops and may take a while to become available.",
      "RecordingFilesTab": "Files",
      "RecordingTranscriptTab": "Transcript",
      "MeetingMinutesTab": "Minutes",
      "CreateTranscription": "Create transcription",
      "CreateTranscriptionTitle": "Create transcription",
      "TranscriptionSession": "Session",
      "TranscriptionRecording": "Recording",
      "TranscriptionNoSessionAvailable": "No session is available to create a transcription for.",
      "TranscriptionNoRecordingAvailable": "No recording is available to create a transcription for.",
      "TranscriptionAlreadyAvailable": "A transcription is already available for this recording.",
      "TranscriptionCreateAccepted": "The transcription job has been accepted. This page will refresh until it is ready.",
      "TranscriptionCreateInProgress": "The transcription is being created. This can take a while.",
      "TranscriptionCreateSuccess": "The transcription has been created.",
      "TranscriptionCreateFailed": "The transcription job failed.",
      "TranscriptionCreateError": "The transcription could not be created.",
      "CreateMeetingMinutes": "Create minutes",
      "CreateMeetingMinutesTitle": "Create minutes",
      "MeetingMinutesSession": "Session",
      "MeetingMinutesRecording": "Recording",
      "MeetingMinutesLanguage": "Language",
      "MeetingMinutesLanguageDutch": "Dutch",
      "MeetingMinutesLanguageEnglish": "English",
      "MeetingMinutesLanguageGerman": "German",
      "MeetingMinutesLanguageSpanish": "Spanish",
      "MeetingMinutesLanguageFrench": "French",
      "MeetingMinutesPrompt": "Minutes type",
      "MeetingMinutesPromptRequired": "Select a minutes type.",
      "MeetingMinutesPromptCustom": "Custom",
      "MeetingMinutesPromptCustomDescription": "Enter a prompt manually",
      "MeetingMinutesCustomPrompt": "Custom prompt",
      "MeetingMinutesCustomPromptRequired": "Enter a custom prompt.",
      "NoTranscriptionSourceRecordings": "No recording files are available yet for which a transcription can be created.",
      "NoMinutesSourceTranscriptions": "No transcriptions are available yet for which minutes can be created.",
      "NoMeetingMinutes": "No minutes are available yet.",
      "NoMeetingMinutesContent": "The minutes are not readable yet.",
      "MeetingMinutesCreateNotAvailable": "Creating minutes is not available yet.",
      "MeetingMinutesCreateSuccess": "The minutes have been queued.",
      "MeetingMinutesCreateInProgress": "The minutes are being created. This can take a while.",
      "MeetingMinutesCreateError": "The minutes could not be created.",
      "MeetingMinutesLoadError": "The minutes could not be loaded.",
      "MeetingMinutesNoSessionAvailable": "No session is available to create minutes for.",
      "MeetingMinutesNoRecordingAvailable": "No recording is available to create minutes for.",
      "MeetingMinutesNoTranscriptAvailable": "No transcript is available yet to create minutes from.",
      "DownloadMeetingMinutes": "Download minutes",
      "DownloadMeetingMinutesAsWord": "Download as Word",
      "DownloadMeetingMinutesAsMarkdown": "Download as MD",
      "DeleteMeetingMinutes": "Delete minutes",
      "DeleteMeetingMinutesConfirm": "Are you sure you want to delete these minutes?",
      "MeetingMinutesDeleteSuccess": "The minutes have been deleted.",
      "MeetingMinutesDeleteError": "The minutes could not be deleted.",
      "DeleteRecordingTranscript": "Delete transcript",
      "DeleteRecordingTranscriptConfirm": "Are you sure you want to delete this transcript?",
      "RecordingTranscriptDeleteSuccess": "The transcript has been deleted.",
      "RecordingTranscriptDeleteError": "The transcript could not be deleted.",
      "DeleteRecordingFile": "Delete recording file",
      "DeleteRecordingFileConfirm": "Are you sure you want to delete this recording file?",
      "RecordingFileDeleteSuccess": "The recording file has been deleted.",
      "RecordingFileDeleteError": "The recording file could not be deleted.",
      "DeleteAllRecordingFiles": "Delete all",
      "DeleteAllRecordingFilesConfirm": "Are you sure you want to delete all files for this recording?",
      "RecordingFilesDeleteSuccess": "All files for this recording have been deleted.",
      "RecordingFilesDeletePartialError": "Not all files for this recording could be deleted.",
      "RecordingFilesDeleteError": "The files for this recording could not be deleted.",
      "Errors": {
        "ErrorCode": {
          "AI_MINUTES_OPENAI_CONNECTION_ERROR": "Could not connect to OpenAI. Please try again later.",
          "AI_MINUTES_OPENAI_AUTHENTICATION_ERROR": "OpenAI authentication failed. Check the AI agent API key, project, and organization.",
          "AI_MINUTES_OPENAI_INSUFFICIENT_QUOTA": "The OpenAI credits or configured limit have been reached. Check the AI agent billing and limits.",
          "AI_MINUTES_OPENAI_INVALID_API_KEY": "The OpenAI API key is incorrect. Check the API key in the AI agent settings.",
          "AI_MINUTES_OPENAI_PERMISSION_DENIED": "The OpenAI API key does not have access to this model, project, or organization.",
          "AI_MINUTES_OPENAI_RATE_LIMIT": "OpenAI is handling too many requests right now. Please try again shortly.",
          "AI_MINUTES_OPENAI_REQUEST_ERROR": "OpenAI could not process the minutes request.",
          "AI_MINUTES_OPENAI_SERVER_ERROR": "OpenAI is temporarily unavailable. Please try again later."
        }
      },
      "RecordingFilesLoadError": "The recording files could not be loaded.",
      "RecordingTranscriptLoadError": "The transcript could not be loaded.",
      "NoRecordingFiles": "No recording files are available yet.",
      "NoRecordingTranscriptContent": "No transcript text is available.",
      "DownloadRecordingFile": "Download file",
      "RecordingFileDownloadError": "The file could not be downloaded.",
      "RecordingSession": "Recording",
      "UnknownRecording": "Unknown recording",
      "RecordingFileTypeArtifact": "Unknown file",
      "RecordingFileTypeMeetingMinutes": "Minutes",
      "RecordingFileTypeMixedAudio": "Mixed audio",
      "RecordingFileTypeVideo": "Video recording",
      "RecordingFileTypeSeparateAudio": "Raw multitrack audio",
      "RecordingFileTypeSpeakerAudio": "Audio per speaker",
      "RecordingFileTypeSpeakerMap": "Speaker mapping",
      "RecordingFileTypeSpeakerTranscriptJson": "Transcript per speaker (JSON)",
      "RecordingFileTypeStreamMap": "Stream metadata",
      "RecordingFileTypeTranscript": "Transcript",
      "RecordingFileTypeTranscriptJson": "Transcript (JSON)",
      "FromDate": "Start date",
      "UntilDate": "End date"
    },
    "SmsStatistics": {
      "LoadError": "The SMS log could not be loaded.",
      "StatusSent": "Sent",
      "StatusFailed": "Failed",
      "OverviewSection": "SMS overview",
      "DeliverySection": "Delivery",
      "RecipientsSection": "Recipients",
      "TypesSection": "SMS types",
      "totalSms": "Total SMS messages",
      "sentSms": "Sent SMS messages",
      "failedSms": "Failed SMS messages",
      "sendSuccessRate": "Send success rate",
      "deliveredSms": "Delivered SMS messages",
      "undeliveredSms": "Undelivered SMS messages",
      "deliveryRate": "Delivery rate",
      "totalRecipients": "Total recipients",
      "uniqueRecipients": "Unique recipients",
      "averageRecipientsPerSms": "Average recipients per SMS",
      "typeAuthentication": "Authentication",
      "typeSharingcenter": "OMNI Sessions",
      "typeOther": "Other",
      "DailyStatisticsSection": "Daily SMS statistics",
      "SmsPerDayTitle": "SMS messages per day",
      "SmsTypesPerDayTitle": "SMS types per day",
      "TotalSmsPerDay": "Total per day",
      "SentSmsPerDay": "Sent per day",
      "FailedSmsPerDay": "Failed per day",
      "NoDailyChartData": "No data is available in the selected period.",
      "NoSmsTypesChartData": "No SMS type trend data is available in the selected period.",
      "SmsListSection": "SMS overview",
      "FromDate": "Start date",
      "UntilDate": "End date",
      "CreatedAt": "Created at",
      "Customer": "Customer",
      "Recipients": "Recipients",
      "SmsSent": "Sent",
      "SmsDelivered": "Delivered"
    },
    "EmailStatistics": {
      "LoadError": "The email log could not be loaded.",
      "StatusSent": "Sent",
      "StatusFailed": "Failed",
      "OverviewSection": "Email overview",
      "RecipientsSection": "Recipients",
      "TypesSection": "Email types",
      "totalEmails": "Total emails",
      "sentEmails": "Sent emails",
      "failedEmails": "Failed emails",
      "sendSuccessRate": "Send success rate",
      "totalRecipients": "Total recipients",
      "uniqueRecipients": "Unique recipients",
      "averageRecipientsPerEmail": "Average recipients per email",
      "typeTriggers": "Triggers",
      "typeAuthentication": "Authentication",
      "typeSharingcenter": "OMNI Sessions",
      "typeInvoices": "Invoices",
      "typeSubscriptions": "Subscriptions",
      "typeDomains": "Domains",
      "typeWebhosting": "Webhosting",
      "typeQueue": "Email queue",
      "typeOther": "Other",
      "DailyStatisticsSection": "Daily email statistics",
      "EmailsPerDayTitle": "Emails per day",
      "EmailTypesPerDayTitle": "Email types per day",
      "TotalEmailsPerDay": "Total per day",
      "SentEmailsPerDay": "Sent per day",
      "FailedEmailsPerDay": "Failed per day",
      "NoDailyChartData": "No data is available in the selected period.",
      "NoEmailTypesChartData": "No email type trend data is available in the selected period.",
      "EmailListSection": "Email overview",
      "FromDate": "Start date",
      "UntilDate": "End date",
      "CreatedAt": "Created at",
      "Customer": "Customer",
      "Recipients": "Recipients",
      "MailSent": "Sent",
      "MailSentAt": "Sent at"
    },
    "LicenseStatistics": {
      "LoadError": "The license statistics could not be loaded.",
      "OverviewSection": "License overview",
      "CapacitySection": "Capacity",
      "FinancialSection": "Revenue",
      "LicenseRevenueSection": "Licenses",
      "SlaRevenueSection": "SLAs",
      "PartnerProgramRevenueSection": "Partner programs",
      "LicenseRevenueSubject": "licenses",
      "SlaRevenueSubject": "SLAs",
      "PartnerProgramRevenueSubject": "partner programs",
      "RenewalSection": "Renewals and changes",
      "ScopeSection": "Scope",
      "TrendSection": "Trends",
      "ProductBreakdownSection": "By product",
      "CustomerBreakdownSection": "By customer",
      "LicenseListSection": "Licenses",
      "activeLicenses": "Active licenses",
      "totalSeats": "Purchased seats",
      "assignedSeats": "Assigned seats",
      "availableSeats": "Available seats",
      "occupancyRate": "Occupancy rate",
      "renewalsNext30Days": "Renewals in 30 days",
      "fullLicenses": "Fully used",
      "unusedLicenses": "Unused",
      "underusedLicenses": "Underused",
      "periodRevenue": "Revenue in period",
      "currentMrr": "Current MRR",
      "currentArr": "Current ARR",
      "projectedMrr": "Projected MRR at snapshot",
      "futureProjectedMrr": "Projected MRR incl. future changes",
      "projectedMrrDelta": "Projected MRR change at snapshot",
      "projectedArr": "Projected ARR at snapshot",
      "futureProjectedArr": "Projected ARR incl. future changes",
      "projectedArrDelta": "Projected ARR change at snapshot",
      "pendingChanges": "Scheduled changes",
      "pendingSeatDelta": "Scheduled seat change",
      "pendingProductChanges": "Scheduled product changes",
      "endingOnRenewal": "Ends on renewal",
      "activeProducts": "Products in use",
      "activeCustomers": "Customers with licenses",
      "periodRevenueCaption": "Prorated license revenue over the selected period. If a subscription starts or ends halfway through a month, only active days are counted.",
      "currentMrrCaption": "Monthly Recurring Revenue: monthly recurring license revenue as a run rate. Yearly amounts are normalized to a month amount; partial months are not prorated.",
      "currentArrCaption": "Annual Recurring Revenue: yearly recurring license revenue as a run rate. This is current MRR multiplied by 12.",
      "projectedMrrCaption": "Projected MRR based on licenses that are in scope on the snapshot date. Future purchases with a later start date are not included.",
      "futureProjectedMrrCaption": "The same projected MRR, but including known future changes such as licenses with a start date after the snapshot date.",
      "projectedMrrDeltaCaption": "Difference between projected MRR at the snapshot date and current MRR.",
      "projectedArrCaption": "Projected ARR after scheduled license changes are applied on the next renewal. This is projected MRR multiplied by 12.",
      "futureProjectedArrCaption": "The same projected ARR, but including known future changes such as licenses with a start date after the snapshot date.",
      "projectedArrDeltaCaption": "Difference between projected ARR at the snapshot date and current ARR.",
      "RevenueBreakdownPeriodRevenueCaption": "Prorated revenue for {subject} over the selected period. If a subscription starts or ends halfway through a month, only active days are counted.",
      "RevenueBreakdownCurrentMrrCaption": "Monthly Recurring Revenue for {subject}: monthly recurring revenue as a run rate. Yearly amounts are normalized to a month amount; partial months are not prorated.",
      "RevenueBreakdownCurrentArrCaption": "Annual Recurring Revenue for {subject}: yearly recurring revenue as a run rate. This is current MRR multiplied by 12.",
      "RevenueBreakdownProjectedMrrCaption": "Projected MRR for {subject} based on licenses that are in scope on the snapshot date. Future purchases with a later start date are not included.",
      "RevenueBreakdownFutureProjectedMrrCaption": "The same projected MRR for {subject}, but including known future changes such as licenses with a start date after the snapshot date.",
      "RevenueBreakdownProjectedMrrDeltaCaption": "Difference between projected MRR at the snapshot date and current MRR for {subject}.",
      "RevenueBreakdownProjectedArrCaption": "Projected ARR for {subject} after scheduled license changes are applied on the next renewal. This is projected MRR multiplied by 12.",
      "RevenueBreakdownFutureProjectedArrCaption": "The same projected ARR for {subject}, but including known future changes such as licenses with a start date after the snapshot date.",
      "RevenueBreakdownProjectedArrDeltaCaption": "Difference between projected ARR at the snapshot date and current ARR for {subject}.",
      "pendingChangesCaption": "Licenses with scheduled changes for the next renewal.",
      "pendingSeatDeltaCaption": "Net seat change from scheduled license changes.",
      "pendingProductChangesCaption": "Scheduled changes where the license product changes.",
      "endingOnRenewalCaption": "Licenses that will go to 0 seats on the next renewal.",
      "FromDate": "Trend from",
      "UntilDate": "Snapshot date",
      "ForecastRange": "Forecast range",
      "ForecastMonthsOption": "{months} months",
      "DateRangeHelp": "The start date determines where the trend charts begin. The snapshot date determines the totals in the cards and is also the end of the trend period.",
      "PeriodRevenueTrendTitle": "Revenue per month",
      "RevenueTrendTitle": "MRR per month",
      "FutureRevenueForecastTitle": "Projected MRR development",
      "SeatTrendTitle": "Seats per month",
      "RenewalTrendTitle": "Renewals per month",
      "PeriodRevenuePerMonth": "Revenue",
      "CurrentMrrPerMonth": "Current MRR",
      "ProjectedMrrPerMonth": "Projected MRR",
      "ForecastMrr": "Projected MRR",
      "TotalSeatsPerMonth": "Purchased seats",
      "AssignedSeatsPerMonth": "Assigned seats",
      "AvailableSeatsPerMonth": "Available seats",
      "RenewalsPerMonth": "Renewals",
      "PendingChangesPerMonth": "Scheduled changes",
      "NoPeriodRevenueTrendData": "No revenue data is available in the selected period.",
      "NoRevenueTrendData": "No revenue trend data is available in the selected period.",
      "NoFutureRevenueForecastData": "No forecast data is available for the selected period.",
      "NoSeatTrendData": "No seat trend data is available in the selected period.",
      "NoRenewalTrendData": "No renewal trend data is available in the selected period.",
      "Name": "Name",
      "Customer": "Customer",
      "Product": "Product",
      "ActiveLicenses": "Active licenses",
      "TotalSeats": "Purchased seats",
      "AssignedSeats": "Assigned seats",
      "AvailableSeats": "Available",
      "OccupancyRate": "Occupancy rate",
      "CurrentMrr": "MRR",
      "RenewDate": "Renew date",
      "PendingChanges": "Scheduled changes",
      "Pending": "Scheduled",
      "User": "User",
      "Email": "Email",
      "StartDate": "Start date",
      "EndDate": "End date",
      "NoAssignedUsers": "No assigned users."
    },
    "AiQueueStatistics": {
      "PageTitle": "AI queue",
      "LoadError": "The AI queue could not be loaded.",
      "OverviewSection": "Queue overview",
      "TranscriptionSection": "Transcription statistics",
      "MinutesSection": "Minutes statistics",
      "StatusSection": "Queue status",
      "DailyStatisticsSection": "Daily statistics",
      "QueueListSection": "Tasks",
      "FilterLoadError": "The AI queue filters could not be loaded.",
      "totalItems": "Tasks",
      "activeItems": "Active jobs",
      "currentState": "Current state",
      "successRate": "Success rate",
      "queuedItems": "Queued",
      "processingItems": "Processing",
      "completedItems": "Completed",
      "failedItems": "Failed",
      "retryScheduledItems": "Scheduled retries",
      "TotalTasksPerDay": "Tasks per day",
      "CompletedTasksPerDay": "Completed per day",
      "FailedTasksPerDay": "Failed per day",
      "TranscriptionTasksPerDayTitle": "Transcription tasks per day",
      "MinutesTasksPerDayTitle": "Minutes tasks per day",
      "NoDailyChartData": "No queue chart data is available for this period.",
      "CreatedAt": "Created at",
      "UpdatedAt": "Updated at",
      "NextAttemptAt": "Next retry",
      "FromDate": "Start date",
      "UntilDate": "End date",
      "Status": "Status",
      "TaskType": "Task",
      "Provider": "Provider",
      "RecordingPath": "Recording",
      "Attempts": "Attempt",
      "DeleteQueueItemTitle": "Delete queue item",
      "DeleteQueueItemText": "Are you sure you want to delete queue item {0}?",
      "DeleteQueueItemSuccess": "Queue item deleted.",
      "DeleteQueueItemFail": "The queue item could not be deleted. {msg}",
      "QueueRetryNowTitle": "Queue retry now",
      "QueueRetryNowText": "Make scheduled retry {item} eligible for the queue now?",
      "QueueRetryNowSuccess": "Retry is eligible for the queue.",
      "QueueRetryNowFail": "The retry could not be queued now. {msg}",
      "State": {
        "active": "Active",
        "idle": "Idle"
      },
      "Statuses": {
        "queued": "Waiting",
        "processing": "Processing",
        "completed": "Completed",
        "failed": "Failed",
        "retryScheduled": "Scheduled"
      },
      "TaskTypes": {
        "transcription": "Transcription",
        "minutes": "Minutes"
      },
      "Providers": {
        "whisper": "Whisper",
        "chatgpt": "ChatGPT",
        "ollama": "Ollama"
      }
    },
    "FeedbackStatistics": {
      "LoadError": "The feedback answers could not be loaded.",
      "OverviewSection": "Feedback overview",
      "totalFeedbackAnswers": "Submitted feedback forms",
      "uniqueParticipants": "Respondents",
      "totalAnswers": "Total answers",
      "averageScore": "Average score",
      "AverageScoreCaption": "Based on {count} scored answers",
      "Answers": "Answers",
      "FeedbackQuestion": "Feedback question",
      "GroupByLabel": "Group by",
      "GroupByMeeting": "By meeting",
      "GroupByQuestion": "By feedback question",
      "MeetingFeedbackSection": "Feedback answers",
      "Question": "Question",
      "Value": "Value",
      "AnswerListSection": "Feedback answer overview",
      "FromDate": "Start date",
      "UntilDate": "End date"
    },
    "Globals": {
      "Account-invitations": "Account invitations",
      "Apply": "Apply",
      "Asset-management": "Monitoring & assets",
      "Assets": {
        "Asset type": "Asset type",
        "Assets": "Assets",
        "Calculations": "Calculations",
        "Hetzner": {
          "Hetzner": "Hetzner",
          "Public IPs": "Public IPs",
          "Storages": "Storages",
          "Virtual machines": "Virtual machines",
          "Virtual machines backups": "Virtual machine backups"
        },
        "Locked Vault Backups": {
          "Backups": "Backups",
          "Locked Vault Backups": "Locked Vault Backups"
        },
        "Microsoft Azure": {
          "Disks": "Disks",
          "Host Pools Session Hosts": "Host Pools Session Hosts",
          "Microsoft Azure": "Microsoft Azure",
          "Recovery Services Backup Policies": "Recovery Services Backup Policies",
          "Recovery Services Protected Items": "Recovery Services Protected Items",
          "Reservations": "Reservations",
          "Virtual Machines": "Virtual Machines"
        },
        "Microsoft Graph": {
          "Applications": "Applications",
          "Audit Logs Sign Ins": "Audit Logs Sign Ins",
          "Devices": "Devices",
          "Microsoft Graph": "Microsoft Graph",
          "Microsoft licenses": "Microsoft licenses",
          "Teams": "Teams",
          "Users": "Users and Shared mailboxes"
        },
        "Microsoft Security": {
          "Machines": "Machines",
          "Microsoft Security": "Microsoft Security",
          "Vulnerabilities": "Vulnerabilities",
          "Vulnerabilities By Machines and Software": "Vulnerabilities By Machines and Software"
        },
        "Overview": "Overview",
        "TransIP": {
          "Block storage backups": "Block storage backups",
          "Block storages": "Block storages",
          "TransIP": "TransIP",
          "Virtual machine backups": "Virtual machine backups",
          "Virtual machines": "Virtual machines"
        },
        "Veeam": {
          "Job sessions": "Job Sessions",
          "Jobs": "Jobs",
          "Veeam": "Veeam"
        },
        "Virtual machines": "Virtual machines"
      },
      "Attention": "Please note",
      "Audit-logs": "Audit logs",
      "Back": "Back",
      "Back to": "Back to @.lower:{to}",
      "Back to previous page": "Back to the previous page",
      "Cancel": "Cancel",
      "Change": "Change",
      "Changed": "@:{key} changed.",
      "Choose customer": "Choose @.lower:Customers.Customer",
      "Click to copy ID": "Click the icon to copy the ID.",
      "Clone item": "Clone @.lower:{item}",
      "Close": "Close",
      "Collapse menu": "Collapse menu",
      "Communication": "Communication",
      "Copy": "Copy",
      "Contacts": "Contacts",
      "Continue": "Continue",
      "Contracts": "Contracts",
      "Copy fail": "Failed to copy text to clipboard. {error}",
      "Copy success": "Text copied to clipboard.",
      "Countries": {
        "ABW": "Aruba",
        "AFG": "Afghanistan",
        "AGO": "Angola",
        "AIA": "Anguilla",
        "ALA": "Åland Islands",
        "ALB": "Albania",
        "AND": "Andorra",
        "ARE": "United Arab Emirates (the)",
        "ARG": "Argentina",
        "ARM": "Armenia",
        "ASM": "American Samoa",
        "ATA": "Antarctica",
        "ATF": "French Southern Territories (the)",
        "ATG": "Antigua and Barbuda",
        "AUS": "Australia",
        "AUT": "Austria",
        "AZE": "Azerbaijan",
        "BDI": "Burundi",
        "BEL": "Belgium",
        "BEN": "Benin",
        "BES": "Bonaire, Sint Eustatius and Saba",
        "BFA": "Burkina Faso",
        "BGD": "Bangladesh",
        "BGR": "Bulgaria",
        "BHR": "Bahrain",
        "BHS": "Bahamas (the)",
        "BIH": "Bosnia and Herzegovina",
        "BLM": "Saint Barthélemy",
        "BLR": "Belarus",
        "BLZ": "Belize",
        "BMU": "Bermuda",
        "BOL": "Bolivia (Plurinational State of)",
        "BRA": "Brazil",
        "BRB": "Barbados",
        "BRN": "Brunei Darussalam",
        "BTN": "Bhutan",
        "BVT": "Bouvet Island",
        "BWA": "Botswana",
        "CAF": "Central African Republic (the)",
        "CAN": "Canada",
        "CCK": "Cocos (Keeling) Islands (the)",
        "CHE": "Switzerland",
        "CHL": "Chile",
        "CHN": "China",
        "CIV": "Côte d'Ivoire",
        "CMR": "Cameroon",
        "COD": "Congo (the Democratic Republic of the)",
        "COG": "Congo (the)",
        "COK": "Cook Islands (the)",
        "COL": "Colombia",
        "COM": "Comoros (the)",
        "CPV": "Cabo Verde",
        "CRI": "Costa Rica",
        "CUB": "Cuba",
        "CUW": "Curaçao",
        "CXR": "Christmas Island",
        "CYM": "Cayman Islands (the)",
        "CYP": "Cyprus",
        "CZE": "Czechia",
        "DEU": "Germany",
        "DJI": "Djibouti",
        "DMA": "Dominica",
        "DNK": "Denmark",
        "DOM": "Dominican Republic (the)",
        "DZA": "Algeria",
        "ECU": "Ecuador",
        "EGY": "Egypt",
        "ERI": "Eritrea",
        "ESH": "Western Sahara",
        "ESP": "Spain",
        "EST": "Estonia",
        "ETH": "Ethiopia",
        "FIN": "Finland",
        "FJI": "Fiji",
        "FLK": "Falkland Islands (the) [Malvinas]",
        "FRA": "France",
        "FRO": "Faroe Islands (the)",
        "FSM": "Micronesia (Federated States of)",
        "GAB": "Gabon",
        "GBR": "United Kingdom of Great Britain and Northern Ireland (the)",
        "GEO": "Georgia",
        "GGY": "Guernsey",
        "GHA": "Ghana",
        "GIB": "Gibraltar",
        "GIN": "Guinea",
        "GLP": "Guadeloupe",
        "GMB": "Gambia (the)",
        "GNB": "Guinea-Bissau",
        "GNQ": "Equatorial Guinea",
        "GRC": "Greece",
        "GRD": "Grenada",
        "GRL": "Greenland",
        "GTM": "Guatemala",
        "GUF": "French Guiana",
        "GUM": "Guam",
        "GUY": "Guyana",
        "HKG": "Hong Kong",
        "HMD": "Heard Island and McDonald Islands",
        "HND": "Honduras",
        "HRV": "Croatia",
        "HTI": "Haiti",
        "HUN": "Hungary",
        "IDN": "Indonesia",
        "IMN": "Isle of Man",
        "IND": "India",
        "IOT": "British Indian Ocean Territory (the)",
        "IRL": "Ireland",
        "IRN": "Iran (Islamic Republic of)",
        "IRQ": "Iraq",
        "ISL": "Iceland",
        "ISR": "Israel",
        "ITA": "Italy",
        "JAM": "Jamaica",
        "JEY": "Jersey",
        "JOR": "Jordan",
        "JPN": "Japan",
        "KAZ": "Kazakhstan",
        "KEN": "Kenya",
        "KGZ": "Kyrgyzstan",
        "KHM": "Cambodia",
        "KIR": "Kiribati",
        "KNA": "Saint Kitts and Nevis",
        "KOR": "Korea (the Republic of)",
        "KWT": "Kuwait",
        "LAO": "Lao People's Democratic Republic (the)",
        "LBN": "Lebanon",
        "LBR": "Liberia",
        "LBY": "Libya",
        "LCA": "Saint Lucia",
        "LIE": "Liechtenstein",
        "LKA": "Sri Lanka",
        "LSO": "Lesotho",
        "LTU": "Lithuania",
        "LUX": "Luxembourg",
        "LVA": "Latvia",
        "MAC": "Macao",
        "MAF": "Saint Martin (French part)",
        "MAR": "Morocco",
        "MCO": "Monaco",
        "MDA": "Moldova (the Republic of)",
        "MDG": "Madagascar",
        "MDV": "Maldives",
        "MEX": "Mexico",
        "MHL": "Marshall Islands (the)",
        "MKD": "Republic of North Macedonia",
        "MLI": "Mali",
        "MLT": "Malta",
        "MMR": "Myanmar",
        "MNE": "Montenegro",
        "MNG": "Mongolia",
        "MNP": "Northern Mariana Islands (the)",
        "MOZ": "Mozambique",
        "MRT": "Mauritania",
        "MSR": "Montserrat",
        "MTQ": "Martinique",
        "MUS": "Mauritius",
        "MWI": "Malawi",
        "MYS": "Malaysia",
        "MYT": "Mayotte",
        "NAM": "Namibia",
        "NCL": "New Caledonia",
        "NER": "Niger (the)",
        "NFK": "Norfolk Island",
        "NGA": "Nigeria",
        "NIC": "Nicaragua",
        "NIU": "Niue",
        "NLD": "Netherlands (the)",
        "NOR": "Norway",
        "NPL": "Nepal",
        "NRU": "Nauru",
        "NZL": "New Zealand",
        "OMN": "Oman",
        "PAK": "Pakistan",
        "PAN": "Panama",
        "PCN": "Pitcairn",
        "PER": "Peru",
        "PHL": "Philippines (the)",
        "PLW": "Palau",
        "PNG": "Papua New Guinea",
        "POL": "Poland",
        "PRI": "Puerto Rico",
        "PRK": "Korea (the Democratic People's Republic of)",
        "PRT": "Portugal",
        "PRY": "Paraguay",
        "PSE": "Palestine, State of",
        "PYF": "French Polynesia",
        "QAT": "Qatar",
        "REU": "Réunion",
        "ROU": "Romania",
        "RUS": "Russian Federation (the)",
        "RWA": "Rwanda",
        "SAU": "Saudi Arabia",
        "SDN": "Sudan (the)",
        "SEN": "Senegal",
        "SGP": "Singapore",
        "SGS": "South Georgia and the South Sandwich Islands",
        "SHN": "Saint Helena, Ascension and Tristan da Cunha",
        "SJM": "Svalbard and Jan Mayen",
        "SLB": "Solomon Islands",
        "SLE": "Sierra Leone",
        "SLV": "El Salvador",
        "SMR": "San Marino",
        "SOM": "Somalia",
        "SPM": "Saint Pierre and Miquelon",
        "SRB": "Serbia",
        "SSD": "South Sudan",
        "STP": "Sao Tome and Principe",
        "SUR": "Suriname",
        "SVK": "Slovakia",
        "SVN": "Slovenia",
        "SWE": "Sweden",
        "SWZ": "Eswatini",
        "SXM": "Sint Maarten (Dutch part)",
        "SYC": "Seychelles",
        "SYR": "Syrian Arab Republic",
        "TCA": "Turks and Caicos Islands (the)",
        "TCD": "Chad",
        "TGO": "Togo",
        "THA": "Thailand",
        "TJK": "Tajikistan",
        "TKL": "Tokelau",
        "TKM": "Turkmenistan",
        "TLS": "Timor-Leste",
        "TON": "Tonga",
        "TTO": "Trinidad and Tobago",
        "TUN": "Tunisia",
        "TUR": "Turkey",
        "TUV": "Tuvalu",
        "TWN": "Taiwan",
        "TZA": "Tanzania, United Republic of",
        "UGA": "Uganda",
        "UKR": "Ukraine",
        "UMI": "United States Minor Outlying Islands (the)",
        "URY": "Uruguay",
        "USA": "United States of America (the)",
        "UZB": "Uzbekistan",
        "VAT": "Holy See (the)",
        "VCT": "Saint Vincent and the Grenadines",
        "VEN": "Venezuela (Bolivarian Republic of)",
        "VGB": "Virgin Islands (British)",
        "VIR": "Virgin Islands (U.S.)",
        "VNM": "Vietnam",
        "VUT": "Vanuatu",
        "WLF": "Wallis and Futuna",
        "WSM": "Samoa",
        "YEM": "Yemen",
        "ZAF": "South Africa",
        "ZMB": "Zambia",
        "ZWE": "Zimbabwe"
      },
      "Created": "Created",
      "Current": "Current",
      "Current time": "Current time",
      "Customer number": "Customer number:",
      "Customer-offers": "Offers",
      "Customer-profile": "Customer data",
      "Customer-users": "Customer users",
      "Customers": "Customers",
      "Data": "Data",
      "Date": "Date",
      "Datepicker": {
        "days": "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday",
        "daysShort": "Sun_Mon_Tue_Wed_Thu_Fri_Sat",
        "months": "January_February_March_April_May_June_July_August_September_October_November_December",
        "monthsShort": "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
        "pluralDay": "Day"
      },
      "Day": "Day",
      "Days": "Day | Days",
      "Default": "Default",
      "Delete": "Delete",
      "Delete item": "Delete @.lower:{item}",
      "Customer-phone-numbers": "Phone numbers",
      "Customer-setting-configurations": "Customer settings",
      "Sharingcenter-profile-setting-configurations": "Profile settings",
      "Licenses": "Licenses",
      "Project-task-time-tracking": "Time registrations",
      "Project-task-types": "Project task types",
      "Project-tasks": "Project tasks",
      "Delete dependencies": "Blocking dependencies",
      "Delete item archive": "Archive {0}",
      "Delete item force delete": "Force delete {0} and all underlying data",
      "Description": "Description",
      "Deselect All": "Deselect all",
      "Direct-debit": "SEPA batches",
      "Domain-details": "Details",
      "Domain-ns-groups": "NS groups",
      "Domains": "Domains | Domain",
      "Done": "Done",
      "Download": "Download | Download {type}",
      "Download fail": "File download failed.",
      "Download success": "File download successful.",
      "Edit": "Edit",
      "Edit data": "Edit data",
      "Edit item": "Edit @.lower:{item}",
      "Edit item fail": "Editing {item} failed. {msg}",
      "Edit item success": "Editing {item} success.",
      "Email address changed": "Email address changed",
      "Email-management": "Email management",
      "Employee login": "Employee login",
      "Empty": "N/A",
      "Error": "Error",
      "Error calling phone number": "Error calling phone number",
      "Errors": {
        "404": "The requested page was not found.",
        "Data error": "There was an error loading the data.",
        "Delete item has dependencies": "Item has dependencies. Please delete the dependencies first.",
        "Delete item has dependencies or archive": "Item has dependencies. Please delete the dependencies first or archive the item.",
        "Delete item has dependencies or force delete": "Item has dependencies. Please delete the dependencies first or force deletion of dependencies.",
        "Email in use": "Given email address is already in use. Login using the old email address and try changing it to an unused email address.",
        "Error loading data": "The list of {item} could not be loaded due to an error.",
        "ErrorCode": {
          "default": "Validation for the field '@:{key}' failed. {msg}",
          "EXPORT_FAILED": "Failed to generate an export file, please try again later.",
          "SUBSCRIPTION_ALREADY_ATTACHED": "Given subscriptions is already attached to another service.",
          "SUBSCRIPTION_ALREADY_ATTACHED_DIFFERENT_SERVICE_ID": "Given subscriptions is already attached to a service with another ID.",
          "SUBSCRIPTION_ALREADY_ATTACHED_DIFFERENT_SERVICE_TYPE": "Given subscriptions is already attached to another service type.",
          "SUBSCRIPTION_DIFFERENT_PRODUCT_TYPE": "Given subscription has a different productType dan the service's productType.",
          "SUBSCRIPTION_NOT_FOUND": "Given subscription not found.",
          "UNIQUE_FIELD_ERROR_NOT_UNIQUE": "The field '@.lower:{key}' is not unique."
        },
        "ColorHex": {
          "INVALID_COLOR": "The provided color code is not valid."
        },
        "FileUploader": {
          "Accept": "This file type is not allowed",
          "Max-file-size": "This file exceeds the maximum allowed size ({maxMB})",
          "Max-total-size": "This file exceeds the maximum allowed size ({maxMB})"
        },
        "Formats": {
          "BIC": "The provided BIC code is not valid.",
          "default": "@:{key} contains an invalid value.",
          "domain": "@:{key} is not a valid domain.",
          "email": "The provided email address is not valid.",
          "exclusiveMaximum": "The field must have a value less than {exclusiveMaximum}.",
          "exclusiveMinimum": "The field must have a value greater than {exclusiveMinimum}.",
          "IBAN": "The provided IBAN number is not valid.",
          "ipv4": "@:{key} does not contain a valid IPv4 address.",
          "ipv6": "@:{key} does not contain a valid IPv6 address.",
          "maximum": "@:{key} must have a maximum value of: {maximum}.",
          "maxItems": "Select at most {maxItems} item(s).",
          "maxLength": "@:{key} can contain a maximum of {maxlength} character(s).",
          "minimum": "@:{key} must have a minimum value of: {minimum}.",
          "minItems": "Select at least {minItems} item(s).",
          "minLength": "@:{key} must have at least {minimum} character(s).",
          "notInFuture": "@:{key} must not be in the future.",
          "notInPast": "@:{key} must not be in the past.",
          "phone": "The provided phone number is not valid.",
          "uri": "@:{key} does not contain a valid URI.",
          "validateCocNumber": "@:{key} has a required length of {requiredLength}.",
          "validateTaxNumber": "@:{key} is invalid for the selected country."
        },
        "Item fail": "There has been an error processing your request, please try again. {msg}",
        "No options available": "No options available",
        "Patterns": {
          "E164PhoneNumber": "Enter a valid international phone number, for example +31612345678.",
          "UppercaseAlphanumeric": "@:{key} should only contains capitals and numbers.",
          "default": "@:{key} does not match the required pattern: '{pattern}'."
        },
        "Required": {
          "betweenFieldValues": "@:{key} should be between @:{requiredKeyFrom} and @:{requiredKeyTo}.",
          "default": "@:{key} is a required field.",
          "greaterThan": "@:{key} should be greater than @:{requiredKey}.",
          "greaterThanOrEqual": "@:{key} should be greater than or equal to @:{requiredKey}.",
          "lessThan": "@:{key} should be less than @:{requiredKey}.",
          "lessThanOrEqual": "@:{key} should be less than or equal to @:{requiredKey}.",
          "requiredIf": "@:{key} is a required field.",
          "requiredIfNot": "@:{key} is a required field.",
          "requiredIfOneOf": "@:{key} is a required field.",
          "requiredIfOneOfNot": "@:{key} is a required field."
        },
        "Type": {
          "default": "@:{key} is a required field."
        },
        "Unauthorized": "Unauthorized",
        "User not found": "The user {m} could not be retrieved from the server.",
        "Verification token has expired": "The verification token has expired. Please request a new one."
      },
      "Expand menu": "Expand menu",
      "Export confirm": "Confirm export",
      "Export confirm text": "Are you sure you want to proceed with the export? The data will be exported based on the current filters.",
      "Failed": "Failed",
      "Feedback-answers": "Feedback answers",
      "Feedback-questions": "Feedback questions",
      "Filters": "Filters | Set filters",
      "Financial": "Financial",
      "Finish": "Finish",
      "Fullscreen": "Fullscreen | Leave fullscreen",
      "Go to overview": "Show overview",
      "Happy birthday": "Today is {name}'s birthday!",
      "History": "History",
      "Home": "Go home",
      "Hours": "Hour | Hours",
      "Hrs": "Hr | Hrs",
      "Https required": "HTTPS required",
      "Information": "Information",
      "Invalid": "@:{key} is invalid",
      "Invalid date": "Invalid date: {format}.",
      "Invalid time": "Invalid time: {format}.",
      "Invoices": "Invoices",
      "Item action": "{action} {type}",
      "Item fail": "Action: {action}. <br />Service: {type}  <br />Target: {item}.  <br />Result: FAIL",
      "Item success": "Action: {action}. <br />Service: {type}  <br />Target: {item}  <br />Result: SUCCESS",
      "Languages": {
        "Dutch": "Dutch",
        "English": "English"
      },
      "Last 2 weeks": "Last 2 weeks",
      "Last 3 days": "Last 3 days",
      "Last 30 days": "Last 30 days",
      "Last 90 days": "Last 90 days",
      "Last hour": "Last hour",
      "Last update": "Last update",
      "Last week": "Last week",
      "Last x hours": "Last {amount} hours",
      "Legend": "Legend",
      "Limit exceeded": "Limit exceeded for '{key}'",
      "Loading": "Loading, one moment please...",
      "Logout": "Logout",
      "Main": "Main page",
      "Management": "Management",
      "Mandatory": "@:{key} is a required field.",
      "Meeting-statistics": "Meeting statistics",
      "Meeting-statistics-detail": "Meeting statistics - Meeting details",
      "Max end date": "Max date: {maxEndDate}.",
      "Max end dateTime": "Max date/time: {maxEndDate}.",
      "Max end time": "Max time: {maxEndDate}.",
      "Maximize": "Maximize",
      "Min start date": "Min date: {minStartDate}.",
      "Min start dateTime": "Min date/time: {minStartDate}.",
      "Min start time": "Min time: {minStartDate}.",
      "Mins": "Min | Mins",
      "Minutes": "Minute | Minutes",
      "Seconds": "Second | Seconds",
      "Month": "Month",
      "Months": "Months",
      "My profile": "My profile",
      "Never": "Never",
      "New item": "New @.lower:{item}",
      "New label": "New label",
      "New-domain": "New domain",
      "New-webhosting-account": "New account",
      "Next": "Next",
      "No": "No",
      "No data": "No results found.",
      "No items found": "No {item} found.",
      "No results": "No results found with the applied filters.",
      "No suggestions": "No suggestions",
      "None": "None",
      "Not allowed": "You're not authorized to access the requested page. Please contact your administrator should you need access to the page.",
      "Not applicable": "n/a",
      "Not synchronized": "not synchronized | Not synchronized",
      "Of": "of",
      "Off": "Uit",
      "On": "Aan",
      "Omni-sessions": "OMNI Sessions",
      "Options": "options",
      "Page": "page",
      "Please note": "Please note",
      "Please wait": "Please wait...",
      "Rate limit exceeded": "Too many requests. Try again later.",
      "Rate limit retry": "Wait {time}",
      "Preview file item": "Preview",
      "Product-groups": "Product groups",
      "Productmanagement": "Productmanagement",
      "Products": "Products",
      "Profile": "User profile",
      "ProjectManagement": "Project management",
      "Projects": "Projects",
      "PublicNameserver": "OMNI Networks DNS",
      "Refresh item": "Refresh {item}",
      "Refresh list": "Refresh list",
      "Reload after current action": "Reload after finishing your current action.",
      "Reload app": "Reload",
      "Later": "Later",
      "PwaUpdateAvailable": "Update available",
      "PwaUpdateMessage": "Save any changes before updating the app. After updating, you will return to this page.",
      "PwaUpdateNow": "Update now",
      "PwaUpdateRequired": "Update required",
      "PwaUnsupported": "This version of the app is no longer supported. You can no longer continue working or save changes. Update the app to continue. After updating, you will return to your destination.",
      "PwaSaveFirst": "Save any changes before updating.",
      "PwaLoadFailed": "This page could not be loaded. Try updating the app. Afterwards, you will return to your destination.",
      "PwaUpdateFailed": "The update failed. Check your connection and try again.",
      "Reset": "Reset",
      "Restore": "Restore",
      "Send": "Send",
      "Sip-accounts": "SIP Accounts",
      "Reset default": "Reset default",
      "Reset defaults": "Reset defaults",
      "Retry": "Try again",
      "Roles": "Roles",
      "Routes": {
        "account-invite": "Account invitation",
        "activateMfa": "Activate MFA",
        "asset-management": "Monitoring & assets",
        "asset-monitoring": "Asset monitoring",
        "asset-overview": "Asset overview",
        "audit-logs": "Audit logs",
        "account-invitations": "Account invitations",
        "mailchimp-account-invitations": "Account invitations",
        "contacts": "Contacts",
        "contracts": "Contracts",
        "customer-api-accounts": "API accounts",
        "customer-contacts": "Contacts",
        "customer-offers": "Offers",
        "customer-phone-numbers": "Phone numbers",
        "customer-sip-accounts": "SIP Accounts",
        "customer-profile": "Customer profile",
        "customer-users": "Customer users",
        "customers": "Customers",
        "customers-old": "Customers (old)",
        "direct-debit": "Direct debit",
        "documentation": "Documentation",
        "intranet": "Intranet",
        "domain-details": "Domain details",
        "domain-ns-groups": "Nameserver groups",
        "domains": "Domains",
        "dmarc": "DMARC",
        "email-management": "Email management",
        "feedback": "Feedback",
        "financial": "Financial",
        "forgot": "Forgot password",
        "invoices": "Invoices",
        "api-accounts": "API accounts",
        "login": "Login",
        "logout": "Logout",
        "main": "Home",
        "management": "Management",
        "meeting-statistics": "Meeting statistics",
        "meeting-statistics-detail": "Meeting statistics - Meeting details",
        "feedback-statistics": "Feedback statistics",
        "new-domain": "New domain",
        "new-webhosting-account": "New hosting account",
        "product-groups": "Product groups",
        "product-management": "Product management",
        "products": "Products",
        "profile": "User profile",
        "project-management": "Project management",
        "projects": "Projects",
        "statistics": "Statistics",
        "statistics-overview": "Overview",
        "statistics-meetings": "Meetings",
        "statistics-meetings-detail": "Meetings - Meeting details",
        "statistics-feedback": "Feedback",
        "statistics-sms": "SMS",
        "statistics-email": "Email",
        "statistics-licenses": "Licenses",
        "relationship-management": "Relationship management",
        "reset": "Reset password",
        "roles": "Roles",
        "sales-orders": "Sales orders",
        "settings": "Settings",
        "settings-management": "Settings management",
        "sc-appointment-form": "New",
        "sc-calendar": "Calendar",
        "sc-contacts": "Contacts",
        "sc-groups": "Groups",
        "sc-meeting": "Meeting",
        "sc-meeting-recordings": "Recordings",
        "sc-meeting-statistics": "Statistics",
        "sc-meeting-statistics-detail": "Statistics - Meeting details",
        "sc-call-colleague": "Colleagues",
        "sc-new-appointment": "New",
        "sc-overview": "Overview",
        "sc-profile": "User profile",
        "sc-profiles": "Profiles",
        "sc-settings": "Settings",
        "sharing-center": "OMNI Sessions",
        "sharing-center-calendar-admin": "Calendar",
        "sharing-center-contact-admin": "Contacts",
        "sharing-center-group-admin": "Groups",
        "sharing-center-profile-admin": "Profiles",
        "sms-management": "SMS management",
        "sms-statistics": "SMS statistics",
        "email-statistics": "Email statistics",
        "license-statistics": "License statistics",
        "ai-queue": "AI queue",
        "ssl-certificates": "SSL certificates",
        "license-partner-programs": "Partner programs",
        "license-slas": "SLAs",
        "subscriptions": "Subscriptions",
        "task-types": "Task types",
        "tasks": "Tasks",
        "time-tracking": "Time tracking",
        "unauthorized": "Unauthorized",
        "users": "Users",
        "vat": "VAT",
        "verify": "Verify account",
        "verifyIdentity": "Verify identity",
        "verifyMfa": "Verify MFA",
        "vision-insights": "Vision insights",
        "vpn-certificates": "VPN certificates",
        "vpn-access-graph": "VPN access graph",
        "vpn-firewalls": "Firewalls",
        "vpn-mac-address-groups": "MAC address groups",
        "whitelabels": "Whitelabel",
        "backups": "Backups",
        "backups-cloud": "Cloud backups",
        "backups-locked-vault": "Locked Vault",
        "backups-microsoft-365": "Microsoft 365",
        "backups-overview": "Overview",
        "licenses": "Licenses",
        "licenses-microsoft": "Microsoft licenses",
        "licenses-omni": "OMNI licenses",
        "licenses-overview": "Overview",
        "webhosting": "Webhosting",
        "webhosting-account-details": "Webhosting account details",
        "webhosting-accounts": "Webhosting accounts",
        "webhosting-packages": "Webhosting packages",
        "microsoft-sign-in-monitor": "Microsoft sign-in monitor",
        "stock-locations": "Stock locations",
        "assets": "Asset management",
        "stock": "Stock",
        "stock-movements": "Stock movements",
        "logistics": "Logistics",
        "purchase-orders": "Purchase orders",
        "webhooks": "Webhooks",
        "webhook-queue": "Webhook deliveries",
        "webhook-logs": "Webhook logs",
        "sharingcenter-appointments": "Appointments",
        "suppliers": "Suppliers",
        "supplier-contacts": "Supplier contacts"
      },
      "Rows per page": "Rows per page",
      "Rows selected": "{count} of {total} {type} record(s) selected",
      "Sales-orders": "Sales orders",
      "Save": "Save",
      "Save and add another": "Save and add another",
      "Save and close": "Save and close",
      "Save and sync": "Save and sync",
      "Save, sync and close": "Save, sync and close",
      "Search": "Search",
      "Select All": "Select all",
      "Select language": "App language",
      "Select regional settings": "Display language (dates, times and values)",
      "Selected customer": "Selected customer",
      "Selected items": "Selected {selected} of {total} @.lower:{items}",
      "Setting": "Setting",
      "Settings": "Settings",
      "Settings-management": "Settings management",
      "Sharing-center": "OMNI Sessions",
      "Show all": "Show all",
      "Show more": "Show more",
      "Ssl-certificates": "SSL certificates | SSL",
      "Status": "Status",
      "Subscriptions": "Subscriptions",
      "Success": "Success",
      "Switching customer has failed": "Switching customer has failed.",
      "Table of contents": "Table of contents",
      "Task-types": "Task types",
      "Tasks": "Tasks",
      "Time-tracking": "Time tracking",
      "Today": "Today",
      "Total": "Total",
      "Matching records": "Results",
      "Unauthorized": "Unauthorized",
      "Unknown": "Unknown",
      "Update available": "Update available. Reload to update.",
      "Users": "Users",
      "Value": "Value",
      "Vat": "VAT",
      "VAT": "VAT",
      "View item": "View @.lower:{item}",
      "Vision insights": "Vision insights",
      "VPN management": "VPN management",
      "Vpn-certificates": "VPN certificates",
      "Vpn-firewall-verification-logs": "VPN firewall verification logs",
      "Vpn-firewalls": "VPN firewalls",
      "Vpn-mac-address-groups": "MAC address groups",
      "Webhosting": "Hosting",
      "Webhosting-account-details": "Details",
      "Webhosting-accounts": "Hosting accounts",
      "Webhosting-packages": "Hosting packages",
      "Week": "Week",
      "Weeks": "Week | Weeks",
      "Windowed": "Windowed",
      "Year": "Year",
      "Yes": "Yes",
      "Monitoring-assets": "Monitoring & assets",
      "Microsoft-sign-in-monitor": "Microsoft sign-in monitor",
      "Data updated at": "Updated at {time}",
      "Refresh": "Refresh",
      "Color": "Color",
      "Confirmation": "Confirmation",
      "Statistics selection hint": "Value for the current selection and filters.",
      "Supplier-services": "Services and agreements",
      "Supplier-contacts": "Supplier contacts",
      "Supplier-assessments": "Supplier assessments",
      "Supplier-documents": "Supplier documents",
      "Purchase-orders": "Purchase orders"
    },
    "Feedback": {
      "How was the quality": "How was the quality?"
    },
    "Settings": {
      "Search settings": "Search settings",
      "Files": {
        "Selection remove": "Remove selection",
        "Remove undo": "Undo removal",
        "Delete file": "Delete file",
        "View file": "View file",
        "Download file": "Download file"
      },
      "Custom sub groups": {
        "Sharing Center - Meeting": "OMNI Sessions - Meeting"
      },
      "UI translations": {
        "Enum": {},
        "Options": {
          "Disabled": "Disabled",
          "MfaMethods authenticator": "Authenticator app",
          "MfaMethods email": "E-mail",
          "MfaMethods sms": "SMS",
          "Unlimited": "Unlimited",
          "1 month": "1 month",
          "2 weeks": "2 weeks",
          "1 week": "1 week",
          "3 days": "3 days",
          "24 hours": "24 hours",
          "12 hours": "12 hours",
          "1 hour": "1 hour",
          "15 minutes": "15 minutes",
          "Not allowed": "Not allowed",
          "Hide participant list": "Hide participant list",
          "Show participant names and email addresses": "Show participant names and email addresses",
          "Hide participant status": "Hide participant status",
          "Show each recipient’s own status only": "Show each recipient’s own status only",
          "Show each recipient’s own status, and show all to the organizer": "Show each recipient’s own status, and show all to the organizer",
          "Show all participant statuses": "Show all participant statuses",
          "TopBarState hide": "Hide",
          "TopBarState hide_in_meeting": "Hide in meeting",
          "TopBarState show": "Show",
          "LeftMenuState hide": "Hide",
          "LeftMenuState hide_in_meeting": "Hide in meeting",
          "LeftMenuState collapsed_in_meeting": "Collapsed in meeting",
          "LeftMenuState normal": "Normal",
          "ShowMenuItemsSecondMenu statistics": "Statistics",
          "ShowMenuItemsSecondMenu settings": "Settings",
          "ShowMenuItemsSecondMenu profile": "Profile",
          "ShowMenuItemsSecondMenu logout": "Logout",
          "MeetingFeatures camera": "Camera",
          "MeetingFeatures chat": "Chat",
          "MeetingFeatures speaker": "Speaker",
          "MeetingFeatures send-group-chat-message": "Send chat message to all",
          "MeetingFeatures closedcaptions": "Closed captions",
          "MeetingFeatures desktop": "Screensharing",
          "MeetingFeatures filmstrip": "Filmstrip toggle",
          "MeetingFeatures fullscreen": "Fullscreen",
          "MeetingFeatures breakout-rooms": "Breakout rooms",
          "MeetingFeatures hangup": "Hang up",
          "MeetingFeatures highlight": "Highlight",
          "MeetingFeatures livestreaming": "Live streaming",
          "MeetingFeatures microphone": "Microphone",
          "MeetingFeatures noisesuppression": "Noise suppression",
          "MeetingFeatures participants-pane": "Participants pane",
          "MeetingFeatures raisehand": "Raise hand",
          "MeetingFeatures reactions": "Reactions",
          "MeetingFeatures chat-reactions": "Chat reactions",
          "MeetingFeatures giphy": "GIFs",
          "MeetingFeatures lobby": "Lobby",
          "MeetingFeatures remote-mute": "Mute participants",
          "MeetingFeatures recording": "Recording",
          "MeetingFeatures security": "Security",
          "MeetingFeatures select-background": "Select background",
          "MeetingFeatures videoblur": "Blur background",
          "MeetingFeatures settings": "Settings",
          "MeetingFeatures shareaudio": "Share audio",
          "MeetingFeatures sharedvideo": "Share video",
          "MeetingFeatures shortcuts": "Shortcuts",
          "MeetingFeatures stats": "Stats",
          "MeetingFeatures tileview": "Tile view",
          "MeetingFeatures toggle-camera": "Toggle camera",
          "MeetingFeatures torch": "Flashlight",
          "MeetingFeatures geolocation": "Location sharing",
          "MeetingFeatures videoquality": "Video quality",
          "MeetingFeatures invite": "Invite users",
          "MeetingFeatures whiteboard": "Whiteboard",
          "MeetingFeatures polls": "Polls",
          "MeetingFeatures create-polls": "Create polls",
          "MeetingFeatures download": "Download apps",
          "MeetingFeatures help": "Help",
          "CameraFacingMode user": "Front camera",
          "CameraFacingMode environment": "Rear camera (when available)",
          "DisableInitialMediaRequest disable": "Disable initial media request",
          "DisableInitialMediaRequest disable_agents": "Disable initial media request for agents",
          "DisableInitialMediaRequest disable_guests": "Disable initial media request for guests",
          "DisableInitialMediaRequest enable": "Enable initial media request",
          "PrejoinScreen enable": "Enable prejoin screen",
          "PrejoinScreen disable": "Disable prejoin screen",
          "PrejoinScreen disable_agents": "Disable prejoin screen for agents",
          "PrejoinScreen disable_guests": "Disable prejoin screen for guests",
          "MeetingHandoff enable": "Enable meeting handoff",
          "MeetingHandoff disable": "Disable meeting handoff",
          "MeetingHandoff disable_agents": "Disable meeting handoff for agents",
          "MeetingHandoff disable_guests": "Disable meeting handoff for guests",
          "Filmstrip enable": "Enable filmstrip",
          "Filmstrip disable": "Disable filmstrip",
          "Filmstrip disable_agents": "Disable filmstrip for agents",
          "Filmstrip disable_guests": "Disable filmstrip for guests",
          "BreakoutRoomsHiddenButtons auto-assign-button": "Hide auto assign button",
          "BreakoutRoomsHiddenButtons join-room-button": "Hide join room button",
          "HiddenConferenceInfo subject": "Hide subject",
          "HiddenConferenceInfo timer": "Hide timer",
          "HiddenConferenceInfo participants-stats": "Hide participants stats",
          "LobbyBypass owner": "Lobby bypass for owner",
          "LobbyBypass agents": "Lobby bypass for agents",
          "LobbyBypass guests": "Lobby bypass for guests",
          "RemoteVideoMenuDisabledActions kick": "Hide kick participant",
          "RemoteVideoMenuDisabledActions grant-moderator": "Hide grant moderator",
          "RemoteVideoMenuPrivateChat none": "None",
          "RemoteVideoMenuPrivateChat all": "Disable all private chat",
          "RemoteVideoMenuPrivateChat allow-moderator-chat": "Allow private chat with moderators",
          "RemoteVideoMenuPrivateChat disable-visitor-chat": "Disable private chat for visitors",
          "ParticipantsPaneHiddenItems moderator-settings-tab": "Hide moderator settings tab",
          "ParticipantsPaneHiddenItems more-actions-button": "Hide more actions button",
          "ParticipantsPaneHiddenItems mute-all-button": "Hide mute all button",
          "MeetingNotifications disabled connection_CONNFAIL": "Connection failed",
          "MeetingNotifications disabled dialog_cameraConstraintFailedError": "Camera constraint failed",
          "MeetingNotifications disabled dialog_cameraNotSendingData": "Camera not sending data",
          "MeetingNotifications disabled dialog_kickTitle": "You were removed",
          "MeetingNotifications disabled dialog_liveStreaming": "Live streaming",
          "MeetingNotifications disabled dialog_lockTitle": "Conference lock failed",
          "MeetingNotifications disabled dialog_maxUsersLimitReached": "Maximum users limit reached",
          "MeetingNotifications disabled dialog_micNotSendingData": "Microphone not sending data",
          "MeetingNotifications disabled dialog_passwordNotSupportedTitle": "Password not supported",
          "MeetingNotifications disabled dialog_recording": "Recording",
          "MeetingNotifications disabled dialog_remoteControlTitle": "Remote control",
          "MeetingNotifications disabled dialog_reservationError": "Reservation error",
          "MeetingNotifications disabled dialog_screenSharingFailedTitle": "Screen sharing failed",
          "MeetingNotifications disabled dialog_serviceUnavailable": "Service unavailable",
          "MeetingNotifications disabled dialog_sessTerminated": "Session terminated",
          "MeetingNotifications disabled dialog_sessionRestarted": "Session restarted",
          "MeetingNotifications disabled dialog_tokenAuthFailed": "Authentication failed",
          "MeetingNotifications disabled dialog_tokenAuthFailedWithReasons": "Authentication failed (details)",
          "MeetingNotifications disabled dialog_transcribing": "Transcribing",
          "MeetingNotifications disabled dialOut_statusMessage": "Dial out status",
          "MeetingNotifications disabled liveStreaming_busy": "Live streaming busy",
          "MeetingNotifications disabled liveStreaming_failedToStart": "Live streaming failed to start",
          "MeetingNotifications disabled liveStreaming_unavailableTitle": "Live streaming unavailable",
          "MeetingNotifications disabled lobby_joinRejectedMessage": "Join request rejected",
          "MeetingNotifications disabled lobby_notificationTitle": "Lobby notification",
          "MeetingNotifications disabled notify_audioUnmuteBlockedTitle": "Unmute blocked",
          "MeetingNotifications disabled notify_chatMessages": "Chat messages",
          "MeetingNotifications disabled notify_connectedOneMember": "One participant joined",
          "MeetingNotifications disabled notify_connectedThreePlusMembers": "Multiple participants joined",
          "MeetingNotifications disabled notify_connectedTwoMembers": "Two participants joined",
          "MeetingNotifications disabled notify_dataChannelClosed": "Data channel closed",
          "MeetingNotifications disabled notify_hostAskedUnmute": "Host asked to unmute",
          "MeetingNotifications disabled notify_invitedOneMember": "One participant invited",
          "MeetingNotifications disabled notify_invitedThreePlusMembers": "Multiple participants invited",
          "MeetingNotifications disabled notify_invitedTwoMembers": "Two participants invited",
          "MeetingNotifications disabled notify_kickParticipant": "Participant removed",
          "MeetingNotifications disabled notify_leftOneMember": "One participant left",
          "MeetingNotifications disabled notify_leftThreePlusMembers": "Multiple participants left",
          "MeetingNotifications disabled notify_leftTwoMembers": "Two participants left",
          "MeetingNotifications disabled notify_linkToSalesforce": "Salesforce link",
          "MeetingNotifications disabled notify_localRecordingStarted": "Local recording started",
          "MeetingNotifications disabled notify_localRecordingStopped": "Local recording stopped",
          "MeetingNotifications disabled notify_moderationInEffectCSTitle": "Moderation in effect (content)",
          "MeetingNotifications disabled notify_moderationInEffectTitle": "Moderation in effect (audio)",
          "MeetingNotifications disabled notify_moderationInEffectVideoTitle": "Moderation in effect (video)",
          "MeetingNotifications disabled notify_moderator": "Moderator granted",
          "MeetingNotifications disabled notify_mutedRemotelyTitle": "Muted by moderator",
          "MeetingNotifications disabled notify_mutedTitle": "Muted on join",
          "MeetingNotifications disabled notify_newDeviceAudioTitle": "New audio device detected",
          "MeetingNotifications disabled notify_newDeviceCameraTitle": "New camera detected",
          "MeetingNotifications disabled notify_noiseSuppressionFailedTitle": "Noise suppression failed",
          "MeetingNotifications disabled notify_participantWantsToJoin": "Participant wants to join",
          "MeetingNotifications disabled notify_participantsWantToJoin": "Participants want to join",
          "MeetingNotifications disabled notify_passwordRemovedRemotely": "Password removed",
          "MeetingNotifications disabled notify_passwordSetRemotely": "Password set",
          "MeetingNotifications disabled notify_raisedHand": "Hand raised",
          "MeetingNotifications disabled notify_screenShareNoAudio": "Screen share without audio",
          "MeetingNotifications disabled notify_screenSharingAudioOnlyTitle": "Screen sharing audio only",
          "MeetingNotifications disabled notify_selfViewTitle": "Self view hidden",
          "MeetingNotifications disabled notify_startSilentTitle": "Joined without audio",
          "MeetingNotifications disabled notify_suboptimalExperienceTitle": "Suboptimal experience",
          "MeetingNotifications disabled notify_unmute": "Unmute request",
          "MeetingNotifications disabled notify_videoMutedRemotelyTitle": "Video muted by moderator",
          "MeetingNotifications disabled notify_videoUnmuteBlockedTitle": "Video unmute blocked",
          "MeetingNotifications disabled prejoin_errorDialOut": "Dial out error",
          "MeetingNotifications disabled prejoin_errorDialOutDisconnected": "Dial out disconnected",
          "MeetingNotifications disabled prejoin_errorDialOutFailed": "Dial out failed",
          "MeetingNotifications disabled prejoin_errorDialOutStatus": "Dial out status error",
          "MeetingNotifications disabled prejoin_errorStatusCode": "Status code error",
          "MeetingNotifications disabled prejoin_errorValidation": "Validation error",
          "MeetingNotifications disabled recording_busy": "Recording busy",
          "MeetingNotifications disabled recording_failedToStart": "Recording failed to start",
          "MeetingNotifications disabled recording_unavailableTitle": "Recording unavailable",
          "MeetingNotifications disabled toolbar_noAudioSignalTitle": "No audio signal",
          "MeetingNotifications disabled toolbar_noisyAudioInputTitle": "Noisy audio input",
          "MeetingNotifications disabled toolbar_talkWhileMutedPopup": "Talking while muted",
          "MeetingNotifications disabled transcribing_failed": "Transcribing failed",
          "MeetingSounds ASKED_TO_UNMUTE_SOUND": "Asked to unmute",
          "MeetingSounds E2EE_OFF_SOUND": "E2EE off",
          "MeetingSounds E2EE_ON_SOUND": "E2EE on",
          "MeetingSounds INCOMING_MSG_SOUND": "Incoming message",
          "MeetingSounds KNOCKING_PARTICIPANT_SOUND": "Knocking participant",
          "MeetingSounds LIVE_STREAMING_OFF_SOUND": "Live streaming off",
          "MeetingSounds LIVE_STREAMING_ON_SOUND": "Live streaming on",
          "MeetingSounds NO_AUDIO_SIGNAL_SOUND": "No audio signal",
          "MeetingSounds NOISY_AUDIO_INPUT_SOUND": "Noisy audio input",
          "MeetingSounds OUTGOING_CALL_EXPIRED_SOUND": "Outgoing call expired",
          "MeetingSounds OUTGOING_CALL_REJECTED_SOUND": "Outgoing call rejected",
          "MeetingSounds OUTGOING_CALL_RINGING_SOUND": "Outgoing call ringing",
          "MeetingSounds OUTGOING_CALL_START_SOUND": "Outgoing call started",
          "MeetingSounds PARTICIPANT_JOINED_SOUND": "Participant joined",
          "MeetingSounds PARTICIPANT_LEFT_SOUND": "Participant left",
          "MeetingSounds RAISE_HAND_SOUND": "Raise hand",
          "MeetingSounds REACTION_SOUND": "Reaction",
          "MeetingSounds RECORDING_OFF_SOUND": "Recording off",
          "MeetingSounds RECORDING_ON_SOUND": "Recording on",
          "MeetingSounds TALK_WHILE_MUTED_SOUND": "Talk while muted"
        },
        "Group": {
          "General": "General",
          "Sharing Center": "OMNI Sessions",
          "OMNI Sessions - Telephony": "OMNI Sessions - Telephony"
        },
        "Label": {
          "Customer logo": "Logo",
          "Customer logo (mark)": "Logo (mark)",
          "Portal name": "Portal name",
          "Support email address": "Support email address",
          "Customer signature for emails": "Customer signature email",
          "Primary color": "Primary color",
          "MFA enabled": "MFA enabled",
          "MFA primary method": "MFA primary method",
          "MFA fallback methods": "MFA fallback methods",
          "Default customer": "Default selected customer on logon",
          "Top bar state": "Top bar state",
          "Top bar state iframe": "Top bar state (iframe)",
          "Left menu state": "Left menu state",
          "Left menu state iframe": "Left menu state (iframe)",
          "Show left menu items in second menu": "Show left menu items in second menu",
          "Show left menu items in second menu iframe": "Show left menu items in second menu (iframe)",
          "AI agent": "AI agent",
          "AI agent settings": "AI agent settings",
          "Whisper agent": "Whisper agent",
          "Whisper agent settings": "Whisper agent settings",
          "Sharing Center - Product name": "Product name",
          "Sharing Center - Default subject": "Default subject",
          "Sharing Center - ICS invite participant visibility": "ICS invite participant visibility",
          "Sharing Center - ICS invite participant status visibility": "ICS invite participant status visibility",
          "Sharing Center - Pre-join time": "Access time before start",
          "Sharing Center - Post-join time": "Access time after end",
          "Sharing Center - Feedback questions": "Feedback questions",
          "Sharing Center - Meeting max participants": "Meeting maximum participants",
          "Sharing Center - Meeting max participants live invite": "Meeting max participants live invite",
          "Sharing Center - Meeting e2e enabled": "Meeting E2E available",
          "Sharing Center - Meeting default e2e encrypted": "Meeting E2E encrypted by default",
          "Sharing Center - Meeting p2p enabled": "Meeting P2P enabled",
          "Sharing Center - Meeting p2p max participants": "Meeting P2P max participants",
          "Sharing Center - Meeting auto transcriptions enabled": "Automatic transcriptions",
          "Sharing Center - Meeting auto AI minutes enabled": "Automatic AI minutes",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Meeting default hidden prompt for AI minutes",
          "Sharing Center - Meeting default AI minutes prompt": "Meeting default prompt for AI minutes",
          "Sharing Center - Meeting default AI minutes prompt NL": "Meeting default prompt for AI minutes (Dutch)",
          "Sharing Center - Meeting default AI minutes prompt EN": "Meeting default prompt for AI minutes (English)",
          "Sharing Center - Features agents": "Meeting features",
          "Sharing Center - Features guests": "Meeting features (guests)",
          "Sharing Center - Meeting chat smileys disabled": "Meeting chat smileys disabled",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Meeting breakout rooms hidden buttons",
          "Sharing Center - Meeting notifications disabled": "Meeting notifications disabled",
          "Sharing Center - Meeting notifications disabled guests": "Meeting notifications disabled (guest)",
          "Sharing Center - Meeting sounds disabled": "Meeting sounds disabled",
          "Sharing Center - Meeting sounds disabled guests": "Meeting sounds disabled (guest)",
          "Sharing Center - Meeting remote video menu enabled": "Meeting participant video menu enabled",
          "Sharing Center - Meeting remote video menu disabled actions": "Meeting participant video menu hidden actions",
          "Sharing Center - Meeting remote video menu private chat": "Meeting participant video menu private chat",
          "Sharing Center - Meeting participants pane enabled": "Meeting participants pane enabled",
          "Sharing Center - Meeting participants pane hidden items": "Meeting participants pane hidden items",
          "Sharing Center - Meeting lobby enabled": "Meeting lobby enabled",
          "Sharing Center - Meeting lobby auto knock": "Meeting lobby auto knock",
          "Sharing Center - Meeting lobby chat enabled": "Meeting lobby chat enabled",
          "Sharing Center - Meeting lobby bypass": "Meeting lobby bypass",
          "Sharing Center - Meeting prejoin screen": "Meeting prejoin screen",
          "Sharing Center - Meeting handoff": "Meeting handoff",
          "Sharing Center - Meeting filmstrip": "Meeting filmstrip",
          "Sharing Center - Tileview enabled": "Tile view enabled",
          "Sharing Center - Number of visible tiles": "Number of visible tiles",
          "Sharing Center - Tileview enabled guests": "Tile view enabled (guest)",
          "Sharing Center - Number of visible tiles guests": "Number of visible tiles (guest)",
          "Sharing Center - Meeting toolbar always visible": "Meeting toolbar always visible",
          "Sharing Center - Meeting toolbar initial timeout": "Meeting toolbar initial timeout",
          "Sharing Center - Meeting toolbar timeout": "Meeting toolbar timeout",
          "Sharing Center - Meeting hidden conference info": "Meeting hidden conference info",
          "Sharing Center - Meeting mute microphone": "Meeting mute microphone",
          "Sharing Center - Meeting mute microphone guests": "Meeting mute microphone (guest)",
          "Sharing Center - Meeting camera off": "Meeting camera off",
          "Sharing Center - Meeting camera off guests": "Meeting camera off (guest)",
          "Sharing Center - Meeting camera facing mode": "Meeting camera facing mode",
          "Sharing Center - Meeting camera facing mode guests": "Meeting camera facing mode (guest)",
          "Sharing Center - Meeting initial media request": "Meeting initial media request",
          "Sharing Center - Meeting force my video on stage": "Meeting force my video on stage",
          "OMNI Sessions - Inbound phone number": "Inbound phone number",
          "OMNI Sessions - Outbound phone number": "Outbound phone number",
          "Sharing Center - Meeting base URL": "Meeting base URL",
          "Sharing Center - Meeting app ID": "Meeting app ID",
          "Sharing Center - Meeting app secret": "Meeting app secret",
          "Sharing Center - Meeting audience": "Meeting token audience",
          "Sharing Center - Meeting subject": "Meeting token subject",
          "Sharing Center - Meeting background color": "Meeting background color",
          "Sharing Center - Meeting background image URL": "Meeting background image URL",
          "Sharing Center - Meeting DID page URL": "Meeting DID page URL",
          "Sharing Center - Meeting invite domain": "Meeting invite domain",
          "Sharing Center - Meeting logo click URL": "Meeting logo click URL",
          "Sharing Center - Meeting logo image URL": "Meeting logo image URL",
          "Sharing Center - Meeting avatar backgrounds": "Meeting avatar backgrounds",
          "Sharing Center - Meeting pre-meeting background": "Meeting pre-meeting background",
          "Sharing Center - Meeting disable virtual backgrounds": "Disable virtual backgrounds",
          "Sharing Center - Meeting disable adding background images": "Disable adding background images",
          "Sharing Center - Meeting custom virtual background 1": "Custom virtual background 1",
          "Sharing Center - Meeting custom virtual background 2": "Custom virtual background 2",
          "Sharing Center - Meeting custom virtual background 3": "Custom virtual background 3",
          "Sharing Center - Meeting custom virtual background 4": "Custom virtual background 4",
          "Sharing Center - Meeting custom virtual background 5": "Custom virtual background 5",
          "Sharing Center - Meeting virtual backgrounds": "Meeting virtual backgrounds",
          "Sharing Center - Meeting virtual backgrounds include defaults": "Virtual backgrounds include defaults",
          "Sharing Center - Meeting user documentation URL": "Meeting user documentation URL",
          "Sharing Center - Meeting download apps URL": "Meeting download apps URL",
          "Sharing Center - Meeting translations": "Meeting translations",
          "Sharing Center - Meeting CSS": "Meeting CSS",
          "Sharing Center - Meeting custom icons - icon Add User": "Meeting custom icons - icon Add User",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "Meeting custom icons - icon Arrow Back",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "Meeting custom icons - icon Arrow Down",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "Meeting custom icons - icon Arrow Down Large",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "Meeting custom icons - icon Arrow Left",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "Meeting custom icons - icon Arrow Up",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "Meeting custom icons - icon Arrow Up Large",
          "Sharing Center - Meeting custom icons - icon Audio Only": "Meeting custom icons - icon Audio Only",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "Meeting custom icons - icon Audio Only Off",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "Meeting custom icons - icon Bluetooth",
          "Sharing Center - Meeting custom icons - icon Bell": "Meeting custom icons - icon Bell",
          "Sharing Center - Meeting custom icons - icon Calendar": "Meeting custom icons - icon Calendar",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "Meeting custom icons - icon Camera Refresh",
          "Sharing Center - Meeting custom icons - icon Car": "Meeting custom icons - icon Car",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "Meeting custom icons - icon Chat Unread",
          "Sharing Center - Meeting custom icons - icon Check": "Meeting custom icons - icon Check",
          "Sharing Center - Meeting custom icons - icon Close Circle": "Meeting custom icons - icon Close Circle",
          "Sharing Center - Meeting custom icons - icon Close Large": "Meeting custom icons - icon Close Large",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "Meeting custom icons - icon Cloud Upload",
          "Sharing Center - Meeting custom icons - icon Code": "Meeting custom icons - icon Code",
          "Sharing Center - Meeting custom icons - icon Connection": "Meeting custom icons - icon Connection",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "Meeting custom icons - icon Connection Inactive",
          "Sharing Center - Meeting custom icons - icon Copy": "Meeting custom icons - icon Copy",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "Meeting custom icons - icon Device Headphone",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "Meeting custom icons - icon Dots Horizontal",
          "Sharing Center - Meeting custom icons - icon Download": "Meeting custom icons - icon Download",
          "Sharing Center - Meeting custom icons - icon E2EE": "Meeting custom icons - icon E2EE",
          "Sharing Center - Meeting custom icons - icon Edit": "Meeting custom icons - icon Edit",
          "Sharing Center - Meeting custom icons - icon Enlarge": "Meeting custom icons - icon Enlarge",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "Meeting custom icons - icon Enter Fullscreen",
          "Sharing Center - Meeting custom icons - icon Envelope": "Meeting custom icons - icon Envelope",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "Meeting custom icons - icon Emotions Angry",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "Meeting custom icons - icon Emotions Disgusted",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "Meeting custom icons - icon Emotions Fearful",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "Meeting custom icons - icon Emotions Happy",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "Meeting custom icons - icon Emotions Neutral",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "Meeting custom icons - icon Emotions Sad",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "Meeting custom icons - icon Emotions Surprised",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "Meeting custom icons - icon Exclamation Solid",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "Meeting custom icons - icon Exclamation Triangle",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "Meeting custom icons - icon Exit Fullscreen",
          "Sharing Center - Meeting custom icons - icon Face Smile": "Meeting custom icons - icon Face Smile",
          "Sharing Center - Meeting custom icons - icon Favorite": "Meeting custom icons - icon Favorite",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "Meeting custom icons - icon Favorite Solid",
          "Sharing Center - Meeting custom icons - icon Feedback": "Meeting custom icons - icon Feedback",
          "Sharing Center - Meeting custom icons - icon Gear": "Meeting custom icons - icon Gear",
          "Sharing Center - Meeting custom icons - icon Google": "Meeting custom icons - icon Google",
          "Sharing Center - Meeting custom icons - icon Hangup": "Meeting custom icons - icon Hangup",
          "Sharing Center - Meeting custom icons - icon Help": "Meeting custom icons - icon Help",
          "Sharing Center - Meeting custom icons - icon Highlight": "Meeting custom icons - icon Highlight",
          "Sharing Center - Meeting custom icons - icon Image": "Meeting custom icons - icon Image",
          "Sharing Center - Meeting custom icons - icon Info": "Meeting custom icons - icon Info",
          "Sharing Center - Meeting custom icons - icon Info Circle": "Meeting custom icons - icon Info Circle",
          "Sharing Center - Meeting custom icons - icon Message": "Meeting custom icons - icon Message",
          "Sharing Center - Meeting custom icons - icon Meter": "Meeting custom icons - icon Meter",
          "Sharing Center - Meeting custom icons - icon Mic": "Meeting custom icons - icon Mic",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "Meeting custom icons - icon Mic Slash",
          "Sharing Center - Meeting custom icons - icon Moderator": "Meeting custom icons - icon Moderator",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "Meeting custom icons - icon Noise Suppression Off",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "Meeting custom icons - icon Noise Suppression On",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "Meeting custom icons - icon Arrow Right",
          "Sharing Center - Meeting custom icons - icon Office365": "Meeting custom icons - icon Office365",
          "Sharing Center - Meeting custom icons - icon Performance": "Meeting custom icons - icon Performance",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "Meeting custom icons - icon Phone Ringing",
          "Sharing Center - Meeting custom icons - icon Pin": "Meeting custom icons - icon Pin",
          "Sharing Center - Meeting custom icons - icon Pinned": "Meeting custom icons - icon Pinned",
          "Sharing Center - Meeting custom icons - icon Play": "Meeting custom icons - icon Play",
          "Sharing Center - Meeting custom icons - icon Plus": "Meeting custom icons - icon Plus",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "Meeting custom icons - icon Raise Hand",
          "Sharing Center - Meeting custom icons - icon Record": "Meeting custom icons - icon Record",
          "Sharing Center - Meeting custom icons - icon Record Account": "Meeting custom icons - icon Record Account",
          "Sharing Center - Meeting custom icons - icon Record Contact": "Meeting custom icons - icon Record Contact",
          "Sharing Center - Meeting custom icons - icon Record Lead": "Meeting custom icons - icon Record Lead",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "Meeting custom icons - icon Record Opportunity",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "Meeting custom icons - icon Remote Control Start",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "Meeting custom icons - icon Remote Control Stop",
          "Sharing Center - Meeting custom icons - icon Reply": "Meeting custom icons - icon Reply",
          "Sharing Center - Meeting custom icons - icon Restore": "Meeting custom icons - icon Restore",
          "Sharing Center - Meeting custom icons - icon Ring Group": "Meeting custom icons - icon Ring Group",
          "Sharing Center - Meeting custom icons - icon Screenshare": "Meeting custom icons - icon Screenshare",
          "Sharing Center - Meeting custom icons - icon Search": "Meeting custom icons - icon Search",
          "Sharing Center - Meeting custom icons - icon Security Off": "Meeting custom icons - icon Security Off",
          "Sharing Center - Meeting custom icons - icon Security On": "Meeting custom icons - icon Security On",
          "Sharing Center - Meeting custom icons - icon Send": "Meeting custom icons - icon Send",
          "Sharing Center - Meeting custom icons - icon Share": "Meeting custom icons - icon Share",
          "Sharing Center - Meeting custom icons - icon Share Doc": "Meeting custom icons - icon Share Doc",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "Meeting custom icons - icon Shortcuts",
          "Sharing Center - Meeting custom icons - icon SIP": "Meeting custom icons - icon SIP",
          "Sharing Center - Meeting custom icons - icon Sites": "Meeting custom icons - icon Sites",
          "Sharing Center - Meeting custom icons - icon Stop": "Meeting custom icons - icon Stop",
          "Sharing Center - Meeting custom icons - icon Subtitles": "Meeting custom icons - icon Subtitles",
          "Sharing Center - Meeting custom icons - icon Tile View": "Meeting custom icons - icon Tile View",
          "Sharing Center - Meeting custom icons - icon Trash": "Meeting custom icons - icon Trash",
          "Sharing Center - Meeting custom icons - icon User Deleted": "Meeting custom icons - icon User Deleted",
          "Sharing Center - Meeting custom icons - icon Users": "Meeting custom icons - icon Users",
          "Sharing Center - Meeting custom icons - icon User": "Meeting custom icons - icon User",
          "Sharing Center - Meeting custom icons - icon Video": "Meeting custom icons - icon Video",
          "Sharing Center - Meeting custom icons - icon Video Off": "Meeting custom icons - icon Video Off",
          "Sharing Center - Meeting custom icons - icon Volume Off": "Meeting custom icons - icon Volume Off",
          "Sharing Center - Meeting custom icons - icon Volume Up": "Meeting custom icons - icon Volume Up",
          "Sharing Center - Meeting custom icons - icon Warning": "Meeting custom icons - icon Warning",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "Meeting custom icons - icon Warning Circle",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "Meeting custom icons - icon Whiteboard",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "Meeting custom icons - icon Whiteboard Hide",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "Meeting custom icons - icon Wifi1 Bar",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "Meeting custom icons - icon Wifi2 Bars",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "Meeting custom icons - icon Wifi3 Bars",
          "Sharing Center - Meeting custom icons - icon Yahoo": "Meeting custom icons - icon Yahoo",
          "Sharing Center - Meeting theme palette - Action01": "Primary action",
          "Sharing Center - Meeting theme palette - Action01 Active": "Primary action (pressed)",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Primary action (hover)",
          "Sharing Center - Meeting theme palette - Action02": "Secondary action",
          "Sharing Center - Meeting theme palette - Action02 Active": "Secondary action (pressed)",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Secondary action (hover)",
          "Sharing Center - Meeting theme palette - Action03": "Subtle action",
          "Sharing Center - Meeting theme palette - Action03 Active": "Subtle action (pressed)",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Subtle action (hover)",
          "Sharing Center - Meeting theme palette - Action Danger": "Danger action",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Danger action (pressed)",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Danger action (hover)",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled background",
          "Sharing Center - Meeting theme palette - Field01": "Form field accent",
          "Sharing Center - Meeting theme palette - Focus01": "Focus ring",
          "Sharing Center - Meeting theme palette - Icon01": "Primary icon color",
          "Sharing Center - Meeting theme palette - Icon02": "Secondary icon/accent",
          "Sharing Center - Meeting theme palette - Icon03": "Inactive icon color",
          "Sharing Center - Meeting theme palette - Icon04": "Contrast icon color",
          "Sharing Center - Meeting theme palette - Icon Error": "Error icon color",
          "Sharing Center - Meeting theme palette - Link01": "Primary link",
          "Sharing Center - Meeting theme palette - Link01 Active": "Link (pressed)",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Link (hover)",
          "Sharing Center - Meeting theme palette - Success01": "Success status primary",
          "Sharing Center - Meeting theme palette - Success02": "Success status secondary",
          "Sharing Center - Meeting theme palette - Support01": "Support color 01",
          "Sharing Center - Meeting theme palette - Support02": "Support color 02",
          "Sharing Center - Meeting theme palette - Support03": "Support color 03",
          "Sharing Center - Meeting theme palette - Support04": "Support color 04",
          "Sharing Center - Meeting theme palette - Support05": "Support color 05",
          "Sharing Center - Meeting theme palette - Support06": "Support color 06",
          "Sharing Center - Meeting theme palette - Support07": "Support color 07",
          "Sharing Center - Meeting theme palette - Support08": "Support color 08",
          "Sharing Center - Meeting theme palette - Support09": "Support color 09",
          "Sharing Center - Meeting theme palette - Text01": "Primary text",
          "Sharing Center - Meeting theme palette - Text02": "Secondary text",
          "Sharing Center - Meeting theme palette - Text03": "Less prominent text",
          "Sharing Center - Meeting theme palette - Text04": "Contrast text",
          "Sharing Center - Meeting theme palette - Text Error": "Error text",
          "Sharing Center - Meeting theme palette - Ui01": "Base container background",
          "Sharing Center - Meeting theme palette - Ui02": "Elevated container background",
          "Sharing Center - Meeting theme palette - Ui03": "Input/control background",
          "Sharing Center - Meeting theme palette - Ui04": "Light border/surface",
          "Sharing Center - Meeting theme palette - Ui05": "Inactive indicator",
          "Sharing Center - Meeting theme palette - Ui06": "Dark separator",
          "Sharing Center - Meeting theme palette - Ui07": "Strong divider",
          "Sharing Center - Meeting theme palette - Ui08": "Muted action fill",
          "Sharing Center - Meeting theme palette - Ui09": "Info badge background",
          "Sharing Center - Meeting theme palette - Ui10": "Active indicator background",
          "Sharing Center - Meeting theme palette - Ui Background": "App background",
          "Sharing Center - Meeting theme palette - Warning01": "Warning accent",
          "Sharing Center - Meeting theme palette - Warning02": "Warning highlight"
        },
        "Description": {
          "Customer logo": "Upload a logo.",
          "Customer logo (mark)": "The logo (mark) in square.",
          "Portal name": "The name used for the portal, emails, and communication.",
          "Support email address": "The support email address used for portal communication.",
          "Customer signature for emails": "Use the customer signature and contact details in authentication emails.",
          "Primary color": "The primary color used in the portal.",
          "MFA enabled": "Enable multi-factor authentication (MFA).",
          "MFA primary method": "Choose the primary multi-factor authentication (MFA) method.",
          "MFA fallback methods": "Choose one or more fallback multi-factor authentication (MFA) methods.",
          "Default customer": "Select a default customer when you log in.",
          "Top bar state": "Set the default state for the top bar.",
          "Top bar state iframe": "Set the default state for the top bar when running embedded (iframe).",
          "Left menu state": "Set the default state for the left menu.",
          "Left menu state iframe": "Set the default state for the left menu when running embedded (iframe).",
          "Show left menu items in second menu": "Show menu items from the left menu in the second menu. Useful when the left menu is hidden or as shortcuts within embedded products.",
          "Show left menu items in second menu iframe": "Show menu items from the left menu in the second menu when running embedded (iframe). Useful when the left menu is hidden or as shortcuts within embedded products.",
          "AI agent": "Choose which AI agent is available.",
          "AI agent settings": "JSON configuration for the selected AI agent.",
          "Whisper agent": "Choose which Whisper agent is available.",
          "Whisper agent settings": "JSON configuration for the selected Whisper agent.",
          "Sharing Center - Product name": "The product name used for mails and communication.",
          "Sharing Center - Default subject": "Set a default subject when you create a new appointment. You can always change it before saving.",
          "Sharing Center - ICS invite participant visibility": "Control what non-organizers can see in ICS invites.",
          "Sharing Center - ICS invite participant status visibility": "Control whether RSVP status is included in ICS invites.",
          "Sharing Center - Pre-join time": "Define how long before the start time participants are allowed to access the appointment.",
          "Sharing Center - Post-join time": "Define how long after the end time participants are still allowed to access the appointment.",
          "Sharing Center - Feedback questions": "Define which feedback questions are shown to participants after an appointment has ended.",
          "Sharing Center - Meeting max participants": "Set the maximum number of participants allowed in a meeting.",
          "Sharing Center - Meeting max participants live invite": "Invite participants during the meeting.",
          "Sharing Center - Meeting e2e enabled": "Allow end-to-end encryption to be used in meetings.",
          "Sharing Center - Meeting default e2e encrypted": "Enable end-to-end encryption by default when available.",
          "Sharing Center - Meeting p2p enabled": "Enable peer-to-peer mode for small meetings.",
          "Sharing Center - Meeting p2p max participants": "Set the maximum number of participants for peer-to-peer mode.",
          "Sharing Center - Meeting auto transcriptions enabled": "Automatically process available meeting recordings into transcripts for this customer.",
          "Sharing Center - Meeting auto AI minutes enabled": "Automatically generate AI minutes when a transcript is available for this customer.",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Default hidden prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt": "Default prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt NL": "Default Dutch prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt EN": "Default English prompt for AI minutes in meetings.",
          "Sharing Center - Features agents": "Enable features to use in the meeting for agents.",
          "Sharing Center - Features guests": "Enable features to use in the meeting for guests.",
          "Sharing Center - Meeting chat smileys disabled": "Disable smileys in the meeting chat.",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Select which breakout room buttons are hidden.",
          "Sharing Center - Meeting notifications disabled": "Select which meeting notifications are disabled.",
          "Sharing Center - Meeting notifications disabled guests": "Select which meeting notifications are disabled for guests.",
          "Sharing Center - Meeting sounds disabled": "Select which meeting sounds are disabled.",
          "Sharing Center - Meeting sounds disabled guests": "Select which meeting sounds are disabled for guests.",
          "Sharing Center - Meeting remote video menu enabled": "Enable or disable the participant video menu in meetings.",
          "Sharing Center - Meeting remote video menu disabled actions": "Select which participant video menu actions are hidden.",
          "Sharing Center - Meeting remote video menu private chat": "Select how private chat is restricted from the participant video menu. None leaves the default unchanged.",
          "Sharing Center - Meeting participants pane enabled": "Enable or disable the participants pane in meetings.",
          "Sharing Center - Meeting participants pane hidden items": "Select which participants pane items are hidden.",
          "Sharing Center - Meeting lobby enabled": "Enable or disable the meeting lobby.",
          "Sharing Center - Meeting lobby auto knock": "Automatically let participants knock when the lobby is enabled.",
          "Sharing Center - Meeting lobby chat enabled": "Allow chat on the lobby screen.",
          "Sharing Center - Meeting lobby bypass": "Select who can bypass the meeting lobby. This setting is also applied when the lobby is enabled during the meeting.",
          "Sharing Center - Meeting prejoin screen": "Control whether the prejoin screen is shown for agents and guests.",
          "Sharing Center - Meeting handoff": "Control whether participants can hand off an active meeting to another device. If disabled, joining from another device is blocked.",
          "Sharing Center - Meeting filmstrip": "Control whether the filmstrip is shown for agents and guests.",
          "Sharing Center - Tileview enabled": "Enable tile view when three or more participants have joined the meeting.",
          "Sharing Center - Number of visible tiles": "Set the optimal number of tiles shown in tile view. Depending on screen size, the exact number may vary.",
          "Sharing Center - Tileview enabled guests": "Enable tile view for guests when three or more participants have joined the meeting.",
          "Sharing Center - Number of visible tiles guests": "Set the optimal number of tiles shown in tile view for guests. Depending on screen size, the exact number may vary.",
          "Sharing Center - Meeting toolbar always visible": "Keep the meeting toolbar visible instead of auto-hiding it.",
          "Sharing Center - Meeting toolbar initial timeout": "Set how long the meeting toolbar stays visible after joining, in seconds.",
          "Sharing Center - Meeting toolbar timeout": "Set how long the meeting toolbar stays visible after user interaction, in seconds.",
          "Sharing Center - Meeting hidden conference info": "Select which conference information is hidden in the meeting UI.",
          "Sharing Center - Meeting mute microphone": "Mute your microphone by default when you start a meeting.",
          "Sharing Center - Meeting mute microphone guests": "Mute your microphone by default when guests start a meeting.",
          "Sharing Center - Meeting camera off": "Turn off your camera by default when you start a meeting.",
          "Sharing Center - Meeting camera off guests": "Turn off your camera by default when guests start a meeting.",
          "Sharing Center - Meeting camera facing mode": "Select which camera is preferred when you start a meeting.",
          "Sharing Center - Meeting camera facing mode guests": "Select which camera is preferred when guests start a meeting.",
          "Sharing Center - Meeting initial media request": "Control whether camera/microphone access is requested immediately when joining a meeting.",
          "Sharing Center - Meeting force my video on stage": "Pin your own video on stage by default when joining a meeting.",
          "Sharing Center - Meeting base URL": "The base URL of the server used for OMNI Sessions meetings.",
          "Sharing Center - Meeting app ID": "The application ID used to authenticate with the meeting server.",
          "Sharing Center - Meeting app secret": "The secret key used to securely sign authentication tokens.",
          "Sharing Center - Meeting audience": "The audience (aud) claim used when generating authentication tokens.",
          "Sharing Center - Meeting subject": "The subject (sub) claim used when generating authentication tokens.",
          "Sharing Center - Meeting background color": "Primary background color used throughout the meeting interface.",
          "Sharing Center - Meeting background image URL": "Background image displayed behind the meeting interface.",
          "Sharing Center - Meeting DID page URL": "URL used for call-in or DID information associated with the meeting.",
          "Sharing Center - Meeting invite domain": "Domain used when generating meeting invitation links.",
          "Sharing Center - Meeting logo click URL": "URL opened when clicking the meeting logo.",
          "Sharing Center - Meeting logo image URL": "Logo image displayed in the meeting interface.",
          "Sharing Center - Meeting avatar backgrounds": "List of background images used behind participant avatars.",
          "Sharing Center - Meeting pre-meeting background": "Background shown in the pre-meeting lobby or waiting room.",
          "Sharing Center - Meeting disable virtual backgrounds": "Disable virtual backgrounds in the meeting interface.",
          "Sharing Center - Meeting disable adding background images": "Prevent users from adding their own background images during the meeting.",
          "Sharing Center - Meeting custom virtual background 1": "Virtual background 1 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 2": "Virtual background 2 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 3": "Virtual background 3 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 4": "Virtual background 4 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 5": "Virtual background 5 available during the meeting.",
          "Sharing Center - Meeting virtual backgrounds": "List of custom virtual backgrounds available during the meeting.",
          "Sharing Center - Meeting virtual backgrounds include defaults": "When enabled, the default virtual backgrounds are included alongside custom ones.",
          "Sharing Center - Meeting user documentation URL": "URL opened by the Help button in the meeting overflow menu.",
          "Sharing Center - Meeting download apps URL": "URL opened by the Download our apps button in the meeting overflow menu.",
          "Sharing Center - Meeting translations": "JSON configuration used to override UI labels and text in the meeting interface.",
          "Sharing Center - Meeting CSS": "CSS overrides applied to the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Add User": "Custom icon URL used for 'add user' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "Custom icon URL used for 'arrow back' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "Custom icon URL used for 'arrow down' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "Custom icon URL used for 'arrow down large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "Custom icon URL used for 'arrow left' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "Custom icon URL used for 'arrow up' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "Custom icon URL used for 'arrow up large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only": "Custom icon URL used for 'audio only' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "Custom icon URL used for 'audio only off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "Custom icon URL used for 'bluetooth' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Bell": "Custom icon URL used for 'bell' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Calendar": "Custom icon URL used for 'calendar' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "Custom icon URL used for 'camera refresh' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Car": "Custom icon URL used for 'car' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "Custom icon URL used for 'chat unread' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Check": "Custom icon URL used for 'check' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Close Circle": "Custom icon URL used for 'close circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Close Large": "Custom icon URL used for 'close large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "Custom icon URL used for 'cloud upload' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Code": "Custom icon URL used for 'code' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Connection": "Custom icon URL used for 'connection' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "Custom icon URL used for 'connection inactive' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Copy": "Custom icon URL used for 'copy' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "Custom icon URL used for 'device headphone' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "Custom icon URL used for 'dots horizontal' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Download": "Custom icon URL used for 'download' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon E2EE": "Custom icon URL used for 'e2ee' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Edit": "Custom icon URL used for 'edit' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Enlarge": "Custom icon URL used for 'enlarge' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "Custom icon URL used for 'enter fullscreen' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Envelope": "Custom icon URL used for 'envelope' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "Custom icon URL used for 'emotions angry' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "Custom icon URL used for 'emotions disgusted' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "Custom icon URL used for 'emotions fearful' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "Custom icon URL used for 'emotions happy' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "Custom icon URL used for 'emotions neutral' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "Custom icon URL used for 'emotions sad' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "Custom icon URL used for 'emotions surprised' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "Custom icon URL used for 'exclamation solid' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "Custom icon URL used for 'exclamation triangle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "Custom icon URL used for 'exit fullscreen' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Face Smile": "Custom icon URL used for 'face smile' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Favorite": "Custom icon URL used for 'favorite' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "Custom icon URL used for 'favorite solid' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Feedback": "Custom icon URL used for 'feedback' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Gear": "Custom icon URL used for 'gear' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Google": "Custom icon URL used for 'google' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Hangup": "Custom icon URL used for 'hangup' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Help": "Custom icon URL used for 'help' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Highlight": "Custom icon URL used for 'highlight' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Image": "Custom icon URL used for 'image' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Info": "Custom icon URL used for 'info' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Info Circle": "Custom icon URL used for 'info circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Message": "Custom icon URL used for 'message' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Meter": "Custom icon URL used for 'meter' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Mic": "Custom icon URL used for 'mic' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "Custom icon URL used for 'mic slash' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Moderator": "Custom icon URL used for 'moderator' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "Custom icon URL used for 'noise suppression off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "Custom icon URL used for 'noise suppression on' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "Custom icon URL used for 'arrow right' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Office365": "Custom icon URL used for 'office365' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Performance": "Custom icon URL used for 'performance' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "Custom icon URL used for 'phone ringing' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Pin": "Custom icon URL used for 'pin' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Pinned": "Custom icon URL used for 'pinned' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Play": "Custom icon URL used for 'play' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Plus": "Custom icon URL used for 'plus' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "Custom icon URL used for 'raise hand' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record": "Custom icon URL used for 'record' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Account": "Custom icon URL used for 'record account' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Contact": "Custom icon URL used for 'record contact' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Lead": "Custom icon URL used for 'record lead' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "Custom icon URL used for 'record opportunity' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "Custom icon URL used for 'remote control start' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "Custom icon URL used for 'remote control stop' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Reply": "Custom icon URL used for 'reply' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Restore": "Custom icon URL used for 'restore' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Ring Group": "Custom icon URL used for 'ring group' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Screenshare": "Custom icon URL used for 'screenshare' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Search": "Custom icon URL used for 'search' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Security Off": "Custom icon URL used for 'security off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Security On": "Custom icon URL used for 'security on' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Send": "Custom icon URL used for 'send' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Share": "Custom icon URL used for 'share' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Share Doc": "Custom icon URL used for 'share doc' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "Custom icon URL used for 'shortcuts' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon SIP": "Custom icon URL used for 'sip' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Sites": "Custom icon URL used for 'sites' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Stop": "Custom icon URL used for 'stop' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Subtitles": "Custom icon URL used for 'subtitles' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Tile View": "Custom icon URL used for 'tile view' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Trash": "Custom icon URL used for 'trash' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon User Deleted": "Custom icon URL used for 'user deleted' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Users": "Custom icon URL used for 'users' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon User": "Custom icon URL used for 'user' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Video": "Custom icon URL used for 'video' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Video Off": "Custom icon URL used for 'video off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Volume Off": "Custom icon URL used for 'volume off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Volume Up": "Custom icon URL used for 'volume up' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Warning": "Custom icon URL used for 'warning' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "Custom icon URL used for 'warning circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "Custom icon URL used for 'whiteboard' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "Custom icon URL used for 'whiteboard hide' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "Custom icon URL used for 'wifi1 bar' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "Custom icon URL used for 'wifi2 bars' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "Custom icon URL used for 'wifi3 bars' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Yahoo": "Custom icon URL used for 'yahoo' in the meeting interface.",
          "Sharing Center - Meeting theme palette - Action01": "Primary CTA buttons, active switch/checkbox states, and accents in notifications/indicators/file sharing/polls.",
          "Sharing Center - Meeting theme palette - Action01 Active": "Active/pressed state for primary web buttons.",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Hover state for primary buttons; selection outline in context menus, filmstrip, and settings previews.",
          "Sharing Center - Meeting theme palette - Action02": "Secondary buttons/chips, new-messages button, participants/lobby actions, and prejoin secondary actions.",
          "Sharing Center - Meeting theme palette - Action02 Active": "Active state for secondary buttons (including new-messages).",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Hover state for secondary buttons and chat action buttons.",
          "Sharing Center - Meeting theme palette - Action03": "Subtle icon buttons/chips, input action chips, chat message actions, and country picker rows.",
          "Sharing Center - Meeting theme palette - Action03 Active": "Pressed state for subtle web button.",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Hover state for subtle button/rows.",
          "Sharing Center - Meeting theme palette - Action Danger": "Actions with major impact, such as hang up/end meeting or delete.",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Pressed state for danger button.",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Hover state for danger button.",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled state for buttons and disabled action containers.",
          "Sharing Center - Meeting theme palette - Field01": "Background/accent for form fields (including Salesforce, speaker stats search, and recording controls).",
          "Sharing Center - Meeting theme palette - Focus01": "Focus outline for input/select/button/switch/tabs.",
          "Sharing Center - Meeting theme palette - Icon01": "Default icon color for most icons (toolbox, chat, participants, filmstrip, welcome).",
          "Sharing Center - Meeting theme palette - Icon02": "Secondary icon background accents (chat/filmstrip).",
          "Sharing Center - Meeting theme palette - Icon03": "Disabled/secondary icons (checkbox/select disabled, captions, polls, file sharing).",
          "Sharing Center - Meeting theme palette - Icon04": "Icons on light/colored badges and labels (raised hand, notifications, toolbar counters).",
          "Sharing Center - Meeting theme palette - Icon Error": "Error icons in connection indicators, notifications, recording, and mic error states.",
          "Sharing Center - Meeting theme palette - Link01": "Clickable links in chat/dialogs/deeplinking/polls/settings/welcome.",
          "Sharing Center - Meeting theme palette - Link01 Active": "Active state for links and some mobile/nav action accents.",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Hover state for links in connection stats/invite/recording/subtitles.",
          "Sharing Center - Meeting theme palette - Success01": "Success indicators (connection OK, audio preview OK, success notifications, prejoin status).",
          "Sharing Center - Meeting theme palette - Success02": "Secondary success badges/labels (including copy/speaker stats).",
          "Sharing Center - Meeting theme palette - Support01": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support02": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support03": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support04": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support05": "Chat accent color (message/recipient highlights).",
          "Sharing Center - Meeting theme palette - Support06": "Second chat accent color (recipient/status accent).",
          "Sharing Center - Meeting theme palette - Support07": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support08": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support09": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Text01": "Main text color across almost all screens and core components.",
          "Sharing Center - Meeting theme palette - Text02": "Subtext/placeholder/supporting labels.",
          "Sharing Center - Meeting theme palette - Text03": "Less prominent or disabled text, helper text, and secondary labels.",
          "Sharing Center - Meeting theme palette - Text04": "Text on light/colored backgrounds (warning badges, secondary surfaces).",
          "Sharing Center - Meeting theme palette - Text Error": "Validation and error texts (including input/select errors and notification error text).",
          "Sharing Center - Meeting theme palette - Ui01": "Primary surfaces of panels/dialogs/lists in the app and side panels.",
          "Sharing Center - Meeting theme palette - Ui02": "Hover/selected surfaces and elevated panel sections.",
          "Sharing Center - Meeting theme palette - Ui03": "Input/select backgrounds, separators, borders, and submenu surfaces.",
          "Sharing Center - Meeting theme palette - Ui04": "Light borders/backgrounds for badges, menu borders, and chips.",
          "Sharing Center - Meeting theme palette - Ui05": "Inactive tracks/borders (switch/tabs/connection/polls/forms).",
          "Sharing Center - Meeting theme palette - Ui06": "Dark outlines/separators (mobile nav, sliders, recording/polls).",
          "Sharing Center - Meeting theme palette - Ui07": "Strong divider/border color in native dialogs/lists/menus.",
          "Sharing Center - Meeting theme palette - Ui08": "Neutral button fill (used sparingly, mainly native button style).",
          "Sharing Center - Meeting theme palette - Ui09": "Subtle info/highlight background (labels, speaker stats, recording tags).",
          "Sharing Center - Meeting theme palette - Ui10": "Active tab/notification/chip/track backgrounds and accent blocks.",
          "Sharing Center - Meeting theme palette - Ui Background": "General page/screen background (base canvas of the app and large containers).",
          "Sharing Center - Meeting theme palette - Warning01": "Warning badges/indicators/notifications (prejoin, connection, dial-in limits).",
          "Sharing Center - Meeting theme palette - Warning02": "Raised-hand/highlight warning badges in filmstrip/participants/recording/visitors."
        },
        "Placeholder": {},
        "Tooltip": {
          "Customer logo": "Upload a logo.",
          "Customer logo (mark)": "The logo (mark) in square.",
          "Portal name": "The name used for the portal, emails, and communication.",
          "Support email address": "The support email address used for portal communication.",
          "Customer signature for emails": "Use the customer signature and contact details in authentication emails.",
          "Primary color": "The primary color used in the portal.",
          "MFA enabled": "Enable multi-factor authentication (MFA).",
          "MFA primary method": "Choose the primary multi-factor authentication (MFA) method.",
          "MFA fallback methods": "Choose one or more fallback multi-factor authentication (MFA) methods.",
          "Default customer": "Select a default customer when you log in.",
          "Top bar state": "Set the default state for the top bar.",
          "Top bar state iframe": "Set the default state for the top bar when running embedded (iframe).",
          "Left menu state": "Set the default state for the left menu.",
          "Left menu state iframe": "Set the default state for the left menu when running embedded (iframe).",
          "Show left menu items in second menu": "Show menu items from the left menu in the second menu. Useful when the left menu is hidden or as shortcuts within embedded products.",
          "Show left menu items in second menu iframe": "Show menu items from the left menu in the second menu when running embedded (iframe). Useful when the left menu is hidden or as shortcuts within embedded products.",
          "AI agent": "Choose which AI agent is available.",
          "AI agent settings": "JSON configuration for the selected AI agent.",
          "Whisper agent": "Choose which Whisper agent is available.",
          "Whisper agent settings": "JSON configuration for the selected Whisper agent.",
          "Sharing Center - Product name": "The product name used for mails and communication.",
          "Sharing Center - Default subject": "Set a default subject when you create a new appointment. You can always change it before saving.",
          "Sharing Center - ICS invite participant visibility": "Control what non-organizers can see in ICS invites.",
          "Sharing Center - ICS invite participant status visibility": "Control whether RSVP status is included in ICS invites.",
          "Sharing Center - Pre-join time": "Define how long before the start time participants are allowed to access the appointment.",
          "Sharing Center - Post-join time": "Define how long after the end time participants are still allowed to access the appointment.",
          "Sharing Center - Feedback questions": "Define which feedback questions are shown to participants after an appointment has ended.",
          "Sharing Center - Meeting max participants": "Set the maximum number of participants allowed in a meeting.",
          "Sharing Center - Meeting max participants live invite": "Invite participants during the meeting.",
          "Sharing Center - Meeting e2e enabled": "Allow end-to-end encryption to be used in meetings.",
          "Sharing Center - Meeting default e2e encrypted": "Enable end-to-end encryption by default when available.",
          "Sharing Center - Meeting p2p enabled": "Enable peer-to-peer mode for small meetings.",
          "Sharing Center - Meeting p2p max participants": "Set the maximum number of participants for peer-to-peer mode.",
          "Sharing Center - Meeting auto transcriptions enabled": "Automatically process available meeting recordings into transcripts for this customer.",
          "Sharing Center - Meeting auto AI minutes enabled": "Automatically generate AI minutes when a transcript is available for this customer.",
          "Sharing Center - Meeting default AI minutes hidden prompt": "Default hidden prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt": "Default prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt NL": "Default Dutch prompt for AI minutes in meetings.",
          "Sharing Center - Meeting default AI minutes prompt EN": "Default English prompt for AI minutes in meetings.",
          "Sharing Center - Features agents": "Enable features to use in the meeting for agents.",
          "Sharing Center - Features guests": "Enable features to use in the meeting for guests.",
          "Sharing Center - Meeting chat smileys disabled": "Disable smileys in the meeting chat.",
          "Sharing Center - Meeting breakout rooms hidden buttons": "Select which breakout room buttons are hidden.",
          "Sharing Center - Meeting notifications disabled": "Select which meeting notifications are disabled.",
          "Sharing Center - Meeting notifications disabled guests": "Select which meeting notifications are disabled for guests.",
          "Sharing Center - Meeting sounds disabled": "Select which meeting sounds are disabled.",
          "Sharing Center - Meeting sounds disabled guests": "Select which meeting sounds are disabled for guests.",
          "Sharing Center - Meeting remote video menu enabled": "Enable or disable the participant video menu in meetings.",
          "Sharing Center - Meeting remote video menu disabled actions": "Select which participant video menu actions are hidden.",
          "Sharing Center - Meeting remote video menu private chat": "Select how private chat is restricted from the participant video menu. None leaves the default unchanged.",
          "Sharing Center - Meeting participants pane enabled": "Enable or disable the participants pane in meetings.",
          "Sharing Center - Meeting participants pane hidden items": "Select which participants pane items are hidden.",
          "Sharing Center - Meeting lobby enabled": "Enable or disable the meeting lobby.",
          "Sharing Center - Meeting lobby auto knock": "Automatically let participants knock when the lobby is enabled.",
          "Sharing Center - Meeting lobby chat enabled": "Allow chat on the lobby screen.",
          "Sharing Center - Meeting lobby bypass": "Select who can bypass the meeting lobby. This setting is also applied when the lobby is enabled during the meeting.",
          "Sharing Center - Meeting prejoin screen": "Control whether the prejoin screen is shown for agents and guests.",
          "Sharing Center - Meeting handoff": "Control whether participants can hand off an active meeting to another device. If disabled, joining from another device is blocked.",
          "Sharing Center - Meeting filmstrip": "Control whether the filmstrip is shown for agents and guests.",
          "Sharing Center - Tileview enabled": "Enable tile view when three or more participants have joined the meeting.",
          "Sharing Center - Number of visible tiles": "Set the optimal number of tiles shown in tile view. Depending on screen size, the exact number may vary.",
          "Sharing Center - Tileview enabled guests": "Enable tile view for guests when three or more participants have joined the meeting.",
          "Sharing Center - Number of visible tiles guests": "Set the optimal number of tiles shown in tile view for guests. Depending on screen size, the exact number may vary.",
          "Sharing Center - Meeting toolbar always visible": "Keep the meeting toolbar visible instead of auto-hiding it.",
          "Sharing Center - Meeting toolbar initial timeout": "Set how long the meeting toolbar stays visible after joining, in seconds.",
          "Sharing Center - Meeting toolbar timeout": "Set how long the meeting toolbar stays visible after user interaction, in seconds.",
          "Sharing Center - Meeting hidden conference info": "Select which conference information is hidden in the meeting UI.",
          "Sharing Center - Meeting mute microphone": "Mute your microphone by default when you start a meeting.",
          "Sharing Center - Meeting mute microphone guests": "Mute your microphone by default when guests start a meeting.",
          "Sharing Center - Meeting camera off": "Turn off your camera by default when you start a meeting.",
          "Sharing Center - Meeting camera off guests": "Turn off your camera by default when guests start a meeting.",
          "Sharing Center - Meeting camera facing mode": "Select which camera is preferred when you start a meeting.",
          "Sharing Center - Meeting camera facing mode guests": "Select which camera is preferred when guests start a meeting.",
          "Sharing Center - Meeting initial media request": "Control whether camera/microphone access is requested immediately when joining a meeting.",
          "Sharing Center - Meeting force my video on stage": "Pin your own video on stage by default when joining a meeting.",
          "Sharing Center - Meeting base URL": "The base URL of the server used for OMNI Sessions meetings.",
          "Sharing Center - Meeting app ID": "The application ID used to authenticate with the meeting server.",
          "Sharing Center - Meeting app secret": "The secret key used to securely sign authentication tokens.",
          "Sharing Center - Meeting audience": "The audience (aud) claim used when generating authentication tokens.",
          "Sharing Center - Meeting subject": "The subject (sub) claim used when generating authentication tokens.",
          "Sharing Center - Meeting background color": "Primary background color used throughout the meeting interface.",
          "Sharing Center - Meeting background image URL": "Background image displayed behind the meeting interface.",
          "Sharing Center - Meeting DID page URL": "URL used for call-in or DID information associated with the meeting.",
          "Sharing Center - Meeting invite domain": "Domain used when generating meeting invitation links.",
          "Sharing Center - Meeting logo click URL": "URL opened when clicking the meeting logo.",
          "Sharing Center - Meeting logo image URL": "Logo image displayed in the meeting interface.",
          "Sharing Center - Meeting avatar backgrounds": "List of background images used behind participant avatars.",
          "Sharing Center - Meeting pre-meeting background": "Background shown in the pre-meeting lobby or waiting room.",
          "Sharing Center - Meeting disable virtual backgrounds": "Disable virtual backgrounds in the meeting interface.",
          "Sharing Center - Meeting disable adding background images": "Prevent users from adding their own background images during the meeting.",
          "Sharing Center - Meeting custom virtual background 1": "Virtual background 1 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 2": "Virtual background 2 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 3": "Virtual background 3 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 4": "Virtual background 4 available during the meeting.",
          "Sharing Center - Meeting custom virtual background 5": "Virtual background 5 available during the meeting.",
          "Sharing Center - Meeting virtual backgrounds": "List of custom virtual backgrounds available during the meeting.",
          "Sharing Center - Meeting virtual backgrounds include defaults": "When enabled, the default virtual backgrounds are included alongside custom ones.",
          "Sharing Center - Meeting user documentation URL": "URL opened by the Help button in the meeting overflow menu.",
          "Sharing Center - Meeting download apps URL": "URL opened by the Download our apps button in the meeting overflow menu.",
          "Sharing Center - Meeting translations": "JSON configuration used to override UI labels and text in the meeting interface.",
          "Sharing Center - Meeting CSS": "CSS overrides applied to the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Add User": "Custom icon URL used for 'add user' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Back": "Custom icon URL used for 'arrow back' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down": "Custom icon URL used for 'arrow down' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Down Large": "Custom icon URL used for 'arrow down large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Left": "Custom icon URL used for 'arrow left' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up": "Custom icon URL used for 'arrow up' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Up Large": "Custom icon URL used for 'arrow up large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only": "Custom icon URL used for 'audio only' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Audio Only Off": "Custom icon URL used for 'audio only off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Bluetooth": "Custom icon URL used for 'bluetooth' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Bell": "Custom icon URL used for 'bell' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Calendar": "Custom icon URL used for 'calendar' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Camera Refresh": "Custom icon URL used for 'camera refresh' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Car": "Custom icon URL used for 'car' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Chat Unread": "Custom icon URL used for 'chat unread' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Check": "Custom icon URL used for 'check' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Close Circle": "Custom icon URL used for 'close circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Close Large": "Custom icon URL used for 'close large' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Cloud Upload": "Custom icon URL used for 'cloud upload' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Code": "Custom icon URL used for 'code' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Connection": "Custom icon URL used for 'connection' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Connection Inactive": "Custom icon URL used for 'connection inactive' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Copy": "Custom icon URL used for 'copy' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Device Headphone": "Custom icon URL used for 'device headphone' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Dots Horizontal": "Custom icon URL used for 'dots horizontal' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Download": "Custom icon URL used for 'download' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon E2EE": "Custom icon URL used for 'e2ee' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Edit": "Custom icon URL used for 'edit' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Enlarge": "Custom icon URL used for 'enlarge' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Enter Fullscreen": "Custom icon URL used for 'enter fullscreen' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Envelope": "Custom icon URL used for 'envelope' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Angry": "Custom icon URL used for 'emotions angry' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Disgusted": "Custom icon URL used for 'emotions disgusted' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Fearful": "Custom icon URL used for 'emotions fearful' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Happy": "Custom icon URL used for 'emotions happy' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Neutral": "Custom icon URL used for 'emotions neutral' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Sad": "Custom icon URL used for 'emotions sad' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Emotions Surprised": "Custom icon URL used for 'emotions surprised' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Solid": "Custom icon URL used for 'exclamation solid' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exclamation Triangle": "Custom icon URL used for 'exclamation triangle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Exit Fullscreen": "Custom icon URL used for 'exit fullscreen' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Face Smile": "Custom icon URL used for 'face smile' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Favorite": "Custom icon URL used for 'favorite' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Favorite Solid": "Custom icon URL used for 'favorite solid' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Feedback": "Custom icon URL used for 'feedback' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Gear": "Custom icon URL used for 'gear' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Google": "Custom icon URL used for 'google' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Hangup": "Custom icon URL used for 'hangup' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Help": "Custom icon URL used for 'help' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Highlight": "Custom icon URL used for 'highlight' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Image": "Custom icon URL used for 'image' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Info": "Custom icon URL used for 'info' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Info Circle": "Custom icon URL used for 'info circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Message": "Custom icon URL used for 'message' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Meter": "Custom icon URL used for 'meter' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Mic": "Custom icon URL used for 'mic' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Mic Slash": "Custom icon URL used for 'mic slash' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Moderator": "Custom icon URL used for 'moderator' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression Off": "Custom icon URL used for 'noise suppression off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Noise Suppression On": "Custom icon URL used for 'noise suppression on' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Arrow Right": "Custom icon URL used for 'arrow right' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Office365": "Custom icon URL used for 'office365' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Performance": "Custom icon URL used for 'performance' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Phone Ringing": "Custom icon URL used for 'phone ringing' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Pin": "Custom icon URL used for 'pin' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Pinned": "Custom icon URL used for 'pinned' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Play": "Custom icon URL used for 'play' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Plus": "Custom icon URL used for 'plus' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Raise Hand": "Custom icon URL used for 'raise hand' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record": "Custom icon URL used for 'record' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Account": "Custom icon URL used for 'record account' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Contact": "Custom icon URL used for 'record contact' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Lead": "Custom icon URL used for 'record lead' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Record Opportunity": "Custom icon URL used for 'record opportunity' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Start": "Custom icon URL used for 'remote control start' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Remote Control Stop": "Custom icon URL used for 'remote control stop' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Reply": "Custom icon URL used for 'reply' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Restore": "Custom icon URL used for 'restore' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Ring Group": "Custom icon URL used for 'ring group' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Screenshare": "Custom icon URL used for 'screenshare' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Search": "Custom icon URL used for 'search' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Security Off": "Custom icon URL used for 'security off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Security On": "Custom icon URL used for 'security on' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Send": "Custom icon URL used for 'send' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Share": "Custom icon URL used for 'share' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Share Doc": "Custom icon URL used for 'share doc' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Shortcuts": "Custom icon URL used for 'shortcuts' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon SIP": "Custom icon URL used for 'sip' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Sites": "Custom icon URL used for 'sites' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Stop": "Custom icon URL used for 'stop' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Subtitles": "Custom icon URL used for 'subtitles' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Tile View": "Custom icon URL used for 'tile view' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Trash": "Custom icon URL used for 'trash' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon User Deleted": "Custom icon URL used for 'user deleted' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Users": "Custom icon URL used for 'users' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon User": "Custom icon URL used for 'user' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Video": "Custom icon URL used for 'video' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Video Off": "Custom icon URL used for 'video off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Volume Off": "Custom icon URL used for 'volume off' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Volume Up": "Custom icon URL used for 'volume up' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Warning": "Custom icon URL used for 'warning' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Warning Circle": "Custom icon URL used for 'warning circle' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard": "Custom icon URL used for 'whiteboard' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Whiteboard Hide": "Custom icon URL used for 'whiteboard hide' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi1 Bar": "Custom icon URL used for 'wifi1 bar' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi2 Bars": "Custom icon URL used for 'wifi2 bars' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Wifi3 Bars": "Custom icon URL used for 'wifi3 bars' in the meeting interface.",
          "Sharing Center - Meeting custom icons - icon Yahoo": "Custom icon URL used for 'yahoo' in the meeting interface.",
          "Sharing Center - Meeting theme palette - Action01": "Primary CTA buttons, active switch/checkbox states, and accents in notifications/indicators/file sharing/polls.",
          "Sharing Center - Meeting theme palette - Action01 Active": "Active/pressed state for primary web buttons.",
          "Sharing Center - Meeting theme palette - Action01 Hover": "Hover state for primary buttons; selection outline in context menus, filmstrip, and settings previews.",
          "Sharing Center - Meeting theme palette - Action02": "Secondary buttons/chips, new-messages button, participants/lobby actions, and prejoin secondary actions.",
          "Sharing Center - Meeting theme palette - Action02 Active": "Active state for secondary buttons (including new-messages).",
          "Sharing Center - Meeting theme palette - Action02 Hover": "Hover state for secondary buttons and chat action buttons.",
          "Sharing Center - Meeting theme palette - Action03": "Subtle icon buttons/chips, input action chips, chat message actions, and country picker rows.",
          "Sharing Center - Meeting theme palette - Action03 Active": "Pressed state for subtle web button.",
          "Sharing Center - Meeting theme palette - Action03 Hover": "Hover state for subtle button/rows.",
          "Sharing Center - Meeting theme palette - Action Danger": "Actions with major impact, such as hang up/end meeting or delete.",
          "Sharing Center - Meeting theme palette - Action Danger Active": "Pressed state for danger button.",
          "Sharing Center - Meeting theme palette - Action Danger Hover": "Hover state for danger button.",
          "Sharing Center - Meeting theme palette - Disabled01": "Disabled state for buttons and disabled action containers.",
          "Sharing Center - Meeting theme palette - Field01": "Background/accent for form fields (including Salesforce, speaker stats search, and recording controls).",
          "Sharing Center - Meeting theme palette - Focus01": "Focus outline for input/select/button/switch/tabs.",
          "Sharing Center - Meeting theme palette - Icon01": "Default icon color for most icons (toolbox, chat, participants, filmstrip, welcome).",
          "Sharing Center - Meeting theme palette - Icon02": "Secondary icon background accents (chat/filmstrip).",
          "Sharing Center - Meeting theme palette - Icon03": "Disabled/secondary icons (checkbox/select disabled, captions, polls, file sharing).",
          "Sharing Center - Meeting theme palette - Icon04": "Icons on light/colored badges and labels (raised hand, notifications, toolbar counters).",
          "Sharing Center - Meeting theme palette - Icon Error": "Error icons in connection indicators, notifications, recording, and mic error states.",
          "Sharing Center - Meeting theme palette - Link01": "Clickable links in chat/dialogs/deeplinking/polls/settings/welcome.",
          "Sharing Center - Meeting theme palette - Link01 Active": "Active state for links and some mobile/nav action accents.",
          "Sharing Center - Meeting theme palette - Link01 Hover": "Hover state for links in connection stats/invite/recording/subtitles.",
          "Sharing Center - Meeting theme palette - Success01": "Success indicators (connection OK, audio preview OK, success notifications, prejoin status).",
          "Sharing Center - Meeting theme palette - Success02": "Secondary success badges/labels (including copy/speaker stats).",
          "Sharing Center - Meeting theme palette - Support01": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support02": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support03": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support04": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support05": "Chat accent color (message/recipient highlights).",
          "Sharing Center - Meeting theme palette - Support06": "Second chat accent color (recipient/status accent).",
          "Sharing Center - Meeting theme palette - Support07": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support08": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Support09": "Currently not mapped in colorMap and not used.",
          "Sharing Center - Meeting theme palette - Text01": "Main text color across almost all screens and core components.",
          "Sharing Center - Meeting theme palette - Text02": "Subtext/placeholder/supporting labels.",
          "Sharing Center - Meeting theme palette - Text03": "Less prominent or disabled text, helper text, and secondary labels.",
          "Sharing Center - Meeting theme palette - Text04": "Text on light/colored backgrounds (warning badges, secondary surfaces).",
          "Sharing Center - Meeting theme palette - Text Error": "Validation and error texts (including input/select errors and notification error text).",
          "Sharing Center - Meeting theme palette - Ui01": "Primary surfaces of panels/dialogs/lists in the app and side panels.",
          "Sharing Center - Meeting theme palette - Ui02": "Hover/selected surfaces and elevated panel sections.",
          "Sharing Center - Meeting theme palette - Ui03": "Input/select backgrounds, separators, borders, and submenu surfaces.",
          "Sharing Center - Meeting theme palette - Ui04": "Light borders/backgrounds for badges, menu borders, and chips.",
          "Sharing Center - Meeting theme palette - Ui05": "Inactive tracks/borders (switch/tabs/connection/polls/forms).",
          "Sharing Center - Meeting theme palette - Ui06": "Dark outlines/separators (mobile nav, sliders, recording/polls).",
          "Sharing Center - Meeting theme palette - Ui07": "Strong divider/border color in native dialogs/lists/menus.",
          "Sharing Center - Meeting theme palette - Ui08": "Neutral button fill (used sparingly, mainly native button style).",
          "Sharing Center - Meeting theme palette - Ui09": "Subtle info/highlight background (labels, speaker stats, recording tags).",
          "Sharing Center - Meeting theme palette - Ui10": "Active tab/notification/chip/track backgrounds and accent blocks.",
          "Sharing Center - Meeting theme palette - Ui Background": "General page/screen background (base canvas of the app and large containers).",
          "Sharing Center - Meeting theme palette - Warning01": "Warning badges/indicators/notifications (prejoin, connection, dial-in limits).",
          "Sharing Center - Meeting theme palette - Warning02": "Raised-hand/highlight warning badges in filmstrip/participants/recording/visitors."
        },
        "Help": {}
      }
    },
    "Unsubscribe-mail": {
      "The email address has been successfully unsubscribed": "The email address {email} has been successfully unsubscribed.",
      "The link is invalid": "The link is invalid."
    },
    "Users": {
      "After Authenticator QR scan": "After scanning the QR code, click {0}.",
      "After install authenticator next": "After installing the Authenticator app on your device, click {0}.",
      "After setup authenticator account next": "When you're ready to continue, click {0}.",
      "Active sessions": "Active sessions",
      "Active sessions description": "Manage your active login sessions per device.",
      "All sessions revoked": "All active sessions were revoked.",
      "Assigned roles": "Assigned roles",
      "Authenticator allow notifications": "When prompted, allow notifications.",
      "Authenticator select other account": "Then add an account. When using the Microsoft Authenticator app, make sure you select \"Other account\".",
      "Avatar": "Choose photo",
      "Avatar item": "Photo",
      "Avatar item fail": "Photo could not be updated",
      "Avatar item success": "Photo successfully updated",
      "Back to login": "Back to login",
      "Back to password reset request": "Request a new password",
      "Capslock enabled": "Note: caps lock key is enabled",
      "Profile photo": "Profile photo",
      "Change photo": "Change photo",
      "Change view": "Change view",
      "Confirm identity fail": "Error confirming user.",
      "Confirm identity success": "User {fullName} confirmed.",
      "Delete": "delete",
      "Delete item": "Delete user",
      "Delete item fail": "Error while deleting the user.",
      "Delete item success": "User {fullName} successfully deleted.",
      "Delete item text": "Are you sure you want to {1} the account for {0}?",
      "Delete user": "Delete user",
      "Delete user fail": "The user could not be deleted.",
      "Delete user success": "User {fullName} successfully deleted.",
      "Delete user text": "Are you sure you want to {1} the account for {0}?",
      "Download Authenticator app": "Download Authenticator app",
      "Download authenticator first": "Download the app first",
      "Edit item": "Edit user",
      "Edit item email fail": "Error requesting email address change.",
      "Edit item fail": "Error editing user.",
      "Edit item fail email": "Current password is incorrect.",
      "Edit item fail profile": "Error while changing profile.",
      "Edit item profile": "Edit profile",
      "Edit item success": "User {fullName} changed.",
      "Edit item success password": "Password is changed.",
      "Edit item success profile": "Profile is changed.",
      "Edit user": "Edit user",
      "Edit user email fail": "Error requesting email address change.",
      "Edit user fail": "Error while changing user.",
      "Edit user success": "User {fullName} successfully changed.",
      "Email": "Email address",
      "Email address change": "Change email address",
      "Email change": "Please confirm the new e-mail address, in order the finalize the change.",
      "Email change success": "The @.lower:Shared.Users.Email has been confirmed.",
      "Email check": "Check the email address.",
      "Email edit": "Click on the pencil icon to change the email address.",
      "Email edit header": "Below you can change the email address.",
      "Email edit message": "{0}: The new email address needs to be confirmed. Follow the instructions in the email that has been sent to the new email address.",
      "Email in use": "Given email address is already in use.",
      "Email invalid": "Email address is invalid.",
      "Email mandatory": "Email address is mandatory.",
      "Error loading data": "User data could not be loaded due to an error.",
      "Errors": {
        "ErrorCode": {
          "TOTP_DEVICE_NAME_MISSING": "Device name is required.",
          "TOTP_TOKEN_INVALID": "Code is invalid."
        }
      },
      "First name": "First name",
      "First name mandatory": "First name is required.",
      "FirstName": "First name",
      "FirstName mandatory": "First name is required.",
      "Forgot": "Forgot password",
      "Help login": "Need help logging in?",
      "Full name": "Full name",
      "Install authenticator on phone": "Install the {0} app or the {1} app on your phone.",
      "IsSSO": "Using SSO?",
      "IsVerified": "Account verified?",
      "Keep me logged in": "Keep me logged in",
      "Last name": "Last name",
      "Last name mandatory": "Last name is required.",
      "LastActivity": "Last activity",
      "LastLoginAt": "Last logon",
      "LastName": "Last name",
      "LastName mandatory": "Last name is required.",
      "Locale": "Locale",
      "LocaleOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Login": "Login",
      "Login failed": "The username/password combination is incorrect.",
      "Login with Microsoft": "Login with Microsoft",
      "Login with SSO": "Login with SSO",
      "Lost MFA code?": "Lost your code?",
      "Manually add code": "Or add the code manually to the Authenticator app.",
      "Mark self": "You",
      "MFA enter code": "Enter the code that is displayed in the Authenticator app.",
      "MFA lost code": "Please send an email to {0} requesting the removal of your security settings. For your safety, we will need to verify your identity to complete this process. To ensure the process goes smoothly, we request that you send the email preferably from the same email address and include your customer number.",
      "MFA lost code after setup": "If you lose the code, please send an email to {0} requesting the removal of your security settings. For your safety, we will need to verify your identity to complete this process. To ensure the process goes smoothly, we request that you send the email preferably from the same email address and include your customer number.",
      "MFA code resent": "A new code has been sent.",
      "MFA setup code send failed": "Unable to send the verification code. Please try again.",
      "MFA resend cooldown": "Try again in {seconds}s.",
      "MFA resend blocked": "Try again in {time}.",
      "MFA session expired": "Your session has expired. Please sign in again to continue.",
      "MFA setup completed": "Completed!",
      "MFA setup completed text": "You have successfully setup your security info. Choose {0} to continue signing in.",
      "MFA Status": "MFA Status",
      "MFA verify failed": "The provided code is invalid.",
      "New item": "New user",
      "New item fail": "Error while creating the new user. {msg}",
      "New item success": "User {fullName} successfully created.",
      "New user": "Add user",
      "New user fail": "User creation error. {msg}",
      "New user success": "User {fullName} successfully created.",
      "No login methods configured": "No login method has been configured for this domain.",
      "Password": "Password",
      "Password change": "Change password",
      "Password change message": "{0}: To change your password, enter your old password and then your new password twice.",
      "Password change set": "Enter your desired password and confirm it.",
      "Password checks": {
        "At least n Characters": "Password is at least {n} characters long.",
        "Contains numbers": "Contains at least one number.",
        "Contains special char": "Contains at least one special character.",
        "Contains uppercase": "Contains at least one uppercase character.",
        "Digits": "The string should have a minimum of 1 digit.",
        "Lowercase": "The string should have a minimum of 1 lowercase letter.",
        "Min": "The string should have a minimum length of {n} characters.",
        "Not_same": "New passwords are not the same.",
        "Passwords different then old password": "Password is not equal to the current password.",
        "Passwords equal": "Both passwords are equal.",
        "Same_old": "New password is the same as the old password.",
        "Symbols": "The string should have a minimum of 1 symbol.",
        "Uppercase": "The string should have a minimum of 1 uppercase letter."
      },
      "Password confirm": "Confirm password",
      "Password current": "Current password",
      "Password fail": "Check your password.",
      "Password mandatory": "Password is mandatory.",
      "Password new": "New password",
      "Password reset": "Reset Password",
      "Password reset fail": "Password reset request failed. {msg}",
      "Password reset new text": "Please enter the new password below.",
      "Password reset request success": "An email for password recovery has been sent to {email}.",
      "Password reset success": "The password has been changed successfully.",
      "Password reset text": "Enter your email address to reset your password.",
      "Password reset token invalid": "The link is invalid or has expired.",
      "Refresh list": "Refresh user list",
      "Revoke": "Revoke",
      "Revoke all sessions": "Revoke all sessions",
      "Revoke all sessions text": "Are you sure you want to revoke all active sessions?",
      "Revoke session": "Revoke session",
      "Revoke session text": "Are you sure you want to revoke this session?",
      "Session created at": "Created",
      "Session OS": "OS",
      "Session Browser": "Browser",
      "Session Device": "Device",
      "Session device": "Device",
      "Session expires at": "Expires at",
      "Session expires at info": "This time is automatically extended while you are active, up to the maximum lifetime.",
      "Session list load fail": "Unable to load active sessions.",
      "Session max lifetime": "Max lifetime",
      "Session max lifetime info": "To prevent sessions from remaining active indefinitely, they expire after the maximum lifetime and users must sign in again.",
      "Session revoked": "Session was revoked.",
      "IP address": "IP address",
      "Phone": "Phone",
      "RegionalSettings": "Regional settings",
      "RegionalSettingsOptions": {
        "En-US": "@:Shared.Globals.Languages.English",
        "Nl-NL": "@:Shared.Globals.Languages.Dutch"
      },
      "Request forgot": "Request",
      "Resend invite": "Resend invite",
      "Resend invite button": "Resend invite",
      "Resend invite text": "Are you sure you want to resend the invitation to {fullName}?",
      "Resend MFA code": "Resend code",
      "ResendInvite": "Resend invite",
      "ResendInvite item success": "The invitation has been resent.",
      "Reset mfa": "Reset MFA",
      "Reset MFA text": "Are you sure you want to reset Multi-Factor Authentication (MFA) for {fullName}?",
      "ResetMFA": "Reset MFA",
      "ResetMFA item success": "Successfully reset MFA.",
      "Roles": "Role(s)",
      "Roles mandatory": "Setting least one role is mandatory.",
      "Scan QR code": "Scan the QR code",
      "Set password": "Set password",
      "Setup authenticator account": "Setup authenticator account",
      "Setup your authenticator account": "Setup your account",
      "SSO Microsoft": "Login using {0} Microsoft",
      "Totp device name": "Device naam",
      "Trust MFA device": "Trust this device for {days} days",
      "Use another MFA method": "Use another method",
      "Use Authenticator app to scan QR code": "Use the Authenticator app to scan the QR code. This will connect the Authenticator app with your account.",
      "User": "User",
      "Value": "Picture",
      "Verify": "Verify",
      "Verify code": "Verify the code",
      "Choose MFA method": "Choose another verification method",
      "Choose MFA method text": "Select how you want to confirm your login.",
      "Verify MFA": "Verify code",
      "MFA method authenticator": "Authenticator app",
      "MFA method authenticator description": "Use a code from your Authenticator app",
      "MFA method authenticator setup description": "Set up the Authenticator app and then use a code",
      "MFA method email": "Email",
      "MFA method email description": "Receive a code by email",
      "MFA method sms": "SMS",
      "MFA method sms description": "Receive a code by SMS",
      "Verify MFA text authenticator": "Please confirm your login by entering the code displayed in your Authenticator app on your device.",
      "Verify MFA text email": "Please confirm your login by entering the code sent to your email address.",
      "Verify MFA setup text email": "Please confirm your login by entering the code sent to your email address.",
      "Verify MFA text sms": "Please confirm your login by entering the code sent by SMS.",
      "Verify MFA text": "Please confirm your login by entering the code displayed in your Authenticator app on your device.",
      "Verify token invalid": "The link is invalid or has expired."
    },
    "OverviewCards": {
      "openPurchaseOrders": "To be ordered",
      "awaitingPurchaseOrders": "Awaiting delivery",
      "overduePurchaseOrders": "Delivery date passed",
      "reservedStock": "Reserved",
      "availableStock": "Available",
      "stockProductCount": "{count} distinct product | {count} distinct products",
      "reservedAssets": "Reserved",
      "supplierWarrantiesExpiring": "Supplier warranty expires within 30 days",
      "customerWarrantiesExpiring": "Customer warranty expires within 30 days",
      "totals": {
        "stock": "Total on hand"
      },
      "totalHints": {
        "stock": "Total units on hand across all locations and bins, including reserved stock and customer stock."
      },
      "archived": "Archived",
      "runningContracts": "Current contracts",
      "endingContracts": "End date within 30 days",
      "licenseProducts": "License products",
      "hostingProducts": "Hosting products",
      "bundles": "Product bundles",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "cancelled": "Cancelled",
      "sso": "SSO sign-in",
      "verified": "Activation confirmed",
      "unverified": "Activation unconfirmed",
      "regularUsers": "Personal accounts",
      "virtualUsers": "Virtual accounts",
      "apiAccounts": "API accounts",
      "receivesMail": "Receives email",
      "noMail": "Does not receive email",
      "customAddress": "Custom address",
      "draftInvoices": "Draft invoices",
      "openInvoices": "Open invoices",
      "overdueInvoices": "Past due",
      "autoRenew": "Automatic renewal",
      "noAutoRenew": "No automatic renewal",
      "quarantine": "In quarantine",
      "wildcard": "Wildcard certificates",
      "domainValidated": "Domain validated",
      "renewSoon": "Renewal within 30 days",
      "openTasks": "Open tasks",
      "startedTasks": "In progress",
      "doneTasks": "Completed tasks",
      "sent": "Sent",
      "notSent": "Not sent",
      "lastDay": "Last 24 hours",
      "delivered": "Delivered",
      "online": "Online",
      "offline": "Offline",
      "defaultGateway": "Default gateway",
      "loadFailed": "The totals could not be loaded. The table remains available.",
      "active": "Active",
      "withDefaultContract": "With default contract",
      "recentlyCreated": "Added in 30 days",
      "recentlyUpdated": "Updated in 7 days",
      "withRoles": "With roles",
      "withContract": "With contract",
      "withSupplierContract": "With contract agreement",
      "invoicedEntries": "Invoiced entries",
      "uninvoicedEntries": "Not yet invoiced",
      "queued": "Ready to send",
      "awaitingApproval": "Awaiting approval",
      "failed": "Failed",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "draftOffers": "Draft offers",
      "sentOffers": "Sent offers",
      "acceptedOffers": "Accepted offers",
      "activeHosting": "Active hosting",
      "pendingHosting": "Pending hosting",
      "suspendedHosting": "Suspended hosting",
      "publicProfiles": "Public profiles",
      "meetingProfiles": "Meeting profiles",
      "chatProfiles": "Chat profiles",
      "inbound": "Inbound calling",
      "outbound": "Outbound calling",
      "encryptedTransport": "Secured with TLS",
      "internalRoles": "Internal roles",
      "customerRoles": "Customer roles",
      "pendingInvitations": "Pending invitations",
      "acceptedInvitations": "Accepted invitations",
      "total": "Total {name}",
      "totalHint": "Total number of registered items.",
      "hints": {
        "openPurchaseOrders": "Purchase orders with status Open.",
        "awaitingPurchaseOrders": "Ordered or partially received purchase orders with quantities still outstanding.",
        "overduePurchaseOrders": "Ordered or partially received orders with an outstanding line whose expected delivery date is before today. A line date takes precedence over the order-wide expected delivery date.",
        "reservedStock": "Units on hand reserved for sales orders.",
        "availableStock": "Units on hand that are not reserved. Customer stock remains allocated to its customer.",
        "reservedAssets": "Present assets reserved for a sales order.",
        "supplierWarrantiesExpiring": "Assets with an active supplier warranty ending today or within 30 days. Written-off assets are excluded.",
        "customerWarrantiesExpiring": "Assets with a started customer warranty ending today or within 30 days. Written-off assets are excluded.",
        "runningContracts": "Contracts that have started and have not yet reached their end date.",
        "endingContracts": "Contracts ending within the next 30 days.",
        "licenseProducts": "Products offered as licenses.",
        "hostingProducts": "Products for web hosting.",
        "bundles": "Products that combine multiple items into a bundle.",
        "monthly": "Subscriptions with a monthly billing period.",
        "yearly": "Subscriptions with a yearly billing period.",
        "cancelled": "Subscriptions with a recorded cancellation.",
        "sso": "Users who sign in through Single Sign-On.",
        "verified": "Users who have confirmed their account activation.",
        "unverified": "Users who have not yet confirmed their account activation.",
        "regularUsers": "Personal accounts linked to a customer. An account may be linked to several customers.",
        "virtualUsers": "Virtual accounts linked to a customer, for example for a shared role.",
        "apiAccounts": "Accounts used for API access.",
        "receivesMail": "Contacts with email reception enabled.",
        "noMail": "Contacts with email reception disabled.",
        "customAddress": "Contacts using their own address instead of the related organisation's address.",
        "draftInvoices": "Invoices that are still in draft.",
        "openInvoices": "Issued invoices with an outstanding balance.",
        "autoRenew": "Domains with automatic renewal enabled.",
        "noAutoRenew": "Domains with automatic renewal disabled.",
        "quarantine": "Domains currently in quarantine.",
        "wildcard": "Certificates that secure multiple subdomains.",
        "domainValidated": "Certificates using domain validation (DV).",
        "renewSoon": "Certificates due for renewal within the next 30 days.",
        "openTasks": "Tasks that have not yet been started.",
        "startedTasks": "Tasks currently being worked on.",
        "doneTasks": "Tasks marked as completed.",
        "sent": "Messages with a recorded successful send.",
        "notSent": "Messages without a recorded successful send.",
        "lastDay": "Events from the past 24 hours.",
        "delivered": "SMS messages with confirmed delivery.",
        "online": "VPN certificates with an active connection.",
        "offline": "VPN certificates with an offline status.",
        "defaultGateway": "VPN certificates configured to use the VPN connection as the default gateway.",
        "active": "Items that have not been archived.",
        "withDefaultContract": "Active customers with a default contract configured.",
        "recentlyCreated": "Added in the past 30 days.",
        "recentlyUpdated": "Changed in the past 7 days.",
        "withRoles": "Accounts with at least one assigned role.",
        "withContract": "Projects linked to a contract.",
        "withSupplierContract": "Active suppliers with at least one recorded contract reference.",
        "invoicedEntries": "Time entries marked as invoiced.",
        "uninvoicedEntries": "Time entries not yet marked as invoiced.",
        "queued": "Approved emails awaiting sending. An earlier sending attempt may have failed.",
        "awaitingApproval": "Emails awaiting approval to send.",
        "failed": "Failed processing attempts. For email, the message has not yet been sent successfully.",
        "enabled": "Items enabled for use.",
        "disabled": "Items that are disabled.",
        "draftOffers": "Offers that are still in draft.",
        "sentOffers": "Offers with a sent status.",
        "acceptedOffers": "Offers that have been accepted.",
        "activeHosting": "Hosting accounts with an active status.",
        "pendingHosting": "Hosting accounts with a pending status.",
        "suspendedHosting": "Hosting accounts that have been suspended.",
        "publicProfiles": "Profiles that are publicly available.",
        "meetingProfiles": "Profiles used to schedule meetings.",
        "chatProfiles": "Profiles used for chat conversations.",
        "inbound": "Phone numbers enabled for incoming calls.",
        "outbound": "Phone numbers enabled for outgoing calls.",
        "encryptedTransport": "SIP accounts using TLS for secure signalling.",
        "internalRoles": "Roles for internal Vision users.",
        "customerRoles": "Roles for customer portal users.",
        "pendingInvitations": "Invitations that have not been accepted and are still valid.",
        "acceptedInvitations": "Invitations that have been accepted.",
        "archived": "Items retained in the archive.",
        "overdueInvoices": "Outstanding invoices whose payment deadline has passed.",
        "initializedBatches": "Direct debit batches awaiting file generation.",
        "generatedBatches": "Direct debit batches with a generated file.",
        "withoutRoles": "Accounts without assigned roles.",
        "recentAuditEvents": "Recorded activities from the past 24 hours.",
        "failedAuditEvents": "Activities with a recorded error.",
        "impersonatedAuditEvents": "Activities performed during user impersonation."
      },
      "selectionHint": "Statistics for the selected period and filters.",
      "initializedBatches": "Pending batches",
      "generatedBatches": "Processed batches",
      "withoutRoles": "Without roles",
      "recentAuditEvents": "Events in 24 hours",
      "failedAuditEvents": "Errors",
      "impersonatedAuditEvents": "Through impersonation"
    },
    "OverviewTitles": {
      "email-logs": "Email logs",
      "email-queue": "Email queue",
      "email-triggers": "Email triggers",
      "sms-logs": "SMS logs",
      "suppliers": "Suppliers",
      "supplier-contacts": "Supplier contacts"
    },
    "DialogSubtitles": {
      "services": {
        "customers": "Customer details, contacts and connected services.",
        "customer-contacts": "Customer contact details and communication preferences.",
        "contracts": "Contract terms, billing and linked subscriptions.",
        "contacts": "Contact details for domain registration and hosting.",
        "products": "Product details, pricing and availability.",
        "product-groups": "Product grouping and related settings.",
        "subscriptions": "Products, term and billing for this subscription.",
        "customer-offers": "Products, prices and terms of the quote.",
        "sales-orders": "Order details, line items and processing.",
        "invoices": "Invoice details, line items and payment status.",
        "sepa": "Direct debit instructions and batch processing.",
        "licenses": "License details, usage and linked users.",
        "license-slas": "Service commitments and availability terms.",
        "license-partner-programs": "Partner agreements and related license terms.",
        "webhosting": "Hosting package, domains and account settings.",
        "webhosting-packages": "Package settings, capacity and available features.",
        "domains": "Domain registration, contacts and DNS settings.",
        "domain-ns-groups": "Nameservers used together for domains.",
        "ssl-certificates": "Certificate details, domains and validity.",
        "projects": "Project details, planning and people responsible.",
        "project-tasks": "Task details, planning and progress.",
        "project-task-types": "Task category and related settings.",
        "project-task-time-tracking": "Recorded time and billing processing.",
        "users": "User details, access and account settings.",
        "customer-users": "User account and access to the customer portal.",
        "customer-api-accounts": "API account and access to customer data.",
        "roles": "Permissions and access to Vision features.",
        "account-invitations": "Invitation and access to the customer portal.",
        "settings": "Settings and values for this feature.",
        "whitelabels": "Branding, sender details and portal settings.",
        "vat": "VAT rate and its use on invoice lines.",
        "audit-logs": "Recorded action, user and changes.",
        "dmarc": "Email authentication results and report details.",
        "feedback-questions": "Question, answer options and usage.",
        "email-queue": "Message content, recipients and scheduled delivery.",
        "email-logs": "Sent message, recipients and delivery status.",
        "email-triggers": "Conditions, recipients and scheduling of automated emails.",
        "sms-logs": "Message content, recipient and delivery status.",
        "vpn-certificates": "Certificate and access to the VPN network.",
        "vpn-firewalls": "Firewall rules, access policy and verification.",
        "vpn-mac-address-groups": "Devices grouped for network access.",
        "sharingcenter-calendars": "Calendar settings, owner and availability.",
        "sharingcenter-contacts": "Contact details, ownership and shared access.",
        "sharingcenter-groups": "Group details, members and shared access.",
        "sharingcenter-profiles": "Profile settings, availability and communication.",
        "sharingcenter-calendar-appointments": "Appointment details, participants and availability.",
        "sharingcenter-meeting-files": "Recordings, transcripts and minutes of the meeting.",
        "customer-sip-accounts": "Telephony account, connection and security.",
        "customer-phone-numbers": "Phone number, routing and usage.",
        "ai-queue": "Processing job, status and result.",
        "customer-assets": "Connected systems and customer asset status.",
        "profile": "Personal details and account settings."
      },
      "actions": {
        "details": "Review the details and available actions.",
        "delete": "Review the selection before removing it.",
        "export": "Export the selected data to a file.",
        "preview": "Preview of the selected file.",
        "color": "Choose a color or enter a color code.",
        "profilePhoto": "View or change your profile picture.",
        "changeEmail": "Change the email address you use to sign in.",
        "emailChanged": "Your account now uses the new email address.",
        "changePassword": "Set a new password for your account.",
        "resetMfa": "Let the user set up multi-factor authentication again.",
        "resendInvite": "Send the user another invitation to the portal.",
        "revokeInvite": "Revoke access through this invitation.",
        "reissueInvite": "Create a new invitation for this recipient.",
        "apiToken": "View the API token for this account.",
        "regenerateToken": "Replace the existing API token for this account.",
        "rotateWebhookSecret": "Replace the signing key for this webhook.",
        "retryWebhookDelivery": "Replay this webhook delivery to the receiver.",
        "copyRoles": "Copy role assignments from another user.",
        "assignRoles": "Select the roles for the relevant user or customer.",
        "restoreSetting": "Restore the default value of this setting.",
        "refreshAssets": "Retrieve current data for the selected customers.",
        "approveMail": "Approve the selected messages for delivery.",
        "removeMail": "Remove the selected messages from the queue.",
        "requeueMail": "Queue the selected messages for delivery again.",
        "retryJob": "Submit this job for processing again.",
        "confirmTime": "Review the recorded hours and selected processing.",
        "changeAppointmentProfile": "Choose which profile settings to use for the appointment.",
        "deleteOccurrence": "Remove only this appointment from the series.",
        "deleteFutureOccurrences": "Remove this and subsequent appointments from the series.",
        "revokeSession": "End access through this sign-in session.",
        "revokeAllSessions": "End access through all listed sign-in sessions.",
        "deleteTranscript": "Remove the saved transcript of this recording.",
        "deleteMinutes": "Remove the saved minutes of this meeting.",
        "deleteRecording": "Remove the selected recording file.",
        "deleteAllRecordings": "Remove all recording files for this meeting.",
        "createTranscript": "Choose the language and settings for the transcript.",
        "createMinutes": "Choose the settings for generating meeting minutes.",
        "changeOwner": "Transfer ownership of the calendar.",
        "changeSharing": "Review changes to ownership and shared access.",
        "futureAppointments": "Choose how to handle future appointments.",
        "deleteCalendar": "Review which calendar and appointments will be removed.",
        "calendarColor": "Choose the display color for this calendar.",
        "upgrade": "Compare the cost of the current and new subscription options.",
        "domainTransferCode": "Use this code to transfer the domain to another provider.",
        "domainDnssec": "Manage DNSSEC security for this domain.",
        "domainRestore": "Restore registration of the selected domain.",
        "domainForceDelete": "Review the conditions for removing this domain.",
        "domainMove": "Transfer the domain and choose how to handle the current subscription.",
        "domainHosting": "Link the domain to another hosting account.",
        "hostingUpgrade": "Choose a new hosting package and review its cost.",
        "hostingDetails": "Choose the recipient of the hosting account details.",
        "uploadPrices": "Import product prices and review the changes.",
        "acceptOffer": "Review the quote and confirm its acceptance.",
        "rejectOffer": "Record why this quote is being rejected.",
        "invoiceMail": "Choose which invoice message to send to the customer.",
        "licenseConditions": "Terms that apply to use of the license.",
        "syncPrices": "Update subscription prices from the product prices.",
        "contractTakeover": "Move the subscription to another contract.",
        "cancelSubscription": "Set the end date and handling of the subscription.",
        "undoCancellation": "Undo the scheduled cancellation of the subscription.",
        "confirmMail": "Review the message and recipients before queuing it.",
        "downloadVpn": "Download the certificate for the VPN connection.",
        "createInvoice": "Turn the selected time entries into invoice lines.",
        "rawReport": "View the original data of the DMARC report."
      }
    },
    "ApiAccounts": {
      "IP whitelist": "IP whitelist",
      "IP whitelist hint": "Empty = access from any IP address. Enter one public IPv4 or IPv6 address per line. Commas are also accepted.",
      "Invalid IP whitelist": "Enter up to 100 valid individual IPv4 or IPv6 addresses, without a port or subnet.",
      "All IP addresses": "All IP addresses"
    },
    "Webhooks": {
      "Tabs": {
        "webhooks": "Configurations",
        "webhook-queue": "Deliveries",
        "webhook-logs": "Logs"
      },
      "Fields": {
        "name": "Name",
        "scope": "Scope",
        "customer": "Customer",
        "service": "Service",
        "events": "Events",
        "destinationHost": "Destination",
        "adminOnly": "Admin only",
        "active": "Active",
        "webhookName": "Webhook",
        "method": "Event",
        "status": "Status",
        "attempts": "Attempts",
        "attempt": "Attempt",
        "statusCode": "HTTP status",
        "errorCode": "Error code",
        "createdAt": "Time",
        "eventId": "Event ID",
        "recordId": "Record ID",
        "durationMs": "Duration",
        "finishedAt": "Finished at"
      },
      "Global": "All customers",
      "Scopes": {
        "customer": "One customer",
        "global": "All customers"
      },
      "Events": {
        "create": "Create",
        "patch": "Patch"
      },
      "Statuses": {
        "queued": "Queued",
        "processing": "Processing",
        "retry": "Retrying",
        "delivered": "Delivered",
        "failed": "Failed",
        "cancelled": "Cancelled"
      },
      "ReadOnlyHelp": "This webhook is managed by an administrator. You can view the configuration but cannot change it.",
      "SetupHelp": "Use a public HTTPS URL on port 443. New webhooks are disabled. Configure the key at the receiver, then activate the webhook.",
      "AdminSetupHelp": "Use an HTTPS URL with a valid certificate. Admin can also configure internal destinations and a custom port. New webhooks are disabled. Configure the key at the receiver, then activate the webhook.",
      "AdminOnlyHelp": "This destination is managed only in Admin. Its configuration, deliveries and logs are not visible in the customer portal.",
      "SecretOnce": "This key is shown once. Copy it to the receiver now. A new key immediately replaces the previous one.",
      "Rotate": "Rotate key",
      "RotateWarning": "The current key is invalidated immediately. Pending deliveries are cancelled; retained deliveries can be replayed manually.",
      "Remove": "Remove webhook",
      "RemoveWarning": "Remove webhook {name}? Pending deliveries will be cancelled.",
      "Retry": "Replay delivery",
      "RetryWarning": "Replay this delivery using the current webhook configuration? The receiver gets the same event ID and payload and must recognize duplicates.",
      "Details": "View details",
      "PayloadExpired": "The payload has expired. Metadata and delivery logs remain available for 90 days.",
      "Enabled": "Active",
      "Disabled": "Disabled",
      "Payload": "Payload",
      "Empty": {
        "webhooks": "No webhooks have been configured yet.",
        "webhook-queue": "There are no webhook deliveries yet.",
        "webhook-logs": "There are no webhook logs yet."
      }
    }
  }
}
